(function() {
  'use strict';

  angular
    .module('fleetApp', [
      'ngStorage',
      'tmh.dynamicLocale',
      'pascalprecht.translate',
      'ngResource',
      'ngCookies',
      'ngAria',
      'ngCacheBuster',
      'ngFileUpload',
      'ui.bootstrap',
      'ui.bootstrap.datetimepicker',
      'ui.router',
      'infinite-scroll',
      'ds.objectDiff',
      // jhipster-needle-angularjs-add-module JHipster will add new module here
      'angular-loading-bar',
      'angular.filter',
      'toaster',
      'ui.utils.masks'
    ])
    .run(run);

  run.$inject = ['stateHandler', 'translationHandler'];

  function run(stateHandler, translationHandler) {
    stateHandler.initialize();
    translationHandler.initialize();
  }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'search':{ method:'GET',
                url:'api/users/search',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'authorities': { method: 'GET',
                url: 'api/users/authorities',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                   // $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function hasValidToken () {
            var token = this.getToken();
            return token && token.expires && token.expires > new Date().getTime();
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', '$location', '$scope'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, $location, $scope) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerDisabled = response.swaggerDisabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        var host = $location.host();
        if (host.indexOf('.') < 0)
            vm.hasSubdomain = false;
        else
            vm.hasSubdomain = true

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                if (account !== null) {
                    vm.settingsAccount = copyAccount(account);
                }
            });
        }

        function login() {
            collapseNavbar();
            //LoginService.open();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    var vehicleEventHistoryFilter = {
        templateUrl: 'app/home/vehicle-event-history-filter.html',
        controller: VehicleEventHistoryFilterController,
    };

    angular
        .module('fleetApp')
        // This component can be used like: <vehicle-event-history-filter></vehicle-event-history-filter>
        .component('vehicleEventHistoryFilter', vehicleEventHistoryFilter);

    VehicleEventHistoryFilterController.$inject = ['$rootScope', '$scope', 'GeoMap', 'Position', 'DateUtils', 'AlertService', '$http'];

    function VehicleEventHistoryFilterController($rootScope, $scope, GeoMap, Position, DateUtils, AlertService, $http) {

        var vm = this;
        vm.initialDateTime = new Date();
        vm.endDateTime = new Date();
        vm.vehicle = angular.copy(GeoMap.vehicleHistory);

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $rootScope.$broadcast("invalidateMapSize");

        $scope.$watch(
          function() { return GeoMap.vehicleHistory; },
          function(newVal, oldVal) {
            vm.vehicle = angular.copy(newVal);
          },
          true
        );

        vm.search = function() {
            Position.history({vehicleid: vm.vehicle.vehicleId, initialDateTime: vm.initialDateTime, endDateTime: vm.endDateTime},
            function(data){
                $rootScope.$broadcast("clearMap");
                $rootScope.$broadcast("showPositions", {positions: data, fitBounds: true});
            }, onError);
        };

        vm.export = function() {
            var startDate = DateUtils.convertLocalDateTimeToServer(vm.initialDateTime);
            var endDate = DateUtils.convertLocalDateTimeToServer(vm.endDateTime);
            var dto = {vehicleId: vm.vehicle.vehicleId, initialDateTime: vm.initialDateTime, endDateTime: vm.endDateTime };
            $http.post('api/positions/history-report', dto, { responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
                saveAs(blob, "positionHistory.xls");
            }, onError);
        }

        vm.close = function () {
            GeoMap.vehicleHistory = null;
            $rootScope.$broadcast("clearMap");
            $rootScope.$broadcast("invalidateMapSize");
        }

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        function onError(error) {
            AlertService.error(error.data.message);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/login',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/login.html',
                    controller: 'LoginHomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('LoginHomeController', LoginHomeController);

    LoginHomeController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

    function LoginHomeController ($rootScope, $state, $timeout, Auth) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');
                $state.go('home');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $state.go('register');
        }

        function requestResetPassword () {
            $state.go('requestReset');
        }

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        function onError(error) {
            AlertService.error(error.data.message);
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/?date?itineraryId?vehicleId?tab',
            data: {
                authorities: []
            },
            onEnter: ['$state', 'Principal', '$timeout', function($state, Principal, $timeout) {
                var isAuthenticated = Principal.isAuthenticated();
                if (!isAuthenticated) {
                    $timeout(function() {
                        $state.go('login');
                    }, 0);
                }
            }],
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                initialLocation: ['GeoMapService', 'Principal', function(GeoMapService, Principal) {
                    if (Principal.isAuthenticated()){
                        return GeoMapService.initialLocation();
                    } else {
                        return '';
                    }
                }],
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('vehicle');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', 'DateUtils', '$filter',  function ($stateParams, DateUtils, $filter) {
                    return {
                        date: $stateParams.date == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.date,
                        tab: $stateParams.tab == null ? 0 : parseInt($stateParams.tab),
                        itineraryId: $stateParams.itineraryId,
                        vehicleId: $stateParams.vehicleId
                    };
                }]
            },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$rootScope', '$scope', 'Principal', 'LoginService', '$state', '$timeout', 'pagingParams', 'Position', 'DateUtils',
    'Itinerary', '$filter', '$interval', 'AlertService', 'GeoMap', 'initialLocation'];

    function HomeController ($rootScope, $scope, Principal, LoginService, $state, $timeout, pagingParams, Position, DateUtils, Itinerary, $filter,
        $interval, AlertService, GeoMap, initialLocation) {
        var vm = this;

        $rootScope.initialLocation = initialLocation.data;

        vm.tab = pagingParams.tab;
        vm.pickerDate = DateUtils.convertStringToDateMomentMMDDYYYY(pagingParams.date);
        vm.vehicleId = pagingParams.vehicleId;
        vm.itineraryId = pagingParams.itineraryId;

        vm.datePickerOpenStatus = {};

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~


        vm.setTab = function(newTab){
          vm.tab = newTab;

          $rootScope.$broadcast("clearMap");

          if (newTab == 1) {
            vm.itineraryId = null;
            vm.vehicleId = null;
            $rootScope.$broadcast("showOnMapEvent", {data: vm.vehicles, fitBounds: false});
          }

          transition(false);
        };

        vm.isSet = function(tabNum){
          return vm.tab === tabNum;
        };

        vm.isItineratySet = function(itinerary) {
          return itinerary.id == vm.itineraryId;
        };

        vm.isVehicleSet = function(vehicle) {
            return vehicle.vehicleId == vm.vehicleId;
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.onDateChange = function () {
            transition(true);
        }

        var initializing = true;
        $scope.$watch('vm.pickerDate', function () {
            if (initializing) {
                $timeout(function() { initializing = false; });
            } else {
                transition(true);
            }
        });

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
        vm.selectItinerarie = function(itinerary) {
            vm.itineraryId = itinerary.id;
            vm.vehicleId = itinerary.vehicleId;
            transition(false);

            $rootScope.$broadcast('clearMap');

            Itinerary.geojson({id: itinerary.id}, function(data) {
                $rootScope.$broadcast("onItineraryClickEvent", {data: data, fitBounds: true});
            }, onError);

            Position.devicetime({itineraryId: itinerary.id, vehicleid: itinerary.vehicleId}, function(data){
                $rootScope.$broadcast("showPositions", {positions: data, fitBounds: true});
            }, onError);
        };

        vm.selectVehicle = function(vehicle) {

            $rootScope.$broadcast("clearMap");
            GeoMap.vehicleHistory = null; // disable history panel
            $rootScope.$broadcast("invalidateMapSize");

            vm.itineraryId = null;
            vm.vehicleId = vehicle.vehicleId;
            $rootScope.$broadcast("onVehicleClickEvent",vehicle);
            transition(false);
        };

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        function transition (notify) {
            var dt = $filter('date')(vm.pickerDate, 'yyyy-MM-dd');

            $state.transitionTo($state.$current, {
                tab: vm.tab,
                date: dt,
                vehicleId: vm.vehicleId,
                itineraryId: vm.itineraryId
            }, {reload: false, notify: notify});
        }

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        vm.showMsg = false;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.$on('authenticationSuccess', function() {
            vm.showMsg = true;
            getAccount();
            $timeout(function () { vm.showMsg = false; }, 3000);
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                if (!Principal.isAuthenticated()) {
                    $timeout(function() {
                        $state.go('login');
                    }, 0);
                }
            });
        }

        function register () {
            $state.go('register');
        }

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        function onError(error) {
            AlertService.error(error.data.message);
        }

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        var intervalPromise;
//        function load() {
//            if (vm.itineraryId != null) {
//
//                loadItinerary(vm.itineraryId, true, vm.vehicleId);
//
                intervalPromise = $interval(function() {
//                    loadItinerary(vm.itineraryId, false, vm.vehicleId);
                }, 10000);
//            }
//        }
//        load();

        $scope.$on('$destroy',function(){
            if(intervalPromise)
                $interval.cancel(intervalPromise);
        });

        function loadItinerary(itineraryId, fitBounds, vehicleId) {

            Itinerary.geojson({id: itineraryId}, function(data) {
                $rootScope.$broadcast("onItineraryClickEvent", {data: data, fitBounds: fitBounds});
            }, onError);

            Position.devicetime({itineraryId: itineraryId, vehicleid: vehicleId}, function(data){
                $rootScope.$broadcast("showPositions", {pcositions: data, fitBounds: fitBounds});
            }, onError);
        }

        // -------------------------------------------------
        // Initial loading

        function loadItineraries() {
            var fromDate = DateUtils.convertLocalDateToServer(vm.pickerDate);

            Itinerary.dashboardlist({date: fromDate}, function (data) {
                vm.itineraries = data;

                //AdminLte Tree component:
                var options = {animationSpeed: 501, accordion: true, followLink: false, trigger: ".treeview a", widget: "tree"};
                setTimeout(function(){ $('#itineraries-menu').tree(options); }, 100);
            }, onError);
        }

        vm.loadVehiclesPosition = function () {
            vm.loadVehicles(true);
        }

        vm.loadVehicles = function (fitBounds) {

            Position.lastposition({}, function(data){
                vm.vehicles = data;
                $rootScope.$broadcast("clearMap");
                $rootScope.$broadcast("showOnMapEvent", {data: data, fitBounds: fitBounds});

                //AdminLte Tree component:
                var options = {animationSpeed: 501, accordion: true, followLink: false, trigger: ".treeview a", widget: "tree"};
                setTimeout(function(){ $('#vehicles-menu').tree(options); }, 100);

                setTimeout(function(){ $('#vehicles-menu').tree(options); }, 100);
            });
        }

        $scope.$on('initialLoadMap', function () {
            vm.loadVehicles(false);
            loadItineraries();
        });

        $scope.$watch(
          function() { return GeoMap.vehicleHistory; },
          function(newVal, oldVal) {
            vm.showHistory = newVal;
          },
          true
        );


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('GeomapController', GeomapController);

    GeomapController.$inject = ['$rootScope', '$scope', 'GeoMap'];

    function GeomapController ($rootScope, $scope, GeoMap) {
        var vm = this;

        this.$onInit = function () {
            console.log('$onInit');
            $rootScope.$broadcast("clearMap");
            $rootScope.$broadcast("initialLoadMap");
        }

        // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

        vm.showHistoryPanel = function (vehicle) {
            GeoMap.vehicleHistory = vehicle;
        }

    }
})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('GeoMap', GeoMap);

    GeoMap.$inject = ['$resource'];

    function GeoMap ($resource) {

        return {
            vehicleHistory: {}
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VisitDialogController', VisitDialogController);

    VisitDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Visit', 'Task', 'Position'];

    function VisitDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Visit, Task, Position) {
        var vm = this;

        vm.visit = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.tasks = Task.query();
//        vm.positions = Position.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.visit.id !== null) {
                Visit.update(vm.visit, onSaveSuccess, onSaveError);
            } else {
                Visit.save(vm.visit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:visitUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.arrivalTime = false;
        vm.datePickerOpenStatus.departure = false;
        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VisitDetailController', VisitDetailController);

    VisitDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Visit', 'Task', 'Position'];

    function VisitDetailController($scope, $rootScope, $stateParams, entity, Visit, Task, Position) {
        var vm = this;

        vm.visit = entity;

        var unsubscribe = $rootScope.$on('fleetApp:visitUpdate', function(event, result) {
            vm.visit = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VisitDeleteController',VisitDeleteController);

    VisitDeleteController.$inject = ['$uibModalInstance', 'entity', 'Visit'];

    function VisitDeleteController($uibModalInstance, entity, Visit) {
        var vm = this;

        vm.visit = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Visit.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('visit', {
            parent: 'entity',
            url: '/visit?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.visit.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/visit/visits.html',
                    controller: 'VisitController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visit');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('visit-detail', {
            parent: 'entity',
            url: '/visit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.visit.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/visit/visit-detail.html',
                    controller: 'VisitDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visit');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Visit', function($stateParams, Visit) {
                    return Visit.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('visit.new', {
            parent: 'visit',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visit/visit-dialog.html',
                    controller: 'VisitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                arrivalTime: null,
                                departure: null,
                                targetDistance: null,
                                creationDate: null,
                                odometer: null,
                                bypass: false,
                                spentTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('visit', null, { reload: true });
                }, function() {
                    $state.go('visit');
                });
            }]
        })
        .state('visit.edit', {
            parent: 'visit',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visit/visit-dialog.html',
                    controller: 'VisitDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Visit', function(Visit) {
                            return Visit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('visit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('visit.delete', {
            parent: 'visit',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visit/visit-delete-dialog.html',
                    controller: 'VisitDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Visit', function(Visit) {
                            return Visit.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('visit', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Visit', Visit);

    Visit.$inject = ['$resource', 'DateUtils'];

    function Visit ($resource, DateUtils) {
        var resourceUrl =  'api/visits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.arrivalTime = DateUtils.convertDateTimeFromServer(data.arrivalTime);
                        data.departure = DateUtils.convertDateTimeFromServer(data.departure);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByTask': {
                method: 'GET', isArray: true,
                url: 'api/visits/task/:id',
                transformResponse: function (data, headersGetter, status) {
                    if (data) {
                        data = angular.fromJson(data);
                         if (status == 200) {
                            angular.forEach(data, function(item) {
                                data.arrivalTime = DateUtils.convertDateTimeFromServer(data.arrivalTime);
                                data.departure = DateUtils.convertDateTimeFromServer(data.departure);
                                data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                            });
                        }
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VisitController', VisitController);

    VisitController.$inject = ['$scope', '$state', 'Visit', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VisitController ($scope, $state, Visit, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Visit.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.visits = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleTypeDialogController', VehicleTypeDialogController);

    VehicleTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VehicleType'];

    function VehicleTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VehicleType) {
        var vm = this;

        vm.vehicleType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vehicleType.id !== null) {
                VehicleType.update(vm.vehicleType, onSaveSuccess, onSaveError);
            } else {
                VehicleType.save(vm.vehicleType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:vehicleTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleTypeDetailController', VehicleTypeDetailController);

    VehicleTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VehicleType'];

    function VehicleTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, VehicleType) {
        var vm = this;

        vm.vehicleType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('fleetApp:vehicleTypeUpdate', function(event, result) {
            vm.vehicleType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleTypeDeleteController',VehicleTypeDeleteController);

    VehicleTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'VehicleType'];

    function VehicleTypeDeleteController($uibModalInstance, entity, VehicleType) {
        var vm = this;

        vm.vehicleType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VehicleType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vehicle-type', {
            parent: 'entity',
            url: '/vehicle-type?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehicleType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-type/vehicle-types.html',
                    controller: 'VehicleTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicleType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vehicle-type-detail', {
            parent: 'entity',
            url: '/vehicle-type/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehicleType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-type/vehicle-type-detail.html',
                    controller: 'VehicleTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicleType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VehicleType', function($stateParams, VehicleType) {
                    return VehicleType.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'vehicle-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('vehicle-type-detail.edit', {
            parent: 'vehicle-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-type/vehicle-type-dialog.html',
                    controller: 'VehicleTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VehicleType', function(VehicleType) {
                            return VehicleType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vehicle-type.new', {
            parent: 'vehicle-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-type/vehicle-type-dialog.html',
                    controller: 'VehicleTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                icon: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vehicle-type', null, { reload: 'vehicle-type' });
                }, function() {
                    $state.go('vehicle-type');
                });
            }]
        })
        .state('vehicle-type.edit', {
            parent: 'vehicle-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-type/vehicle-type-dialog.html',
                    controller: 'VehicleTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VehicleType', function(VehicleType) {
                            return VehicleType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle-type', null, { reload: 'vehicle-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vehicle-type.delete', {
            parent: 'vehicle-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-type/vehicle-type-delete-dialog.html',
                    controller: 'VehicleTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VehicleType', function(VehicleType) {
                            return VehicleType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle-type', null, { reload: 'vehicle-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('VehicleType', VehicleType);

    VehicleType.$inject = ['$resource'];

    function VehicleType ($resource) {
        var resourceUrl =  'api/vehicle-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleTypeController', VehicleTypeController);

    VehicleTypeController.$inject = ['$scope', '$state', 'VehicleType', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VehicleTypeController ($scope, $state, VehicleType, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            VehicleType.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vehicleTypes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentItemDialogController', VehiclePaymentItemDialogController);

    VehiclePaymentItemDialogController.$inject = ['$timeout', '$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'VehiclePayment',
    'vehiclePayment', '$filter'];

    function VehiclePaymentItemDialogController ($timeout, $scope, $rootScope, $stateParams, $uibModalInstance, entity, VehiclePayment,
    vehiclePayment, $filter) {
        var vm = this;

        vm.vehiclePaymentItem = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vehiclePayment = vehiclePayment;

        vm.minStartTime = moment(vm.vehiclePaymentItem.startTime).startOf('day').toDate();
        vm.maxStartTime = moment(vm.vehiclePaymentItem.startTime).endOf('day').toDate();


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        vm.isInitialTimeIsAfterEndTime = function() {
            var ini = moment(vm.vehiclePaymentItem.startTime);
            var end = moment(vm.vehiclePaymentItem.endTime);
            return ini.isAfter(end);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vehiclePaymentItem.id !== null) {
                var foundItem = $filter('filter')(vm.vehiclePayment.itens, { id: vm.vehiclePaymentItem.id }, true)[0];
                var index = vm.vehiclePayment.itens.indexOf(foundItem);
                vm.vehiclePayment.itens.splice(index, 1);
                vm.vehiclePayment.itens.push(vm.vehiclePaymentItem);
                VehiclePayment.update(vm.vehiclePayment, onSaveSuccess, onSaveError);
            } else {
                vm.vehiclePayment.itens.push(vm.vehiclePaymentItem);
                VehiclePayment.update(vm.vehiclePayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:vehiclePaymentItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.paymentDate = false;
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        // ****************************************************

        vm.updateOdometer = function () {
            vm.vehiclePaymentItem.kmTotal = vm.vehiclePaymentItem.endOdometer - vm.vehiclePaymentItem.startOdometer;
            var extra = vm.vehiclePaymentItem.kmTotal - vm.vehiclePayment.kmAllowed;
            vm.vehiclePaymentItem.kmExtra = extra > 0 ? extra : 0;
            vm.vehiclePaymentItem.kmCostTotalRegular = 0;
            vm.vehiclePaymentItem.kmCostTotalTrip = 0;
            vm.vehiclePaymentItem.kmExtraRegular = 0;
            vm.vehiclePaymentItem.kmExtraTrip = 0;

            if (vm.vehiclePaymentItem.kmExtra > 0) {
                vm.vehiclePaymentItem.kmExtraRegular = vm.vehiclePaymentItem.kmExtra;
                vm.updateKmExtraRegular();
            }
        }

        vm.updateKmExtraRegular = function () {
            vm.vehiclePaymentItem.kmCostTotalRegular = vm.vehiclePaymentItem.kmExtraRegular * vm.vehiclePayment.kmCost;
        }
        vm.updateKmExtraTrip = function () {
            vm.vehiclePaymentItem.kmCostTotalTrip = vm.vehiclePaymentItem.kmExtraTrip * vm.vehiclePayment.kmCostTrip;
        }

        // ****************************************************

        vm.changeTime = function () {
            var start = vm.vehiclePaymentItem.startTime ? moment(vm.vehiclePaymentItem.startTime) : undefined;
            var end = vm.vehiclePaymentItem.endTime ? moment(vm.vehiclePaymentItem.endTime) : undefined;

            if (start && end) {
                var duration = moment.duration(end.diff(start));
                vm.vehiclePaymentItem.totalTime = duration.asMinutes();
            } else {
                vm.vehiclePaymentItem.totalTime = undefined;
            }
            extraTimeCalculate();
            vm.formatTime();
        }

        vm.formatTime = function() {
            vm.totalTimeFormatted = formatTime(vm.vehiclePaymentItem.totalTime);
            vm.extraTimeFormatted = formatTime(vm.vehiclePaymentItem.extraTime);
        }

        function extraTimeCalculate() {
            if (parseInt(vm.vehiclePaymentItem.totalTime) > vm.vehiclePayment.timeAllowed) {
                vm.vehiclePaymentItem.extraTime = vm.vehiclePaymentItem.totalTime - vm.vehiclePayment.timeAllowed;
                vm.vehiclePaymentItem.extraTimeCostTotal = (vm.vehiclePayment.extraTimeCost / 60) * vm.vehiclePaymentItem.extraTime;
            } else {
                vm.vehiclePaymentItem.extraTime = 0;
                vm.vehiclePaymentItem.extraTimeCostTotal = 0;
            }
        }

        function formatTime(value) {
            if (value) {
                return moment().startOf('day').add(value, 'minutes').format('HH:mm');
            } else {
                return undefined;
            }
        }

        vm.formatTime();

        // ****************************************************

        vm.changeTotal = function() {
            vm.vehiclePaymentItem.total = vm.vehiclePaymentItem.extraTimeCostTotal + vm.vehiclePaymentItem.kmCostTotalRegular +
                            vm.vehiclePaymentItem.kmCostTotalTrip + vm.vehiclePaymentItem.dailyCost;
        }

        // **********************************************

        vm.addExpense = function() {
            if (!vm.vehiclePaymentItem.expenses) vm.vehiclePaymentItem.expenses = [];
            var nextDate = moment(vm.vehiclePaymentItem.paymentDate).startOf('day').toDate();
            vm.vehiclePaymentItem.expenses.push({expenseDate: nextDate});
        }

        vm.addRefund = function() {
            if (!vm.vehiclePaymentItem.refunds) vm.vehiclePaymentItem.refunds = [];
            vm.vehiclePaymentItem.refunds.push({});
        }

        vm.deleteItem = function(collection, item) {
            var index = collection.indexOf(item);
            collection.splice(index, 1);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentItemDetailController', VehiclePaymentItemDetailController);

    VehiclePaymentItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VehiclePaymentItem', 'VehiclePayment', 'User'];

    function VehiclePaymentItemDetailController($scope, $rootScope, $stateParams, entity, VehiclePaymentItem, VehiclePayment, User) {
        var vm = this;

        vm.vehiclePaymentItem = entity;

        var unsubscribe = $rootScope.$on('fleetApp:vehiclePaymentItemUpdate', function(event, result) {
            vm.vehiclePaymentItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentItemDeleteController',VehiclePaymentItemDeleteController);

    VehiclePaymentItemDeleteController.$inject = ['$uibModalInstance', 'vehiclePaymentItem', 'vehiclePayment', 'VehiclePayment'];

    function VehiclePaymentItemDeleteController($uibModalInstance, vehiclePaymentItem, vehiclePayment, VehiclePayment) {
        var vm = this;

        vm.vehiclePaymentItem = vehiclePaymentItem;
        vm.vehiclePayment = vehiclePayment;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VehiclePayment.deleteItem({itemId: id, vehiclePaymentId: vm.vehiclePayment.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vehicle-payment-item', {
            parent: 'entity',
            url: '/vehicle-payment-item?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehiclePaymentItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-items.html',
                    controller: 'VehiclePaymentItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehiclePaymentItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vehicle-payment-item-detail', {
            parent: 'entity',
            url: '/vehicle-payment-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehiclePaymentItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-item-detail.html',
                    controller: 'VehiclePaymentItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehiclePaymentItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VehiclePaymentItem', function($stateParams, VehiclePaymentItem) {
                    return VehiclePaymentItem.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vehicle-payment-item.new', {
            parent: 'vehicle-payment-item',
            url: '/item-new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-item-dialog.html',
                    controller: 'VehiclePaymentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                paymentDate: null,
                                startOdometer: null,
                                endOdometer: null,
                                kmTotal: null,
                                kmExtra: null,
                                kmExtraRegular: null,
                                kmExtraTrip: null,
                                kmCostTotalRegular: null,
                                kmCostTotalTrip: null,
                                startTime: null,
                                endTime: null,
                                totalTime: null,
                                extraTime: null,
                                extraTimeCostTotal: null,
                                expenseTotal: null,
                                total: null,
                                dailyCost: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function(data) {
                    $state.go('vehicle-payment-item', data, { reload: true });
                }, function() {
                    $state.go('vehicle-payment-item');
                });
            }]
        })
        .state('vehicle-payment-item.edit', {
            parent: 'vehicle-payment-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-item-dialog.html',
                    controller: 'VehiclePaymentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VehiclePaymentItem', function(VehiclePaymentItem) {
                            return VehiclePaymentItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle-payment-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('VehiclePaymentItem', VehiclePaymentItem);

    VehiclePaymentItem.$inject = ['$resource', 'DateUtils'];

    function VehiclePaymentItem ($resource, DateUtils) {
        var resourceUrl =  'api/vehicle-payment-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.paymentDate = DateUtils.convertLocalDateFromServer(data.paymentDate);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);

                        if (data.expenses) {
                            angular.forEach(data.expenses, function(expense) {
                                expense = angular.fromJson(expense);
                                expense.creation = DateUtils.convertDateTimeFromServer(expense.creation);
                                expense.expenseDate = DateUtils.convertDateTimeFromServer(expense.expenseDate);
                                expense.newDate = new Date();
                            });
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.paymentDate = DateUtils.convertLocalDateToServer(data.paymentDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.paymentDate = DateUtils.convertLocalDateToServer(data.paymentDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentItemController', VehiclePaymentItemController);

    VehiclePaymentItemController.$inject = ['$scope', '$state', 'VehiclePaymentItem', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VehiclePaymentItemController ($scope, $state, VehiclePaymentItem, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            VehiclePaymentItem.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vehiclePaymentItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentNewDialogController', VehicleDialogController);

    VehicleDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'VehiclePayment'];

    function VehicleDialogController ($timeout, $scope, $uibModalInstance, entity, VehiclePayment) {
        var vm = this;

        vm.vehiclePayment = entity;
        vm.clear = clear;
        vm.save = save;
        vm.datePickerOpenStatus = {};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vehiclePayment.id !== null) {
                VehiclePayment.update(vm.vehiclePayment, onSaveSuccess, onSaveError);
            } else {
                VehiclePayment.save(vm.vehiclePayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:vehiclePaymentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creation = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentEditController', VehiclePaymentEditController);

    VehiclePaymentEditController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'VehiclePayment', 'VehiclePaymentItem', '$state',
    'Vehicle', '$uibModal', 'DateUtils'];

    function VehiclePaymentEditController ($timeout, $scope, $stateParams, entity, VehiclePayment, VehiclePaymentItem, $state, Vehicle, $uibModal, DateUtils) {
        var vm = this;

        vm.vehiclePayment = entity;
        vm.vehicleTimeAllowed = minutesToHoursFormatter(vm.vehiclePayment.timeAllowed);
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.convertMinutesToDisplay = DateUtils.convertMinutesToDisplay;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save () {
            vm.isSaving = true;
            if (vm.vehiclePayment.id !== null) {
                VehiclePayment.update(vm.vehiclePayment, onSaveSuccess, onSaveError);
            } else {
                VehiclePayment.save(vm.vehiclePayment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:vehiclePaymentUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creation = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.cancel = function() {
            $state.go('^');
        }

        vm.deleteItem = function(vehiclePaymentItem) {
            $uibModal.open({
                templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-item-delete-dialog.html',
                controller: 'VehiclePaymentItemDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    vehiclePaymentItem: vehiclePaymentItem,
                    vehiclePayment: vm.vehiclePayment
                }
            }).result.then(function() {
                $state.go($state.$current, null, { reload: true });
            }, function() {
                $state.go('^');
            });
        }

        vm.editItem = function(itemId) {
            $uibModal.open({
                    templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-item-dialog.html',
                    controller: 'VehiclePaymentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        vehiclePayment: vm.vehiclePayment,
                        entity: function () {
                            return VehiclePaymentItem.get({id : itemId}).$promise;
                        }
                    }
                }).result.then(function() {
                    $state.go($state.$current, null, { reload: true });
                }, function() {
                    $state.go($state.$current, null, { reload: true });
                });
        };


         function getNextDateFromItens() {
            if (vm.vehiclePayment.itens.length == 0) {
                return moment(vm.vehiclePayment.startDate).startOf('day').toDate();
            } else {
                var dates = [];

                angular.forEach(vm.vehiclePayment.itens, function(value) {
                     dates.push(moment(value.paymentDate, 'YYYY-MM-DD').startOf('day').toDate());
                 });
                 // get max date:
                 var dt = new Date(Math.max.apply(null, dates));
                 return moment(dt).add(1, 'day').startOf('day').toDate();
            }

         }

         vm.importItineraryData = function() {
            VehiclePayment.importItineraryData({id: vm.vehiclePayment.id}, function() {
                $state.go($state.$current, null, { reload: true });
            }, onSaveError);
         }

        vm.addItem = function() {
            $uibModal.open({
                    templateUrl: 'app/entities/vehicle-payment-item/vehicle-payment-item-dialog.html',
                    controller: 'VehiclePaymentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        vehiclePayment: vm.vehiclePayment,
                        entity: function () {
                            var refDate = moment().startOf('day').add(8,'hour');
                            var endRefDate = moment(refDate.toDate()).add(10, 'hour');
                            var nextDate = getNextDateFromItens();

                            return {
                                paymentDate: nextDate,
                                startOdometer: 0,
                                endOdometer: 0,
                                kmTotal: 0,
                                kmExtra: 0,
                                kmExtraRegular: 0,
                                kmExtraTrip: 0,
                                kmCostTotalRegular: 0,
                                kmCostTotalTrip: 0,
                                startTime: refDate.toDate(),
                                endTime: endRefDate.toDate(),
                                totalTime: moment.duration(endRefDate.diff(refDate)).asMinutes(),
                                extraTime: 0,
                                extraTimeCostTotal: null,
                                expenseTotal: 0,
                                refundTotal: 0,
                                total: vm.vehiclePayment.dailyCost,
                                dailyCost: vm.vehiclePayment.dailyCost,
                                id: null,
                                type: null,
                                driverId: vm.vehiclePayment.preferentialDriverId,
                                driverFirstName: vm.vehiclePayment.preferentialDriverFirstName,
                                expenses: [],
                                refunds: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.$current, null, { reload: true });
                }, function() {
                    $state.go($state.$current, null, { reload: true });
                });
        }

        function minutesToHoursFormatter(value) {
            if (value) {
                return moment().startOf('day').add(value, 'minutes').format('HH:mm');
            } else {
                return undefined;
            }
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentDetailController', VehiclePaymentDetailController);

    VehiclePaymentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VehiclePayment', 'User', 'Vehicle'];

    function VehiclePaymentDetailController($scope, $rootScope, $stateParams, entity, VehiclePayment, User, Vehicle) {
        var vm = this;

        vm.vehiclePayment = entity;

        var unsubscribe = $rootScope.$on('fleetApp:vehiclePaymentUpdate', function(event, result) {
            vm.vehiclePayment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentDeleteController',VehiclePaymentDeleteController);

    VehiclePaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'VehiclePayment'];

    function VehiclePaymentDeleteController($uibModalInstance, entity, VehiclePayment) {
        var vm = this;

        vm.vehiclePayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VehiclePayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vehicle-payment', {
            parent: 'entity',
            url: '/vehicle-payment?page&sort&search&start&end&plate$vehicleId',
            data: {
                authorities: ['EDIT_FINANCIAL', 'ROLE_ADMIN'],
                pageTitle: 'fleetApp.vehiclePayment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-payment/vehicle-payments.html',
                    controller: 'VehiclePaymentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                start: null,
                end: null,
                vehicleId: null,
                plate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', '$filter', function ($stateParams, PaginationUtil, $filter) {
                    var dt = moment().startOf('month');
                    var iniDate = dt.clone().toDate();
                    var endDate = dt.clone().add(14, 'd').toDate();
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        start: $stateParams.start == null ? $filter('date')(iniDate, 'yyyy-MM-dd') : $stateParams.start,
                        end: $stateParams.end == null ? $filter('date')(endDate, "yyyy-MM-dd") : $stateParams.end,
                        vehicleId: $stateParams.vehicleId,
                        plate: $stateParams.plate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('vehiclePayment');
                    $translatePartialLoader.addPart('vehiclePaymentItem');
                    $translatePartialLoader.addPart('vehicle');
                    return $translate.refresh();
                }]
            }
        })
        .state('vehicle-payment-detail', {
            parent: 'entity',
            url: '/vehicle-payment/{id}',
            data: {
                authorities: ['EDIT_FINANCIAL', 'ROLE_ADMIN'],
                pageTitle: 'fleetApp.vehiclePayment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-payment/vehicle-payment-detail.html',
                    controller: 'VehiclePaymentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehiclePayment');
                    $translatePartialLoader.addPart('vehiclePaymentItem');
                    $translatePartialLoader.addPart('vehicle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VehiclePayment', function($stateParams, VehiclePayment) {
                    return VehiclePayment.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vehicle-payment.new', {
            parent: 'vehicle-payment',
            url: '/new',
            data: {
                authorities: ['EDIT_FINANCIAL', 'ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-payment/vehicle-payment-new-dialog.html',
                    controller: 'VehiclePaymentNewDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: {
                                creation: null,
                                kmCost: null,
                                dailyCost: null,
                                extraTimeCost: null,
                                kmCostTrip: null,
                                startDate: moment().startOf('month').toDate(),
                                endDate: moment().startOf('month').add(14, 'd').toDate(),
                                expenseCost: 0,
                                refundCost: 0,
                                total: null,
                                timeAllowed: null,
                                kmAllowed: null,
                                vehicleId: null,
                                vehiclePlate: null,
                                importItineraryData: true,
                                id: null,
                                itens: [],
                                kmTotalExtra: 0,
                                kmTotalRegular: 0
                            }
                    }
                }).result.then(function() {
                    $state.go('vehicle-payment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vehicle-payment.edit', {
            parent: 'vehicle-payment',
            url: '/{id}/edit',
            data: {
                authorities: ['EDIT_FINANCIAL', 'ROLE_ADMIN'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-payment/vehicle-payment-edit.html',
                    controller: 'VehiclePaymentEditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehiclePayment');
                    $translatePartialLoader.addPart('vehiclePaymentItem');
                    $translatePartialLoader.addPart('vehicle');
                    $translatePartialLoader.addPart('expense');
                    $translatePartialLoader.addPart('expenseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VehiclePayment', function($stateParams, VehiclePayment) {
                    return VehiclePayment.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vehicle-payment.delete', {
            parent: 'vehicle-payment',
            url: '/{id}/delete',
            data: {
                authorities: ['EDIT_FINANCIAL', 'ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-payment/vehicle-payment-delete-dialog.html',
                    controller: 'VehiclePaymentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VehiclePayment', function(VehiclePayment) {
                            return VehiclePayment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle-payment', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });


    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('VehiclePayment', VehiclePayment);

    VehiclePayment.$inject = ['$resource', 'DateUtils'];

    function VehiclePayment ($resource, DateUtils) {
        var resourceUrl =  'api/vehicle-payments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creation = DateUtils.convertDateTimeFromServer(data.creation);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        if (data.itens) {
                            angular.forEach(data.itens, function (item) {
                                if (item.expenses) {
                                    angular.forEach(item.expenses, function(expense) {
                                        expense = angular.fromJson(expense);
                                        expense.creation = DateUtils.convertDateTimeFromServer(expense.creation);
                                        expense.expenseDate = DateUtils.convertDateTimeFromServer(expense.expenseDate);
                                        expense.newDate = new Date();
                                    });
                                }
                            });
                        }
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                    data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                    return angular.toJson(data);
                }
            },
            'deleteItem': {
                method: 'DELETE', url: 'api/vehicle-payments/delete-item/:itemId/:vehiclePaymentId'
            },
            'importItineraryData': {
                method: 'GET',
                url: 'api/vehicle-payments/import-itinerary-data/:id'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehiclePaymentController', VehiclePaymentController);

    VehiclePaymentController.$inject = ['$scope', '$state', 'VehiclePayment', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants',
    'DateUtils', '$filter', '$http'];

    function VehiclePaymentController ($scope, $state, VehiclePayment, ParseLinks, AlertService, pagingParams, paginationConstants, DateUtils,
    $filter, $http) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll = loadAll;

        vm.startDate = DateUtils.convertLocalDateFromServer(pagingParams.start);
        vm.endDate = DateUtils.convertLocalDateFromServer(pagingParams.end);

        vm.vehicleId = pagingParams.vehicleId;
        vm.vehiclePlate = pagingParams.plate;

        vm.datePickerOpenStatus = {};

        loadAll();

        function loadAll () {
            VehiclePayment.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                startDate: DateUtils.convertLocalDateToServer(pagingParams.start),
                endDate: DateUtils.convertLocalDateToServer(pagingParams.end),
                vehicleId: pagingParams.vehicleId
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vehiclePayments = data;
                vm.page = pagingParams.page;
                vm.vehicleId = pagingParams.vehicleId;
                vm.vehiclePlate = pagingParams.plate;
            }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.search = function () {
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                start: DateUtils.convertLocalDateToServer(vm.startDate),
                end: DateUtils.convertLocalDateToServer(vm.endDate),
                vehicleId: vm.vehicleId,
                plate: vm.vehiclePlate
            });
        }

        vm.fortnight = function (status) {
            var dt = moment().startOf('month');
            if (status === 'first') {
                vm.startDate = dt.toDate();
                vm.endDate = dt.clone().add(14, 'd').toDate();
            } else {
                vm.startDate = dt.clone().add(15, 'd').toDate();
                vm.endDate = dt.clone().endOf('month').toDate();
            }
        }

        vm.reportTotal = function() {
            vm.startDate.setHours(0,0,0,0);
            vm.endDate.setHours(0,0,0,0);
            var dto = {startDate: vm.startDate, endDate: vm.endDate };
            $http.post('api/vehicle-payments/report-total/', dto, { responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
                saveAs(blob, "ReportTotal.xls");
            }, onError);
        }

        vm.report = function(id) {
            $http.get('api/vehicle-payments/report/' + id, { responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
                saveAs(blob, "Report.xls");
            }, onError);
        }

        vm.datePickerOpenStatus.date = false;

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleGroupDialogController', VehicleGroupDialogController);

    VehicleGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VehicleGroup'];

    function VehicleGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VehicleGroup) {
        var vm = this;

        vm.vehicleGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vehicleGroup.id !== null) {
                VehicleGroup.update(vm.vehicleGroup, onSaveSuccess, onSaveError);
            } else {
                VehicleGroup.save(vm.vehicleGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:vehicleGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleGroupDetailController', VehicleGroupDetailController);

    VehicleGroupDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'VehicleGroup', 'Company'];

    function VehicleGroupDetailController($scope, $rootScope, $stateParams, entity, VehicleGroup, Company) {
        var vm = this;

        vm.vehicleGroup = entity;

        var unsubscribe = $rootScope.$on('fleetApp:vehicleGroupUpdate', function(event, result) {
            vm.vehicleGroup = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleGroupDeleteController',VehicleGroupDeleteController);

    VehicleGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'VehicleGroup'];

    function VehicleGroupDeleteController($uibModalInstance, entity, VehicleGroup) {
        var vm = this;

        vm.vehicleGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VehicleGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var vehicleGroupTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" ng-if="!$ctrl.hideTitle" translate="{{$ctrl.label}}" for="field_user">User</label>' +
            '<div class="input-group">' +
            '  <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ $ctrl.translateLabelKey | translate }}" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)" ' +
            '  uib-typeahead="address as address.name for address in getEntityData($viewValue)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: VehicleGroupTypeaheadController,
        bindings: {
            modelEntity: '=',
            modelId: '=',
            modelLabel: '=',
            label: '<',
            translateLabelKey: '<',
            hideTitle: '@' // title hide when true
        }
    };

    angular
        .module('fleetApp')
        .component('vehicleGroupTypeahead', vehicleGroupTypeahead);

    VehicleGroupTypeaheadController.$inject = ['$scope', 'VehicleGroup', '$http', 'paginationConstants'];

    function VehicleGroupTypeaheadController($scope, VehicleGroup, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.name;
            vm.modelId = model.id;
        }

        $scope.getEntityData = function(val) {
            return VehicleGroup.search({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                name: val}).$promise;
        };

        vm.clear = function() {
            vm.vehicleGroup = undefined;
            vm.modelLabel = undefined;
            vm.modelId = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vehicle-group', {
            parent: 'entity',
            url: '/vehicle-group',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehicleGroup.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-group/vehicle-groups.html',
                    controller: 'VehicleGroupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicleGroup');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('vehicle-group-detail', {
            parent: 'entity',
            url: '/vehicle-group/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehicleGroup.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle-group/vehicle-group-detail.html',
                    controller: 'VehicleGroupDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicleGroup');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VehicleGroup', function($stateParams, VehicleGroup) {
                    return VehicleGroup.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('vehicle-group.new', {
            parent: 'vehicle-group',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-group/vehicle-group-dialog.html',
                    controller: 'VehicleGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vehicle-group', null, { reload: true });
                }, function() {
                    $state.go('vehicle-group');
                });
            }]
        })
        .state('vehicle-group.edit', {
            parent: 'vehicle-group',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-group/vehicle-group-dialog.html',
                    controller: 'VehicleGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VehicleGroup', function(VehicleGroup) {
                            return VehicleGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle-group', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vehicle-group.delete', {
            parent: 'vehicle-group',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle-group/vehicle-group-delete-dialog.html',
                    controller: 'VehicleGroupDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VehicleGroup', function(VehicleGroup) {
                            return VehicleGroup.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle-group', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('VehicleGroup', VehicleGroup);

    VehicleGroup.$inject = ['$resource'];

    function VehicleGroup ($resource) {
        var resourceUrl =  'api/vehicle-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'search':{ method:'GET',
                url:'api/vehicle-groups/search',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleGroupController', VehicleGroupController);

    VehicleGroupController.$inject = ['$scope', '$state', 'VehicleGroup'];

    function VehicleGroupController ($scope, $state, VehicleGroup) {
        var vm = this;
        
        vm.vehicleGroups = [];

        loadAll();

        function loadAll() {
            VehicleGroup.query(function(result) {
                vm.vehicleGroups = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleDialogController', VehicleDialogController);

    VehicleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Vehicle', 'Company', 'Device', 'VehicleType'];

    function VehicleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Vehicle, Company, Device, VehicleType) {
        var vm = this;

        vm.vehicle = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
//        vm.devices = Device.query();
        vm.vehicletypes = VehicleType.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();

            initialize();
        });

        function initialize() {
            var myWidget = cloudinary.createUploadWidget({
                cloudName: 'dvzlcxrvw', 
                multiple: false,
                defaultSource: "local",
                uploadPreset: 'vehicle' }, 
                function (error, result) { 
                    if (!error && result && result.event === "success") { 
                        vm.vehicle.photoUrl = result.info.url;
                        $scope.$apply();
                    }
                }
              );

            document.getElementById("upload_widget").addEventListener("click", function(){
                myWidget.open();
                }, false);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vehicle.id !== null) {
                Vehicle.update(vm.vehicle, onSaveSuccess, onSaveError);
            } else {
                Vehicle.save(vm.vehicle, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:vehicleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleDetailController', VehicleDetailController);

    VehicleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Vehicle', 'Company', 'Device', 'VehicleType'];

    function VehicleDetailController($scope, $rootScope, $stateParams, previousState, entity, Vehicle, Company, Device, VehicleType) {
        var vm = this;

        vm.vehicle = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('fleetApp:vehicleUpdate', function(event, result) {
            vm.vehicle = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleDeleteController',VehicleDeleteController);

    VehicleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Vehicle'];

    function VehicleDeleteController($uibModalInstance, entity, Vehicle) {
        var vm = this;

        vm.vehicle = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Vehicle.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var vehicleTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" ng-if="!$ctrl.hideTitle" translate="global.field.vehicle" for="field_vehicle">vehicle</label>' +
            '<div class="input-group">' +
            ' <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ \'global.field.vehicle\' | translate }}" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)"  ' +
            '  uib-typeahead="address as address.plate for address in getEntityData($viewValue)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: VehicleTypeaheadController,
        bindings: {
            modelEntity: '=',
            modelId: '=',
            modelLabel: '=',
            hideTitle: '@' // title hide when true
        }
    };

    angular
        .module('fleetApp')
        .component('vehicleTypeahead', vehicleTypeahead);

    VehicleTypeaheadController.$inject = ['$scope', 'Vehicle', '$http', 'paginationConstants'];

    function VehicleTypeaheadController($scope, Vehicle, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.plate;
            vm.modelId = model.id;
        }

        $scope.getEntityData = function(val) {
            return Vehicle.search({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                plate: val}).$promise;
        };

        vm.clear = function() {
            vm.vehicle = undefined;
            vm.modelLabel = undefined;
            vm.modelId = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('vehicle', {
            parent: 'entity',
            url: '/vehicle?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehicle.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle/vehicles.html',
                    controller: 'VehicleController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicle');
                    $translatePartialLoader.addPart('device');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('vehiclePayment');
                    $translatePartialLoader.addPart('bank');
                    $translatePartialLoader.addPart('bankAccount');
                    $translatePartialLoader.addPart('vehicleGroup');
                    return $translate.refresh();
                }]
            }
        })
        .state('vehicle-detail', {
            parent: 'entity',
            url: '/vehicle/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.vehicle.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/vehicle/vehicle-detail.html',
                    controller: 'VehicleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicle');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Vehicle', function($stateParams, Vehicle) {
                    return Vehicle.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'vehicle',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('vehicle-detail.edit', {
            parent: 'vehicle-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle/vehicle-dialog.html',
                    controller: 'VehicleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vehicle', function(Vehicle) {
                            return Vehicle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vehicle.new', {
            parent: 'vehicle',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle/vehicle-dialog.html',
                    controller: 'VehicleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                plate: null,
                                activated: true,
                                externalId: null,
                                photoUrl: null,
                                kmCost: null,
                                dailyCost: null,
                                extraTimeCost: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('vehicle', null, { reload: 'vehicle' });
                }, function() {
                    $state.go('vehicle');
                });
            }]
        })
        .state('vehicle.edit', {
            parent: 'vehicle',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle/vehicle-dialog.html',
                    controller: 'VehicleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Vehicle', function(Vehicle) {
                            return Vehicle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle', null, { reload: 'vehicle' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('vehicle.delete', {
            parent: 'vehicle',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/vehicle/vehicle-delete-dialog.html',
                    controller: 'VehicleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Vehicle', function(Vehicle) {
                            return Vehicle.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('vehicle', null, { reload: 'vehicle' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Vehicle', Vehicle);

    Vehicle.$inject = ['$resource'];

    function Vehicle ($resource) {
        var resourceUrl =  'api/vehicles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': { method:'GET',
                isArray: true,
                url:'api/vehicles/search',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'getPaymentInfo': {
                method: 'GET',
                url: 'api/vehicles/paymentInfo/:id',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('VehicleController', VehicleController);

    VehicleController.$inject = ['$scope', '$state', 'Vehicle', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VehicleController ($scope, $state, Vehicle, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Vehicle.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.vehicles = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('v3', {
            parent: 'entity',
            url: '/v3',
            views: {
                'content@': {
                    templateUrl: 'app/entities/v3/v3.html',
                    controller: 'AppV3Controller',
                    controllerAs: 'vm'
                }
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'fleetApp.fleetPreference.home.title'
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }

})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AppV3Controller', AppV3Controller);

    AppV3Controller.$inject = ['$scope', '$state', '$localStorage', '$sessionStorage'];

    function AppV3Controller ($scope, $state, $localStorage, $sessionStorage) {
        var vm = this;

        vm.postMessage = postMessage;

        function postMessage () {
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            console.log('posting msg to frame')
            var iframeWin = document.getElementById("da-iframe").contentWindow;
            iframeWin.postMessage(token, "*");
        }

        function init () {
            postMessage();
        }

        init();

    }
})();
;
(function() {
    'use strict';

    var userItinerarySelector = {
        templateUrl: 'app/entities/user-itinerary/user-itinerary-selector.html',
        controller: UserItinerarySelectorController,
        bindings: {
            itinerary: '='
        }
    };

    angular
        .module('fleetApp')
        .component('userItinerarySelector', userItinerarySelector);

    UserItinerarySelectorController.$inject = ['AlertService'];

    function UserItinerarySelectorController(AlertService) {
        var vm = this;

        vm.removeUser = function(userId) {
            var pos;
            angular.forEach(vm.itinerary.users, function (element) {
                if (element.userId === userId) {
                    pos = vm.itinerary.users.indexOf(element);
                }
            });
            if (pos > -1) vm.itinerary.users.splice(pos, 1);
        };

        vm.addUser = function() {
            var item = { userId: vm.userId, userFirstName: vm.userFirstName };

            if (!vm.itinerary.users) vm.itinerary.users = [];
            
            var duplicated = false;
            angular.forEach(vm.itinerary.users, function (element) {
                if (element.userId === item.userId) duplicated = true;
            });
           
            if (!duplicated) {
                vm.itinerary.users.unshift(item);
                vm.userId = null;
                vm.userFirstName = null;
            } else {
                AlertService.error('Esse item já existe');
            }
        };
    }
})();
;
(function() {
    'use strict';

    var userTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" ng-if="!$ctrl.hideTitle" translate="{{$ctrl.label}}" for="field_user">User</label>' +
            '<div class="input-group">' +
            '  <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ $ctrl.translateLabelKey | translate }}" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)" ' +
            '  uib-typeahead="address as address.name for address in getEntityData($viewValue)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: UserTypeaheadController,
        bindings: {
            modelEntity: '=',
            modelId: '=',
            modelLabel: '=',
            label: '<',
            translateLabelKey: '<',
            hideTitle: '@' // title hide when true. Eg.: hide-title="'true'"
        }
    };

    angular
        .module('fleetApp')
        .component('userTypeahead', userTypeahead);

    UserTypeaheadController.$inject = ['$scope', 'User', '$http', 'paginationConstants'];

    function UserTypeaheadController($scope, User, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.name;
            vm.modelId = model.id;
        };

        $scope.getEntityData = function(val) {
            return User.search({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                query: val}).$promise;
        };

        vm.clear = function() {
            vm.user = undefined;
            vm.modelLabel = undefined;
            vm.modelId = undefined;
            $scope.noResults = false;
        };
    }
})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Traccar', Traccar);

    Traccar.$inject = ['$resource', 'DateUtils'];

    function Traccar ($resource, DateUtils) {
        var resourceUrl =  'api/traccar/:id';

        return $resource(resourceUrl, {}, {
            'importDevices': { method:'GET', url: 'api/traccar/importDevices' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskEventDialogController', TaskEventDialogController);

    TaskEventDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TaskEvent', 'User', 'Task'];

    function TaskEventDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TaskEvent, User, Task) {
        var vm = this;

        vm.taskEvent = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.tasks = Task.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.taskEvent.id !== null) {
                TaskEvent.update(vm.taskEvent, onSaveSuccess, onSaveError);
            } else {
                TaskEvent.save(vm.taskEvent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:taskEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.eventDateTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskEventDetailController', TaskEventDetailController);

    TaskEventDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TaskEvent', 'User', 'Task'];

    function TaskEventDetailController($scope, $rootScope, $stateParams, previousState, entity, TaskEvent, User, Task) {
        var vm = this;

        vm.taskEvent = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('fleetApp:taskEventUpdate', function(event, result) {
            vm.taskEvent = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskEventDeleteController',TaskEventDeleteController);

    TaskEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaskEvent'];

    function TaskEventDeleteController($uibModalInstance, entity, TaskEvent) {
        var vm = this;

        vm.taskEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TaskEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task-event', {
            parent: 'entity',
            url: '/task-event?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.taskEvent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-event/task-events.html',
                    controller: 'TaskEventController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskEvent');
                    $translatePartialLoader.addPart('taskEventType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-event-detail', {
            parent: 'task-event',
            url: '/task-event/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.taskEvent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task-event/task-event-detail.html',
                    controller: 'TaskEventDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('taskEvent');
                    $translatePartialLoader.addPart('taskEventType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TaskEvent', function($stateParams, TaskEvent) {
                    return TaskEvent.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'task-event',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('task-event-detail.edit', {
            parent: 'task-event-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-event/task-event-dialog.html',
                    controller: 'TaskEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaskEvent', function(TaskEvent) {
                            return TaskEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task-event.new', {
            parent: 'task-event',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-event/task-event-dialog.html',
                    controller: 'TaskEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                eventDateTime: null,
                                eventType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('task-event', null, { reload: 'task-event' });
                }, function() {
                    $state.go('task-event');
                });
            }]
        })
        .state('task-event.edit', {
            parent: 'task-event',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-event/task-event-dialog.html',
                    controller: 'TaskEventDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TaskEvent', function(TaskEvent) {
                            return TaskEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-event', null, { reload: 'task-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task-event.delete', {
            parent: 'task-event',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task-event/task-event-delete-dialog.html',
                    controller: 'TaskEventDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TaskEvent', function(TaskEvent) {
                            return TaskEvent.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task-event', null, { reload: 'task-event' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('TaskEvent', TaskEvent);

    TaskEvent.$inject = ['$resource', 'DateUtils'];

    function TaskEvent ($resource, DateUtils) {
        var resourceUrl =  'api/task-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.eventDateTime = DateUtils.convertDateTimeFromServer(data.eventDateTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskEventController', TaskEventController);

    TaskEventController.$inject = ['$state', 'TaskEvent', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function TaskEventController($state, TaskEvent, ParseLinks, AlertService, paginationConstants, pagingParams) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TaskEvent.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.taskEvents = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    "use strict";

    angular
        .module("fleetApp")
        .controller("TaskDialogDetailController", TaskDialogController);

    TaskDialogController.$inject = [
        "ImageService",
        "$scope",
        "$stateParams",
        "$uibModalInstance",
        "entity"
    ];

    function TaskDialogController(
        ImageService,
        $scope,
        $stateParams,
        $uibModalInstance,
        entity
    ) {
        var vm = this;

        vm.clear = clear;
        vm.task = entity;
        vm.radioModel = "product";

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        vm.arrayToString = function(string) {
            return string.join(", ");
        };

        vm.getClass = function(invoiceItem) {
            invoiceItem.refusedReasonId === undefined ? "bold" : "bold";
        };

        vm.url = function(value, append) {
            var url = value.replace(/\"/g, "");
            return url.replace("/upload", "/upload" + append);
        };

        vm.task.photoUrl = ImageService.image300(vm.task.photoUrl);

        vm.task.fleetMedias.forEach(function(v) {
            v.urlFixed = vm.url(v.url, "/w_300,h_300/dpr_1.0");
            v.urlOriginal = vm.url(v.url, "");
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskDialogController', TaskDialogController);

    TaskDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Task', 'Itinerary', 'PersonAddress', 'Invoice'];

    function TaskDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Task, Itinerary, PersonAddress, Invoice) {
        var vm = this;

        vm.task = entity;
        vm.clear = clear;
        vm.save = save;
        vm.itineraries = Itinerary.query();
        vm.personaddresses = PersonAddress.query();
        vm.invoices = [];//Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.task.id !== null) {
                Task.update(vm.task, onSaveSuccess, onSaveError);
            } else {
                Task.save(vm.task, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:taskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskDetailController', TaskDetailController);

    TaskDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Task', 'Itinerary', 'PersonAddress', 'Invoice'];

    function TaskDetailController($scope, $rootScope, $stateParams, entity, Task, Itinerary, PersonAddress, Invoice) {
        var vm = this;

        vm.task = entity;

        var unsubscribe = $rootScope.$on('fleetApp:taskUpdate', function(event, result) {
            vm.task = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskDeleteController',TaskDeleteController);

    TaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'Task'];

    function TaskDeleteController($uibModalInstance, entity, Task) {
        var vm = this;

        vm.task = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Task.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('task', {
            parent: 'entity',
            url: '/task?page&sort&search&itinerary&date&taskStatus',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.task.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task/tasks.html',
                    controller: 'TaskController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                itinerary: null,
                date: null,
                taskStatus: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        itinerary: $stateParams.itinerary,
                        date: $stateParams.date == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.date,
                        taskStatus: $stateParams.taskStatus
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('itinerary');
                    $translatePartialLoader.addPart('taskType');
                    $translatePartialLoader.addPart('taskStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('task-detail', {
            parent: 'entity',
            url: '/task/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.task.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/task/task-detail.html',
                    controller: 'TaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('taskType');
                    $translatePartialLoader.addPart('taskStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Task', function($stateParams, Task) {
                    return Task.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('task.new', {
            parent: 'task',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                taskType: null,
                                taskStatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: true });
                }, function() {
                    $state.go('task');
                });
            }]
        })
        .state('task.edit', {
            parent: 'task',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-dialog.html',
                    controller: 'TaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('task.delete', {
            parent: 'task',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-delete-dialog.html',
                    controller: 'TaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('task', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Task', Task);

    Task.$inject = ['$resource', 'DateUtils'];

    function Task ($resource, DateUtils) {
        var resourceUrl =  'api/tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        angular.forEach(data.itens, function(item) {
                            item.expirationDate = DateUtils.convertLocalDateFromServer(item.expirationDate);
                        });
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByItinerary': {
                method: 'GET', isArray: true,
                url: 'api/tasks/itinerary/:id',
                transformResponse: function (data, headersGetter, status) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (status == 200) {
                            var models = [];
                            angular.forEach(data, function(item) {
                                item.isCollapsed = true;
                                models.push(item);
                            });
                            return models;
                        }
                    }
                    return data;
                }
            },
            'geojson': { method:'GET', url:'api/tasks/geojson', isArray: true},
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TaskController', TaskController);

    TaskController.$inject = ['$scope', '$state', 'Task', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DateUtils'];

    function TaskController ($scope, $state, Task, ParseLinks, AlertService, pagingParams, paginationConstants, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.dashboardDate = pagingParams.date;

        loadAll();

        function loadAll () {
            var fromDate = DateUtils.convertLocalDateToServer(vm.dashboardDate);
            Task.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                iniDate: fromDate,
                endDate: fromDate,
                taskStatus: pagingParams.taskStatus
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.tasks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ItineraryTaskDialogController', ItineraryTaskDialogController);

    ItineraryTaskDialogController.$inject = ['AlertService', '$scope', '$uibModalInstance', 'entity', 'Visit', 'InvoiceItem'];

    function ItineraryTaskDialogController (AlertService, $scope, $uibModalInstance, entity, Visit, InvoiceItem) {
        var vm = this;

        vm.tasks = entity;
        vm.clear = clear;
        vm.openDialog = openDialog;

        vm.isCollapsed = true;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function openDialog(task) {
            if (task.isCollapsed == undefined) {
                task.isCollapsed = true;
            }

            InvoiceItem.getInvoiceItens({taskid: task.id}, onSuccess, onError);
            function onSuccess(data, headers) {
                task.itens = data;
            }

            task.isCollapsed = !task.isCollapsed;
        }

        vm.showVisits = function(task) {
            if (!(task.visits == undefined)) {
                return;
            }
            Visit.getByTask({id: task.id}, onSuccess, onError);
            function onSuccess(data, headers) {
                task.visits = data;
            }
        }

        vm.arrayToString = function(string){
            return string.join(", ");
        };

    }
})();

;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RouteReviewDialogController', RouteReviewDialogController);

    RouteReviewDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RouteReview', 'Visit', 'User'];

    function RouteReviewDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RouteReview, Visit, User) {
        var vm = this;

        vm.routeReview = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.visits = Visit.query();
        vm.users = User.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.routeReview.id !== null) {
                RouteReview.update(vm.routeReview, onSaveSuccess, onSaveError);
            } else {
                RouteReview.save(vm.routeReview, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:routeReviewUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RouteReviewDetailController', RouteReviewDetailController);

    RouteReviewDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RouteReview', 'Visit', 'User'];

    function RouteReviewDetailController($scope, $rootScope, $stateParams, entity, RouteReview, Visit, User) {
        var vm = this;

        vm.routeReview = entity;

        var unsubscribe = $rootScope.$on('fleetApp:routeReviewUpdate', function(event, result) {
            vm.routeReview = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RouteReviewDeleteController',RouteReviewDeleteController);

    RouteReviewDeleteController.$inject = ['$uibModalInstance', 'entity', 'RouteReview'];

    function RouteReviewDeleteController($uibModalInstance, entity, RouteReview) {
        var vm = this;

        vm.routeReview = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RouteReview.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('route-review', {
            parent: 'entity',
            url: '/route-review?page&sort&search&date',
            data: {
                authorities: ['EDIT_ROUTE_REVIEW'],
                pageTitle: 'fleetApp.routeReview.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/route-review/route-reviews.html',
                    controller: 'RouteReviewController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                date: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', 'DateUtils', function ($stateParams, PaginationUtil, DateUtils) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        date: $stateParams.date == null ? DateUtils.newDateString() : $stateParams.date,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('vehicle');
                    $translatePartialLoader.addPart('routeReview');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('route-review-detail', {
            parent: 'entity',
            url: '/route-review/{id}',
            data: {
                authorities: ['EDIT_ROUTE_REVIEW'],
                pageTitle: 'fleetApp.routeReview.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/route-review/route-review-detail.html',
                    controller: 'RouteReviewDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('routeReview');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RouteReview', function($stateParams, RouteReview) {
                    return RouteReview.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('route-review.new', {
            parent: 'route-review',
            url: '/new/{visitId}',
            data: {
                authorities: ['EDIT_ROUTE_REVIEW']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/route-review/route-review-dialog.html',
                    controller: 'RouteReviewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reason: null,
                                creationDate: null,
                                id: null,
                                visitId: $stateParams.visitId
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('route-review', null, { reload: true });
                }, function() {
                    $state.go('route-review');
                });
            }]
        })
        .state('route-review.edit', {
            parent: 'route-review',
            url: '/{id}/edit',
            data: {
                authorities: ['EDIT_ROUTE_REVIEW']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/route-review/route-review-dialog.html',
                    controller: 'RouteReviewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RouteReview', function(RouteReview) {
                            return RouteReview.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('route-review', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('route-review.delete', {
            parent: 'route-review',
            url: '/{id}/delete',
            data: {
                authorities: ['EDIT_ROUTE_REVIEW']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/route-review/route-review-delete-dialog.html',
                    controller: 'RouteReviewDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RouteReview', function(RouteReview) {
                            return RouteReview.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('route-review', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('RouteReview', RouteReview);

    RouteReview.$inject = ['$resource', 'DateUtils'];

    function RouteReview ($resource, DateUtils) {
        var resourceUrl =  'api/route-reviews/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'reindex': { method:'POST',
                url:'api/route-reviews/reindex',
                transformRequest: function (data) {
                    data = DateUtils.convertLocalDateToServer(data.routeReviewDate);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RouteReviewController', RouteReviewController);

    RouteReviewController.$inject = ['$scope', '$state', 'RouteReview', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DateUtils'];

    function RouteReviewController ($scope, $state, RouteReview, ParseLinks, AlertService, pagingParams, paginationConstants, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.reindex = reindex;
        vm.routeReviewDate = pagingParams.date;
        vm.pickerDate = DateUtils.convertLocalDateFromServer(pagingParams.date);
        vm.datePickerOpenStatus = {};

        loadAll();

        function loadAll () {
            RouteReview.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                date: pagingParams.date
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.routeReviews = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            var fromDate = DateUtils.convertLocalDateToServer(vm.pickerDate);

            $state.transitionTo($state.$current, {
                page: vm.page,
                date: fromDate,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function reindex() {
            RouteReview.reindex({routeReviewDate: vm.routeReviewDate}, function() {
                loadAll();
            });
        }

        vm.openCalendar = function (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('TimeReportController', TimeReportController);

    TimeReportController.$inject = ['$scope', '$state', '$http', 'AlertService', 'DateUtils'];

    function TimeReportController ($scope, $state, $http, AlertService, DateUtils) {
        var vm = this;

        vm.fortnight = function (status) {
            var dt = moment().startOf('month');
            if (status === 'first') {
                vm.startDate = dt.toDate();
                vm.endDate = dt.clone().add(14, 'd').toDate();
            } else {
                vm.startDate = dt.clone().add(15, 'd').toDate();
                vm.endDate = dt.clone().endOf('month').toDate();
            }
        }

        vm.fortnight('first');

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.analyticReport = function(id) {
            var dto = {startDate: vm.startDate, endDate: vm.endDate, vehicleId: vm.vehicleId };
            $http.post('api/report/timeReport/', dto, { responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
                saveAs(blob, "TimeReport.xls");
            }, onError);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('report', {
            parent: 'entity',
            url: '/report?page&sort&search&inidate&enddate&secondExternalId',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.report.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report/reports.html',
                    controller: 'ReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                inidate: null,
                enddate: null,
                product: null,
                person: null,
                secondExternalId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', '$filter', function ($stateParams, PaginationUtil, $filter) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        inidate: $stateParams.inidate == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.inidate,
                        enddate: $stateParams.enddate == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.enddate,
                        product: $stateParams.product,
                        person: $stateParams.person,
                        secondExternalId: $stateParams.secondExternalId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('report');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('report.deliveredProduct', {
            parent: 'entity',
            url: '/report/delivered-product?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.report.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report/delivered-product.html',
                    controller: 'ReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('report');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('report.products-by-task', {
            parent: 'report',
            url: '/{id}/products',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-item/invoice-items-dialog.html',
                    controller: 'InvoiceItemsDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoiceItem', function(InvoiceItem) {
                            return InvoiceItem.getInvoiceItens({taskid : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoiceItem');
                    return $translate.refresh();
                }]
            }
        })
        .state('report.payment', {
            parent: 'app',
            url: '/report-payment',
            data: {
                authorities: ['ACCESS_REPORTS']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report/payment-report.html',
                    controller: 'PaymentReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('report');
                    $translatePartialLoader.addPart('vehiclePayment');
                    $translatePartialLoader.addPart('vehiclePaymentItem');
                    return $translate.refresh();
                }]
            }
        })
        .state('report.time', {
            parent: 'app',
            url: '/report-time',
            data: {
                authorities: ['ACCESS_REPORTS']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report/time-report.html',
                    controller: 'TimeReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('report');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Report', Report);

    Report.$inject = ['$resource', 'DateUtils'];

    function Report ($resource, DateUtils) {
        var resourceUrl =  'api/reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'analytic': { method: 'POST', isArray: true, url: 'api/report/analytics',
                 transformRequest: function (data) {
                     data.startDate = DateUtils.convertLocalDateToServer(data.startDate);
                     data.endDate = DateUtils.convertLocalDateToServer(data.endDate);
                     return angular.toJson(data);
                 },
                 transformResponse: function (data) {
                     if (data) {
                         data = angular.fromJson(data);
                         angular.forEach(data, function(item) {
//                            item.firstTimeIn = DateUtils.convertDateTimeFromServer(item.firstTimeIn);
//                            item.lastTimeOut = DateUtils.convertDateTimeFromServer(item.lastTimeOut);
//                            item.durationTime = DateUtils.convertMinutesToDisplay(item.durationTime);
                         });
                     }
                     return data;
                 }
             }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ReportController', ReportController);

    ReportController.$inject = ['$scope', '$state', 'Report', 'ParseLinks', 'AlertService', 'pagingParams',
         'paginationConstants', 'DateUtils', '$http'];

    function ReportController ($scope, $state, Report, ParseLinks, AlertService, pagingParams,
        paginationConstants, DateUtils, $http) {

        var vm = this;

        vm.report = {};
        vm.report.startDate = DateUtils.convertLocalDateFromServer(pagingParams.inidate);
        vm.report.endDate = DateUtils.convertLocalDateFromServer(pagingParams.enddate);
        vm.secondExternalId = pagingParams.secondExternalId;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.product = pagingParams.product;
        vm.person = pagingParams.person;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        loadAll();

        function loadAll () {
            var productId = vm.product ? vm.product.id : undefined;
            var personId = vm.person ? vm.person.id : undefined;
            Report.analytic({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,

                startDate: vm.report.startDate,
                endDate: vm.report.endDate,
                secondExternalId: vm.secondExternalId,
                productId: productId,
                personId: personId
                }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;

                vm.reports = data;
                vm.page = pagingParams.page;
                vm.date = pagingParams.date;
            }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                product: vm.product,
                person: vm.person,
                secondExternalId: vm.secondExternalId,
                inidate: DateUtils.convertLocalDateToServer(vm.report.startDate),
                enddate: DateUtils.convertLocalDateToServer(vm.report.endDate)
            });
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

         vm.analyticReport = function(id) {
             var dto = {
                 productId: vm.product,
                 personId: vm.person,
                 secondExternalId: vm.secondExternalId,
                 startDate: DateUtils.convertLocalDateToServer(vm.report.startDate),
                 endDate: DateUtils.convertLocalDateToServer(vm.report.endDate)
             }
             $http.post('api/report/analytics/xls', dto, { responseType: 'arraybuffer' }).then(function (response) {
                 var blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
                 saveAs(blob, "analytic.xls");
             }, onError);
         }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PaymentReportController', PaymentReportController);

    PaymentReportController.$inject = ['$scope', '$state', '$http', 'AlertService', 'DateUtils'];

    function PaymentReportController ($scope, $state, $http, AlertService, DateUtils) {
        var vm = this;

        vm.fortnight = function (status) {
            var dt = moment().startOf('month');
            if (status === 'first') {
                vm.startDate = dt.toDate();
                vm.endDate = dt.clone().add(14, 'd').toDate();
            } else {
                vm.startDate = dt.clone().add(15, 'd').toDate();
                vm.endDate = dt.clone().endOf('month').toDate();
            }
        }

        vm.fortnight('first');

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.analyticReport = function(id) {
            var startDate = DateUtils.convertLocalDateToServer(vm.startDate);
            var endDate = DateUtils.convertLocalDateToServer(vm.endDate);

            var dto = {startDate: startDate, endDate: endDate, vehicleId: vm.vehicleId };
            $http.post('api/vehicle-payments/analyticReport/', dto, { responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.data], {type: "application/vnd.ms-excel"});
                saveAs(blob, "ReportAnalytics.xls");
            }, onError);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RefusedReasonDialogController', RefusedReasonDialogController);

    RefusedReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RefusedReason', 'Company'];

    function RefusedReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RefusedReason, Company) {
        var vm = this;

        vm.refusedReason = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.refusedReason.id !== null) {
                RefusedReason.update(vm.refusedReason, onSaveSuccess, onSaveError);
            } else {
                RefusedReason.save(vm.refusedReason, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:refusedReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RefusedReasonDetailController', RefusedReasonDetailController);

    RefusedReasonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'RefusedReason', 'Company'];

    function RefusedReasonDetailController($scope, $rootScope, $stateParams, entity, RefusedReason, Company) {
        var vm = this;

        vm.refusedReason = entity;

        var unsubscribe = $rootScope.$on('fleetApp:refusedReasonUpdate', function(event, result) {
            vm.refusedReason = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RefusedReasonDeleteController',RefusedReasonDeleteController);

    RefusedReasonDeleteController.$inject = ['$uibModalInstance', 'entity', 'RefusedReason'];

    function RefusedReasonDeleteController($uibModalInstance, entity, RefusedReason) {
        var vm = this;

        vm.refusedReason = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RefusedReason.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('refused-reason', {
            parent: 'entity',
            url: '/refused-reason?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.refusedReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/refused-reason/refused-reasons.html',
                    controller: 'RefusedReasonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('refusedReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('refused-reason-detail', {
            parent: 'entity',
            url: '/refused-reason/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.refusedReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/refused-reason/refused-reason-detail.html',
                    controller: 'RefusedReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('refusedReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RefusedReason', function($stateParams, RefusedReason) {
                    return RefusedReason.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('refused-reason.new', {
            parent: 'refused-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/refused-reason/refused-reason-dialog.html',
                    controller: 'RefusedReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('refused-reason', null, { reload: true });
                }, function() {
                    $state.go('refused-reason');
                });
            }]
        })
        .state('refused-reason.edit', {
            parent: 'refused-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/refused-reason/refused-reason-dialog.html',
                    controller: 'RefusedReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RefusedReason', function(RefusedReason) {
                            return RefusedReason.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('refused-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('refused-reason.delete', {
            parent: 'refused-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/refused-reason/refused-reason-delete-dialog.html',
                    controller: 'RefusedReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RefusedReason', function(RefusedReason) {
                            return RefusedReason.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('refused-reason', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('RefusedReason', RefusedReason);

    RefusedReason.$inject = ['$resource'];

    function RefusedReason ($resource) {
        var resourceUrl =  'api/refused-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'all': {
                url: '/api/refused-reasons/all', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RefusedReasonController', RefusedReasonController);

    RefusedReasonController.$inject = ['$scope', '$state', 'RefusedReason', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RefusedReasonController ($scope, $state, RefusedReason, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            RefusedReason.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.refusedReasons = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Product', 'Company'];

    function ProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Product, Company) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.product.id !== null) {
                Product.update(vm.product, onSaveSuccess, onSaveError);
            } else {
                Product.save(vm.product, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:productUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ProductDetailController', ProductDetailController);

    ProductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Product', 'Company'];

    function ProductDetailController($scope, $rootScope, $stateParams, entity, Product, Company) {
        var vm = this;

        vm.product = entity;

        var unsubscribe = $rootScope.$on('fleetApp:productUpdate', function(event, result) {
            vm.product = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ProductDeleteController',ProductDeleteController);

    ProductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Product'];

    function ProductDeleteController($uibModalInstance, entity, Product) {
        var vm = this;

        vm.product = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Product.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var productTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" translate="global.field.product" for="field_product">Product</label>' +
            '<div class="input-group">' +
            ' <input type="text" ng-model="$ctrl.product" placeholder="{{ \'global.field.product\' | translate }}" ' +
            '  uib-typeahead="address as address.name for address in getLocation($viewValue)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: ProductTypeaheadController,
        bindings: {
            product: '='
        }
    };

    angular
        .module('fleetApp')
        .component('productTypeahead', productTypeahead);

    ProductTypeaheadController.$inject = ['$scope', 'Product', '$http', 'paginationConstants'];

    function ProductTypeaheadController($scope, Product, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
            if (vm.product && vm.product.id && vm.product.name == undefined) {
            }
        };

        $scope.getLocation = function(val) {
            return Product.findByName({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                name: val}).$promise;
        };

        vm.clear = function() {
            vm.product = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('product', {
            parent: 'entity',
            url: '/product?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.product.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/products.html',
                    controller: 'ProductController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('product-detail', {
            parent: 'entity',
            url: '/product/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.product.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/product/product-detail.html',
                    controller: 'ProductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('product');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Product', function($stateParams, Product) {
                    return Product.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('product.new', {
            parent: 'product',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                shortName: null,
                                unit: null,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('product');
                });
            }]
        })
        .state('product.edit', {
            parent: 'product',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-dialog.html',
                    controller: 'ProductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('product.delete', {
            parent: 'product',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/product/product-delete-dialog.html',
                    controller: 'ProductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Product', function(Product) {
                            return Product.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('product', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Product', Product);

    Product.$inject = ['$resource'];

    function Product ($resource) {
        var resourceUrl =  'api/products/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findByName': {
                method: 'GET',
                url: 'api/products/findbyname',
                isArray: true,
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['$scope', '$state', 'Product', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProductController ($scope, $state, Product, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Product.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.products = data;
                vm.page = pagingParams.page;
            }
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PositionDialogController', PositionDialogController);

    PositionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Position', 'Vehicle'];

    function PositionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Position, Vehicle) {
        var vm = this;

        vm.position = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vehicles = Vehicle.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.position.id !== null) {
                Position.update(vm.position, onSaveSuccess, onSaveError);
            } else {
                Position.save(vm.position, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:positionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.serverTime = false;
        vm.datePickerOpenStatus.deviceTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PositionDetailController', PositionDetailController);

    PositionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Position', 'Vehicle'];

    function PositionDetailController($scope, $rootScope, $stateParams, entity, Position, Vehicle) {
        var vm = this;

        vm.position = entity;

        var unsubscribe = $rootScope.$on('fleetApp:positionUpdate', function(event, result) {
            vm.position = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PositionDeleteController',PositionDeleteController);

    PositionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Position'];

    function PositionDeleteController($uibModalInstance, entity, Position) {
        var vm = this;

        vm.position = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Position.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('position', {
            parent: 'entity',
            url: '/position?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.position.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/position/positions.html',
                    controller: 'PositionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('position');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('position-detail', {
            parent: 'entity',
            url: '/position/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.position.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/position/position-detail.html',
                    controller: 'PositionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('position');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Position', function($stateParams, Position) {
                    return Position.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('position.new', {
            parent: 'position',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serverTime: null,
                                deviceTime: null,
                                latitude: null,
                                longitude: null,
                                altitude: null,
                                speed: null,
                                course: null,
                                address: null,
                                vehicleIgnition: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: true });
                }, function() {
                    $state.go('position');
                });
            }]
        })
        .state('position.edit', {
            parent: 'position',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-dialog.html',
                    controller: 'PositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('position.delete', {
            parent: 'position',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/position/position-delete-dialog.html',
                    controller: 'PositionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('position', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Position', Position);

    Position.$inject = ['$resource', 'DateUtils'];

    function Position ($resource, DateUtils) {
        var resourceUrl =  'api/positions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.serverTime = DateUtils.convertDateTimeFromServer(data.serverTime);
                        data.deviceTime = DateUtils.convertDateTimeFromServer(data.deviceTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'lastposition': {method:'GET', isArray: true, url: 'api/positions/lastposition'},
            'devicetime': {method:'GET', isArray: true, url: 'api/positions/devicetime'},
            'history': {method:'GET', isArray: true, url: 'api/positions/history'}
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PositionController', PositionController);

    PositionController.$inject = ['$scope', '$state', 'Position', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PositionController ($scope, $state, Position, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Position.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.positions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDistanceDialogController', PersonDistanceDialogController);

    PersonDistanceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PersonDistance', 'Person'];

    function PersonDistanceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PersonDistance, Person) {
        var vm = this;

        vm.personDistance = entity;
        vm.clear = clear;
        vm.save = save;
//        vm.people = Person.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.personDistance.id !== null) {
                PersonDistance.update(vm.personDistance, onSaveSuccess, onSaveError);
            } else {
                PersonDistance.save(vm.personDistance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:personDistanceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDistanceDetailController', PersonDistanceDetailController);

    PersonDistanceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PersonDistance', 'Person'];

    function PersonDistanceDetailController($scope, $rootScope, $stateParams, entity, PersonDistance, Person) {
        var vm = this;

        vm.personDistance = entity;

        var unsubscribe = $rootScope.$on('fleetApp:personDistanceUpdate', function(event, result) {
            vm.personDistance = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDistanceDeleteController',PersonDistanceDeleteController);

    PersonDistanceDeleteController.$inject = ['$uibModalInstance', 'entity', 'PersonDistance'];

    function PersonDistanceDeleteController($uibModalInstance, entity, PersonDistance) {
        var vm = this;

        vm.personDistance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PersonDistance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('person-distance', {
            parent: 'entity',
            url: '/person-distance?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.personDistance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person-distance/person-distances.html',
                    controller: 'PersonDistanceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('personDistance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('person-distance-detail', {
            parent: 'entity',
            url: '/person-distance/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.personDistance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person-distance/person-distance-detail.html',
                    controller: 'PersonDistanceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('personDistance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PersonDistance', function($stateParams, PersonDistance) {
                    return PersonDistance.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('person-distance.new', {
            parent: 'person-distance',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-distance/person-distance-dialog.html',
                    controller: 'PersonDistanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                distance: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('person-distance', null, { reload: true });
                }, function() {
                    $state.go('person-distance');
                });
            }]
        })
        .state('person-distance.edit', {
            parent: 'person-distance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-distance/person-distance-dialog.html',
                    controller: 'PersonDistanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PersonDistance', function(PersonDistance) {
                            return PersonDistance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-distance', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person-distance.delete', {
            parent: 'person-distance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-distance/person-distance-delete-dialog.html',
                    controller: 'PersonDistanceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PersonDistance', function(PersonDistance) {
                            return PersonDistance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-distance', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('PersonDistance', PersonDistance);

    PersonDistance.$inject = ['$resource'];

    function PersonDistance ($resource) {
        var resourceUrl =  'api/person-distances/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDistanceController', PersonDistanceController);

    PersonDistanceController.$inject = ['$scope', '$state', 'PersonDistance', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PersonDistanceController ($scope, $state, PersonDistance, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            PersonDistance.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.personDistances = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonAddressDialogController', PersonAddressDialogController);

    PersonAddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PersonAddress', 'Person', 'Address'];

    function PersonAddressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PersonAddress, Person, Address) {
        var vm = this;

        vm.personAddress = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.people = Person.query();
        vm.addresses = Address.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.personAddress.id !== null) {
                PersonAddress.update(vm.personAddress, onSaveSuccess, onSaveError);
            } else {
                PersonAddress.save(vm.personAddress, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:personAddressUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonAddressDetailController', PersonAddressDetailController);

    PersonAddressDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'PersonAddress', 'Person', 'Address'];

    function PersonAddressDetailController($scope, $rootScope, $stateParams, entity, PersonAddress, Person, Address) {
        var vm = this;

        vm.personAddress = entity;

        var unsubscribe = $rootScope.$on('fleetApp:personAddressUpdate', function(event, result) {
            vm.personAddress = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonAddressDeleteController',PersonAddressDeleteController);

    PersonAddressDeleteController.$inject = ['$uibModalInstance', 'entity', 'PersonAddress'];

    function PersonAddressDeleteController($uibModalInstance, entity, PersonAddress) {
        var vm = this;

        vm.personAddress = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PersonAddress.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('person-address', {
            parent: 'entity',
            url: '/person-address?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.personAddress.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person-address/person-addresses.html',
                    controller: 'PersonAddressController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('personAddress');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('person-address-detail', {
            parent: 'entity',
            url: '/person-address/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.personAddress.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person-address/person-address-detail.html',
                    controller: 'PersonAddressDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('personAddress');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PersonAddress', function($stateParams, PersonAddress) {
                    return PersonAddress.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('person-address.new', {
            parent: 'person-address',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-address/person-address-dialog.html',
                    controller: 'PersonAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                created: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('person-address', null, { reload: true });
                }, function() {
                    $state.go('person-address');
                });
            }]
        })
        .state('person-address.edit', {
            parent: 'person-address',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-address/person-address-dialog.html',
                    controller: 'PersonAddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PersonAddress', function(PersonAddress) {
                            return PersonAddress.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-address', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person-address.delete', {
            parent: 'person-address',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person-address/person-address-delete-dialog.html',
                    controller: 'PersonAddressDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PersonAddress', function(PersonAddress) {
                            return PersonAddress.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person-address', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('PersonAddress', PersonAddress);

    PersonAddress.$inject = ['$resource', 'DateUtils'];

    function PersonAddress ($resource, DateUtils) {
        var resourceUrl =  'api/person-addresses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertDateTimeFromServer(data.created);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonAddressController', PersonAddressController);

    PersonAddressController.$inject = ['$scope', '$state', 'PersonAddress', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PersonAddressController ($scope, $state, PersonAddress, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            PersonAddress.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.personAddresses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDialogController', PersonDialogController);

    PersonDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Person', 'DataUtils'];

    function PersonDialogController ($timeout, $scope, $uibModalInstance, entity, Person, DataUtils) {
        var vm = this;

        vm.person = entity;
        vm.clear = clear;
        vm.save = save;

        var map;
        var marker;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();

            initialize();
            initCloudnary();
        });

        function initCloudnary() {
            // eslint-disable-next-line no-undef
            var myWidget = cloudinary.createUploadWidget(
                {
                    cloudName: "dvzlcxrvw",
                    multiple: false,
                    defaultSource: "local",
                    uploadPreset: "clientes"
                },
                function(error, result) {
                    if (!error && result && result.event === "success") {
                        vm.person.photoUrl = result.info.url;
                        $scope.$apply();
                    }
                }
            );

            // eslint-disable-next-line angular/document-service
            document.getElementById("upload_widget").addEventListener(
                "click",
                function() {
                    myWidget.open();
                },
                false
            );
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.person.id !== null) {
                Person.update(vm.person, onSaveSuccess, onSaveError);
            } else {
                vm.person.companyId = 1; // will be changed at backend
                Person.save(vm.person, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:personUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.setPhoto = function ($file, person) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        person.photo = base64Data;
                        person.photoContentType = $file.type;
                    });
                });
            }
        };

        function initialize() {

            var latLng = new google.maps.LatLng(-10.8665433,10.1956316);
            map = new google.maps.Map(document.getElementById('map'), { center: latLng, zoom: 3 });

            if (vm.person.address.latitude != undefined) {
                latLng = new google.maps.LatLng(vm.person.address.latitude, vm.person.address.longitude);
                map.setCenter(latLng);
                map.setZoom(15);
                createMarker(vm.person.name, latLng);
            } else {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {

                        latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        map.setCenter(latLng);
                        map.setZoom(15);
                        createMarker(vm.person.name, latLng);

                    }, function() {
                        handleLocationError(true, map.getCenter());
                    });
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, map.getCenter());
                }
            }

            addSearchAddressBox();
        }

        function handleLocationError(browserHasGeolocation, pos) {
            var title = browserHasGeolocation ?
                                  'Error: The Geolocation service failed.' :
                                  'Error: Your browser doesn\'t support geolocation.';
             createMarker(title, pos);
        }

        function createMarker(title, location) {

            marker = new google.maps.Marker({position: location, title: title, map: map, draggable:true});
            var infoWindow = new google.maps.InfoWindow({ content: title });

            marker.addListener('click', function() {
                infoWindow.open(map, marker);
            });

            marker.addListener('drag', handleEvent);
            marker.addListener('dragend', handleEvent);
        }

        function handleEvent(event) {
            vm.person.address.latitude = event.latLng.lat();
            vm.person.address.longitude = event.latLng.lng();
            $scope.$apply();
        }

        vm.saveAndUpdateTasks = function() {
            Person.saveAndUpdateTasks(vm.person, onSaveSuccess, onSaveError);
        }

        function addSearchAddressBox() {


            var input = document.getElementById('pac-input');
            var searchBox = new google.maps.places.SearchBox(input);
            map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);

            map.addListener('bounds_changed', function() {
              searchBox.setBounds(map.getBounds());
            });

            var markers = [];
            // Listen for the event fired when the user selects a prediction and retrieve
            // more details for that place.
            searchBox.addListener('places_changed', function() {
              var places = searchBox.getPlaces();

              if (places.length == 0) {
                return;
              }

              // Clear out the old markers.
              markers.forEach(function(marker) {
                marker.setMap(null);
              });
              markers = [];

              // For each place, get the icon, name and location.
              var bounds = new google.maps.LatLngBounds();
              places.forEach(function(place) {
                if (!place.geometry) {
                  console.log("Returned place contains no geometry");
                  return;
                }
                var icon = {
                  url: place.icon,
                  size: new google.maps.Size(71, 71),
                  origin: new google.maps.Point(0, 0),
                  anchor: new google.maps.Point(17, 34),
                  scaledSize: new google.maps.Size(25, 25)
                };

                // Create a marker for each place.
                markers.push(new google.maps.Marker({
                  map: map,
                  icon: icon,
                  title: place.name,
                  position: place.geometry.location
                }));

                // UPDATE MARKER LOCATION
                marker.setPosition(place.geometry.location);
                new google.maps.event.trigger( marker, 'drag' );


                if (place.geometry.viewport) {
                  // Only geocodes have viewport.
                  bounds.union(place.geometry.viewport);
                } else {
                  bounds.extend(place.geometry.location);
                }
              });
              map.fitBounds(bounds);
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDetailController', PersonDetailController);

    PersonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Person', 'Company'];

    function PersonDetailController($scope, $rootScope, $stateParams, entity, Person, Company) {
        var vm = this;

        vm.person = entity;

        var unsubscribe = $rootScope.$on('fleetApp:personUpdate', function(event, result) {
            vm.person = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonDeleteController',PersonDeleteController);

    PersonDeleteController.$inject = ['$uibModalInstance', 'entity', 'Person'];

    function PersonDeleteController($uibModalInstance, entity, Person) {
        var vm = this;

        vm.person = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Person.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var personTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" translate="{{$ctrl.label}}" for="field_person">person</label>' +
            '<div class="input-group">' +
            ' <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ $ctrl.label | translate }}" ' +
            '  uib-typeahead="address as address.name for address in getLocation($viewValue)" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: PersonTypeaheadController,
        bindings: {
            modelId: '=',
            modelLabel: '=',
            label: '<'
        }
    };

    angular
        .module('fleetApp')
        .component('personTypeahead', personTypeahead);

    PersonTypeaheadController.$inject = ['$scope', 'Person', '$http', 'paginationConstants'];

    function PersonTypeaheadController($scope, Person, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.name;
            vm.modelId = model.id;
        }

        $scope.getLocation = function(val) {
            return Person.findByName({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                name: val}).$promise;
        };

        vm.clear = function() {
            vm.modelId = undefined;
            vm.modelLabel = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('person', {
            parent: 'entity',
            url: '/person?page&sort&search&personId',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.person.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person/people.html',
                    controller: 'PersonController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        personId: $stateParams.personId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('person');
                    $translatePartialLoader.addPart('personType');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('address');
                    return $translate.refresh();
                }]
            }
        })
        .state('person-detail', {
            parent: 'entity',
            url: '/person/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.person.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/person/person-detail.html',
                    controller: 'PersonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('person');
                    $translatePartialLoader.addPart('personType');
                    $translatePartialLoader.addPart('address');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Person', function($stateParams, Person) {
                    return Person.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('person.new', {
            parent: 'person',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-dialog.html',
                    controller: 'PersonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                personType: null,
                                federalId: null,
                                name: null,
                                tradeName: null,
                                email: null,
                                alfaId: null,
                                externalId: null,
                                photoUrl: null,
                                phone: null,
                                contact: null,
                                id: null,
                                address: {}
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('person', null, { reload: true });
                }, function() {
                    $state.go('person');
                });
            }]
        })
        .state('person.edit', {
            parent: 'person',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-dialog.html',
                    controller: 'PersonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Person', function(Person) {
                            return Person.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('person.delete', {
            parent: 'person',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-delete-dialog.html',
                    controller: 'PersonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Person', function(Person) {
                            return Person.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('person', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Person', Person);

    Person.$inject = ['$resource'];

    function Person ($resource) {
        var resourceUrl =  'api/person/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'saveAndUpdateTasks': { method: 'POST', url: 'api/person/saveAndUpdateTasks'},
            'geojson': { method:'GET', url:'api/person/geojson', isArray: true},
            'findByName': {
                method: 'GET',
                url: 'api/person/findbyname',
                isArray: true,
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PersonController', PersonController);

    PersonController.$inject = ['$scope', '$state', 'Person', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PersonController ($scope, $state, Person, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.personId = pagingParams.personId;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search = search;
        vm.isLoading = false;

        loadAll();

        function loadAll () {
            vm.isLoading = true;
            Person.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                personName: vm.personName
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.people = data;
                vm.page = pagingParams.page;
                vm.isLoading = false;
            }
        }

        function onError(error) {
            vm.isLoading = false;
            AlertService.error(error.data.message);
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                personId: vm.personId
            });
        }

        function search () {
            loadAll();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OrderDialogController', OrderDialogController);

    OrderDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Order', 'PersonAddress'];

    function OrderDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Order, PersonAddress) {
        var vm = this;

        vm.order = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.order.id !== null) {
                Order.update(vm.order, onSaveSuccess, onSaveError);
            } else {
                Order.save(vm.order, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:orderUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OrderDetailController', OrderDetailController);

    OrderDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Order', 'PersonAddress'];

    function OrderDetailController($scope, $rootScope, $stateParams, entity, Order, PersonAddress) {
        var vm = this;

        vm.order = entity;

        var unsubscribe = $rootScope.$on('fleetApp:orderUpdate', function(event, result) {
            vm.order = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OrderDeleteController',OrderDeleteController);

    OrderDeleteController.$inject = ['$uibModalInstance', 'entity', 'Order'];

    function OrderDeleteController($uibModalInstance, entity, Order) {
        var vm = this;

        vm.order = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Order.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('order', {
            parent: 'entity',
            url: '/order?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.order.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order/orders.html',
                    controller: 'OrderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        personId: $stateParams.personId
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('order');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('order-detail', {
            parent: 'entity',
            url: '/order/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.order.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/order/order-detail.html',
                    controller: 'OrderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('order');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Order', function($stateParams, Order) {
                    return Order.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('order.new', {
            parent: 'order',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order/order-dialog.html',
                    controller: 'OrderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('order', null, { reload: true });
                }, function() {
                    $state.go('order');
                });
            }]
        })
        .state('order.edit', {
            parent: 'order',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order/order-dialog.html',
                    controller: 'OrderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Order', function(Order) {
                            return Order.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('order', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('order.delete', {
            parent: 'order',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/order/order-delete-dialog.html',
                    controller: 'OrderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Order', function(Order) {
                            return Order.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('order', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Order', Order);

    Order.$inject = ['$resource'];

    function Order ($resource) {
        var resourceUrl =  'api/orders/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OrderController', OrderController);

    OrderController.$inject = ['$scope', '$state', 'Order', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrderController ($scope, $state, Order, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.personId = pagingParams.personId;
        vm.transition = transition;
        vm.search = search;

        loadAll();

        function loadAll () {
            Order.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                personId: vm.personId
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.orders = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                personId: vm.personId
            });
        }

        function search () {
            loadAll();
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OfficehoursDialogController', OfficehoursDialogController);

    OfficehoursDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Officehours', 'User', 'Vehicle'];

    function OfficehoursDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Officehours, User, Vehicle) {
        var vm = this;

        vm.officehours = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.vehicles = Vehicle.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.officehours.id !== null) {
                Officehours.update(vm.officehours, onSaveSuccess, onSaveError);
            } else {
                Officehours.save(vm.officehours, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:officehoursUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.datePickerOpenStatus.creation = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        // time picker
        vm.timepickerOptions = {
           readonlyInput: false,
           showMeridian: false
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OfficehoursDetailController', OfficehoursDetailController);

    OfficehoursDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Officehours', 'User', 'Vehicle'];

    function OfficehoursDetailController($scope, $rootScope, $stateParams, entity, Officehours, User, Vehicle) {
        var vm = this;

        vm.officehours = entity;

        var unsubscribe = $rootScope.$on('fleetApp:officehoursUpdate', function(event, result) {
            vm.officehours = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OfficehoursDeleteController',OfficehoursDeleteController);

    OfficehoursDeleteController.$inject = ['$uibModalInstance', 'entity', 'Officehours'];

    function OfficehoursDeleteController($uibModalInstance, entity, Officehours) {
        var vm = this;

        vm.officehours = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Officehours.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('officehours', {
            parent: 'entity',
            url: '/officehours?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.officehours.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/officehours/officehours.html',
                    controller: 'OfficehoursController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officehours');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('officehours-detail', {
            parent: 'entity',
            url: '/officehours/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.officehours.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/officehours/officehours-detail.html',
                    controller: 'OfficehoursDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officehours');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Officehours', function($stateParams, Officehours) {
                    return Officehours.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('officehours.new', {
            parent: 'officehours',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/officehours/officehours-dialog.html',
                    controller: 'OfficehoursDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                startTime: null,
                                endTime: null,
                                creation: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('officehours', null, { reload: true });
                }, function() {
                    $state.go('officehours');
                });
            }]
        })
        .state('officehours.edit', {
            parent: 'officehours',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/officehours/officehours-dialog.html',
                    controller: 'OfficeHourDashboardController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Officehours', function(Officehours) {
                            return Officehours.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('officehours', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('officehours.delete', {
            parent: 'officehours',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/officehours/officehours-delete-dialog.html',
                    controller: 'OfficehoursDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Officehours', function(Officehours) {
                            return Officehours.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('officehours', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Officehours', Officehours);

    Officehours.$inject = ['$resource', 'DateUtils'];

    function Officehours ($resource, DateUtils) {
        var resourceUrl =  'api/officehours/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getAllByItineraryDate': { method: 'GET', url: 'api/officehours/itinerary/:id'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                        data.creation = DateUtils.convertDateTimeFromServer(data.creation);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OfficehoursController', OfficehoursController);

    OfficehoursController.$inject = ['$scope', '$state', 'Officehours', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OfficehoursController ($scope, $state, Officehours, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Officehours.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.officehours = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('OfficeHourDashboardController', OfficeHourDashboardController);

    OfficeHourDashboardController.$inject = ['$scope', '$uibModalInstance', 'entity', '$state', '$stateParams', '$uibModalStack', '$uibModal'];

    function OfficeHourDashboardController ($scope, $uibModalInstance, entity, $state, $stateParams, $modalStack, $uibModal) {
        var vm = this;

        vm.officehours = entity.entries;
        vm.vehicleId = entity.vehicleId;
        vm.vehiclePlate = entity.vehiclePlate;
        vm.driverName = entity.driverName;
        vm.driverId = entity.driverId;

        vm.clear = clear;
        vm.edit = edit;
        vm.del = del;
        vm.add = add;

        function clear () {
            $uibModalInstance.close();
            $uibModalInstance.dismiss('cancel');
            $modalStack.dismissAll('cancel'); // force close duplicated modal
        }

        function edit (id) {
            $state.go('dashboard.officehours-modal.edit', {id: id});
        }

        function del (id) {
            $uibModal.open({
                templateUrl: 'app/entities/officehours/officehours-delete-dialog.html',
                controller: 'OfficehoursDeleteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['Officehours', function(Officehours) {
                        return Officehours.get({id: id}).$promise;
                    }]
                }
            }).result.then(function() {
                clear();
            }, function() {
                clear();
            });
        }

        function add () {
            $uibModal.open({
                templateUrl: 'app/entities/officehours/officehours-dialog.html',
                controller: 'OfficehoursDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            startTime: $stateParams.date,
                            endTime: $stateParams.date,
                            creation: new Date(),
                            id: null,
                            vehicleId: vm.vehicleId,
                            vehiclePlate: vm.vehiclePlate,
                            driverId: vm.driverId,
                            driverFirstName: vm.driverName
                        };
                    }
                }
            }).result.then(function() {
                clear();
            }, function() {
                clear();
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('MessagesDialogController', MessageDialogController);

    MessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Message', 'Device'];

    function MessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Message, Device) {
        var vm = this;

        vm.messages = entity;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('MessageDialogController', MessageDialogController);

    MessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Message', 'Device'];

    function MessageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Message, Device) {
        var vm = this;

        vm.message = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.devices = Device.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.message.id !== null) {
                Message.update(vm.message, onSaveSuccess, onSaveError);
            } else {
                Message.save(vm.message, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:messageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.messageTime = false;
        vm.datePickerOpenStatus.positionTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('MessageDetailController', MessageDetailController);

    MessageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Message', 'Device'];

    function MessageDetailController($scope, $rootScope, $stateParams, entity, Message, Device) {
        var vm = this;

        vm.message = entity;

        var unsubscribe = $rootScope.$on('fleetApp:messageUpdate', function(event, result) {
            vm.message = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('MessageDeleteController',MessageDeleteController);

    MessageDeleteController.$inject = ['$uibModalInstance', 'entity', 'Message'];

    function MessageDeleteController($uibModalInstance, entity, Message) {
        var vm = this;

        vm.message = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Message.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('message', {
            parent: 'entity',
            url: '/message?page&sort&search&date',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.message.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/message/messages.html',
                    controller: 'MessageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                date: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', '$filter', function ($stateParams, PaginationUtil, $filter) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        date: $stateParams.date == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.date,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('message');
                    $translatePartialLoader.addPart('device');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('message-detail', {
            parent: 'entity',
            url: '/message/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.message.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/message/message-detail.html',
                    controller: 'MessageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('message');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Message', function($stateParams, Message) {
                    return Message.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('message.new', {
            parent: 'message',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-dialog.html',
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                messageTime: null,
                                macroNumber: null,
                                text: null,
                                macroJob: null,
                                latitude: null,
                                longitude: null,
                                landmark: null,
                                vehicleIgnition: null,
                                positionTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('message', null, { reload: true });
                }, function() {
                    $state.go('message');
                });
            }]
        })
        .state('message.edit', {
            parent: 'message',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-dialog.html',
                    controller: 'MessageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('message', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('message.delete', {
            parent: 'message',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/message-delete-dialog.html',
                    controller: 'MessageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('message', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Message', Message);

    Message.$inject = ['$resource', 'DateUtils'];

    function Message ($resource, DateUtils) {
        var resourceUrl =  'api/messages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.messageTime = DateUtils.convertDateTimeFromServer(data.messageTime);
                        data.positionTime = DateUtils.convertDateTimeFromServer(data.positionTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'jobAllMessages': { url: 'api/messages/jobAllMessages', method: 'GET' },
            'getAllByItinerary': { url: 'api/messages/itinerary', method: 'GET', isArray: true },
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('MessageController', MessageController);

    MessageController.$inject = ['$filter', '$scope', '$state', 'Message', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DateUtils'];

    function MessageController ($filter, $scope, $state, Message, ParseLinks, AlertService, pagingParams, paginationConstants, DateUtils) {
        var vm = this;

        var dateFormat = 'yyyy-MM-dd';

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.job = job;
        vm.jobAllMessages = jobAllMessages;

        vm.fromDate = DateUtils.convertStringToDate(pagingParams.date);

        loadAll();

        function loadAll () {
            Message.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                fromDate: pagingParams.date,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.messages = data;
                vm.page = pagingParams.page;
                vm.date = pagingParams.date;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                date: vm.date
            });
        }

        function jobAllMessages() {
            Message.jobAllMessages({fromDate: vm.date}, onSuccess, onError);
        }

        function job(id) {
            Message.job({id: id}, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            $scope.$emit('fleetApp:messageUpdate', data);
            loadAll();
        }
        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.onDateChange = function () {
            vm.date = $filter('date')(vm.fromDate, dateFormat);
            transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JobErrorDialogController', JobErrorDialogController);

    JobErrorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'JobError', 'Message'];

    function JobErrorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, JobError, Message) {
        var vm = this;

        vm.jobError = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.messages = Message.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.jobError.id !== null) {
                JobError.update(vm.jobError, onSaveSuccess, onSaveError);
            } else {
                JobError.save(vm.jobError, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:jobErrorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JobErrorDetailController', JobErrorDetailController);

    JobErrorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'JobError', 'Message'];

    function JobErrorDetailController($scope, $rootScope, $stateParams, entity, JobError, Message) {
        var vm = this;

        vm.jobError = entity;

        var unsubscribe = $rootScope.$on('fleetApp:jobErrorUpdate', function(event, result) {
            vm.jobError = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JobErrorDeleteController',JobErrorDeleteController);

    JobErrorDeleteController.$inject = ['$uibModalInstance', 'entity', 'JobError'];

    function JobErrorDeleteController($uibModalInstance, entity, JobError) {
        var vm = this;

        vm.jobError = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            JobError.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('job-error', {
            parent: 'entity',
            url: '/job-error?page&sort&search&date',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.jobError.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/job-error/job-errors.html',
                    controller: 'JobErrorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                date: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', 'DateUtils', function ($stateParams, PaginationUtil, DateUtils) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        date: $stateParams.date == null ? DateUtils.newDateString() : $stateParams.date
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('jobError');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('job-error-detail', {
            parent: 'entity',
            url: '/job-error/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.jobError.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/job-error/job-error-detail.html',
                    controller: 'JobErrorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('jobError');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'JobError', function($stateParams, JobError) {
                    return JobError.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('job-error.new', {
            parent: 'job-error',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job-error/job-error-dialog.html',
                    controller: 'JobErrorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                creationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('job-error', null, { reload: true });
                }, function() {
                    $state.go('job-error');
                });
            }]
        })
        .state('job-error.edit', {
            parent: 'job-error',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job-error/job-error-dialog.html',
                    controller: 'JobErrorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['JobError', function(JobError) {
                            return JobError.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job-error', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('job-error.delete', {
            parent: 'job-error',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/job-error/job-error-delete-dialog.html',
                    controller: 'JobErrorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['JobError', function(JobError) {
                            return JobError.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('job-error', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('JobError', JobError);

    JobError.$inject = ['$resource', 'DateUtils'];

    function JobError ($resource, DateUtils) {
        var resourceUrl =  'api/job-errors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JobErrorController', JobErrorController);

    JobErrorController.$inject = ['$scope', '$state', 'JobError', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'DateUtils'];

    function JobErrorController ($scope, $state, JobError, ParseLinks, AlertService, pagingParams, paginationConstants, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.fromDate = DateUtils.convertStringToDate(pagingParams.date);

        loadAll();

        function loadAll () {
            JobError.query({
                fromDate: pagingParams.date,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.jobErrors = data;
                vm.page = pagingParams.page;
                vm.date = pagingParams.date;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                date: DateUtils.convertLocalDateToServer(vm.fromDate),
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ItineraryDialogController', ItineraryDialogController);

    ItineraryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Itinerary', 'Invoice',
    'AlertService', 'DateUtils'];

    function ItineraryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Itinerary, Invoice, AlertService,
        DateUtils) {
        var vm = this;

        vm.itinerary = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.itinerary.id !== null) {
                Itinerary.update(vm.itinerary, onSaveSuccess, onSaveError);
            } else {
                Itinerary.save(vm.itinerary, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:itineraryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError (error) {
            vm.isSaving = false;
            AlertService.error(error.data.message);
        }

        vm.isOpen = function(id) {
            return vm.datePickerOpenStatus[id];
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.plannedDate = false;
        vm.datePickerOpenStatus.startTime = false;
        vm.datePickerOpenStatus.endTime = false;
        vm.datePickerOpenStatus.firstTimeIn = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.removeTask = function(index) {
            vm.itinerary.tasks.splice(index, 1);
        }

        vm.addTask = function(taskType) {
            var dt = DateUtils.utcNow();
            vm.itinerary.tasks.push({taskType: taskType,
                firstTimeIn: dt,
                lastTimeOut: dt,
                servicesNumber: [],
                ordersNumber: []});
        }

        // time picker
        vm.timepickerOptions = {
           readonlyInput: false,
           showMeridian: false
        };

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ItineraryDetailController', ItineraryDetailController);

    ItineraryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Itinerary', 'Vehicle', 'User', 'Task', 'Company'];

    function ItineraryDetailController($scope, $rootScope, $stateParams, entity, Itinerary, Vehicle, User, Task, Company) {
        var vm = this;

        vm.itinerary = entity;

        var unsubscribe = $rootScope.$on('fleetApp:itineraryUpdate', function(event, result) {
            vm.itinerary = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ItineraryDeleteController',ItineraryDeleteController);

    ItineraryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Itinerary'];

    function ItineraryDeleteController($uibModalInstance, entity, Itinerary) {
        var vm = this;

        vm.itinerary = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Itinerary.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('itinerary', {
            parent: 'entity',
            url: '/itinerary?page&sort&search&date',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.itinerary.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/itinerary/itineraries.html',
                    controller: 'ItineraryController',
                    controllerAs: 'vm'
                }
            },
            params:  {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    date: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', '$filter', function ($stateParams, PaginationUtil, $filter) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        date: $stateParams.date == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.date
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('itinerary');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('itinerary-detail', {
            parent: 'entity',
            url: '/itinerary/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.itinerary.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/itinerary/itinerary-detail.html',
                    controller: 'ItineraryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('itinerary');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Itinerary', function($stateParams, Itinerary) {
                    return Itinerary.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('itinerary.new', {
            parent: 'itinerary',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'DateUtil', function($stateParams, $state, $uibModal, DateUtil) {
                $uibModal.open({
                    templateUrl: 'app/entities/itinerary/itinerary-dialog.html',
                    controller: 'ItineraryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            var dt = DateUtil.utcNow();
                            return {
                                creationDate: null,
                                plannedDate: dt,
                                number: null,
                                startTime: dt,
                                endTime: dt,
                                startOdometer: null,
                                endOdometer: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('itinerary', null, { reload: true });
                }, function() {
                    $state.go('itinerary');
                });
            }]
        })
        .state('itinerary.edit', {
            parent: 'itinerary',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/itinerary/itinerary-dialog.html',
                    controller: 'ItineraryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Itinerary', function(Itinerary) {
                            return Itinerary.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('itinerary', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('itinerary.delete', {
            parent: 'itinerary',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/itinerary/itinerary-delete-dialog.html',
                    controller: 'ItineraryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Itinerary', function(Itinerary) {
                            return Itinerary.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('itinerary', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('itinerary-messages', {
            parent: 'itinerary',
            url: '/{id}/messages',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/messages-dialog.html',
                    controller: 'MessagesDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.getAllByItinerary({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('message');
                    return $translate.refresh();
                }]
            }
        })
        .state('tasks', {
            parent: 'itinerary',
            url: '/{id}/tasks',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/itinerary-task-dialog.html',
                    controller: 'ItineraryTaskDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.getAllByItinerary({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('taskType');
                    $translatePartialLoader.addPart('taskStatus');
                    $translatePartialLoader.addPart('address');
                    $translatePartialLoader.addPart('visit');
                    $translatePartialLoader.addPart('invoice');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Itinerary', Itinerary);

    Itinerary.$inject = ['$resource', 'DateUtils', 'ImageService'];

    function Itinerary ($resource, DateUtils, ImageService) {
        var resourceUrl =  'api/itineraries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true,
                transformResponse: function (data, headersGetter, status) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (status == 200) {
                            var models = [];
                            angular.forEach(data, function(item) {
                                item.creationDate = DateUtils.convertDateTimeFromServer(item.creationDate);
                                item.plannedDate = DateUtils.convertDateTimeFromServer(item.plannedDate);
                                item.startTime = DateUtils.convertDateTimeFromServer(item.startTime);
                                item.endTime = DateUtils.convertDateTimeFromServer(item.endTime);
                                item.plannedDate = DateUtils.convertDateTimeFromServer(item.plannedDate);
                                models.push(item);
                            });
                            return models;
                        }
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.plannedDate = DateUtils.convertDateTimeFromServer(data.plannedDate);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                        angular.forEach(data.tasks, function(task) {
                            task.firstTimeIn = DateUtils.convertDateTimeFromServer(task.firstTimeIn);
                            task.lastTimeOut = DateUtils.convertDateTimeFromServer(task.lastTimeOut);
                        });
                    }
                    return data;
                }
            },
            'dashboardlist': {
                method: 'GET', isArray: true,
                url: 'api/itineraries/dashboardlist',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.positionTime = DateUtils.convertDateTimeFromServer(data.positionTime);
                    }
                    return data;
                }
            },
            'graphlist': {
                method: 'GET', isArray: true,
                url: 'api/itineraries/graphlist',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        angular.forEach(data, function(groupItem) {
                            if (groupItem) {
                                groupItem.vehiclePhotoUrl = ImageService.thumbnail(groupItem.vehiclePhotoUrl);
                                angular.forEach(groupItem.itineraries, function(item) {
                                    item.startTime = DateUtils.convertDateTimeFromServer(item.startTime);
                                    item.endTime   = DateUtils.convertDateTimeFromServer(item.endTime);
                                    item.spentTime = DateUtils.convertMinutesToDisplay(item.spentTime);
                                    angular.forEach(item.tasks, function(task) {
                                        task.spentTime = DateUtils.convertMinutesToDisplay(task.spentTime);
                                    });
                                });
                            }
                        });
                    }
                    return data;
                }
            },
            'geojson': {
                method: 'GET',
                url: '/api/itineraries/geojson/:id'
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ItineraryController', ItineraryController);

    ItineraryController.$inject = ['$scope', '$state', 'Itinerary', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$filter',
     'DateUtils'];

    function ItineraryController ($scope, $state, Itinerary, ParseLinks, AlertService, pagingParams, paginationConstants, $filter, DateUtils) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        vm.fromDate = DateUtils.convertStringToDate(pagingParams.date);

        loadAll();

        function loadAll () {
            Itinerary.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                date: pagingParams.date,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.itineraries = data;
                vm.page = pagingParams.page;
                vm.date = pagingParams.date;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                date: vm.date
            });
        }

        vm.onDateChange = function () {
            vm.date = $filter('date')(vm.fromDate, 'yyyy-MM-dd');
            transition();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceItemsDialogController', InvoiceItemsDialogController);

    InvoiceItemsDialogController.$inject = ['$scope', '$state', 'entity', '$uibModalInstance'];

    function InvoiceItemsDialogController ($scope, $state, entity, $uibModalInstance) {
        var vm = this;

        vm.invoiceItems = entity;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceItemDialogController', InvoiceItemDialogController);

    InvoiceItemDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InvoiceItem', 'Product', 'Invoice'];

    function InvoiceItemDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InvoiceItem, Product, Invoice) {
        var vm = this;

        vm.invoiceItem = entity;
        vm.clear = clear;
        vm.save = save;
        vm.products = Product.query();
        vm.invoices = Invoice.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoiceItem.id !== null) {
                InvoiceItem.update(vm.invoiceItem, onSaveSuccess, onSaveError);
            } else {
                InvoiceItem.save(vm.invoiceItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:invoiceItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceItemDetailController', InvoiceItemDetailController);

    InvoiceItemDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'InvoiceItem', 'Product', 'Invoice'];

    function InvoiceItemDetailController($scope, $rootScope, $stateParams, entity, InvoiceItem, Product, Invoice) {
        var vm = this;

        vm.invoiceItem = entity;

        var unsubscribe = $rootScope.$on('fleetApp:invoiceItemUpdate', function(event, result) {
            vm.invoiceItem = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceItemDeleteController',InvoiceItemDeleteController);

    InvoiceItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'InvoiceItem'];

    function InvoiceItemDeleteController($uibModalInstance, entity, InvoiceItem) {
        var vm = this;

        vm.invoiceItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InvoiceItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var invoiceItem = {
        templateUrl: 'app/entities/invoice-item/invoice-item-create.component.html',
        controller: InvoiceItemCreate,
        bindings: {
            itens: '=',
            item: '='
        }
    };

    angular
        .module('fleetApp')
        .component('invoiceItemCreate', invoiceItem);

    InvoiceItemCreate.$inject = ['$scope', 'Itinerary', '$http', 'AlertService', '$state', '$uibModal'];

    function InvoiceItemCreate($scope, Itinerary, $http, AlertService, $state, $uibModal) {
        var vm = this;

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.getTotal = function() {
            vm.total = [];
            angular.forEach(vm.itens, function(item) {
                vm.total.push(item.total);
            });
        }
        vm.getTotal();

        vm.getLineClass = function(invoiceItem) {
            if (invoiceItem.refusedReasonId > 0)
                return 'text-red';
            else
                return '';
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice-item', {
            parent: 'entity',
            url: '/invoice-item?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.invoiceItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-item/invoice-items.html',
                    controller: 'InvoiceItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoiceItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice-item-detail', {
            parent: 'entity',
            url: '/invoice-item/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.invoiceItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice-item/invoice-item-detail.html',
                    controller: 'InvoiceItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoiceItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InvoiceItem', function($stateParams, InvoiceItem) {
                    return InvoiceItem.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('invoice-item.new', {
            parent: 'invoice-item',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-item/invoice-item-dialog.html',
                    controller: 'InvoiceItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                pricePerUnit: null,
                                total: null,
                                discountPercent: null,
                                discount: null,
                                size: null,
                                unityType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('invoice-item', null, { reload: true });
                }, function() {
                    $state.go('invoice-item');
                });
            }]
        })
        .state('invoice-item.edit', {
            parent: 'invoice-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-item/invoice-item-dialog.html',
                    controller: 'InvoiceItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InvoiceItem', function(InvoiceItem) {
                            return InvoiceItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice-item.delete', {
            parent: 'invoice-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice-item/invoice-item-delete-dialog.html',
                    controller: 'InvoiceItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InvoiceItem', function(InvoiceItem) {
                            return InvoiceItem.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('InvoiceItem', InvoiceItem);

    InvoiceItem.$inject = ['$resource'];

    function InvoiceItem ($resource) {
        var resourceUrl =  'api/invoice-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getInvoiceItens': {
                method: 'GET', isArray: true,
                url: 'api/invoice-items/task/:taskid',
                transformResponse: function (data, headersGetter, status) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceItemController', InvoiceItemController);

    InvoiceItemController.$inject = ['$scope', '$state', 'InvoiceItem', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InvoiceItemController ($scope, $state, InvoiceItem, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            InvoiceItem.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoiceItems = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    var invoiceItem = {
        templateUrl: 'app/entities/invoice-item/invoice-item.component.html',
        controller: InvoiceItem,
        bindings: {
            itens: '<'
        }
    };

    angular
        .module('fleetApp')
        .component('invoiceItem', invoiceItem);

    InvoiceItem.$inject = ['$scope', 'Itinerary', '$http', 'AlertService', '$state', '$uibModal'];

    function InvoiceItem($scope, Itinerary, $http, AlertService, $state, $uibModal) {
        var vm = this;

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.getTotal = function() {
            vm.total = [];
            angular.forEach(vm.itens, function(item) {
                vm.total.push(item.total);
            });
        }
        vm.getTotal();

        vm.getLineClass = function(invoiceItem) {
            if (invoiceItem.refusedReasonId > 0)
                return 'text-red';
            else
                return '';
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceDialogController', InvoiceDialogController);

    InvoiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Invoice', 'PersonAddress',
    'InvoiceItem', 'Task', 'RefusedReason', 'Order'];

    function InvoiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Invoice, PersonAddress, InvoiceItem, Task,
    RefusedReason, Order) {
        var vm = this;

        vm.invoice = entity;
        vm.invoice.createOrderIfNotExists = true
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        //vm.refusedreasons = RefusedReason.query();

        if (!vm.invoice.items) {
            vm.invoice.items = [{}];
        }


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.invoice.id !== null) {
                Invoice.update(vm.invoice, onSaveSuccess, onSaveError);
            } else {
                Invoice.save(vm.invoice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:invoiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceDetailController', InvoiceDetailController);

    InvoiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Invoice', 'PersonAddress', 'InvoiceItem', 'Task', 'RefusedReason'];

    function InvoiceDetailController($scope, $rootScope, $stateParams, entity, Invoice, PersonAddress, InvoiceItem, Task, RefusedReason) {
        var vm = this;

        vm.invoice = entity;

        var unsubscribe = $rootScope.$on('fleetApp:invoiceUpdate', function(event, result) {
            vm.invoice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceDeleteController',InvoiceDeleteController);

    InvoiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Invoice'];

    function InvoiceDeleteController($uibModalInstance, entity, Invoice) {
        var vm = this;

        vm.invoice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Invoice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('invoice', {
            parent: 'entity',
            url: '/invoice?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.invoice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoices.html',
                    controller: 'InvoiceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('invoiceItem');
                    $translatePartialLoader.addPart('invoiceStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('invoice-detail', {
            parent: 'entity',
            url: '/invoice/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.invoice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/invoice/invoice-detail.html',
                    controller: 'InvoiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('invoice');
                    $translatePartialLoader.addPart('invoiceStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Invoice', function($stateParams, Invoice) {
                    return Invoice.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('invoice.new', {
            parent: 'invoice',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                number: null,
                                date: moment().toDate(),
                                invoiceStatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: true });
                }, function() {
                    $state.go('invoice');
                });
            }]
        })
        .state('invoice.edit', {
            parent: 'invoice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-dialog.html',
                    controller: 'InvoiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('invoice.delete', {
            parent: 'invoice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/invoice/invoice-delete-dialog.html',
                    controller: 'InvoiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Invoice', function(Invoice) {
                            return Invoice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('invoice', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Invoice', Invoice);

    Invoice.$inject = ['$resource', 'DateUtils'];

    function Invoice ($resource, DateUtils) {
        var resourceUrl =  'api/invoices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(data);
                }
            },
            'personbyservicenumber': {
                method: 'GET',
                url: 'api/invoices/personbyservicenumber/:serviceNumber'
            },
            'personbyordernumber': {
                method: 'GET',
                url: 'api/invoices/personbyordernumber/:orderNumber'
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('InvoiceController', InvoiceController);

    InvoiceController.$inject = ['$scope', '$state', 'Invoice', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function InvoiceController ($scope, $state, Invoice, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Invoice.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.invoices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    var geomap = {
        templateUrl: 'app/entities/geomap/geomap.template.html',
        controller: GeomapController,
        bindings: {
            autoHeight: '@' // title hide when true
        }
    };

    angular
        .module('fleetApp')
        // This component can be used like: <geomap></geomap>
        .component('geomap', geomap);

    GeomapController.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$uibModal', 'ImageService'];

    function GeomapController($rootScope, $scope, $state, $timeout, $uibModal, ImageService) {

        var vm = this;

        var mbAttr = 'Map data &copy; <a href=\"http://openstreetmap.org\">OpenStreetMap</a> contributors, <a href=\"http://creativecommons.org/licenses/by-sa/2.0/\">CC-BY-SA</a>, Imagery © <a href=\"http://mapbox.com\">Mapbox</a>';
        //var mbUrl = 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}';
        var mbUrl = 'https://api.mapbox.com/styles/v1/iuricmp/ckmlabufsfxje17o7dy0nabgb.html?title=view&access_token=pk.eyJ1IjoiaXVyaWNtcCIsImEiOiJjbHdmZm41bmQxNTFmMmpwbjJlOHB5cGJxIn0.0B8wSxMewPXErMxDtJDKNA&zoomwheel=true&fresh=true#7.95/-22.36/-42.948'


        var layer1 = L.tileLayer(mbUrl, {
            attribution: mbAttr,
            maxZoom: 17,
            id: 'mapbox.streets',
            detectRetina: true,
            accessToken: 'pk.eyJ1IjoiaXVyaWNtcCIsImEiOiJjbHdmZm41bmQxNTFmMmpwbjJlOHB5cGJxIn0.0B8wSxMewPXErMxDtJDKNA'
        });

        var mapJson = $rootScope.initialLocation ? $rootScope.initialLocation : { center: [-22.5410, -43.1227], zoom: 9 };
        mapJson['layers'] = [layer1];
        var myMap = L.map('mapid', mapJson);

        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
             attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
           }).addTo(myMap);

         var baseLayers = {
                   "Streets 1": layer1,
               };
               L.control.layers(baseLayers).addTo(myMap);

        function invalidateSize () {
            if (vm.autoHeight) {
                setTimeout(function(){
                        $("#mapid").height($(window).height() - $('.main-header').height() - $('#vehicle-history').height() );
                        $(".content-map").css('padding-left', $('.main-sidebar').width());
                        myMap.invalidateSize();
                    }, 200);
            }
            myMap.invalidateSize();
        }

        invalidateSize();

        $rootScope.$on('invalidateMapSize', function () {
            invalidateSize();
        });

        var vehicleIcon = L.BeautifyIcon.icon({icon: 'truck', borderColor: '#0066a2', backgroundColor: '#0066a2', textColor: 'white', iconShape:
        'marker'});
        var redMarker = L.BeautifyIcon.icon({icon: 'power-off', borderColor: 'red', textColor: 'red', backgroundColor: 'transparent'});
        var speedMarker = L.BeautifyIcon.icon({icon: 'rocket', borderColor: 'yellow', textColor: 'yellow', backgroundColor: 'transparent'});

        var engineAndSpeedLayerGroup;

        var polyline = L.markerClusterGroup();
        var vehicleMarkers = L.markerClusterGroup({
                                        maxClusterRadius: 120,
                                        iconCreateFunction: function (cluster) {
                                            var markers = cluster.getAllChildMarkers();
                                            var n = markers.length;
                                            return L.divIcon({ html: n, className: 'vehicle-cluster',iconSize : L.icon({}) });
                                        },
                                        //Disable all of the defaults:
                                        spiderfyOnMaxZoom: true, showCoverageOnHover: false, zoomToBoundsOnClick: true
                                    });

        var tasksMarkers = L.markerClusterGroup({
                                         iconCreateFunction: function (cluster) {
                                             var markers = cluster.getAllChildMarkers();
                                             var n = markers.length;
                                             return L.divIcon({ html: n, className: 'delivery-cluster',iconSize : L.icon({}) });
                                         },
                                         //Disable all of the defaults:
                                         spiderfyOnMaxZoom: true, showCoverageOnHover: false, zoomToBoundsOnClick: true
                                     });

		tasksMarkers.on('clusterclick', function (a) {
			a.layer.zoomToBounds();
		});

        function clearMap() {
            vehicleMarkers.clearLayers();
            tasksMarkers.clearLayers();
            if (engineAndSpeedLayerGroup) engineAndSpeedLayerGroup.remove();
        }

        vm.selectVehicle = function(vehicle) {
            vm.map.center = {latitude: vehicle.latitude, longitude: vehicle.longitude};
            vm.map.zoom = 13;
        };

        $scope.$on("clearMap", function(evt){
            clearMap();
        });

        $scope.$on("showOnMapEvent", function(evt, data){

            invalidateSize();

            angular.forEach(data.data, function(v) {
                addVehicleToLayer(v);
            });

            myMap.addLayer(vehicleMarkers);

            if (data.fitBounds) {
                myMap.fitBounds(vehicleMarkers.getBounds());
            }
        });

        function vehicleTooltipTemplate(v) {
            var dt = v.deviceTime ? moment(v.deviceTime) : null;
            var dtStr = dt ? dt.utc().format('DD/MM/YYYY HH:mm') : '-';
            var avatarUrl = ImageService.thumbnail(v.vehiclePhotoUrl);
            var avatar = avatarUrl ? ("<img class='img-circle' src='" + avatarUrl +"' alt='Vehicle Avatar'>") : "";
            return (
                "<div class='widget-user-2'> " +
                " <div class='widget-user-header'> " +
                "  <div class='widget-user-image'> " +
                     avatar +
                "  </div>  " +
                "  <h3 class='widget-user-username'>" + v.vehiclePlate + "</h3>  " +
                "  <h5 class='widget-user-desc' ng-if='v.vehicleTypeName'>" + v.vehicleTypeName + "</h5>  " +
                " </div> " +
                " <div class='box-footer no-padding'> " +
                "  <div class='box-footer no-padding'>" +
                "      <ul class='nav nav-stacked'>" +
                "          <li><a>Latitude <span class='pull-right'>" + v.latitude + "</span></a></li>" +
                "          <li><a>Longitude <span class='pull-right'>" + v.longitude + "</span></a></li>" +
                "          <li><a>Hora <span class='pull-right'>" + (dtStr ? dtStr : '-') + "</span></a></li>" +
                "          <li><a>Velocidade <span class='pull-right'>" + (v.speed ? v.speed : '-') + "</span></a></li>" +
                "          <li><a>Ignição <span class='pull-right'>" + (v.vehicleIgnition ? v.vehicleIgnition : '-') + "</span></a></li>" +
                "          <li><a>Precisão <span class='pull-right'>Entre 10 e 50 metros</span></a></li>" +
                "      </ul>" +
                "   </div>" +
                " </div>" +
                "</div>"
                );
        }

        // specify popup options
        var customOptions = { 'className' : 'leafPopup', autoPan: true, keepInView: true };

        function addVehicleToLayer(v) {
            var marker = L.marker([v.latitude, v.longitude], {icon: vehicleIcon, id: v.vehicleId});
            marker.bindTooltip(v.vehiclePlate);
            marker.bindPopup(vehicleTooltipTemplate(v), customOptions);

            vehicleMarkers.addLayer(marker);
            return marker;
        }

        $scope.$on("onVehicleClickEvent", function(evt, vehicle){
            myMap.setView([vehicle.latitude, vehicle.longitude], 17);
            var marker = addVehicleToLayer(vehicle);
            marker.openPopup();
        });

        $scope.$on('onItineraryClickEvent', function(evt, data) {
            selectItinerary(data.data, data.fitBounds);
        });


        $scope.$on('showPositions', function(evt, data) {

            engineAndSpeedLayerGroup = L.featureGroup();

            var latLongs = [];

            angular.forEach(data.positions, function(position) {
                if (position.vehicleIgnition == 0) {
                    var dt = moment(position.deviceTime);
                    var str = 'Engine OFF: ' + dt.utc().format('HH:mm');
                    engineAndSpeedLayerGroup.addLayer(L.marker([position.latitude, position.longitude], {icon: redMarker}).bindTooltip(str));
                }
                if (position.speed > 111) {
                    engineAndSpeedLayerGroup.addLayer(L.marker([position.latitude, position.longitude], {icon: speedMarker})
                        .bindTooltip('Speed: ' + parseFloat(position.speed).toFixed(0) + ' km/h'));
                }
                latLongs.push([position.latitude, position.longitude]);
            });
            latLongs.reverse();

            var lineColor = '#0052cc';
            polyline = L.polyline(latLongs, {color: lineColor});
            // --- Simple arrow ---
            var polylineDecorator = L.polylineDecorator(polyline, {
                patterns: [
                    {offset: 25, repeat: 100, symbol: L.Symbol.arrowHead({pixelSize: 10, pathOptions: {color: lineColor, fillOpacity: 1, weight: 0}})
                    },
                    { offset: 12, repeat: 25, symbol: L.Symbol.dash({pixelSize: 10, pathOptions: {color: lineColor, weight: 1}}) },
                    { offset: 0, repeat: 25, symbol: L.Symbol.dash({pixelSize: 0, pathOptions: {color: lineColor} }) }
                ]
            });
            engineAndSpeedLayerGroup.addLayer(polylineDecorator);
            myMap.addLayer(engineAndSpeedLayerGroup);

            if (data.fitBounds && latLongs.length > 1) {
                //myMap.fitBounds(polyline.getBounds(), {padding: [50, 50]});
                vm.fitBounds();
            }
        });

        vm.onTaskClicked = function (marker) {
//            $state.go('home.itineraries.task', {id: marker.model.id});

            var taskId =  marker.target.options.id;

            $uibModal.open({
                templateUrl: 'app/entities/task/task-dialog-detail.html',
                controller: 'TaskDialogDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Task', function(Task) {
                        return Task.get({id : taskId}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('task');
                        $translatePartialLoader.addPart('taskType');
                        $translatePartialLoader.addPart('taskStatus');
                        $translatePartialLoader.addPart('taskEvent');
                        $translatePartialLoader.addPart('taskEventType');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function() {
//                    $state.go('^', null, { reload: false });
            }, function() {
//                    $state.go('^');
            });
        }

        vm.fitBounds = function() {
            var bounds = [];
            bounds.push(vehicleMarkers.getBounds());
            bounds.push(polyline.getBounds());
            bounds.push(tasksMarkers.getBounds());
            myMap.fitBounds(bounds, {padding: [50, 50]});
        }

        function selectItinerary(data, fitBounds) {
            vm.tasks = [];

            if (data == undefined) return;

            angular.forEach(data.tasks, function(taskItem) {
                for (var i=0; i < vm.tasks.length; i++) {
                    var existingMarker = vm.tasks[i];
                    //if a marker already exists in the same position as this marker
                    if (existingMarker.latitude == taskItem.latitude && existingMarker.longitude == taskItem.longitude) {
                        //update the position of the coincident marker by applying a small multipler to its coordinates
                        taskItem.latitude = taskItem.latitude + (Math.random() -.5) / 2500;// * (Math.random() * (max - min) + min);
                        taskItem.longitude = taskItem.longitude + (Math.random() -.5) / 2500;// * (Math.random() * (max - min) + min);
                    }
                }

                var icon = 'content/images/i_delivery.png';
                var popupHtml = '';
                switch(taskItem.taskStatus) {
                    case 'COMPLETED':
                        icon = 'content/images/i_delivery_green.png';
                        break;
                    case 'REJECTED': icon = 'content/images/i_delivery_red.png'; break;
                    case 'PARTIALLY_DONE': icon = 'content/images/i_delivery_partial.png'; break;
                    case 'IN_PROGRESS': icon = 'content/images/i_delivering.png'; break;
                }

                var deliveryIcon = L.icon({ iconUrl: icon });
                var marker = L.marker([taskItem.latitude, taskItem.longitude], {icon: deliveryIcon, id: taskItem.id})
                    .bindTooltip(taskItem.name);

                marker.on('click', function(e) {
                    vm.onTaskClicked(e);
                });

                tasksMarkers.addLayer(marker);

            });

            if (data.vehicleLastPosition) {
                addVehicleToLayer(data.vehicleLastPosition);
            }

            myMap.addLayer(tasksMarkers);
            myMap.addLayer(vehicleMarkers);

            if (fitBounds) {
                vm.fitBounds();
            }
        };


    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('fullscreen', function() {
             return function (scope, element, attrs) {
                    var window_height = $(window).height(),
                    header_height = $(".navbar-header").height(),
                    footer_height = $('.main-footer').height();
                    footer_height = footer_height == null ? 0 : footer_height;
                    element.css("height", window_height - header_height - footer_height - 30);
             }
         });
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetPreferenceDialogController', FleetPreferenceDialogController);

    FleetPreferenceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FleetPreference', 'Company'];

    function FleetPreferenceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FleetPreference, Company) {
        var vm = this;

        vm.fleetPreference = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fleetPreference.id !== null) {
                FleetPreference.update(vm.fleetPreference, onSaveSuccess, onSaveError);
            } else {
                FleetPreference.save(vm.fleetPreference, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:fleetPreferenceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetPreferenceDetailController', FleetPreferenceDetailController);

    FleetPreferenceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FleetPreference', 'Company'];

    function FleetPreferenceDetailController($scope, $rootScope, $stateParams, entity, FleetPreference, Company) {
        var vm = this;

        vm.fleetPreference = entity;

        var unsubscribe = $rootScope.$on('fleetApp:fleetPreferenceUpdate', function(event, result) {
            vm.fleetPreference = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetPreferenceDeleteController',FleetPreferenceDeleteController);

    FleetPreferenceDeleteController.$inject = ['$uibModalInstance', 'entity', 'FleetPreference'];

    function FleetPreferenceDeleteController($uibModalInstance, entity, FleetPreference) {
        var vm = this;

        vm.fleetPreference = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FleetPreference.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fleet-preference', {
            parent: 'entity',
            url: '/fleet-preference?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.fleetPreference.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fleet-preference/fleet-preferences.html',
                    controller: 'FleetPreferenceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fleetPreference');
                    $translatePartialLoader.addPart('fleetPreferenceType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fleet-preference-detail', {
            parent: 'entity',
            url: '/fleet-preference/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.fleetPreference.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fleet-preference/fleet-preference-detail.html',
                    controller: 'FleetPreferenceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fleetPreference');
                    $translatePartialLoader.addPart('fleetPreferenceType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FleetPreference', function($stateParams, FleetPreference) {
                    return FleetPreference.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('fleet-preference.new', {
            parent: 'fleet-preference',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-preference/fleet-preference-dialog.html',
                    controller: 'FleetPreferenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fleetPreferenceType: null,
                                fieldValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fleet-preference', null, { reload: true });
                }, function() {
                    $state.go('fleet-preference');
                });
            }]
        })
        .state('fleet-preference.edit', {
            parent: 'fleet-preference',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-preference/fleet-preference-dialog.html',
                    controller: 'FleetPreferenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FleetPreference', function(FleetPreference) {
                            return FleetPreference.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-preference', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fleet-preference.delete', {
            parent: 'fleet-preference',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-preference/fleet-preference-delete-dialog.html',
                    controller: 'FleetPreferenceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FleetPreference', function(FleetPreference) {
                            return FleetPreference.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-preference', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('FleetPreference', FleetPreference);

    FleetPreference.$inject = ['$resource'];

    function FleetPreference ($resource) {
        var resourceUrl =  'api/fleet-preferences/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetPreferenceController', FleetPreferenceController);

    FleetPreferenceController.$inject = ['$scope', '$state', 'FleetPreference', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FleetPreferenceController ($scope, $state, FleetPreference, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            FleetPreference.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fleetPreferences = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetMediaDialogController', FleetMediaDialogController);

    FleetMediaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FleetMedia', 'User', 'Task'];

    function FleetMediaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FleetMedia, User, Task) {
        var vm = this;

        vm.fleetMedia = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.users = User.query();
        vm.tasks = Task.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fleetMedia.id !== null) {
                FleetMedia.update(vm.fleetMedia, onSaveSuccess, onSaveError);
            } else {
                FleetMedia.save(vm.fleetMedia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:fleetMediaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetMediaDetailController', FleetMediaDetailController);

    FleetMediaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'FleetMedia', 'User', 'Task'];

    function FleetMediaDetailController($scope, $rootScope, $stateParams, entity, FleetMedia, User, Task) {
        var vm = this;

        vm.fleetMedia = entity;

        var unsubscribe = $rootScope.$on('fleetApp:fleetMediaUpdate', function(event, result) {
            vm.fleetMedia = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetMediaDeleteController',FleetMediaDeleteController);

    FleetMediaDeleteController.$inject = ['$uibModalInstance', 'entity', 'FleetMedia'];

    function FleetMediaDeleteController($uibModalInstance, entity, FleetMedia) {
        var vm = this;

        vm.fleetMedia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FleetMedia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('fleet-media', {
            parent: 'entity',
            url: '/fleet-media?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.fleetMedia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fleet-media/fleet-medias.html',
                    controller: 'FleetMediaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fleetMedia');
                    $translatePartialLoader.addPart('mediaType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('fleet-media-detail', {
            parent: 'entity',
            url: '/fleet-media/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.fleetMedia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/fleet-media/fleet-media-detail.html',
                    controller: 'FleetMediaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fleetMedia');
                    $translatePartialLoader.addPart('mediaType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FleetMedia', function($stateParams, FleetMedia) {
                    return FleetMedia.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('fleet-media.new', {
            parent: 'fleet-media',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-media/fleet-media-dialog.html',
                    controller: 'FleetMediaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                externalId: null,
                                url: null,
                                mediaType: null,
                                creationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('fleet-media', null, { reload: true });
                }, function() {
                    $state.go('fleet-media');
                });
            }]
        })
        .state('fleet-media.edit', {
            parent: 'fleet-media',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-media/fleet-media-dialog.html',
                    controller: 'FleetMediaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FleetMedia', function(FleetMedia) {
                            return FleetMedia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-media', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('fleet-media.delete', {
            parent: 'fleet-media',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/fleet-media/fleet-media-delete-dialog.html',
                    controller: 'FleetMediaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FleetMedia', function(FleetMedia) {
                            return FleetMedia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('fleet-media', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('FleetMedia', FleetMedia);

    FleetMedia.$inject = ['$resource', 'DateUtils'];

    function FleetMedia ($resource, DateUtils) {
        var resourceUrl =  'api/fleet-medias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('FleetMediaController', FleetMediaController);

    FleetMediaController.$inject = ['$scope', '$state', 'FleetMedia', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', '$window'];

    function FleetMediaController ($scope, $state, FleetMedia, ParseLinks, AlertService, pagingParams, paginationConstants, $window) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            FleetMedia.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.fleetMedias = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        vm.openImage = function(imageUrl) {
            $window.open(imageUrl.replace(/"/g, ''), "_blank");
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ExpenseDialogController', ExpenseDialogController);

    ExpenseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Expense'];

    function ExpenseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Expense) {
        var vm = this;

        vm.expense = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.expense.id !== null) {
                Expense.update(vm.expense, onSaveSuccess, onSaveError);
            } else {
                Expense.save(vm.expense, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:expenseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creation = false;
        vm.datePickerOpenStatus.expenseDate = false;

        vm.setFilemedia = function ($file, expense) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        expense.filemedia = base64Data;
                        expense.filemediaContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ExpenseDetailController', ExpenseDetailController);

    ExpenseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Expense', 'User', 'Vehicle', 'Company', 'FleetMedia'];

    function ExpenseDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Expense, User, Vehicle, Company, FleetMedia) {
        var vm = this;

        vm.expense = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('fleetApp:expenseUpdate', function(event, result) {
            vm.expense = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ExpenseDeleteController',ExpenseDeleteController);

    ExpenseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Expense'];

    function ExpenseDeleteController($uibModalInstance, entity, Expense) {
        var vm = this;

        vm.expense = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Expense.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('expense', {
            parent: 'entity',
            url: '/expense?page&sort&search&from&to&plate&vehicleId&vehiclePlate',
            data: {
                authorities: ['ROLE_USER', 'EDIT_FINANCIAL'],
                pageTitle: 'fleetApp.expense.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/expense/expenses.html',
                    controller: 'ExpenseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                from: null,
                to: null,
                vehiclePlate: null,
                vehicleId: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', '$filter', function ($stateParams, PaginationUtil, $filter) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        from: $stateParams.from == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.from,
                        to: $stateParams.to == null ? $filter('date')(new Date(), "yyyy-MM-dd") : $stateParams.to,
                        vehicleId: $stateParams.vehicleId,
                        vehiclePlate: $stateParams.vehiclePlate
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expense');
                    $translatePartialLoader.addPart('expenseType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('expense-detail', {
            parent: 'entity',
            url: '/expense/{id}',
            data: {
                authorities: ['ROLE_USER', 'EDIT_FINANCIAL'],
                pageTitle: 'fleetApp.expense.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/expense/expense-detail.html',
                    controller: 'ExpenseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('expense');
                    $translatePartialLoader.addPart('expenseType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Expense', function($stateParams, Expense) {
                    return Expense.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('expense.new', {
            parent: 'expense',
            url: '/new',
            data: {
                authorities: ['ROLE_USER', 'EDIT_FINANCIAL'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/expense/expense-dialog.html',
                    controller: 'ExpenseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                creation: null,
                                expenseType: null,
                                total: null,
                                expenseDate: null,
                                filemedia: null,
                                filemediaContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('expense');
                });
            }]
        })
        .state('expense.edit', {
            parent: 'expense',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER', 'EDIT_FINANCIAL'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/expense/expense-dialog.html',
                    controller: 'ExpenseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Expense', function(Expense) {
                            return Expense.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('expense.delete', {
            parent: 'expense',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER', 'EDIT_FINANCIAL'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/expense/expense-delete-dialog.html',
                    controller: 'ExpenseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Expense', function(Expense) {
                            return Expense.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('expense', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Expense', Expense);

    Expense.$inject = ['$resource', 'DateUtils'];

    function Expense ($resource, DateUtils) {
        var resourceUrl =  'api/expenses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creation = DateUtils.convertDateTimeFromServer(data.creation);
                        data.expenseDate = DateUtils.convertDateTimeFromServer(data.expenseDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ExpenseController', ExpenseController);

    ExpenseController.$inject = ['$scope', '$state', 'DataUtils', 'Expense', 'ParseLinks', 'AlertService', 'pagingParams',
        'paginationConstants', 'DateUtils', '$filter'];

    function ExpenseController ($scope, $state, DataUtils, Expense, ParseLinks, AlertService, pagingParams, paginationConstants, DateUtils, $filter) {
        var vm = this;

        var dateFormat = 'yyyy-MM-dd';

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        vm.fromDate = DateUtils.convertStringToDate(pagingParams.from);
        vm.toDate = DateUtils.convertStringToDate(pagingParams.to);
        vm.vehiclePlate = pagingParams.vehiclePlate;
        vm.vehicleId = pagingParams.vehicleId;

        vm.loadAll = function() {
            Expense.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort(),
                from: $filter('date')(vm.fromDate, dateFormat),
                to: $filter('date')(vm.toDate, dateFormat),
                vehiclePlate: pagingParams.vehiclePlate,
                vehicleId: pagingParams.vehicleId
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.expenses = data;
                vm.page = pagingParams.page;
                vm.from = pagingParams.from;
                vm.to = pagingParams.to;
                vm.plate = pagingParams.plate;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                from: $filter('date')(vm.fromDate, dateFormat),
                to: $filter('date')(vm.toDate, dateFormat),
                vehicleId: vm.vehicleId,
                vehiclePlate: vm.vehiclePlate
            });
        }

        vm.onDateChange = function (key) {
            transition();
        }

        $scope.$watch('vm.vehicleId', function (vehicleId) {
            transition();
        });

        vm.loadAll();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DeviceDialogController', DeviceDialogController);

    DeviceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Device', 'Company'];

    function DeviceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Device, Company) {
        var vm = this;

        vm.device = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.device.id !== null) {
                Device.update(vm.device, onSaveSuccess, onSaveError);
            } else {
                Device.save(vm.device, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:deviceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastUpdate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DeviceDetailController', DeviceDetailController);

    DeviceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Device', 'Company'];

    function DeviceDetailController($scope, $rootScope, $stateParams, entity, Device, Company) {
        var vm = this;

        vm.device = entity;

        var unsubscribe = $rootScope.$on('fleetApp:deviceUpdate', function(event, result) {
            vm.device = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DeviceDeleteController',DeviceDeleteController);

    DeviceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Device'];

    function DeviceDeleteController($uibModalInstance, entity, Device) {
        var vm = this;

        vm.device = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Device.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var deviceTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" translate="{{$ctrl.label}}" for="field_device">device</label>' +
            '<div class="input-group">' +
            ' <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ $ctrl.label | translate }}" ' +
            '  uib-typeahead="address as address.name for address in search($viewValue)" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: DeviceTypeaheadController,
        bindings: {
            modelId: '=',
            modelLabel: '=',
            label: '<'
        }
    };

    angular
        .module('fleetApp')
        .component('deviceTypeahead', deviceTypeahead);

    DeviceTypeaheadController.$inject = ['$scope', 'Device', '$http', 'paginationConstants'];

    function DeviceTypeaheadController($scope, Device, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.name;
            vm.modelId = model.id;
        }

        $scope.search = function(uniqueId) {
            return Device.search({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                uniqueId: uniqueId}).$promise;
        };

        vm.clear = function() {
            vm.modelId = undefined;
            vm.modelLabel = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('device', {
            parent: 'entity',
            url: '/device?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.device.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/device/devices.html',
                    controller: 'DeviceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('device');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('device-detail', {
            parent: 'entity',
            url: '/device/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.device.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/device/device-detail.html',
                    controller: 'DeviceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('device');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Device', function($stateParams, Device) {
                    return Device.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('device.new', {
            parent: 'device',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/device/device-dialog.html',
                    controller: 'DeviceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                uniqueId: null,
                                status: null,
                                lastUpdate: null,
                                traccarId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('device', null, { reload: true });
                }, function() {
                    $state.go('device');
                });
            }]
        })
        .state('device.edit', {
            parent: 'device',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/device/device-dialog.html',
                    controller: 'DeviceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Device', function(Device) {
                            return Device.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('device', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('device.delete', {
            parent: 'device',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/device/device-delete-dialog.html',
                    controller: 'DeviceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Device', function(Device) {
                            return Device.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('device', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Device', Device);

    Device.$inject = ['$resource', 'DateUtils'];

    function Device ($resource, DateUtils) {
        var resourceUrl =  'api/devices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpdate = DateUtils.convertDateTimeFromServer(data.lastUpdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'search': { method:'GET',
                isArray: true,
                url:'api/devices/search',
                transformRequest: function (data) {
                    return angular.toJson(data);
                }
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DeviceController', DeviceController);

    DeviceController.$inject = ['$scope', '$state', 'Device', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DeviceController ($scope, $state, Device, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Device.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.devices = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    var deliverItem = {
        templateUrl: 'app/entities/deliver/deliver-item.component.html',
        controller: DeliverController,
        bindings: {
            task: '='
        }
    };

    angular
        .module('fleetApp')
        .component('deliverItem', deliverItem);

    DeliverController.$inject = ['$scope', 'Invoice', 'AlertService', '$state', '$uibModal', 'Task', 'RefusedReason'];

    function DeliverController($scope, Invoice, AlertService, $state, $uibModal, Task, RefusedReason) {
        var vm = this;

        RefusedReason.all({}, function(data){
            vm.refusedReasons = data;
        }, onError);

        $scope.status = {
            isCustomHeaderOpen: false,
            isFirstOpen: true,
            isFirstDisabled: false
        };

        vm.invoiceDetailOpen = false

        vm.searchService = function (task, serviceNumber) {
            if (serviceNumber != undefined && task.servicesNumber.indexOf(serviceNumber) === -1) {
                Invoice.personbyservicenumber({serviceNumber: serviceNumber}, function(data){
                    if (task.personId != undefined && task.personId != data.id) {
                        AlertService.error("A ordem de serviço " + serviceNumber + " não pertence ao cliente " + task.personName)
                    } else {
                        task.servicesNumber.push(serviceNumber);
                        task.personId = data.id;
                        task.personName = data.name;
                    }
                }, onError);

            }
        }

        vm.searchByOrderNumber = function(task, orderNumber) {
            if (orderNumber != undefined && task.ordersNumber.indexOf(orderNumber) === -1) {
                 Invoice.personbyordernumber({orderNumber: orderNumber}, function(data){
                     if (task.personId != undefined && task.personId != data.id) {
                         AlertService.error("O pedido " + orderNumber + " não pertence ao cliente " + task.personName)
                     } else {
                         task.ordersNumber.push(orderNumber);
                         task.personId = data.id;
                         task.personName = data.name;
                     }
                 }, onError);
             }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        vm.removeService = function(task, serviceNumber, indexjs) {
            task.servicesNumber.splice(task.servicesNumber.indexOf(serviceNumber), 1);
        }

        vm.removeOrder = function(task, orderNumber, indexjs) {
            task.ordersNumber.splice(task.ordersNumber.indexOf(orderNumber), 1);
        }

        vm.showInvoices = function(task) {
//            Task.get({id : task.id}, function(data) {
//                if (data) {
//                    vm.task.itens = data.itens;
//                }
//            }, onError);
        }

        vm.taskRejectDetail = function() {
//            console.log(vm.task);
//            $uibModal.open({
//                    templateUrl: 'app/entities/itinerary/itinerary-dialog.html',
//                    controller: 'ItineraryDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: vm.task
//                        },
//                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                            $translatePartialLoader.addPart('itinerary');
//                            $translatePartialLoader.addPart('task');
//                            $translatePartialLoader.addPart('taskStatus');
//                            $translatePartialLoader.addPart('visit');
//                            $translatePartialLoader.addPart('global');
//                            return $translate.refresh();
//                        }]
//                }).result.then(function() {
////                    $state.go('^', null, { reload: true });
//                }, function() {
////                    $state.go('^');
//                });
        }

    }
})();
;
(function() {
    "use strict";

    angular
        .module("fleetApp")
        .controller(
            "ItineraryMapDialogController",
            ItineraryMapDialogController
        );

    ItineraryMapDialogController.$inject = [
        "$uibModalInstance",
        "geojson",
        "positions",
        "$timeout",
        "$rootScope"
    ];

    function ItineraryMapDialogController($uibModalInstance, geojson, positions, $timeout, $rootScope) {
        var vm = this;

        vm.clear = clear;
        vm.close = close;

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function close(id) {
            $uibModalInstance.close(true);
        }

        function invalidateSize() {
            $timeout(function() {
                $("#mapid").height($(window).height() - 200);
                // myMap.invalidateSize();
                $rootScope.$broadcast("invalidateMapSize");

                $rootScope.$broadcast('clearMap');

                $rootScope.$broadcast("onItineraryClickEvent", {data: geojson, fitBounds: true});
                $rootScope.$broadcast("showPositions", {positions: positions, fitBounds: true});
            }, 200);
        }

        invalidateSize();
    }
})();
;
(function() {
    "use strict";

    var dashboardGraph = {
        templateUrl: "app/entities/dashboard/dashboard-graph-template.html",
        controller: DashboardGraphController,
        bindings: {
            date: "<"
        }
    };

    angular.module("fleetApp").component("dashboardGraph", dashboardGraph);

    DashboardGraphController.$inject = [
        "$scope",
        "Itinerary",
        "Position",
        "AlertService",
        "$state",
        "$uibModal"
    ];

    function DashboardGraphController(
        $scope,
        Itinerary,
        Position,
        AlertService,
        $state,
        $uibModal
    ) {
        var vm = this;

        vm.refresh = function() {
            Itinerary.graphlist(
                { date: vm.date },
                function(data) {
                    vm.groups = data;
                },
                onError
            );
        };

        this.$onChanges = function(changes) {
            vm.refresh();
        };

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function diffInDays(date1, date2) {
            var diffTime = Math.abs(date2 - date1);
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays;
        }

        vm.taskHourStyle = function(d1, d2) {
            if (diffInDays(new Date(d1), new Date(d2)) > 1) {
                return 'text-danger';
            }
            return ''
        }

        vm.taskStyle = function(task) {
            if (task === "COMPLETED") {
                return { color: "#00a65a", "text-align": "center" };
            } else if (task === "PARTIALLY_DONE") {
                return { color: "#f39c12" };
            } else if (task === "REJECTED") {
                return { color: "#f56954" };
            }
            return "";
        };
        vm.taskClass = function(task) {
            if (task.taskType === "WAREHOUSE_DEPARTURE")
                return "fa fa-industry fa-4x";
            if (task.taskType === "WAREHOUSE_ARRIVAL")
                return "fa fa-industry fa-4x";

            if (task.taskStatus === "IN_PROGRESS") {
                return "fa fa-dropbox fa-4x";
            } else {
                if (task.taskType === "COLLECT") return "fa fa-exchange fa-4x";
                return "fa fa-hospital-o fa-4x";
            }
        };

        vm.onTaskClicked = function(task) {
            if (task.taskType === "DELIVER")
                $state.go("dashboard.task-detail", { id: task.id });
            if (task.taskType === "COLLECT")
                $state.go("dashboard.collect-detail", { id: task.id });
        };

        vm.onOfficeHourClicked = function(itinerary, dashboardDate) {
            $uibModal.open({
                templateUrl: "app/entities/officehours/officehour-dashboard-dialog.html",
                controller: "OfficeHourDashboardController",
                controllerAs: "vm",
                size: "lg",
                resolve: {
                    entities: ['Officehours', function(Officehours) {
                        return Officehours.getAllByItineraryDate({date: dashboardDate, itineraryId: itinerary.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('officehours');
                        return $translate.refresh();
                    }]
                }
            });
        };

        vm.onItineraryMapClicked = function(itineraryId, vehicleId) {
            $uibModal.open({
                templateUrl: "app/entities/dashboard/itinerary-map-dialog.html",
                controller: "ItineraryMapDialogController",
                controllerAs: "vm",
                size: "lg",
                resolve: {
                    geojson: [
                        "Itinerary",
                        function(Itinerary) {
                            return Itinerary.geojson({ id: itineraryId })
                                .$promise;
                        }
                    ],
                    positions: [
                        "Position",
                        function(Position) {
                            return Position.devicetime({
                                itineraryId: itineraryId,
                                vehicleid: vehicleId
                            }).$promise;
                        }
                    ]
                }
            });
        };

        vm.onDeleteItineraryClicked = function(itineraryId) {
            $uibModal
                .open({
                    templateUrl:
                        "app/entities/itinerary/itinerary-delete-dialog.html",
                    controller: "ItineraryDeleteController",
                    controllerAs: "vm",
                    size: "md",
                    resolve: {
                        entity: [
                            "Itinerary",
                            function(Itinerary) {
                                return Itinerary.get({ id: itineraryId })
                                    .$promise;
                            }
                        ]
                    }
                })
                .result.then(
                    function() {
                        $state.go($state.$current, null, { reload: true });
                    },
                    function() {
                        //                $state.go('^');
                    }
                );
        };

        vm.arrayToString = function(string) {
            return string.join(", ");
        };

        vm.onEditItineraryClicked = function(itineraryId) {
            $uibModal
                .open({
                    templateUrl: "app/entities/itinerary/itinerary-dialog.html",
                    controller: "ItineraryDialogController",
                    controllerAs: "vm",
                    backdrop: "static",
                    size: "lg",
                    resolve: {
                        entity: [
                            "Itinerary",
                            function(Itinerary) {
                                return Itinerary.get({ id: itineraryId })
                                    .$promise;
                            }
                        ],
                        translatePartialLoader: [
                            "$translate",
                            "$translatePartialLoader",
                            function($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart("itinerary");
                                $translatePartialLoader.addPart("task");
                                $translatePartialLoader.addPart("taskStatus");
                                $translatePartialLoader.addPart("visit");
                                $translatePartialLoader.addPart("global");
                                return $translate.refresh();
                            }
                        ]
                    }
                })
                .result.then(
                    function() {
                        $state.go($state.$current, null, { reload: true });
                    },
                    function() {
                        //                $state.go('^');
                    }
                );
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DashboardDialogController', DashboardDialogController);

    DashboardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dashboard'];

    function DashboardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dashboard) {
        var vm = this;

        vm.dashboard = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dashboard.id !== null) {
                Dashboard.update(vm.dashboard, onSaveSuccess, onSaveError);
            } else {
                Dashboard.save(vm.dashboard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:dashboardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DashboardDetailController', DashboardDetailController);

    DashboardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dashboard'];

    function DashboardDetailController($scope, $rootScope, $stateParams, previousState, entity, Dashboard) {
        var vm = this;

        vm.dashboard = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('fleetApp:dashboardUpdate', function(event, result) {
            vm.dashboard = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DashboardDeleteController',DashboardDeleteController);

    DashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dashboard'];

    function DashboardDeleteController($uibModalInstance, entity, Dashboard) {
        var vm = this;

        vm.dashboard = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dashboard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dashboard', {
            parent: 'app',
            url: '/dashboard?date&view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.dashboard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dashboard/dashboards.html',
                    controller: 'DashboardController',
                    controllerAs: 'vm'
                }
            },
            params:  {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    date: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'DateUtils',  function ($stateParams, DateUtils) {
                    return {
                        date: $stateParams.date == null ? DateUtils.newDateString() : $stateParams.date,
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('itinerary');
                    $translatePartialLoader.addPart('dashboard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboard.new', {
            parent: 'dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'DateUtils', function($stateParams, $state, $uibModal, DateUtils) {
                $uibModal.open({
                    templateUrl: 'app/entities/itinerary/itinerary-dialog.html',
                    controller: 'ItineraryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            var dt = DateUtils.utcNow();
                            return {
                                creationDate: null,
                                number: null,
                                plannedDate: dt,
                                startTime: dt,
                                endTime: dt,
                                startOdometer: null,
                                endOdometer: null,
                                id: null,
                                tasks: []
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('itinerary');
                            $translatePartialLoader.addPart('task');
                            $translatePartialLoader.addPart('taskStatus');
                            $translatePartialLoader.addPart('visit');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        // QUANDO USUÁRIO CLICA SOBRE A ENTREGA
        .state('dashboard.edit', {
            parent: 'dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dashboard/dashboard-dialog.html',
                    controller: 'DashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dashboard', function(Dashboard) {
                            return Dashboard.getTask({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboard', null, { reload: 'dashboard' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dashboard.messages-modal',{
            parent: 'dashboard',
            url: '/{id}/messages-modal',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message/messages-dialog.html',
                    controller: 'MessagesDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Message', function(Message) {
                            return Message.getAllByItinerary({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('message');
                    return $translate.refresh();
                }]
            }
        })
        // QUANDO USUÁRIO CLICA SOBRE UMA ENTREGA
        .state('dashboard.task-detail', {
            parent: 'dashboard',
            url: '/{id}/task-detail',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/task/task-dialog-detail.html',
                    controller: 'TaskDialogDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('task');
                            $translatePartialLoader.addPart('taskType');
                            $translatePartialLoader.addPart('taskStatus');
                            $translatePartialLoader.addPart('taskEvent');
                            $translatePartialLoader.addPart('taskEventType');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dashboard.collect-detail', {
            parent: 'dashboard',
            url: '/{id}/collect-detail',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collect/collect-dialog-detail.html',
                    controller: 'CollectDialogDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Task', function(Task) {
                            return Task.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('task');
                            $translatePartialLoader.addPart('taskType');
                            $translatePartialLoader.addPart('taskStatus');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        // QUANDO USUÁRIO CLICA SOBRE UM DETALHE DE PERSON NO MAPA
        .state('dashboard.person', {
            parent: 'dashboard',
            url: '/{id}/person',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/person/person-detail-dialog.html',
                    controller: 'PersonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Person', function(Person) {
                            return Person.get({id : $stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('person');
                            $translatePartialLoader.addPart('personType');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', null, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        // Office Hours
        .state('dashboard.officehours-modal',{
            parent: 'dashboard',
            url: '/{itineraryId}/officehours-modal',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/officehours/officehour-dashboard-dialog.html',
                    controller: 'OfficeHourDashboardController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Officehours', function(Officehours) {
                            return Officehours.getAllByItineraryDate({date: $stateParams.date, itineraryId: $stateParams.itineraryId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboard', null, { reload: false });
                }, function() {
                    $state.go('dashboard');
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('officehours');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboard.officehours-modal.edit',{
            parent: 'dashboard.officehours-modal',
            url: '/{id}/officehours-modal/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/officehours/officehours-dialog.html',
                    controller: 'OfficehoursDialogController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['Officehours', function(Officehours) {
                            return Officehours.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    console.log('333')
                    $state.go('^', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Dashboard', Dashboard);

    Dashboard.$inject = ['$resource', 'DateUtils'];

    function Dashboard ($resource, DateUtils) {
        var resourceUrl =  'api/dashboards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'build': {
                url: 'api/dashboards/build',
                method: 'POST',
                transformRequest: function (data) {
                    data.dashboardDate = DateUtils.convertLocalDateToServer(data.dashboardDate);
                    return angular.toJson(data);
                }
            },
            'getTask': {
                url: 'api/dashboards/task/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['AlertService', '$filter', '$scope', '$state', '$interval', 'pagingParams',
    'DateUtils']

    function DashboardController (AlertService, $filter, $scope, $state, $interval, pagingParams, DateUtils) {
        var vm = this;

        var dateFormat = 'yyyy-MM-dd';
        vm.dashboardDate = pagingParams.date;
        vm.pickerDate = DateUtils.convertLocalDateFromServer(pagingParams.date);

        $scope.clock = Date.now();
        $interval(function () { $scope.clock = Date.now(); }, 1000);

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.overlayOptions = [];

        vm.datePickerOpenStatus.dashboardDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        /*
        * Page reload when notify is true.
        */
        vm.transitionTo = function(notify) {
            var fromDate = DateUtils.convertLocalDateToServer(vm.pickerDate);
            $state.transitionTo($state.$current, { date: fromDate }, {notify: notify});
        }

        vm.onTaskClicked = function(marker) {
            $state.go('dashboard.task-detail', {id: marker.model.id});
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('CompanyDialogController', CompanyDialogController);

    CompanyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Company'];

    function CompanyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.company.id !== null) {
                Company.update(vm.company, onSaveSuccess, onSaveError);
            } else {
                Company.save(vm.company, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:companyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('CompanyDetailController', CompanyDetailController);

    CompanyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Company'];

    function CompanyDetailController($scope, $rootScope, $stateParams, entity, Company) {
        var vm = this;

        vm.company = entity;

        var unsubscribe = $rootScope.$on('fleetApp:companyUpdate', function(event, result) {
            vm.company = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('CompanyDeleteController',CompanyDeleteController);

    CompanyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Company'];

    function CompanyDeleteController($uibModalInstance, entity, Company) {
        var vm = this;

        vm.company = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Company.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company', {
            parent: 'entity',
            url: '/company?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.company.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company/companies.html',
                    controller: 'CompanyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('company');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('company-detail', {
            parent: 'entity',
            url: '/company/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.company.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company/company-detail.html',
                    controller: 'CompanyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('company');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('company.new', {
            parent: 'company',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                domain: null,
                                activated: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: true });
                }, function() {
                    $state.go('company');
                });
            }]
        })
        .state('company.edit', {
            parent: 'company',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company.delete', {
            parent: 'company',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-delete-dialog.html',
                    controller: 'CompanyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Company', Company);

    Company.$inject = ['$resource'];

    function Company ($resource) {
        var resourceUrl =  'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('CompanyController', CompanyController);

    CompanyController.$inject = ['$scope', '$state', 'Company', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function CompanyController ($scope, $state, Company, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;

        loadAll();

        function loadAll () {
            Company.query({
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.companies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    var collectItem = {
        templateUrl: 'app/entities/collect/collect-item.component.html',
        controller: CollectController,
        bindings: {
            task: '='
        }
    };

    angular
        .module('fleetApp')
        .component('collectItem', collectItem);

    CollectController.$inject = ['$scope', 'Itinerary', '$http', 'AlertService', '$state', '$uibModal'];

    function CollectController($scope, Itinerary, $http, AlertService, $state, $uibModal) {
        var vm = this;

        function onError(error) {
            AlertService.error(error.data.message);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('CollectDialogDetailController', CollectDialogDetailController);

    CollectDialogDetailController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function CollectDialogDetailController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;

        vm.clear = clear;
        vm.task = entity;
        vm.radioModel = 'product';

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.arrayToString = function(string){
            return string.join(", ");
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankAccountDialogController', BankAccountDialogController);

    BankAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BankAccount'];

    function BankAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BankAccount) {
        var vm = this;

        vm.bankAccount = entity;
        vm.clear = clear;
        vm.save = save;
        vm.vehicle = { };

        vm.stateOptions = [
             {id: '1', name: "Conta Corrente"},
             {id: '2', name: "Poupança"}
          ]

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bankAccount.id !== null) {
                BankAccount.update(vm.bankAccount, onSaveSuccess, onSaveError);
            } else {
                BankAccount.save(vm.bankAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:bankAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankAccountDetailController', BankAccountDetailController);

    BankAccountDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BankAccount'];

    function BankAccountDetailController($scope, $rootScope, $stateParams, entity, BankAccount) {
        var vm = this;

        vm.bankAccount = entity;

        var unsubscribe = $rootScope.$on('fleetApp:bankAccountUpdate', function(event, result) {
            vm.bankAccount = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankAccountDeleteController',BankAccountDeleteController);

    BankAccountDeleteController.$inject = ['$uibModalInstance', 'entity', 'BankAccount'];

    function BankAccountDeleteController($uibModalInstance, entity, BankAccount) {
        var vm = this;

        vm.bankAccount = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BankAccount.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var bankAccountTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" ng-if="!$ctrl.hideTitle" translate="global.menu.entities.bankAccount" for="field_vehicle"> ' +
            '  bankAccount</label> ' +
            '<div class="input-group">' +
            ' <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ \'global.menu.entities.bankAccount\' | translate }}" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)"  ' +
            '  uib-typeahead="address as address.name for address in getEntityData($viewValue)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: BankAccountTypeaheadController,
        bindings: {
            modelEntity: '=',
            modelId: '=',
            modelLabel: '=',
            hideTitle: '@' // title hide when true
        }
    };

    angular
        .module('fleetApp')
        .component('bankAccountTypeahead', bankAccountTypeahead);

    BankAccountTypeaheadController.$inject = ['$scope', 'BankAccount', '$http', 'paginationConstants'];

    function BankAccountTypeaheadController($scope, BankAccount, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.name;
            vm.modelId = model.id;
        }

        $scope.getEntityData = function(val) {
            return BankAccount.search({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                bankName: val}).$promise;
        };

        vm.clear = function() {
            vm.modelLabel = undefined;
            vm.modelId = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bank-account', {
            parent: 'entity',
            url: '/bank-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.bankAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bank-account/bank-accounts.html',
                    controller: 'BankAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bankAccount');
                    $translatePartialLoader.addPart('bank');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bank-account-detail', {
            parent: 'entity',
            url: '/bank-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.bankAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bank-account/bank-account-detail.html',
                    controller: 'BankAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bankAccount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BankAccount', function($stateParams, BankAccount) {
                    return BankAccount.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('bank-account.new', {
            parent: 'bank-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-account/bank-account-dialog.html',
                    controller: 'BankAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                accountNumber: null,
                                accountCheckNumber: null,
                                name: null,
                                branchNumber: null,
                                accountType: null,
                                bankNumber: null,
                                federalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bank-account', null, { reload: true });
                }, function() {
                    $state.go('bank-account');
                });
            }]
        })
        .state('bank-account.edit', {
            parent: 'bank-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-account/bank-account-dialog.html',
                    controller: 'BankAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BankAccount', function(BankAccount) {
                            return BankAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bank-account', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bank-account.delete', {
            parent: 'bank-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank-account/bank-account-delete-dialog.html',
                    controller: 'BankAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BankAccount', function(BankAccount) {
                            return BankAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bank-account', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('BankAccount', BankAccount);

    BankAccount.$inject = ['$resource'];

    function BankAccount ($resource) {
        var resourceUrl =  'api/bank-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'search':{ method:'GET',
                url:'api/bank-accounts/search',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankAccountController', BankAccountController);

    BankAccountController.$inject = ['$scope', '$state', 'BankAccount'];

    function BankAccountController ($scope, $state, BankAccount) {
        var vm = this;
        
        vm.bankAccounts = [];

        loadAll();

        function loadAll() {
            BankAccount.query(function(result) {
                vm.bankAccounts = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankDialogController', BankDialogController);

    BankDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Bank'];

    function BankDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Bank) {
        var vm = this;

        vm.bank = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bank.id !== null) {
                Bank.update(vm.bank, onSaveSuccess, onSaveError);
            } else {
                Bank.save(vm.bank, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:bankUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankDetailController', BankDetailController);

    BankDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Bank'];

    function BankDetailController($scope, $rootScope, $stateParams, entity, Bank) {
        var vm = this;

        vm.bank = entity;

        var unsubscribe = $rootScope.$on('fleetApp:bankUpdate', function(event, result) {
            vm.bank = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankDeleteController',BankDeleteController);

    BankDeleteController.$inject = ['$uibModalInstance', 'entity', 'Bank'];

    function BankDeleteController($uibModalInstance, entity, Bank) {
        var vm = this;

        vm.bank = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Bank.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    var bankTypeahead = {
        template: '<div class="form-group">' +
            '<label class="control-label" ng-if="!$ctrl.hideTitle" translate="{{$ctrl.label}}" for="field_user">User</label>' +
            '<div class="input-group">' +
            '  <input type="text" ng-model="$ctrl.modelLabel" placeholder="{{ $ctrl.translateLabelKey | translate }}" ' +
            '  typeahead-on-select="onSelect($item, $model, $label)" ' +
            '  uib-typeahead="address as address.name for address in getEntityData($viewValue)" ' +
            '  typeahead-loading="loadingLocations" typeahead-no-results="noResults" class="form-control">' +
            ' <span class="input-group-btn"> ' +
            '   <button type="button" class="btn btn-default" ng-click="$ctrl.clear()"><i class="glyphicon glyphicon-remove"></i></button> ' +
            ' </span>'+
            '</div>' +
            '<i ng-show="loadingLocations" class="glyphicon glyphicon-refresh"></i>' +
            ' <div ng-show="noResults">' +
            '   <i class="glyphicon glyphicon-remove"></i> <span translate="error.notFound"></span>' +
            ' </div>' +
            '</div>',
        controller: BankTypeaheadController,
        bindings: {
            modelEntity: '=',
            modelId: '=',
            modelLabel: '=',
            label: '<',
            translateLabelKey: '<',
            hideTitle: '@' // title hide when true
        }
    };

    angular
        .module('fleetApp')
        .component('bankTypeahead', bankTypeahead);

    BankTypeaheadController.$inject = ['$scope', 'Bank', '$http', 'paginationConstants'];

    function BankTypeaheadController($scope, Bank, $http, paginationConstants) {
        var vm = this;

        vm.$onInit = function () {
        };

        $scope.onSelect = function(item, model, label) {
            vm.modelLabel = model.name;
            vm.modelId = model.id;
        }

        $scope.getEntityData = function(val) {
            return Bank.search({
                sort: '',
                page: 0,
                size: paginationConstants.itemsPerPageTypeahead,
                bankName: val}).$promise;
        };

        vm.clear = function() {
            vm.bank = undefined;
            vm.modelLabel = undefined;
            vm.modelId = undefined;
            $scope.noResults = false;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('bank', {
            parent: 'entity',
            url: '/bank',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.bank.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bank/banks.html',
                    controller: 'BankController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bank');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('bank-detail', {
            parent: 'entity',
            url: '/bank/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.bank.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/bank/bank-detail.html',
                    controller: 'BankDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('bank');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Bank', function($stateParams, Bank) {
                    return Bank.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('bank.new', {
            parent: 'bank',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank/bank-dialog.html',
                    controller: 'BankDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('bank', null, { reload: true });
                }, function() {
                    $state.go('bank');
                });
            }]
        })
        .state('bank.edit', {
            parent: 'bank',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank/bank-dialog.html',
                    controller: 'BankDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Bank', function(Bank) {
                            return Bank.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bank', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('bank.delete', {
            parent: 'bank',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/bank/bank-delete-dialog.html',
                    controller: 'BankDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Bank', function(Bank) {
                            return Bank.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('bank', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Bank', Bank);

    Bank.$inject = ['$resource'];

    function Bank ($resource) {
        var resourceUrl =  'api/banks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'search':{ method:'GET',
                url:'api/banks/search',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('BankController', BankController);

    BankController.$inject = ['$scope', '$state', 'Bank'];

    function BankController ($scope, $state, Bank) {
        var vm = this;
        
        vm.banks = [];

        loadAll();

        function loadAll() {
            Bank.query(function(result) {
                vm.banks = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AddressDialogController', AddressDialogController);

    AddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Address'];

    function AddressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Address) {
        var vm = this;

        vm.address = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.address.id !== null) {
                Address.update(vm.address, onSaveSuccess, onSaveError);
            } else {
                Address.save(vm.address, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('fleetApp:addressUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AddressDetailController', AddressDetailController);

    AddressDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Address'];

    function AddressDetailController($scope, $rootScope, $stateParams, previousState, entity, Address) {
        var vm = this;

        vm.address = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('fleetApp:addressUpdate', function(event, result) {
            vm.address = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AddressDeleteController',AddressDeleteController);

    AddressDeleteController.$inject = ['$uibModalInstance', 'entity', 'Address'];

    function AddressDeleteController($uibModalInstance, entity, Address) {
        var vm = this;

        vm.address = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Address.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('address', {
            parent: 'entity',
            url: '/address?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.address.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/address/addresses.html',
                    controller: 'AddressController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('address');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('address-detail', {
            parent: 'entity',
            url: '/address/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'fleetApp.address.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/address/address-detail.html',
                    controller: 'AddressDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('address');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Address', function($stateParams, Address) {
                    return Address.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'address',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('address-detail.edit', {
            parent: 'address-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/address/address-dialog.html',
                    controller: 'AddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Address', function(Address) {
                            return Address.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('address.new', {
            parent: 'address',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/address/address-dialog.html',
                    controller: 'AddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                postcode: null,
                                street: null,
                                number: null,
                                district: null,
                                latitude: null,
                                longitude: null,
                                city: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('address', null, { reload: true });
                }, function() {
                    $state.go('address');
                });
            }]
        })
        .state('address.edit', {
            parent: 'address',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/address/address-dialog.html',
                    controller: 'AddressDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Address', function(Address) {
                            return Address.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('address', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('address.delete', {
            parent: 'address',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/address/address-delete-dialog.html',
                    controller: 'AddressDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Address', function(Address) {
                            return Address.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('address', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
;
(function() {
    'use strict';
    angular
        .module('fleetApp')
        .factory('Address', Address);

    Address.$inject = ['$resource'];

    function Address ($resource) {
        var resourceUrl =  'api/addresses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AddressController', AddressController);

    AddressController.$inject = ['$scope', '$state', 'Address', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AddressController ($scope, $state, Address, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Address.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.addresses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('fleetApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse (header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function (p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if( angular.isString(page) ) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });

            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page-1) * 20)==0 ? 1:(($ctrl.page-1) * 20 + 1)}} - ' +
                    '{{($ctrl.page * 20) < $ctrl.queryCount ? ($ctrl.page * 20) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total'
        }
    };

    angular
        .module('fleetApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function(){
    'use strict';

    angular
        .module('fleetApp')
        .factory('ImageService', ImageService);

    function ImageService () {

        var service = {
            thumbnail : thumbnail,
            image300: image300
        };

        return service;

        function thumbnail (url) {
            if (url) {
                return url.replace('image/upload/', 'image/upload/t_media_lib_thumb/');
            }
            return null;
        }

        function image300 (url) {
            if (url) {
                return url.replace('image/upload/', 'image/upload/c_scale,w_300/');
            }
            return null;
        }
    }
})();
;
(function() {
  'use strict';

  angular.module('fleetApp').factory('GeoMapService', GeoMapService);

  GeoMapService.$inject = ['$http', '$rootScope'];

  function GeoMapService($http, $rootScope) {
    var service = {
      initialLocation: initialLocation
    };

    return service;

    function initialLocation() {
      $http.get('api/fleet-preferences/initial-map-position').then(function(value) {
        $rootScope.initialLocation = value;
      });
      return $http.get('api/fleet-preferences/initial-map-position');
    }
  }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat,
            convertMinutesToDisplay : convertMinutesToDisplay,
            convertStringToDate : convertStringToDate,
            newDateString : newDateString,
            utcNow : utcNow,
            convertLocalDateTimeToServer: convertLocalDateTimeToServer,
            convertStringToDateMomentMMDDYYYY: convertStringToDateMomentMMDDYYYY
        };

        return service;

        /**
        * Retorna um now na timezone 0
        */
        function utcNow () {
            return new Date();
        }

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);

            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateTimeToServer (date) {
             if (date) {
                return $filter('date')(date, 'yyyy-MM-dd\'T\'HH:mm:ss.Z');
            } else {
                return null;
            }
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }

        function newDateString() {
            return $filter('date')(new Date(), "yyyy-MM-dd")
         }

        //http://stackoverflow.com/questions/25470475/angular-js-format-minutes-in-template
        function convertMinutesToDisplay(minutes) {
            if (minutes == undefined) {
                return ''
            }
            var result;
            if(minutes < 60){
                result = (minutes) + 'm';
            }
            else if(minutes % 60==0){
                result = (minutes - minutes % 60)/60 + 'h';
            }
            else{
                 result = ((minutes - minutes % 60)/60 + 'h' + ' ' + minutes % 60 + 'm');
            }
            return result;
        }

         /* deprecated! not working at GMT+0 */
        // Convert '2016-01-20' to a date object
        function convertStringToDate(str) {
            if (!str) { return null; }
            var pattern = /(\d{4})(\d{2})(\d{2})/;
            var dat = new Date(str.replace(pattern, '$1-$2-$3'));
            dat.setDate(dat.getDate() + 1);
            return dat;
        }

        function convertStringToDateMomentMMDDYYYY(str) {
            return moment(str, "YYYY-MM-DD").toDate();
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
// Binding select to a non-string value via ngModel parsing / formatting
// https://code.angularjs.org/1.4.6/docs/api/ng/directive/select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting

(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('convertToNumber', convertToNumber);

    function convertToNumber() {
        var directive = {
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function(val) {
                return parseInt(val, 10);
            });
            ngModel.$formatters.push(function(val) {
                return '' + val;
            });
        };
    }
})();

;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('fleetApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    //$state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        vm.currentLanguage = $translate.use();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            vm.currentLanguage = languageKey;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'pt-br',
            'en'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();
;
/*
  Leaflet.BeautifyIcon, a plugin that adds colorful iconic markers for Leaflet by giving full control of style to end user, It has also ability to adjust font awesome
  and glyphicon icons
  (c) 2016-2017, Muhammad Arslan Sajid
  http://leafletjs.com
*/

/*global L of leaflet*/

(function (window, document, undefined) {

    'use strict';

    /*
    * Leaflet.BeautifyIcon assumes that you have already included the Leaflet library.
    */

    /*
    * Default settings for various style markers
    */
    var defaults = {

        iconColor: '#1EB300',

        iconAnchor: {
            'marker': [14, 36]
            , 'circle': [11, 10]
            , 'circle-dot': [5, 5]
            , 'rectangle-dot': [5, 6]
            , 'doughnut': [8, 8]
        },

        popupAnchor: {
            'marker': [0, -25]
            , 'circle': [-3, -76]
            , 'circle-dot': [0, -2]
            , 'rectangle-dot': [0, -2]
            , 'doughnut': [0, -2]
        },

        innerIconAnchor: {
            'marker': [-2, 5]
            , 'circle': [0, 2]
        },

        iconSize: {
            'marker': [28, 28]
            , 'circle': [22, 22]
            , 'circle-dot': [2, 2]
            , 'rectangle-dot': [2, 2]
            , 'doughnut': [15, 15]
        }
    };

    L.BeautifyIcon = {

        Icon: L.Icon.extend({

            options: {
                icon: 'leaf'
               , iconSize: defaults.iconSize.circle
               , iconAnchor: defaults.iconAnchor.circle
               , iconShape: 'circle'
               , iconStyle: ''
               , innerIconAnchor: [0, 3] // circle with fa or glyphicon or marker with text
               , innerIconStyle: ''
               , isAlphaNumericIcon: false
               , text: 1
               , borderColor: defaults.iconColor
               , borderWidth: 2
               , borderStyle: 'solid'
               , backgroundColor: 'white'
               , textColor: defaults.iconColor
               , customClasses: ''
               , spin: false
               , prefix: 'fa'
               , html: ''
            },

            initialize: function (options) {

                this.applyDefaults(options);
                this.options = (!options || !options.html)  ? L.Util.setOptions(this, options) : options;
            },

            applyDefaults: function (options) {

                if (options) {
                    if (!options.iconSize && options.iconShape) {
                        options.iconSize = defaults.iconSize[options.iconShape];
                    }

                    if (!options.iconAnchor && options.iconShape) {
                        options.iconAnchor = defaults.iconAnchor[options.iconShape];
                    }

                    if (!options.popupAnchor && options.iconShape) {
                        options.popupAnchor = defaults.popupAnchor[options.iconShape];
                    }

                    if (!options.innerIconAnchor) {
                        // if icon is type of circle or marker
                        if (options.iconShape === 'circle' || options.iconShape === 'marker') {
                            if (options.iconShape === 'circle' && options.isAlphaNumericIcon) { // if circle with text
                                options.innerIconAnchor = [0, -1];
                            }
                            else if (options.iconShape === 'marker' && !options.isAlphaNumericIcon) {// marker with icon
                                options.innerIconAnchor = defaults.innerIconAnchor[options.iconShape];
                            }
                        }
                    }
                }
            },

            createIcon: function () {

                var iconDiv = document.createElement('div')
                    , options = this.options;

                iconDiv.innerHTML = !options.html ? this.createIconInnerHtml() : options.html;
                this._setIconStyles(iconDiv);

                // having a marker requires an extra parent div for rotation correction
                if (this.options.iconShape === 'marker') {
                    var wrapperDiv = document.createElement('div');
                    wrapperDiv.appendChild(iconDiv);
                    return wrapperDiv;
                }

                return iconDiv;
            },

            createIconInnerHtml: function () {

                var options = this.options;

                if (options.iconShape === 'circle-dot' || options.iconShape === 'rectangle-dot' || options.iconShape === 'doughnut') {
                    return '';
                }

                var innerIconStyle = this.getInnerIconStyle(options);
                if (options.isAlphaNumericIcon) {
                    return '<div style="' + innerIconStyle + '">' + options.text + '</div>';
                }

                var spinClass = '';
                if (options.spin) {
                    spinClass = ' fa-spin';
                }

                return '<i class="' + options.prefix + ' ' + options.prefix + '-' + options.icon + spinClass + '" style="' + innerIconStyle + '"></i>';
            },

            getInnerIconStyle: function (options) {

                var innerAnchor = L.point(options.innerIconAnchor)
                return 'color:' + options.textColor + ';margin-top:' + innerAnchor.y + 'px; margin-left:' + innerAnchor.x + 'px;' + options.innerIconStyle;
            },

            _setIconStyles: function (iconDiv) {

                var options = this.options
                    , size = L.point(options.iconSize)
                    , anchor = L.point(options.iconAnchor);

                iconDiv.className = 'beautify-marker ';

                if (options.iconShape) {
                    iconDiv.className += options.iconShape;
                }

                if (options.customClasses) {
                    iconDiv.className += ' ' + options.customClasses;
                }

                iconDiv.style.backgroundColor = options.backgroundColor;
                iconDiv.style.color = options.textColor;
                iconDiv.style.borderColor = options.borderColor;
                iconDiv.style.borderWidth = options.borderWidth + 'px';
                iconDiv.style.borderStyle = options.borderStyle;

                if (size) {
                    iconDiv.style.width = size.x + 'px';
                    iconDiv.style.height = size.y + 'px';
                }

                if (anchor) {
                    iconDiv.style.marginLeft = (-anchor.x) + 'px';
                    iconDiv.style.marginTop = (-anchor.y) + 'px';
                }

                if (options.iconStyle) {
                    var cStyle = iconDiv.getAttribute('style');
                    cStyle += options.iconStyle;
                    iconDiv.setAttribute('style', cStyle);
                }
            }
        })
    };

    L.BeautifyIcon.icon = function (options) {
        return new L.BeautifyIcon.Icon(options);
    }

}(this, document));
;
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('leaflet')) :
	typeof define === 'function' && define.amd ? define(['leaflet'], factory) :
	(factory(global.L));
}(this, (function (L$1) { 'use strict';

L$1 = L$1 && L$1.hasOwnProperty('default') ? L$1['default'] : L$1;

// functional re-impl of L.Point.distanceTo,
// with no dependency on Leaflet for easier testing
function pointDistance(ptA, ptB) {
    var x = ptB.x - ptA.x;
    var y = ptB.y - ptA.y;
    return Math.sqrt(x * x + y * y);
}

var computeSegmentHeading = function computeSegmentHeading(a, b) {
    return (Math.atan2(b.y - a.y, b.x - a.x) * 180 / Math.PI + 90 + 360) % 360;
};

var asRatioToPathLength = function asRatioToPathLength(_ref, totalPathLength) {
    var value = _ref.value,
        isInPixels = _ref.isInPixels;
    return isInPixels ? value / totalPathLength : value;
};

function parseRelativeOrAbsoluteValue(value) {
    if (typeof value === 'string' && value.indexOf('%') !== -1) {
        return {
            value: parseFloat(value) / 100,
            isInPixels: false
        };
    }
    var parsedValue = value ? parseFloat(value) : 0;
    return {
        value: parsedValue,
        isInPixels: parsedValue > 0
    };
}

var pointsEqual = function pointsEqual(a, b) {
    return a.x === b.x && a.y === b.y;
};

function pointsToSegments(pts) {
    return pts.reduce(function (segments, b, idx, points) {
        // this test skips same adjacent points
        if (idx > 0 && !pointsEqual(b, points[idx - 1])) {
            var a = points[idx - 1];
            var distA = segments.length > 0 ? segments[segments.length - 1].distB : 0;
            var distAB = pointDistance(a, b);
            segments.push({
                a: a,
                b: b,
                distA: distA,
                distB: distA + distAB,
                heading: computeSegmentHeading(a, b)
            });
        }
        return segments;
    }, []);
}

function projectPatternOnPointPath(pts, pattern) {
    // 1. split the path into segment infos
    var segments = pointsToSegments(pts);
    var nbSegments = segments.length;
    if (nbSegments === 0) {
        return [];
    }

    var totalPathLength = segments[nbSegments - 1].distB;

    var offset = asRatioToPathLength(pattern.offset, totalPathLength);
    var endOffset = asRatioToPathLength(pattern.endOffset, totalPathLength);
    var repeat = asRatioToPathLength(pattern.repeat, totalPathLength);

    var repeatIntervalPixels = totalPathLength * repeat;
    var startOffsetPixels = offset > 0 ? totalPathLength * offset : 0;
    var endOffsetPixels = endOffset > 0 ? totalPathLength * endOffset : 0;

    // 2. generate the positions of the pattern as offsets from the path start
    var positionOffsets = [];
    var positionOffset = startOffsetPixels;
    do {
        positionOffsets.push(positionOffset);
        positionOffset += repeatIntervalPixels;
    } while (repeatIntervalPixels > 0 && positionOffset < totalPathLength - endOffsetPixels);

    // 3. projects offsets to segments
    var segmentIndex = 0;
    var segment = segments[0];
    return positionOffsets.map(function (positionOffset) {
        // find the segment matching the offset,
        // starting from the previous one as offsets are ordered
        while (positionOffset > segment.distB && segmentIndex < nbSegments - 1) {
            segmentIndex++;
            segment = segments[segmentIndex];
        }

        var segmentRatio = (positionOffset - segment.distA) / (segment.distB - segment.distA);
        return {
            pt: interpolateBetweenPoints(segment.a, segment.b, segmentRatio),
            heading: segment.heading
        };
    });
}

/**
* Finds the point which lies on the segment defined by points A and B,
* at the given ratio of the distance from A to B, by linear interpolation.
*/
function interpolateBetweenPoints(ptA, ptB, ratio) {
    if (ptB.x !== ptA.x) {
        return {
            x: ptA.x + ratio * (ptB.x - ptA.x),
            y: ptA.y + ratio * (ptB.y - ptA.y)
        };
    }
    // special case where points lie on the same vertical axis
    return {
        x: ptA.x,
        y: ptA.y + (ptB.y - ptA.y) * ratio
    };
}

(function() {
    // save these original methods before they are overwritten
    var proto_initIcon = L.Marker.prototype._initIcon;
    var proto_setPos = L.Marker.prototype._setPos;

    var oldIE = (L.DomUtil.TRANSFORM === 'msTransform');

    L.Marker.addInitHook(function () {
        var iconOptions = this.options.icon && this.options.icon.options;
        var iconAnchor = iconOptions && this.options.icon.options.iconAnchor;
        if (iconAnchor) {
            iconAnchor = (iconAnchor[0] + 'px ' + iconAnchor[1] + 'px');
        }
        this.options.rotationOrigin = this.options.rotationOrigin || iconAnchor || 'center bottom' ;
        this.options.rotationAngle = this.options.rotationAngle || 0;

        // Ensure marker keeps rotated during dragging
        this.on('drag', function(e) { e.target._applyRotation(); });
    });

    L.Marker.include({
        _initIcon: function() {
            proto_initIcon.call(this);
        },

        _setPos: function (pos) {
            proto_setPos.call(this, pos);
            this._applyRotation();
        },

        _applyRotation: function () {
            if(this.options.rotationAngle) {
                this._icon.style[L.DomUtil.TRANSFORM+'Origin'] = this.options.rotationOrigin;

                if(oldIE) {
                    // for IE 9, use the 2D rotation
                    this._icon.style[L.DomUtil.TRANSFORM] = 'rotate(' + this.options.rotationAngle + 'deg)';
                } else {
                    // for modern browsers, prefer the 3D accelerated version
                    this._icon.style[L.DomUtil.TRANSFORM] += ' rotateZ(' + this.options.rotationAngle + 'deg)';
                }
            }
        },

        setRotationAngle: function(angle) {
            this.options.rotationAngle = angle;
            this.update();
            return this;
        },

        setRotationOrigin: function(origin) {
            this.options.rotationOrigin = origin;
            this.update();
            return this;
        }
    });
})();

// enable rotationAngle and rotationOrigin support on L.Marker
/**
* Defines several classes of symbol factories,
* to be used with L.PolylineDecorator
*/

L$1.Symbol = L$1.Symbol || {};

/**
* A simple dash symbol, drawn as a Polyline.
* Can also be used for dots, if 'pixelSize' option is given the 0 value.
*/
L$1.Symbol.Dash = L$1.Class.extend({
    options: {
        pixelSize: 10,
        pathOptions: {}
    },

    initialize: function initialize(options) {
        L$1.Util.setOptions(this, options);
        this.options.pathOptions.clickable = false;
    },

    buildSymbol: function buildSymbol(dirPoint, latLngs, map, index, total) {
        var opts = this.options;
        var d2r = Math.PI / 180;

        // for a dot, nothing more to compute
        if (opts.pixelSize <= 1) {
            return L$1.polyline([dirPoint.latLng, dirPoint.latLng], opts.pathOptions);
        }

        var midPoint = map.project(dirPoint.latLng);
        var angle = -(dirPoint.heading - 90) * d2r;
        var a = L$1.point(midPoint.x + opts.pixelSize * Math.cos(angle + Math.PI) / 2, midPoint.y + opts.pixelSize * Math.sin(angle) / 2);
        // compute second point by central symmetry to avoid unecessary cos/sin
        var b = midPoint.add(midPoint.subtract(a));
        return L$1.polyline([map.unproject(a), map.unproject(b)], opts.pathOptions);
    }
});

L$1.Symbol.dash = function (options) {
    return new L$1.Symbol.Dash(options);
};

L$1.Symbol.ArrowHead = L$1.Class.extend({
    options: {
        polygon: true,
        pixelSize: 10,
        headAngle: 60,
        pathOptions: {
            stroke: false,
            weight: 2
        }
    },

    initialize: function initialize(options) {
        L$1.Util.setOptions(this, options);
        this.options.pathOptions.clickable = false;
    },

    buildSymbol: function buildSymbol(dirPoint, latLngs, map, index, total) {
        return this.options.polygon ? L$1.polygon(this._buildArrowPath(dirPoint, map), this.options.pathOptions) : L$1.polyline(this._buildArrowPath(dirPoint, map), this.options.pathOptions);
    },

    _buildArrowPath: function _buildArrowPath(dirPoint, map) {
        var d2r = Math.PI / 180;
        var tipPoint = map.project(dirPoint.latLng);
        var direction = -(dirPoint.heading - 90) * d2r;
        var radianArrowAngle = this.options.headAngle / 2 * d2r;

        var headAngle1 = direction + radianArrowAngle;
        var headAngle2 = direction - radianArrowAngle;
        var arrowHead1 = L$1.point(tipPoint.x - this.options.pixelSize * Math.cos(headAngle1), tipPoint.y + this.options.pixelSize * Math.sin(headAngle1));
        var arrowHead2 = L$1.point(tipPoint.x - this.options.pixelSize * Math.cos(headAngle2), tipPoint.y + this.options.pixelSize * Math.sin(headAngle2));

        return [map.unproject(arrowHead1), dirPoint.latLng, map.unproject(arrowHead2)];
    }
});

L$1.Symbol.arrowHead = function (options) {
    return new L$1.Symbol.ArrowHead(options);
};

L$1.Symbol.Marker = L$1.Class.extend({
    options: {
        markerOptions: {},
        rotate: false
    },

    initialize: function initialize(options) {
        L$1.Util.setOptions(this, options);
        this.options.markerOptions.clickable = false;
        this.options.markerOptions.draggable = false;
    },

    buildSymbol: function buildSymbol(directionPoint, latLngs, map, index, total) {
        if (this.options.rotate) {
            this.options.markerOptions.rotationAngle = directionPoint.heading + (this.options.angleCorrection || 0);
        }
        return L$1.marker(directionPoint.latLng, this.options.markerOptions);
    }
});

L$1.Symbol.marker = function (options) {
    return new L$1.Symbol.Marker(options);
};

L$1.PolylineDecorator = L$1.FeatureGroup.extend({
    options: {
        patterns: []
    },

    initialize: function initialize(paths, options) {
        L$1.FeatureGroup.prototype.initialize.call(this);
        L$1.Util.setOptions(this, options);
        this._map = null;
        this._paths = this._initPaths(paths);
        this._patterns = this._initPatterns(this.options.patterns);
    },

    /**
    * Deals with all the different cases. input can be one of these types:
    * array of LatLng, array of 2-number arrays, Polyline, Polygon,
    * array of one of the previous.
    */
    _initPaths: function _initPaths(input, isPolygon) {
        var _this = this;

        if (this._isCoordArray(input)) {
            // Leaflet Polygons don't need the first point to be repeated, but we do
            var coords = isPolygon ? input.concat([input[0]]) : input;
            return [coords];
        }
        if (input instanceof L$1.Polyline) {
            // we need some recursivity to support multi-poly*
            return this._initPaths(input.getLatLngs(), input instanceof L$1.Polygon);
        }
        if (Array.isArray(input)) {
            // flatten everything, we just need coordinate lists to apply patterns
            return input.reduce(function (flatArray, p) {
                return flatArray.concat(_this._initPaths(p, isPolygon));
            }, []);
        }
        return [];
    },

    _isCoordArray: function _isCoordArray(ll) {
        return Array.isArray(ll) && this._isCoord(ll[0]);
    },

    _isCoord: function _isCoord(c) {
        return c instanceof L$1.LatLng || Array.isArray(c) && c.length === 2 && typeof c[0] === 'number';
    },

    // parse pattern definitions and precompute some values
    _initPatterns: function _initPatterns(patternDefs) {
        return patternDefs.map(this._parsePatternDef);
    },

    /**
    * Changes the patterns used by this decorator
    * and redraws the new one.
    */
    setPatterns: function setPatterns(patterns) {
        this.options.patterns = patterns;
        this._patterns = this._initPatterns(this.options.patterns);
        this.redraw();
    },

    /**
    * Changes the patterns used by this decorator
    * and redraws the new one.
    */
    setPaths: function setPaths(paths) {
        this._paths = this._initPaths(paths);
        this.redraw();
    },

    /**
    * Parse the pattern definition
    */
    _parsePatternDef: function _parsePatternDef(patternDef, latLngs) {
        return {
            symbolFactory: patternDef.symbol,
            // Parse offset and repeat values, managing the two cases:
            // absolute (in pixels) or relative (in percentage of the polyline length)
            offset: parseRelativeOrAbsoluteValue(patternDef.offset),
            endOffset: parseRelativeOrAbsoluteValue(patternDef.endOffset),
            repeat: parseRelativeOrAbsoluteValue(patternDef.repeat)
        };
    },

    onAdd: function onAdd(map) {
        this._map = map;
        this._draw();
        this._map.on('moveend', this.redraw, this);
    },

    onRemove: function onRemove(map) {
        this._map.off('moveend', this.redraw, this);
        this._map = null;
        L$1.LayerGroup.prototype.onRemove.call(this, map);
    },

    /**
    * Returns an array of ILayers object
    */
    _buildSymbols: function _buildSymbols(latLngs, symbolFactory, directionPoints) {
        var _this2 = this;

        return directionPoints.map(function (directionPoint, i) {
            return symbolFactory.buildSymbol(directionPoint, latLngs, _this2._map, i, directionPoints.length);
        });
    },

    _projectPatternOnPath: function _projectPatternOnPath(latLngs, pattern, map) {
        var pathAsPoints = latLngs.map(function (latLng) {
            return map.project(latLng);
        });
        return projectPatternOnPointPath(pathAsPoints, pattern).map(function (point) {
            return {
                latLng: map.unproject(L$1.point(point.pt)),
                heading: point.heading
            };
        });
    },

    /**
    * Select pairs of LatLng and heading angle,
    * that define positions and directions of the symbols
    * on the path
    */
    _getDirectionPoints: function _getDirectionPoints(pathIndex, pattern) {
        var latLngs = this._paths[pathIndex];
        if (latLngs.length < 2) {
            return [];
        }

        return this._projectPatternOnPath(latLngs, pattern, this._map);
    },

    /**
    * Public redraw, invalidating the cache.
    */
    redraw: function redraw() {
        if (!this._map) {
            return;
        }
        this.clearLayers();
        this._draw();
    },

    /**
    * Returns all symbols for a given pattern as an array of LayerGroup
    */
    _getPatternLayers: function _getPatternLayers(pattern) {
        var _this3 = this;

        var directionPoints = void 0,
            symbols = void 0;
        var mapBounds = this._map.getBounds().pad(0.1);
        return this._paths.map(function (path, i) {
            directionPoints = _this3._getDirectionPoints(i, pattern)
            // filter out invisible points
            .filter(function (point) {
                return mapBounds.contains(point.latLng);
            });

            return L$1.layerGroup(_this3._buildSymbols(path, pattern.symbolFactory, directionPoints));
        });
    },

    /**
    * Draw all patterns
    */
    _draw: function _draw() {
        var _this4 = this;

        this._patterns.map(function (pattern) {
            return _this4._getPatternLayers(pattern);
        }).forEach(function (layers) {
            _this4.addLayer(L$1.layerGroup(layers));
        });
    }
});
/*
 * Allows compact syntax to be used
 */
L$1.polylineDecorator = function (paths, options) {
    return new L$1.PolylineDecorator(paths, options);
};

})));
;
/*
 Leaflet.markercluster, Provides Beautiful Animated Marker Clustering functionality for Leaflet, a JS library for interactive maps.
 https://github.com/Leaflet/Leaflet.markercluster
 (c) 2012-2013, Dave Leaver, smartrak
*/
!function(e,t,i){L.MarkerClusterGroup=L.FeatureGroup.extend({options:{maxClusterRadius:80,iconCreateFunction:null,spiderfyOnMaxZoom:!0,showCoverageOnHover:!0,zoomToBoundsOnClick:!0,singleMarkerMode:!1,disableClusteringAtZoom:null,removeOutsideVisibleBounds:!0,animate:!0,animateAddingMarkers:!1,spiderfyDistanceMultiplier:1,spiderLegPolylineOptions:{weight:1.5,color:"#222",opacity:.5},chunkedLoading:!1,chunkInterval:200,chunkDelay:50,chunkProgress:null,polygonOptions:{}},initialize:function(e){L.Util.setOptions(this,e),this.options.iconCreateFunction||(this.options.iconCreateFunction=this._defaultIconCreateFunction),this.options.clusterPane||(this.options.clusterPane=L.Marker.prototype.options.pane),this._featureGroup=L.featureGroup(),this._featureGroup.addEventParent(this),this._nonPointGroup=L.featureGroup(),this._nonPointGroup.addEventParent(this),this._inZoomAnimation=0,this._needsClustering=[],this._needsRemoving=[],this._currentShownBounds=null,this._queue=[],this._childMarkerEventHandlers={dragstart:this._childMarkerDragStart,move:this._childMarkerMoved,dragend:this._childMarkerDragEnd};var t=L.DomUtil.TRANSITION&&this.options.animate;L.extend(this,t?this._withAnimation:this._noAnimation),this._markerCluster=t?L.MarkerCluster:L.MarkerClusterNonAnimated},addLayer:function(e){if(e instanceof L.LayerGroup)return this.addLayers([e]);if(!e.getLatLng)return this._nonPointGroup.addLayer(e),this.fire("layeradd",{layer:e}),this;if(!this._map)return this._needsClustering.push(e),this.fire("layeradd",{layer:e}),this;if(this.hasLayer(e))return this;this._unspiderfy&&this._unspiderfy(),this._addLayer(e,this._maxZoom),this.fire("layeradd",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons();var t=e,i=this._zoom;if(e.__parent)for(;t.__parent._zoom>=i;)t=t.__parent;return this._currentShownBounds.contains(t.getLatLng())&&(this.options.animateAddingMarkers?this._animationAddLayer(e,t):this._animationAddLayerNonAnimated(e,t)),this},removeLayer:function(e){return e instanceof L.LayerGroup?this.removeLayers([e]):e.getLatLng?this._map?e.__parent?(this._unspiderfy&&(this._unspiderfy(),this._unspiderfyLayer(e)),this._removeLayer(e,!0),this.fire("layerremove",{layer:e}),this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),e.off(this._childMarkerEventHandlers,this),this._featureGroup.hasLayer(e)&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow()),this):this:(!this._arraySplice(this._needsClustering,e)&&this.hasLayer(e)&&this._needsRemoving.push({layer:e,latlng:e._latlng}),this.fire("layerremove",{layer:e}),this):(this._nonPointGroup.removeLayer(e),this.fire("layerremove",{layer:e}),this)},addLayers:function(e,t){if(!L.Util.isArray(e))return this.addLayer(e);var i,n=this._featureGroup,r=this._nonPointGroup,s=this.options.chunkedLoading,o=this.options.chunkInterval,a=this.options.chunkProgress,h=e.length,l=0,u=!0;if(this._map){var _=(new Date).getTime(),d=L.bind(function(){for(var c=(new Date).getTime();h>l;l++){if(s&&0===l%200){var p=(new Date).getTime()-c;if(p>o)break}if(i=e[l],i instanceof L.LayerGroup)u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length;else if(i.getLatLng){if(!this.hasLayer(i)&&(this._addLayer(i,this._maxZoom),t||this.fire("layeradd",{layer:i}),i.__parent&&2===i.__parent.getChildCount())){var f=i.__parent.getAllChildMarkers(),m=f[0]===i?f[1]:f[0];n.removeLayer(m)}}else r.addLayer(i),t||this.fire("layeradd",{layer:i})}a&&a(l,h,(new Date).getTime()-_),l===h?(this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds)):setTimeout(d,this.options.chunkDelay)},this);d()}else for(var c=this._needsClustering;h>l;l++)i=e[l],i instanceof L.LayerGroup?(u&&(e=e.slice(),u=!1),this._extractNonGroupLayers(i,e),h=e.length):i.getLatLng?this.hasLayer(i)||c.push(i):r.addLayer(i);return this},removeLayers:function(e){var t,i,n=e.length,r=this._featureGroup,s=this._nonPointGroup,o=!0;if(!this._map){for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):(this._arraySplice(this._needsClustering,i),s.removeLayer(i),this.hasLayer(i)&&this._needsRemoving.push({layer:i,latlng:i._latlng}),this.fire("layerremove",{layer:i}));return this}if(this._unspiderfy){this._unspiderfy();var a=e.slice(),h=n;for(t=0;h>t;t++)i=a[t],i instanceof L.LayerGroup?(this._extractNonGroupLayers(i,a),h=a.length):this._unspiderfyLayer(i)}for(t=0;n>t;t++)i=e[t],i instanceof L.LayerGroup?(o&&(e=e.slice(),o=!1),this._extractNonGroupLayers(i,e),n=e.length):i.__parent?(this._removeLayer(i,!0,!0),this.fire("layerremove",{layer:i}),r.hasLayer(i)&&(r.removeLayer(i),i.clusterShow&&i.clusterShow())):(s.removeLayer(i),this.fire("layerremove",{layer:i}));return this._topClusterLevel._recalculateBounds(),this._refreshClustersIcons(),this._topClusterLevel._recursivelyAddChildrenToMap(null,this._zoom,this._currentShownBounds),this},clearLayers:function(){return this._map||(this._needsClustering=[],delete this._gridClusters,delete this._gridUnclustered),this._noanimationUnspiderfy&&this._noanimationUnspiderfy(),this._featureGroup.clearLayers(),this._nonPointGroup.clearLayers(),this.eachLayer(function(e){e.off(this._childMarkerEventHandlers,this),delete e.__parent},this),this._map&&this._generateInitialClusters(),this},getBounds:function(){var e=new L.LatLngBounds;this._topClusterLevel&&e.extend(this._topClusterLevel._bounds);for(var t=this._needsClustering.length-1;t>=0;t--)e.extend(this._needsClustering[t].getLatLng());return e.extend(this._nonPointGroup.getBounds()),e},eachLayer:function(e,t){var i,n,r,s=this._needsClustering.slice(),o=this._needsRemoving;for(this._topClusterLevel&&this._topClusterLevel.getAllChildMarkers(s),n=s.length-1;n>=0;n--){for(i=!0,r=o.length-1;r>=0;r--)if(o[r].layer===s[n]){i=!1;break}i&&e.call(t,s[n])}this._nonPointGroup.eachLayer(e,t)},getLayers:function(){var e=[];return this.eachLayer(function(t){e.push(t)}),e},getLayer:function(e){var t=null;return e=parseInt(e,10),this.eachLayer(function(i){L.stamp(i)===e&&(t=i)}),t},hasLayer:function(e){if(!e)return!1;var t,i=this._needsClustering;for(t=i.length-1;t>=0;t--)if(i[t]===e)return!0;for(i=this._needsRemoving,t=i.length-1;t>=0;t--)if(i[t].layer===e)return!1;return!(!e.__parent||e.__parent._group!==this)||this._nonPointGroup.hasLayer(e)},zoomToShowLayer:function(e,t){"function"!=typeof t&&(t=function(){});var i=function(){!e._icon&&!e.__parent._icon||this._inZoomAnimation||(this._map.off("moveend",i,this),this.off("animationend",i,this),e._icon?t():e.__parent._icon&&(this.once("spiderfied",t,this),e.__parent.spiderfy()))};e._icon&&this._map.getBounds().contains(e.getLatLng())?t():e.__parent._zoom<Math.round(this._map._zoom)?(this._map.on("moveend",i,this),this._map.panTo(e.getLatLng())):(this._map.on("moveend",i,this),this.on("animationend",i,this),e.__parent.zoomToBounds())},onAdd:function(e){this._map=e;var t,i,n;if(!isFinite(this._map.getMaxZoom()))throw"Map has no maxZoom specified";for(this._featureGroup.addTo(e),this._nonPointGroup.addTo(e),this._gridClusters||this._generateInitialClusters(),this._maxLat=e.options.crs.projection.MAX_LATITUDE,t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],n.newlatlng=n.layer._latlng,n.layer._latlng=n.latlng;for(t=0,i=this._needsRemoving.length;i>t;t++)n=this._needsRemoving[t],this._removeLayer(n.layer,!0),n.layer._latlng=n.newlatlng;this._needsRemoving=[],this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds(),this._map.on("zoomend",this._zoomEnd,this),this._map.on("moveend",this._moveEnd,this),this._spiderfierOnAdd&&this._spiderfierOnAdd(),this._bindEvents(),i=this._needsClustering,this._needsClustering=[],this.addLayers(i,!0)},onRemove:function(e){e.off("zoomend",this._zoomEnd,this),e.off("moveend",this._moveEnd,this),this._unbindEvents(),this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim",""),this._spiderfierOnRemove&&this._spiderfierOnRemove(),delete this._maxLat,this._hideCoverage(),this._featureGroup.remove(),this._nonPointGroup.remove(),this._featureGroup.clearLayers(),this._map=null},getVisibleParent:function(e){for(var t=e;t&&!t._icon;)t=t.__parent;return t||null},_arraySplice:function(e,t){for(var i=e.length-1;i>=0;i--)if(e[i]===t)return e.splice(i,1),!0},_removeFromGridUnclustered:function(e,t){for(var i=this._map,n=this._gridUnclustered,r=Math.floor(this._map.getMinZoom());t>=r&&n[t].removeObject(e,i.project(e.getLatLng(),t));t--);},_childMarkerDragStart:function(e){e.target.__dragStart=e.target._latlng},_childMarkerMoved:function(e){if(!this._ignoreMove&&!e.target.__dragStart){var t=e.target._popup&&e.target._popup.isOpen();this._moveChild(e.target,e.oldLatLng,e.latlng),t&&e.target.openPopup()}},_moveChild:function(e,t,i){e._latlng=t,this.removeLayer(e),e._latlng=i,this.addLayer(e)},_childMarkerDragEnd:function(e){e.target.__dragStart&&this._moveChild(e.target,e.target.__dragStart,e.target._latlng),delete e.target.__dragStart},_removeLayer:function(e,t,i){var n=this._gridClusters,r=this._gridUnclustered,s=this._featureGroup,o=this._map,a=Math.floor(this._map.getMinZoom());t&&this._removeFromGridUnclustered(e,this._maxZoom);var h,l=e.__parent,u=l._markers;for(this._arraySplice(u,e);l&&(l._childCount--,l._boundsNeedUpdate=!0,!(l._zoom<a));)t&&l._childCount<=1?(h=l._markers[0]===e?l._markers[1]:l._markers[0],n[l._zoom].removeObject(l,o.project(l._cLatLng,l._zoom)),r[l._zoom].addObject(h,o.project(h.getLatLng(),l._zoom)),this._arraySplice(l.__parent._childClusters,l),l.__parent._markers.push(h),h.__parent=l.__parent,l._icon&&(s.removeLayer(l),i||s.addLayer(h))):l._iconNeedsUpdate=!0,l=l.__parent;delete e.__parent},_isOrIsParent:function(e,t){for(;t;){if(e===t)return!0;t=t.parentNode}return!1},fire:function(e,t,i){if(t&&t.layer instanceof L.MarkerCluster){if(t.originalEvent&&this._isOrIsParent(t.layer._icon,t.originalEvent.relatedTarget))return;e="cluster"+e}L.FeatureGroup.prototype.fire.call(this,e,t,i)},listens:function(e,t){return L.FeatureGroup.prototype.listens.call(this,e,t)||L.FeatureGroup.prototype.listens.call(this,"cluster"+e,t)},_defaultIconCreateFunction:function(e){var t=e.getChildCount(),i=" marker-cluster-";return i+=10>t?"small":100>t?"medium":"large",new L.DivIcon({html:"<div><span>"+t+"</span></div>",className:"marker-cluster"+i,iconSize:new L.Point(40,40)})},_bindEvents:function(){var e=this._map,t=this.options.spiderfyOnMaxZoom,i=this.options.showCoverageOnHover,n=this.options.zoomToBoundsOnClick;(t||n)&&this.on("clusterclick",this._zoomOrSpiderfy,this),i&&(this.on("clustermouseover",this._showCoverage,this),this.on("clustermouseout",this._hideCoverage,this),e.on("zoomend",this._hideCoverage,this))},_zoomOrSpiderfy:function(e){for(var t=e.layer,i=t;1===i._childClusters.length;)i=i._childClusters[0];i._zoom===this._maxZoom&&i._childCount===t._childCount&&this.options.spiderfyOnMaxZoom?t.spiderfy():this.options.zoomToBoundsOnClick&&t.zoomToBounds(),e.originalEvent&&13===e.originalEvent.keyCode&&this._map._container.focus()},_showCoverage:function(e){var t=this._map;this._inZoomAnimation||(this._shownPolygon&&t.removeLayer(this._shownPolygon),e.layer.getChildCount()>2&&e.layer!==this._spiderfied&&(this._shownPolygon=new L.Polygon(e.layer.getConvexHull(),this.options.polygonOptions),t.addLayer(this._shownPolygon)))},_hideCoverage:function(){this._shownPolygon&&(this._map.removeLayer(this._shownPolygon),this._shownPolygon=null)},_unbindEvents:function(){var e=this.options.spiderfyOnMaxZoom,t=this.options.showCoverageOnHover,i=this.options.zoomToBoundsOnClick,n=this._map;(e||i)&&this.off("clusterclick",this._zoomOrSpiderfy,this),t&&(this.off("clustermouseover",this._showCoverage,this),this.off("clustermouseout",this._hideCoverage,this),n.off("zoomend",this._hideCoverage,this))},_zoomEnd:function(){this._map&&(this._mergeSplitClusters(),this._zoom=Math.round(this._map._zoom),this._currentShownBounds=this._getExpandedVisibleBounds())},_moveEnd:function(){if(!this._inZoomAnimation){var e=this._getExpandedVisibleBounds();this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,e),this._topClusterLevel._recursivelyAddChildrenToMap(null,Math.round(this._map._zoom),e),this._currentShownBounds=e}},_generateInitialClusters:function(){var e=Math.ceil(this._map.getMaxZoom()),t=Math.floor(this._map.getMinZoom()),i=this.options.maxClusterRadius,n=i;"function"!=typeof i&&(n=function(){return i}),null!==this.options.disableClusteringAtZoom&&(e=this.options.disableClusteringAtZoom-1),this._maxZoom=e,this._gridClusters={},this._gridUnclustered={};for(var r=e;r>=t;r--)this._gridClusters[r]=new L.DistanceGrid(n(r)),this._gridUnclustered[r]=new L.DistanceGrid(n(r));this._topClusterLevel=new this._markerCluster(this,t-1)},_addLayer:function(e,t){var i,n,r=this._gridClusters,s=this._gridUnclustered,o=Math.floor(this._map.getMinZoom());for(this.options.singleMarkerMode&&this._overrideMarkerIcon(e),e.on(this._childMarkerEventHandlers,this);t>=o;t--){i=this._map.project(e.getLatLng(),t);var a=r[t].getNearObject(i);if(a)return a._addChild(e),e.__parent=a,void 0;if(a=s[t].getNearObject(i)){var h=a.__parent;h&&this._removeLayer(a,!1);var l=new this._markerCluster(this,t,a,e);r[t].addObject(l,this._map.project(l._cLatLng,t)),a.__parent=l,e.__parent=l;var u=l;for(n=t-1;n>h._zoom;n--)u=new this._markerCluster(this,n,u),r[n].addObject(u,this._map.project(a.getLatLng(),n));return h._addChild(u),this._removeFromGridUnclustered(a,t),void 0}s[t].addObject(e,i)}this._topClusterLevel._addChild(e),e.__parent=this._topClusterLevel},_refreshClustersIcons:function(){this._featureGroup.eachLayer(function(e){e instanceof L.MarkerCluster&&e._iconNeedsUpdate&&e._updateIcon()})},_enqueue:function(e){this._queue.push(e),this._queueTimeout||(this._queueTimeout=setTimeout(L.bind(this._processQueue,this),300))},_processQueue:function(){for(var e=0;e<this._queue.length;e++)this._queue[e].call(this);this._queue.length=0,clearTimeout(this._queueTimeout),this._queueTimeout=null},_mergeSplitClusters:function(){var e=Math.round(this._map._zoom);this._processQueue(),this._zoom<e&&this._currentShownBounds.intersects(this._getExpandedVisibleBounds())?(this._animationStart(),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),this._zoom,this._getExpandedVisibleBounds()),this._animationZoomIn(this._zoom,e)):this._zoom>e?(this._animationStart(),this._animationZoomOut(this._zoom,e)):this._moveEnd()},_getExpandedVisibleBounds:function(){return this.options.removeOutsideVisibleBounds?L.Browser.mobile?this._checkBoundsMaxLat(this._map.getBounds()):this._checkBoundsMaxLat(this._map.getBounds().pad(1)):this._mapBoundsInfinite},_checkBoundsMaxLat:function(e){var t=this._maxLat;return t!==i&&(e.getNorth()>=t&&(e._northEast.lat=1/0),e.getSouth()<=-t&&(e._southWest.lat=-1/0)),e},_animationAddLayerNonAnimated:function(e,t){if(t===e)this._featureGroup.addLayer(e);else if(2===t._childCount){t._addToMap();var i=t.getAllChildMarkers();this._featureGroup.removeLayer(i[0]),this._featureGroup.removeLayer(i[1])}else t._updateIcon()},_extractNonGroupLayers:function(e,t){var i,n=e.getLayers(),r=0;for(t=t||[];r<n.length;r++)i=n[r],i instanceof L.LayerGroup?this._extractNonGroupLayers(i,t):t.push(i);return t},_overrideMarkerIcon:function(e){var t=e.options.icon=this.options.iconCreateFunction({getChildCount:function(){return 1},getAllChildMarkers:function(){return[e]}});return t}}),L.MarkerClusterGroup.include({_mapBoundsInfinite:new L.LatLngBounds(new L.LatLng(-1/0,-1/0),new L.LatLng(1/0,1/0))}),L.MarkerClusterGroup.include({_noAnimation:{_animationStart:function(){},_animationZoomIn:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationZoomOut:function(e,t){this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this.fire("animationend")},_animationAddLayer:function(e,t){this._animationAddLayerNonAnimated(e,t)}},_withAnimation:{_animationStart:function(){this._map._mapPane.className+=" leaflet-cluster-anim",this._inZoomAnimation++},_animationZoomIn:function(e,t){var i,n=this._getExpandedVisibleBounds(),r=this._featureGroup,s=Math.floor(this._map.getMinZoom());this._ignoreMove=!0,this._topClusterLevel._recursively(n,e,s,function(s){var o,a=s._latlng,h=s._markers;for(n.contains(a)||(a=null),s._isSingleParent()&&e+1===t?(r.removeLayer(s),s._recursivelyAddChildrenToMap(null,t,n)):(s.clusterHide(),s._recursivelyAddChildrenToMap(a,t,n)),i=h.length-1;i>=0;i--)o=h[i],n.contains(o._latlng)||r.removeLayer(o)}),this._forceLayout(),this._topClusterLevel._recursivelyBecomeVisible(n,t),r.eachLayer(function(e){e instanceof L.MarkerCluster||!e._icon||e.clusterShow()}),this._topClusterLevel._recursively(n,e,t,function(e){e._recursivelyRestoreChildPositions(t)}),this._ignoreMove=!1,this._enqueue(function(){this._topClusterLevel._recursively(n,e,s,function(e){r.removeLayer(e),e.clusterShow()}),this._animationEnd()})},_animationZoomOut:function(e,t){this._animationZoomOutSingle(this._topClusterLevel,e-1,t),this._topClusterLevel._recursivelyAddChildrenToMap(null,t,this._getExpandedVisibleBounds()),this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds,Math.floor(this._map.getMinZoom()),e,this._getExpandedVisibleBounds())},_animationAddLayer:function(e,t){var i=this,n=this._featureGroup;n.addLayer(e),t!==e&&(t._childCount>2?(t._updateIcon(),this._forceLayout(),this._animationStart(),e._setPos(this._map.latLngToLayerPoint(t.getLatLng())),e.clusterHide(),this._enqueue(function(){n.removeLayer(e),e.clusterShow(),i._animationEnd()})):(this._forceLayout(),i._animationStart(),i._animationZoomOutSingle(t,this._map.getMaxZoom(),this._zoom)))}},_animationZoomOutSingle:function(e,t,i){var n=this._getExpandedVisibleBounds(),r=Math.floor(this._map.getMinZoom());e._recursivelyAnimateChildrenInAndAddSelfToMap(n,r,t+1,i);var s=this;this._forceLayout(),e._recursivelyBecomeVisible(n,i),this._enqueue(function(){if(1===e._childCount){var o=e._markers[0];this._ignoreMove=!0,o.setLatLng(o.getLatLng()),this._ignoreMove=!1,o.clusterShow&&o.clusterShow()}else e._recursively(n,i,r,function(e){e._recursivelyRemoveChildrenFromMap(n,r,t+1)});s._animationEnd()})},_animationEnd:function(){this._map&&(this._map._mapPane.className=this._map._mapPane.className.replace(" leaflet-cluster-anim","")),this._inZoomAnimation--,this.fire("animationend")},_forceLayout:function(){L.Util.falseFn(t.body.offsetWidth)}}),L.markerClusterGroup=function(e){return new L.MarkerClusterGroup(e)},L.MarkerCluster=L.Marker.extend({initialize:function(e,t,i,n){L.Marker.prototype.initialize.call(this,i?i._cLatLng||i.getLatLng():new L.LatLng(0,0),{icon:this,pane:e.options.clusterPane}),this._group=e,this._zoom=t,this._markers=[],this._childClusters=[],this._childCount=0,this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._bounds=new L.LatLngBounds,i&&this._addChild(i),n&&this._addChild(n)},getAllChildMarkers:function(e){e=e||[];for(var t=this._childClusters.length-1;t>=0;t--)this._childClusters[t].getAllChildMarkers(e);for(var i=this._markers.length-1;i>=0;i--)e.push(this._markers[i]);return e},getChildCount:function(){return this._childCount},zoomToBounds:function(e){for(var t,i=this._childClusters.slice(),n=this._group._map,r=n.getBoundsZoom(this._bounds),s=this._zoom+1,o=n.getZoom();i.length>0&&r>s;){s++;var a=[];for(t=0;t<i.length;t++)a=a.concat(i[t]._childClusters);i=a}r>s?this._group._map.setView(this._latlng,s):o>=r?this._group._map.setView(this._latlng,o+1):this._group._map.fitBounds(this._bounds,e)},getBounds:function(){var e=new L.LatLngBounds;return e.extend(this._bounds),e},_updateIcon:function(){this._iconNeedsUpdate=!0,this._icon&&this.setIcon(this)},createIcon:function(){return this._iconNeedsUpdate&&(this._iconObj=this._group.options.iconCreateFunction(this),this._iconNeedsUpdate=!1),this._iconObj.createIcon()},createShadow:function(){return this._iconObj.createShadow()},_addChild:function(e,t){this._iconNeedsUpdate=!0,this._boundsNeedUpdate=!0,this._setClusterCenter(e),e instanceof L.MarkerCluster?(t||(this._childClusters.push(e),e.__parent=this),this._childCount+=e._childCount):(t||this._markers.push(e),this._childCount++),this.__parent&&this.__parent._addChild(e,!0)},_setClusterCenter:function(e){this._cLatLng||(this._cLatLng=e._cLatLng||e._latlng)},_resetBounds:function(){var e=this._bounds;e._southWest&&(e._southWest.lat=1/0,e._southWest.lng=1/0),e._northEast&&(e._northEast.lat=-1/0,e._northEast.lng=-1/0)},_recalculateBounds:function(){var e,t,i,n,r=this._markers,s=this._childClusters,o=0,a=0,h=this._childCount;if(0!==h){for(this._resetBounds(),e=0;e<r.length;e++)i=r[e]._latlng,this._bounds.extend(i),o+=i.lat,a+=i.lng;for(e=0;e<s.length;e++)t=s[e],t._boundsNeedUpdate&&t._recalculateBounds(),this._bounds.extend(t._bounds),i=t._wLatLng,n=t._childCount,o+=i.lat*n,a+=i.lng*n;this._latlng=this._wLatLng=new L.LatLng(o/h,a/h),this._boundsNeedUpdate=!1}},_addToMap:function(e){e&&(this._backupLatlng=this._latlng,this.setLatLng(e)),this._group._featureGroup.addLayer(this)},_recursivelyAnimateChildrenIn:function(e,t,i){this._recursively(e,this._group._map.getMinZoom(),i-1,function(e){var i,n,r=e._markers;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())},function(e){var i,n,r=e._childClusters;for(i=r.length-1;i>=0;i--)n=r[i],n._icon&&(n._setPos(t),n.clusterHide())})},_recursivelyAnimateChildrenInAndAddSelfToMap:function(e,t,i,n){this._recursively(e,n,t,function(r){r._recursivelyAnimateChildrenIn(e,r._group._map.latLngToLayerPoint(r.getLatLng()).round(),i),r._isSingleParent()&&i-1===n?(r.clusterShow(),r._recursivelyRemoveChildrenFromMap(e,t,i)):r.clusterHide(),r._addToMap()})},_recursivelyBecomeVisible:function(e,t){this._recursively(e,this._group._map.getMinZoom(),t,null,function(e){e.clusterShow()})},_recursivelyAddChildrenToMap:function(e,t,i){this._recursively(i,this._group._map.getMinZoom()-1,t,function(n){if(t!==n._zoom)for(var r=n._markers.length-1;r>=0;r--){var s=n._markers[r];i.contains(s._latlng)&&(e&&(s._backupLatlng=s.getLatLng(),s.setLatLng(e),s.clusterHide&&s.clusterHide()),n._group._featureGroup.addLayer(s))}},function(t){t._addToMap(e)})},_recursivelyRestoreChildPositions:function(e){for(var t=this._markers.length-1;t>=0;t--){var i=this._markers[t];i._backupLatlng&&(i.setLatLng(i._backupLatlng),delete i._backupLatlng)}if(e-1===this._zoom)for(var n=this._childClusters.length-1;n>=0;n--)this._childClusters[n]._restorePosition();else for(var r=this._childClusters.length-1;r>=0;r--)this._childClusters[r]._recursivelyRestoreChildPositions(e)},_restorePosition:function(){this._backupLatlng&&(this.setLatLng(this._backupLatlng),delete this._backupLatlng)},_recursivelyRemoveChildrenFromMap:function(e,t,i,n){var r,s;this._recursively(e,t-1,i-1,function(e){for(s=e._markers.length-1;s>=0;s--)r=e._markers[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())},function(e){for(s=e._childClusters.length-1;s>=0;s--)r=e._childClusters[s],n&&n.contains(r._latlng)||(e._group._featureGroup.removeLayer(r),r.clusterShow&&r.clusterShow())})},_recursively:function(e,t,i,n,r){var s,o,a=this._childClusters,h=this._zoom;if(h>=t&&(n&&n(this),r&&h===i&&r(this)),t>h||i>h)for(s=a.length-1;s>=0;s--)o=a[s],e.intersects(o._bounds)&&o._recursively(e,t,i,n,r)},_isSingleParent:function(){return this._childClusters.length>0&&this._childClusters[0]._childCount===this._childCount}}),L.Marker.include({clusterHide:function(){return this.options.opacityWhenUnclustered=this.options.opacity||1,this.setOpacity(0)},clusterShow:function(){var e=this.setOpacity(this.options.opacity||this.options.opacityWhenUnclustered);return delete this.options.opacityWhenUnclustered,e}}),L.DistanceGrid=function(e){this._cellSize=e,this._sqCellSize=e*e,this._grid={},this._objectPoint={}},L.DistanceGrid.prototype={addObject:function(e,t){var i=this._getCoord(t.x),n=this._getCoord(t.y),r=this._grid,s=r[n]=r[n]||{},o=s[i]=s[i]||[],a=L.Util.stamp(e);this._objectPoint[a]=t,o.push(e)},updateObject:function(e,t){this.removeObject(e),this.addObject(e,t)},removeObject:function(e,t){var i,n,r=this._getCoord(t.x),s=this._getCoord(t.y),o=this._grid,a=o[s]=o[s]||{},h=a[r]=a[r]||[];for(delete this._objectPoint[L.Util.stamp(e)],i=0,n=h.length;n>i;i++)if(h[i]===e)return h.splice(i,1),1===n&&delete a[r],!0},eachObject:function(e,t){var i,n,r,s,o,a,h,l=this._grid;for(i in l){o=l[i];for(n in o)for(a=o[n],r=0,s=a.length;s>r;r++)h=e.call(t,a[r]),h&&(r--,s--)}},getNearObject:function(e){var t,i,n,r,s,o,a,h,l=this._getCoord(e.x),u=this._getCoord(e.y),_=this._objectPoint,d=this._sqCellSize,c=null;for(t=u-1;u+1>=t;t++)if(r=this._grid[t])for(i=l-1;l+1>=i;i++)if(s=r[i])for(n=0,o=s.length;o>n;n++)a=s[n],h=this._sqDist(_[L.Util.stamp(a)],e),d>h&&(d=h,c=a);return c},_getCoord:function(e){return Math.floor(e/this._cellSize)},_sqDist:function(e,t){var i=t.x-e.x,n=t.y-e.y;return i*i+n*n}},function(){L.QuickHull={getDistant:function(e,t){var i=t[1].lat-t[0].lat,n=t[0].lng-t[1].lng;return n*(e.lat-t[0].lat)+i*(e.lng-t[0].lng)},findMostDistantPointFromBaseLine:function(e,t){var i,n,r,s=0,o=null,a=[];for(i=t.length-1;i>=0;i--)n=t[i],r=this.getDistant(n,e),r>0&&(a.push(n),r>s&&(s=r,o=n));return{maxPoint:o,newPoints:a}},buildConvexHull:function(e,t){var i=[],n=this.findMostDistantPointFromBaseLine(e,t);return n.maxPoint?(i=i.concat(this.buildConvexHull([e[0],n.maxPoint],n.newPoints)),i=i.concat(this.buildConvexHull([n.maxPoint,e[1]],n.newPoints))):[e[0]]},getConvexHull:function(e){var t,i=!1,n=!1,r=!1,s=!1,o=null,a=null,h=null,l=null,u=null,_=null;for(t=e.length-1;t>=0;t--){var d=e[t];(i===!1||d.lat>i)&&(o=d,i=d.lat),(n===!1||d.lat<n)&&(a=d,n=d.lat),(r===!1||d.lng>r)&&(h=d,r=d.lng),(s===!1||d.lng<s)&&(l=d,s=d.lng)}n!==i?(_=a,u=o):(_=l,u=h);var c=[].concat(this.buildConvexHull([_,u],e),this.buildConvexHull([u,_],e));return c}}}(),L.MarkerCluster.include({getConvexHull:function(){var e,t,i=this.getAllChildMarkers(),n=[];for(t=i.length-1;t>=0;t--)e=i[t].getLatLng(),n.push(e);return L.QuickHull.getConvexHull(n)}}),L.MarkerCluster.include({_2PI:2*Math.PI,_circleFootSeparation:25,_circleStartAngle:Math.PI/6,_spiralFootSeparation:28,_spiralLengthStart:11,_spiralLengthFactor:5,_circleSpiralSwitchover:9,spiderfy:function(){if(this._group._spiderfied!==this&&!this._group._inZoomAnimation){var e,t=this.getAllChildMarkers(),i=this._group,n=i._map,r=n.latLngToLayerPoint(this._latlng);this._group._unspiderfy(),this._group._spiderfied=this,t.length>=this._circleSpiralSwitchover?e=this._generatePointsSpiral(t.length,r):(r.y+=10,e=this._generatePointsCircle(t.length,r)),this._animationSpiderfy(t,e)}},unspiderfy:function(e){this._group._inZoomAnimation||(this._animationUnspiderfy(e),this._group._spiderfied=null)},_generatePointsCircle:function(e,t){var i,n,r=this._group.options.spiderfyDistanceMultiplier*this._circleFootSeparation*(2+e),s=r/this._2PI,o=this._2PI/e,a=[];for(a.length=e,i=e-1;i>=0;i--)n=this._circleStartAngle+i*o,a[i]=new L.Point(t.x+s*Math.cos(n),t.y+s*Math.sin(n))._round();return a},_generatePointsSpiral:function(e,t){var i,n=this._group.options.spiderfyDistanceMultiplier,r=n*this._spiralLengthStart,s=n*this._spiralFootSeparation,o=n*this._spiralLengthFactor*this._2PI,a=0,h=[];for(h.length=e,i=e-1;i>=0;i--)a+=s/r+5e-4*i,h[i]=new L.Point(t.x+r*Math.cos(a),t.y+r*Math.sin(a))._round(),r+=o/a;return h},_noanimationUnspiderfy:function(){var e,t,i=this._group,n=i._map,r=i._featureGroup,s=this.getAllChildMarkers();for(i._ignoreMove=!0,this.setOpacity(1),t=s.length-1;t>=0;t--)e=s[t],r.removeLayer(e),e._preSpiderfyLatlng&&(e.setLatLng(e._preSpiderfyLatlng),delete e._preSpiderfyLatlng),e.setZIndexOffset&&e.setZIndexOffset(0),e._spiderLeg&&(n.removeLayer(e._spiderLeg),delete e._spiderLeg);i.fire("unspiderfied",{cluster:this,markers:s}),i._ignoreMove=!1,i._spiderfied=null}}),L.MarkerClusterNonAnimated=L.MarkerCluster.extend({_animationSpiderfy:function(e,t){var i,n,r,s,o=this._group,a=o._map,h=o._featureGroup,l=this._group.options.spiderLegPolylineOptions;for(o._ignoreMove=!0,i=0;i<e.length;i++)s=a.layerPointToLatLng(t[i]),n=e[i],r=new L.Polyline([this._latlng,s],l),a.addLayer(r),n._spiderLeg=r,n._preSpiderfyLatlng=n._latlng,n.setLatLng(s),n.setZIndexOffset&&n.setZIndexOffset(1e6),h.addLayer(n);this.setOpacity(.3),o._ignoreMove=!1,o.fire("spiderfied",{cluster:this,markers:e})},_animationUnspiderfy:function(){this._noanimationUnspiderfy()}}),L.MarkerCluster.include({_animationSpiderfy:function(e,t){var n,r,s,o,a,h,l=this,u=this._group,_=u._map,d=u._featureGroup,c=this._latlng,p=_.latLngToLayerPoint(c),f=L.Path.SVG,m=L.extend({},this._group.options.spiderLegPolylineOptions),g=m.opacity;for(g===i&&(g=L.MarkerClusterGroup.prototype.options.spiderLegPolylineOptions.opacity),f?(m.opacity=0,m.className=(m.className||"")+" leaflet-cluster-spider-leg"):m.opacity=g,u._ignoreMove=!0,n=0;n<e.length;n++)r=e[n],h=_.layerPointToLatLng(t[n]),s=new L.Polyline([c,h],m),_.addLayer(s),r._spiderLeg=s,f&&(o=s._path,a=o.getTotalLength()+.1,o.style.strokeDasharray=a,o.style.strokeDashoffset=a),r.setZIndexOffset&&r.setZIndexOffset(1e6),r.clusterHide&&r.clusterHide(),d.addLayer(r),r._setPos&&r._setPos(p);for(u._forceLayout(),u._animationStart(),n=e.length-1;n>=0;n--)h=_.layerPointToLatLng(t[n]),r=e[n],r._preSpiderfyLatlng=r._latlng,r.setLatLng(h),r.clusterShow&&r.clusterShow(),f&&(s=r._spiderLeg,o=s._path,o.style.strokeDashoffset=0,s.setStyle({opacity:g}));this.setOpacity(.3),u._ignoreMove=!1,setTimeout(function(){u._animationEnd(),u.fire("spiderfied",{cluster:l,markers:e})},200)},_animationUnspiderfy:function(e){var t,i,n,r,s,o,a=this,h=this._group,l=h._map,u=h._featureGroup,_=e?l._latLngToNewLayerPoint(this._latlng,e.zoom,e.center):l.latLngToLayerPoint(this._latlng),d=this.getAllChildMarkers(),c=L.Path.SVG;for(h._ignoreMove=!0,h._animationStart(),this.setOpacity(1),i=d.length-1;i>=0;i--)t=d[i],t._preSpiderfyLatlng&&(t.closePopup(),t.setLatLng(t._preSpiderfyLatlng),delete t._preSpiderfyLatlng,o=!0,t._setPos&&(t._setPos(_),o=!1),t.clusterHide&&(t.clusterHide(),o=!1),o&&u.removeLayer(t),c&&(n=t._spiderLeg,r=n._path,s=r.getTotalLength()+.1,r.style.strokeDashoffset=s,n.setStyle({opacity:0})));h._ignoreMove=!1,setTimeout(function(){var e=0;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&e++;for(i=d.length-1;i>=0;i--)t=d[i],t._spiderLeg&&(t.clusterShow&&t.clusterShow(),t.setZIndexOffset&&t.setZIndexOffset(0),e>1&&u.removeLayer(t),l.removeLayer(t._spiderLeg),delete t._spiderLeg);h._animationEnd(),h.fire("unspiderfied",{cluster:a,markers:d})},200)}}),L.MarkerClusterGroup.include({_spiderfied:null,unspiderfy:function(){this._unspiderfy.apply(this,arguments)},_spiderfierOnAdd:function(){this._map.on("click",this._unspiderfyWrapper,this),this._map.options.zoomAnimation&&this._map.on("zoomstart",this._unspiderfyZoomStart,this),this._map.on("zoomend",this._noanimationUnspiderfy,this),L.Browser.touch||this._map.getRenderer(this)},_spiderfierOnRemove:function(){this._map.off("click",this._unspiderfyWrapper,this),this._map.off("zoomstart",this._unspiderfyZoomStart,this),this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._map.off("zoomend",this._noanimationUnspiderfy,this),this._noanimationUnspiderfy()},_unspiderfyZoomStart:function(){this._map&&this._map.on("zoomanim",this._unspiderfyZoomAnim,this)},_unspiderfyZoomAnim:function(e){L.DomUtil.hasClass(this._map._mapPane,"leaflet-touching")||(this._map.off("zoomanim",this._unspiderfyZoomAnim,this),this._unspiderfy(e))},_unspiderfyWrapper:function(){this._unspiderfy()
},_unspiderfy:function(e){this._spiderfied&&this._spiderfied.unspiderfy(e)},_noanimationUnspiderfy:function(){this._spiderfied&&this._spiderfied._noanimationUnspiderfy()},_unspiderfyLayer:function(e){e._spiderLeg&&(this._featureGroup.removeLayer(e),e.clusterShow&&e.clusterShow(),e.setZIndexOffset&&e.setZIndexOffset(0),this._map.removeLayer(e._spiderLeg),delete e._spiderLeg)}}),L.MarkerClusterGroup.include({refreshClusters:function(e){return e?e instanceof L.MarkerClusterGroup?e=e._topClusterLevel.getAllChildMarkers():e instanceof L.LayerGroup?e=e._layers:e instanceof L.MarkerCluster?e=e.getAllChildMarkers():e instanceof L.Marker&&(e=[e]):e=this._topClusterLevel.getAllChildMarkers(),this._flagParentsIconsNeedUpdate(e),this._refreshClustersIcons(),this.options.singleMarkerMode&&this._refreshSingleMarkerModeMarkers(e),this},_flagParentsIconsNeedUpdate:function(e){var t,i;for(t in e)for(i=e[t].__parent;i;)i._iconNeedsUpdate=!0,i=i.__parent},_refreshSingleMarkerModeMarkers:function(e){var t,i;for(t in e)i=e[t],this.hasLayer(i)&&i.setIcon(this._overrideMarkerIcon(i))}}),L.Marker.include({refreshIconOptions:function(e,t){var i=this.options.icon;return L.setOptions(i,e),this.setIcon(i),t&&this.__parent&&this.__parent._group.refreshClusters(this),this}})}(window,document);
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20,
            'itemsPerPageTypeahead': 6
        });
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .constant('uiDatetimePickerConfig', {
            dateFormat: 'dd-MM-yyyy HH:mm', // yyyy-MM-dd HH:mm
            defaultTime: '00:00:00',
            html5Types: {
                date: 'dd-MM-yyyydd', // yyyy-MM-dd'
                'datetime-local': 'dd-MM-yyyyTHH:mm:ss.sss', //'yyyy-MM-ddTHH:mm:ss.sss'
                'month': 'MM-yyyy' // yyyy-MM
            },
            initialPicker: 'date',
            reOpenDefault: false,
            enableDate: true,
            enableTime: true,
            buttonBar: {
                show: true,
                now: {
                    show: true,
                    text: 'Agora',
                    cls: 'btn-sm btn-default'
                },
                today: {
                    show: true,
                    text: 'Hoje',
                    cls: 'btn-sm btn-default'
                },
                clear: {
                    show: true,
                    text: 'Limpar',
                    cls: 'btn-sm btn-default'
                },
                date: {
                    show: true,
                    text: 'Data',
                    cls: 'btn-sm btn-default'
                },
                time: {
                    show: true,
                    text: 'Hora',
                    cls: 'btn-sm btn-default'
                },
                close: {
                    show: true,
                    text: 'Fechar',
                    cls: 'btn-sm btn-default'
                }
            },
            closeOnDateSelection: true,
            closeOnTimeNow: true,
            appendToBody: false,
            altInputFormats: [],
            ngModelOptions: { timezone: null },
            saveAs: false,
            readAs: false
        });

//            uiDatetimePickerConfig.buttonBar.now.text = $translate('global.field.vehicle');
//            $translate('global.field.vehicle').then(function (title) {
//                uiDatetimePickerConfig.buttonBar.now.text = title;
//                console.log('global.field.vehicle' + title);
//            });
})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('fleetApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('fleetApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-fleetApp-error');
                var entityKey = httpResponse.headers('X-fleetApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('fleetApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate', 'toaster'];

        function getService ($timeout, $sce,$translate, toaster) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                showToast(alertOptions)
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function showToast(alertOptions) {
                if (alertOptions.type == 'success') {
                    toaster.pop('success', '', alertOptions.msg);
                } else if (alertOptions.type == 'info') {
                    toaster.pop('info', '', alertOptions.msg);
                } else if (alertOptions.type == 'danger') {
                    toaster.pop('warning', '', alertOptions.msg);
                }
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('fleetApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-fleetApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-fleetApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('fleetApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            
            return config;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES', '$window'];

    function translationStorageProvider($cookies, $log, LANGUAGES, $window) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                var defaultLocation = getDefaultLanguage();
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language ' + defaultLocation);
                $cookies.putObject(name, defaultLocation);
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }


        function getDefaultLanguage() {
            var lang = $window.navigator.language || $window.navigator.userLanguage;
            $log.info('$window.navigator.language ' + lang);
            if (lang.toUpperCase().indexOf('PT') !== -1) {
                return 'pt-br';
            } else if (lang.toUpperCase().indexOf('EN') !== -1) {
                return 'en';
            } else {
                return 'en'; // default
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider'];

    function localStorageConfig($localStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('fleetApp')
        .constant('VERSION', "2.26.03")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
;
/*! AdminLTE app.js
* ================
* Main JS application file for AdminLTE v2. This file
* should be included in all pages. It controls some layout
* options and implements exclusive AdminLTE plugins.
*
* @Author  Almsaeed Studio
* @Support <https://www.almsaeedstudio.com>
* @Email   <abdullah@almsaeedstudio.com>
* @version 2.4.0
* @repository git://github.com/almasaeed2010/AdminLTE.git
* @license MIT <http://opensource.org/licenses/MIT>
*/

// Make sure jQuery has been loaded
if (typeof jQuery === 'undefined') {
throw new Error('AdminLTE requires jQuery')
}

/* Layout()
 * ========
 * Implements AdminLTE layout.
 * Fixes the layout height in case min-height fails.
 *
 * @usage activated automatically upon window load.
 *        Configure any options by passing data-option="value"
 *        to the body tag.
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.layout'

  var Default = {
    slimscroll : true,
    resetHeight: true
  }

  var Selector = {
    wrapper       : '.wrapper',
    contentWrapper: '.content-wrapper',
    layoutBoxed   : '.layout-boxed',
    mainFooter    : '.main-footer',
    mainHeader    : '.main-header',
    sidebar       : '.sidebar',
    controlSidebar: '.control-sidebar',
    fixed         : '.fixed',
    sidebarMenu   : '.sidebar-menu',
    logo          : '.main-header .logo'
  }

  var ClassName = {
    fixed         : 'fixed',
    holdTransition: 'hold-transition'
  }

  var Layout = function (options) {
    this.options      = options
    this.bindedResize = false
    this.activate()
  }

  Layout.prototype.activate = function () {
    this.fix()
    this.fixSidebar()

    $('body').removeClass(ClassName.holdTransition)

    if (this.options.resetHeight) {
      $('body, html, ' + Selector.wrapper).css({
        'height'    : 'auto',
        'min-height': '100%'
      })
    }

    if (!this.bindedResize) {
      $(window).resize(function () {
        this.fix()
        this.fixSidebar()

        $(Selector.logo + ', ' + Selector.sidebar).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          this.fix()
          this.fixSidebar()
        }.bind(this))
      }.bind(this))

      this.bindedResize = true
    }

    $(Selector.sidebarMenu).on('expanded.tree', function () {
      this.fix()
      this.fixSidebar()
    }.bind(this))

    $(Selector.sidebarMenu).on('collapsed.tree', function () {
      this.fix()
      this.fixSidebar()
    }.bind(this))
  }

  Layout.prototype.fix = function () {
    // Remove overflow from .wrapper if layout-boxed exists
    $(Selector.layoutBoxed + ' > ' + Selector.wrapper).css('overflow', 'hidden')

    // Get window height and the wrapper height
    var footerHeight  = $(Selector.mainFooter).outerHeight() || 0
    var neg           = $(Selector.mainHeader).outerHeight() + footerHeight
    var windowHeight  = $(window).height()
    var sidebarHeight = $(Selector.sidebar).height() || 0

    // Set the min-height of the content and sidebar based on
    // the height of the document.
    if ($('body').hasClass(ClassName.fixed)) {
      $(Selector.contentWrapper).css('min-height', windowHeight - footerHeight)
    } else {
      var postSetHeight

      if (windowHeight >= sidebarHeight) {
        $(Selector.contentWrapper).css('min-height', windowHeight - neg)
        postSetHeight = windowHeight - neg
      } else {
        $(Selector.contentWrapper).css('min-height', sidebarHeight)
        postSetHeight = sidebarHeight
      }

      // Fix for the control sidebar height
      var $controlSidebar = $(Selector.controlSidebar)
      if (typeof $controlSidebar !== 'undefined') {
        if ($controlSidebar.height() > postSetHeight)
          $(Selector.contentWrapper).css('min-height', $controlSidebar.height())
      }
    }
  }

  Layout.prototype.fixSidebar = function () {
    // Make sure the body tag has the .fixed class
    if (!$('body').hasClass(ClassName.fixed)) {
      if (typeof $.fn.slimScroll !== 'undefined') {
        $(Selector.sidebar).slimScroll({ destroy: true }).height('auto')
      }
      return
    }

    // Enable slimscroll for fixed layout
    if (this.options.slimscroll) {
      if (typeof $.fn.slimScroll !== 'undefined') {
        // Destroy if it exists
        $(Selector.sidebar).slimScroll({ destroy: true }).height('auto')

        // Add slimscroll
        $(Selector.sidebar).slimScroll({
          height: ($(window).height() - $(Selector.mainHeader).height()) + 'px',
          color: '#ec7b1c',
          class: 'slimScrollFleet',
          alwaysVisible: false,
          railVisible: true,
          railColor: '#222',
          railOpacity: 0.8,
          wheelStep: 10,
          allowPageScroll: false,
          disableFadeOut: false,
          size  : '7px'
        })
      }
    }
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option === 'object' && option)
        $this.data(DataKey, (data = new Layout(options)))
      }

      if (typeof option === 'string') {
        if (typeof data[option] === 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.layout

  $.fn.layout            = Plugin
  $.fn.layout.Constuctor = Layout

  // No conflict mode
  // ================
  $.fn.layout.noConflict = function () {
    $.fn.layout = old
    return this
  }

  // Layout DATA-API
  // ===============
  $(window).on('load', function () {
    Plugin.call($('body'))
  })
}(jQuery)


/* PushMenu()
 * ==========
 * Adds the push menu functionality to the sidebar.
 *
 * @usage: $('.btn').pushMenu(options)
 *          or add [data-toggle="push-menu"] to any button
 *          Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.pushmenu'

  var Default = {
    collapseScreenSize   : 767,
    expandOnHover        : false,
    expandTransitionDelay: 200
  }

  var Selector = {
    collapsed     : '.sidebar-collapse',
    open          : '.sidebar-open',
    mainSidebar   : '.main-sidebar',
    contentWrapper: '.content-wrapper',
    searchInput   : '.sidebar-form .form-control',
    button        : '[data-toggle="push-menu"]',
    mini          : '.sidebar-mini',
    expanded      : '.sidebar-expanded-on-hover',
    layoutFixed   : '.fixed'
  }

  var ClassName = {
    collapsed    : 'sidebar-collapse',
    open         : 'sidebar-open',
    mini         : 'sidebar-mini',
    expanded     : 'sidebar-expanded-on-hover',
    expandFeature: 'sidebar-mini-expand-feature',
    layoutFixed  : 'fixed'
  }

  var Event = {
    expanded : 'expanded.pushMenu',
    collapsed: 'collapsed.pushMenu'
  }

  // PushMenu Class Definition
  // =========================
  var PushMenu = function (options) {
    this.options = options
    this.init()
  }

  PushMenu.prototype.init = function () {
    if (this.options.expandOnHover
      || ($('body').is(Selector.mini + Selector.layoutFixed))) {
      this.expandOnHover()
      $('body').addClass(ClassName.expandFeature)
    }

    $(Selector.contentWrapper).click(function () {
      // Enable hide menu when clicking on the content-wrapper on small screens
      if ($(window).width() <= this.options.collapseScreenSize && $('body').hasClass(ClassName.open)) {
        this.close()
      }
    }.bind(this))

    // __Fix for android devices
    $(Selector.searchInput).click(function (e) {
      e.stopPropagation()
    })
  }

  PushMenu.prototype.toggle = function () {
    var windowWidth = $(window).width()
    var isOpen      = !$('body').hasClass(ClassName.collapsed)

    if (windowWidth <= this.options.collapseScreenSize) {
      isOpen = $('body').hasClass(ClassName.open)
    }

    if (!isOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  PushMenu.prototype.open = function () {
    var windowWidth = $(window).width()

    if (windowWidth > this.options.collapseScreenSize) {
      $('body').removeClass(ClassName.collapsed)
        .trigger($.Event(Event.expanded))
    }
    else {
      $('body').addClass(ClassName.open)
        .trigger($.Event(Event.expanded))
    }
  }

  PushMenu.prototype.close = function () {
    var windowWidth = $(window).width()
    if (windowWidth > this.options.collapseScreenSize) {
      $('body').addClass(ClassName.collapsed)
        .trigger($.Event(Event.collapsed))
    } else {
      $('body').removeClass(ClassName.open + ' ' + ClassName.collapsed)
        .trigger($.Event(Event.collapsed))
    }
  }

  PushMenu.prototype.expandOnHover = function () {
    $(Selector.mainSidebar).hover(function () {
      if ($('body').is(Selector.mini + Selector.collapsed)
        && $(window).width() > this.options.collapseScreenSize) {
        this.expand()
      }
    }.bind(this), function () {
      if ($('body').is(Selector.expanded)) {
        this.collapse()
      }
    }.bind(this))
  }

  PushMenu.prototype.expand = function () {
    setTimeout(function () {
      $('body').removeClass(ClassName.collapsed)
        .addClass(ClassName.expanded)
    }, this.options.expandTransitionDelay)
  }

  PushMenu.prototype.collapse = function () {
    setTimeout(function () {
      $('body').removeClass(ClassName.expanded)
        .addClass(ClassName.collapsed)
    }, this.options.expandTransitionDelay)
  }

  // PushMenu Plugin Definition
  // ==========================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new PushMenu(options)))
      }

      if (option == 'toggle') data.toggle()
    })
  }

  var old = $.fn.pushMenu

  $.fn.pushMenu             = Plugin
  $.fn.pushMenu.Constructor = PushMenu

  // No Conflict Mode
  // ================
  $.fn.pushMenu.noConflict = function () {
    $.fn.pushMenu = old
    return this
  }

  // Data API
  // ========
  $(document).on('click', Selector.button, function (e) {
    e.preventDefault()
    Plugin.call($(this), 'toggle')
  })
  $(window).on('load', function () {
    Plugin.call($(Selector.button))
  })
}(jQuery)


/* Tree()
 * ======
 * Converts a nested list into a multilevel
 * tree view menu.
 *
 * @Usage: $('.my-menu').tree(options)
 *         or add [data-widget="tree"] to the ul element
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.tree'

  var Default = {
    animationSpeed: 500,
    accordion     : true,
    followLink    : false,
    trigger       : '.treeview a'
  }

  var Selector = {
    tree        : '.tree',
    treeview    : '.treeview',
    treeviewMenu: '.treeview-menu',
    open        : '.menu-open, .active',
    li          : 'li',
    data        : '[data-widget="tree"]',
    active      : '.active'
  }

  var ClassName = {
    open: 'menu-open',
    tree: 'tree'
  }

  var Event = {
    collapsed: 'collapsed.tree',
    expanded : 'expanded.tree'
  }

  // Tree Class Definition
  // =====================
  var Tree = function (element, options) {
    this.element = element
    this.options = options

    $(this.element).addClass(ClassName.tree)

    $(Selector.treeview + Selector.active, this.element).addClass(ClassName.open)

    this._setUpListeners()
  }

  Tree.prototype.toggle = function (link, event) {
    var treeviewMenu = link.next(Selector.treeviewMenu)
    var parentLi     = link.parent()
    var isOpen       = parentLi.hasClass(ClassName.open)

    if (!parentLi.is(Selector.treeview)) {
      return
    }

    if (!this.options.followLink || link.attr('href') == '#') {
      event.preventDefault()
    }

    if (isOpen) {
      this.collapse(treeviewMenu, parentLi)
    } else {
      this.expand(treeviewMenu, parentLi)
    }
  }

  Tree.prototype.expand = function (tree, parent) {
    var expandedEvent = $.Event(Event.expanded)

    if (this.options.accordion) {
      var openMenuLi = parent.siblings(Selector.open)
      var openTree   = openMenuLi.children(Selector.treeviewMenu)
      this.collapse(openTree, openMenuLi)
    }

    parent.addClass(ClassName.open)
    tree.slideDown(this.options.animationSpeed, function () {
      $(this.element).trigger(expandedEvent)
    }.bind(this))
  }

  Tree.prototype.collapse = function (tree, parentLi) {
    var collapsedEvent = $.Event(Event.collapsed)

    tree.find(Selector.open).removeClass(ClassName.open)
    parentLi.removeClass(ClassName.open)
    tree.slideUp(this.options.animationSpeed, function () {
      tree.find(Selector.open + ' > ' + Selector.treeview).slideUp()
      $(this.element).trigger(collapsedEvent)
    }.bind(this))
  }

  // Private

  Tree.prototype._setUpListeners = function () {
    var that = this

    $(this.element).on('click', this.options.trigger, function (event) {
      that.toggle($(this), event)
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, new Tree($this, options))
      }
    })
  }

  var old = $.fn.tree

  $.fn.tree             = Plugin
  $.fn.tree.Constructor = Tree

  // No Conflict Mode
  // ================
  $.fn.tree.noConflict = function () {
    $.fn.tree = old
    return this
  }

  // Tree Data API
  // =============
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

}(jQuery)


/* ControlSidebar()
 * ===============
 * Toggles the state of the control sidebar
 *
 * @Usage: $('#control-sidebar-trigger').controlSidebar(options)
 *         or add [data-toggle="control-sidebar"] to the trigger
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.controlsidebar'

  var Default = {
    slide: true
  }

  var Selector = {
    sidebar: '.control-sidebar',
    data   : '[data-toggle="control-sidebar"]',
    open   : '.control-sidebar-open',
    bg     : '.control-sidebar-bg',
    wrapper: '.wrapper',
    content: '.content-wrapper',
    boxed  : '.layout-boxed'
  }

  var ClassName = {
    open : 'control-sidebar-open',
    fixed: 'fixed'
  }

  var Event = {
    collapsed: 'collapsed.controlsidebar',
    expanded : 'expanded.controlsidebar'
  }

  // ControlSidebar Class Definition
  // ===============================
  var ControlSidebar = function (element, options) {
    this.element         = element
    this.options         = options
    this.hasBindedResize = false

    this.init()
  }

  ControlSidebar.prototype.init = function () {
    // Add click listener if the element hasn't been
    // initialized using the data API
    if (!$(this.element).is(Selector.data)) {
      $(this).on('click', this.toggle)
    }

    this.fix()
    $(window).resize(function () {
      this.fix()
    }.bind(this))
  }

  ControlSidebar.prototype.toggle = function (event) {
    if (event) event.preventDefault()

    this.fix()

    if (!$(Selector.sidebar).is(Selector.open) && !$('body').is(Selector.open)) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  ControlSidebar.prototype.expand = function () {
    if (!this.options.slide) {
      $('body').addClass(ClassName.open)
    } else {
      $(Selector.sidebar).addClass(ClassName.open)
    }

    $(this.element).trigger($.Event(Event.expanded))
  }

  ControlSidebar.prototype.collapse = function () {
    $('body, ' + Selector.sidebar).removeClass(ClassName.open)
    $(this.element).trigger($.Event(Event.collapsed))
  }

  ControlSidebar.prototype.fix = function () {
    if ($('body').is(Selector.boxed)) {
      this._fixForBoxed($(Selector.bg))
    }
  }

  // Private

  ControlSidebar.prototype._fixForBoxed = function (bg) {
    bg.css({
      position: 'absolute',
      height  : $(Selector.wrapper).height()
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new ControlSidebar($this, options)))
      }

      if (typeof option == 'string') data.toggle()
    })
  }

  var old = $.fn.controlSidebar

  $.fn.controlSidebar             = Plugin
  $.fn.controlSidebar.Constructor = ControlSidebar

  // No Conflict Mode
  // ================
  $.fn.controlSidebar.noConflict = function () {
    $.fn.controlSidebar = old
    return this
  }

  // ControlSidebar Data API
  // =======================
  $(document).on('click', Selector.data, function (event) {
    if (event) event.preventDefault()
    Plugin.call($(this), 'toggle')
  })

}(jQuery)


/* BoxWidget()
 * ======
 * Adds box widget functions to boxes.
 *
 * @Usage: $('.my-box').boxWidget(options)
 *         This plugin auto activates on any element using the `.box` class
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.boxwidget'

  var Default = {
    animationSpeed : 500,
    collapseTrigger: '[data-widget="collapse"]',
    removeTrigger  : '[data-widget="remove"]',
    collapseIcon   : 'fa-minus',
    expandIcon     : 'fa-plus',
    removeIcon     : 'fa-times'
  }

  var Selector = {
    data     : '.box',
    collapsed: '.collapsed-box',
    body     : '.box-body',
    footer   : '.box-footer',
    tools    : '.box-tools'
  }

  var ClassName = {
    collapsed: 'collapsed-box'
  }

  var Event = {
    collapsed: 'collapsed.boxwidget',
    expanded : 'expanded.boxwidget',
    removed  : 'removed.boxwidget'
  }

  // BoxWidget Class Definition
  // =====================
  var BoxWidget = function (element, options) {
    this.element = element
    this.options = options

    this._setUpListeners()
  }

  BoxWidget.prototype.toggle = function () {
    var isOpen = !$(this.element).is(Selector.collapsed)

    if (isOpen) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  BoxWidget.prototype.expand = function () {
    var expandedEvent = $.Event(Event.expanded)
    var collapseIcon  = this.options.collapseIcon
    var expandIcon    = this.options.expandIcon

    $(this.element).removeClass(ClassName.collapsed)

    $(this.element)
      .find(Selector.tools)
      .find('.' + expandIcon)
      .removeClass(expandIcon)
      .addClass(collapseIcon)

    $(this.element).find(Selector.body + ', ' + Selector.footer)
      .slideDown(this.options.animationSpeed, function () {
        $(this.element).trigger(expandedEvent)
      }.bind(this))
  }

  BoxWidget.prototype.collapse = function () {
    var collapsedEvent = $.Event(Event.collapsed)
    var collapseIcon   = this.options.collapseIcon
    var expandIcon     = this.options.expandIcon

    $(this.element)
      .find(Selector.tools)
      .find('.' + collapseIcon)
      .removeClass(collapseIcon)
      .addClass(expandIcon)

    $(this.element).find(Selector.body + ', ' + Selector.footer)
      .slideUp(this.options.animationSpeed, function () {
        $(this.element).addClass(ClassName.collapsed)
        $(this.element).trigger(collapsedEvent)
      }.bind(this))
  }

  BoxWidget.prototype.remove = function () {
    var removedEvent = $.Event(Event.removed)

    $(this.element).slideUp(this.options.animationSpeed, function () {
      $(this.element).trigger(removedEvent)
      $(this.element).remove()
    }.bind(this))
  }

  // Private

  BoxWidget.prototype._setUpListeners = function () {
    var that = this

    $(this.element).on('click', this.options.collapseTrigger, function (event) {
      if (event) event.preventDefault()
      that.toggle()
    })

    $(this.element).on('click', this.options.removeTrigger, function (event) {
      if (event) event.preventDefault()
      that.remove()
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new BoxWidget($this, options)))
      }

      if (typeof option == 'string') {
        if (typeof data[option] == 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.boxWidget

  $.fn.boxWidget             = Plugin
  $.fn.boxWidget.Constructor = BoxWidget

  // No Conflict Mode
  // ================
  $.fn.boxWidget.noConflict = function () {
    $.fn.boxWidget = old
    return this
  }

  // BoxWidget Data API
  // ==================
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

}(jQuery)


/* TodoList()
 * =========
 * Converts a list into a todoList.
 *
 * @Usage: $('.my-list').todoList(options)
 *         or add [data-widget="todo-list"] to the ul element
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.todolist'

  var Default = {
    iCheck   : false,
    onCheck  : function () {
    },
    onUnCheck: function () {
    }
  }

  var Selector = {
    data: '[data-widget="todo-list"]'
  }

  var ClassName = {
    done: 'done'
  }

  // TodoList Class Definition
  // =========================
  var TodoList = function (element, options) {
    this.element = element
    this.options = options

    this._setUpListeners()
  }

  TodoList.prototype.toggle = function (item) {
    item.parents(Selector.li).first().toggleClass(ClassName.done)
    if (!item.prop('checked')) {
      this.unCheck(item)
      return
    }

    this.check(item)
  }

  TodoList.prototype.check = function (item) {
    this.options.onCheck.call(item)
  }

  TodoList.prototype.unCheck = function (item) {
    this.options.onUnCheck.call(item)
  }

  // Private

  TodoList.prototype._setUpListeners = function () {
    var that = this
    $(this.element).on('change ifChanged', 'input:checkbox', function () {
      that.toggle($(this))
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new TodoList($this, options)))
      }

      if (typeof data == 'string') {
        if (typeof data[option] == 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.todoList

  $.fn.todoList         = Plugin
  $.fn.todoList.Constructor = TodoList

  // No Conflict Mode
  // ================
  $.fn.todoList.noConflict = function () {
    $.fn.todoList = old
    return this
  }

  // TodoList Data API
  // =================
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

}(jQuery)


/* DirectChat()
 * ===============
 * Toggles the state of the control sidebar
 *
 * @Usage: $('#my-chat-box').directChat()
 *         or add [data-widget="direct-chat"] to the trigger
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.directchat'

  var Selector = {
    data: '[data-widget="chat-pane-toggle"]',
    box : '.direct-chat'
  }

  var ClassName = {
    open: 'direct-chat-contacts-open'
  }

  // DirectChat Class Definition
  // ===========================
  var DirectChat = function (element) {
    this.element = element
  }

  DirectChat.prototype.toggle = function ($trigger) {
    $trigger.parents(Selector.box).first().toggleClass(ClassName.open)
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        $this.data(DataKey, (data = new DirectChat($this)))
      }

      if (typeof option == 'string') data.toggle($this)
    })
  }

  var old = $.fn.directChat

  $.fn.directChat             = Plugin
  $.fn.directChat.Constructor = DirectChat

  // No Conflict Mode
  // ================
  $.fn.directChat.noConflict = function () {
    $.fn.directChat = old
    return this
  }

  // DirectChat Data API
  // ===================
  $(document).on('click', Selector.data, function (event) {
    if (event) event.preventDefault()
    Plugin.call($(this), 'toggle')
  })

}(jQuery)
;
(function() {
    "use strict";

    angular
        .module("fleetApp")
        .controller(
            "UserManagementDialogController",
            UserManagementDialogController
        );

    UserManagementDialogController.$inject = [
        "$timeout",
        "$scope",
        "$uibModalInstance",
        "entity",
        "User",
        "JhiLanguageService",
        "authorities"
    ];

    function UserManagementDialogController(
        $timeout,
        $scope,
        $uibModalInstance,
        entity,
        User,
        JhiLanguageService,
        authorities
    ) {
        var vm = this;

        vm.authorities = authorities;
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;

        JhiLanguageService.getAll().then(function(languages) {
            vm.languages = languages;
        });

        $timeout(function() {
            angular.element(".form-group:eq(1)>input").focus();
            initialize();
        });

        function initialize() {
            // eslint-disable-next-line no-undef
            var myWidget = cloudinary.createUploadWidget(
                {
                    cloudName: "dvzlcxrvw",
                    multiple: false,
                    defaultSource: "local",
                    uploadPreset: "usuarios"
                },
                function(error, result) {
                    if (!error && result && result.event === "success") {
                        vm.user.photoUrl = result.info.url;
                        $scope.$apply();
                    }
                }
            );

            // eslint-disable-next-line angular/document-service
            document.getElementById("upload_widget").addEventListener(
                "click",
                function() {
                    myWidget.open();
                },
                false
            );
        }

        function clear() {
            $uibModalInstance.dismiss("cancel");
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN', 'ACCESS_USERS'],
                pageTitle: 'user-management.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN', 'ACCESS_USERS'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN', 'ACCESS_USERS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        },
                        authorities: ['User', function(User) {
                            return User.authorities();
                        }],
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN', 'ACCESS_USERS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }],
                        authorities: ['User', function(User) {
                            return User.authorities();
                        }],
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN', 'ACCESS_USERS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.currentAccount = null;
        vm.languages = null;
        vm.links = null;
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.page = 1;
        vm.setActive = setActive;
        vm.totalItems = null;
        vm.users = [];


        vm.loadAll();


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function loadAll () {
            User.query({page: vm.page - 1, size: paginationConstants.itemsPerPage}, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');

                //hide anonymous user from user management: it's a required user for Spring Security
                for(var i in result) {
                    if(result[i]['login'] === 'anonymoususer') {
                        result.splice(i,1);
                    }
                }
                vm.users = result;
            });
        }

        function loadPage (page) {
            vm.page = page;
            vm.loadAll();
        }

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
        }

        vm.changePass = function (id) {
            console.log(id);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();
;
(function() {
    'use strict';

    angular.module('fleetApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("There is no previous version available for this entry.\nThis is the first" +
                    " audit entry captured for this object");
            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
/* globals $ */
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('fleetApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
;(function(){angular.module("fleetApp").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/geomap-menu.html","<div class=\"main-sidebar\" ng-controller=\"GeomapController as geomapVm\"><section class=\"sidebar\" style=\"height: auto\"><div class=\"nav-tabs-custom-geomap nav-tabs-custom\"><div class=\"user-panel\"><div class=\"col-md-12\"></div></div><ul class=\"nav nav-tabs-geomap nav-tabs ui-sortable-handle\"><li ng-class=\"{ active: vm.isSet(0) }\"><a href ng-click=\"vm.setTab(0)\">{{ \'fleetApp.vehicle.itineraries\' | translate }}</a></li><li ng-class=\"{ active: vm.isSet(1) }\"><a href ng-click=\"vm.setTab(1)\">{{ \'fleetApp.vehicle.vehicles\' | translate }}</a></li></ul><div class=\"tab-content no-padding\"><!--fullscreen--><div id=\"home\" class=\"tab-pane fade in active fleet-vehicle-list\" ng-class=\"{ active: vm.isSet(1) }\" ng-if=\"vm.isSet(1)\"><!-- search form\n                    <form action=\"#\" method=\"get\" class=\"sidebar-form\">\n                        <div class=\"input-group\">\n                            <input type=\"text\" name=\"q\" class=\"form-control\" placeholder=\"Search...\">\n                            <span class=\"input-group-btn\">\n                            <button type=\"submit\" name=\"search\" id=\"search-btn\" class=\"btn btn-flat\"><i class=\"fa fa-search\"></i>\n                            </button>\n                          </span>\n                        </div>\n                    </form>\n                    --><!-- /.search form --><ul id=\"vehicles-menu\" class=\"sidebar-menu tree\"><li><a ng-click=\"vm.loadVehiclesPosition()\" uib-tooltip=\"{{\'fleetApp.vehicle.showAll\' | translate}}\"><i class=\"fa fa-refresh\"></i><span class=\"text-muted\">{{ \'fleetApp.vehicle.showAll\' | translate }}</span></a></li><li class=\"treeview\" ng-repeat=\"vehicle in vm.vehicles | filter:searchText track by vehicle.vehicleId\" ng-class=\"{ active: vm.isVehicleSet(vehicle) }\"><a href=\"javascript:;\" ng-click=\"vm.selectVehicle(vehicle)\"><i class=\"fa fa-truck\"></i> <span>{{vehicle.vehiclePlate}}</span></a><ul class=\"treeview-menu\" style=\"\"><div style=\"padding: 7px 10px\"><span class=\"text-muted\">{{vehicle.vehicleTypeName}}</span><br><span class=\"text-muted\">{{\'fleetApp.vehicle.lastPosition\'|translate}}: {{vehicle.deviceTime|date:\'short\'}}</span><br><span class=\"text-muted\">{{vehicle.latitude | number : 6}}, {{vehicle.longitude | number : 6}}</span> <a class=\"btn pull-right\" ng-click=\"geomapVm.showHistoryPanel(vehicle)\" uib-tooltip=\"{{\'fleetApp.vehicle.positionHistory\'|translate}}\"><i class=\"fa fa-calendar\"></i></a><br></div></ul></li></ul></div><div id=\"itineraries\" class=\"tab-pane fade in active\" ng-class=\"{ active: vm.isSet(0) }\" ng-if=\"vm.isSet(0)\"><ul id=\"itineraries-menu\" class=\"sidebar-menu tree\"><li><a ng-click=\"vm.openCalendar(\'pickerDate\')\" ng-valid ng-isolate-scope ng-not-empty ng-valid-datetime ng-dirty ng-touched datetime-picker enable-time=\"false\" ng-model=\"vm.pickerDate\" datepicker-append-to-body=\"true\" whenclosed=\"vm.onDateChange\" datepicker-options=\"{ showWeeks: false }\" is-open=\"vm.datePickerOpenStatus.pickerDate\"><i class=\"fa fa-calendar\"></i> {{ vm.pickerDate | date:\'MMM dd, yyyy\'}}</a></li><li class=\"treeview\" ng-repeat=\"itinerary in vm.itineraries | filter:searchText track by itinerary.id\" ng-click=\"vm.selectItinerarie(itinerary)\" ng-class=\"{ active: vm.isItineratySet(itinerary) }\"><a href=\"javascript:;\"><i class=\"fa fa-th\" aria-hidden=\"true\"></i> <span>{{itinerary.vehiclePlate}}</span><div class=\"pull-right\" ng-if=\"!vm.isItineratySet(itinerary)\"><span class=\"text-muted small\" style=\"padding: 0px 5px\">{{itinerary.driverFirstName}}</span></div></a><ul class=\"treeview-menu\" style=\"\"><div style=\"padding: 7px 10px\"><span class=\"text-muted\">{{\'fleetApp.vehicle.driver\'|translate}}: {{itinerary.driverFirstName}}</span><br><span class=\"text-muted\">{{\'global.field.total\'|translate}}: {{itinerary.total | currency:fractionSize:6}}</span></div></ul></li></ul></div></div></div></section></div>");
$templateCache.put("app/home/home.html","<div style=\"height=100%\" ng-cloak><div ng-if=\"vm.isAuthenticated()\"><span ng-include=\"\'app/home/geomap-menu.html\'\"></span><section class=\"content-map\"><div id=\"vehicle-history\" class=\"row content-vehicle-history\" ng-if=\"vm.showHistory.vehicleId\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\">&nbsp;</div></div><vehicle-event-history-filter></vehicle-event-history-filter></div></div><geomap auto-height=\"true\"></geomap></section></div></div>");
$templateCache.put("app/home/login.html","<div style=\"height=100% width=100%\" ng-cloak><h1 translate=\"home.title\">Welcome!</h1><div class=\"login-box\" style=\"\"><!--\n        <div class=\"login-logo\">\n            <a ng-href=\"#\">\n                <span><div class=\"brand-img\"></div></span>\n            </a>\n        </div>\n        --><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"\"><a class=\"\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div></div></div></div></div><!--\n    <div class=\"login-box\" style=\"\">\n        <div class=\"login-logo\">\n            <a href=\"../../index2.html\"><b>Admin</b>LTE</a>\n        </div>\n        <div class=\"login-box-body\">\n            <p class=\"login-box-msg\">Sign in to start your session</p>\n\n            <form action=\"../../index2.html\" method=\"post\">\n                <div class=\"form-group has-feedback\">\n                    <input type=\"email\" class=\"form-control\" placeholder=\"Email\">\n                    <span class=\"glyphicon glyphicon-envelope form-control-feedback\"></span>\n                </div>\n                <div class=\"form-group has-feedback\">\n                    <input type=\"password\" class=\"form-control\" placeholder=\"Password\">\n                    <span class=\"glyphicon glyphicon-lock form-control-feedback\"></span>\n                </div>\n                <div class=\"row\">\n                    <div class=\"col-xs-8\">\n                        <div class=\"checkbox icheck\">\n                            <label>\n                                <div class=\"icheckbox_square-blue\" aria-checked=\"false\" aria-disabled=\"false\" style=\"position: relative;\"><input type=\"checkbox\" style=\"position: absolute; top: -20%; left: -20%; display: block; width: 140%; height: 140%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;\"><ins class=\"iCheck-helper\" style=\"position: absolute; top: -20%; left: -20%; display: block; width: 140%; height: 140%; margin: 0px; padding: 0px; background: rgb(255, 255, 255); border: 0px; opacity: 0;\"></ins></div> Remember Me\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"form-group\">\n                        <label for=\"rememberMe\">\n                            <input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked>\n                            <span translate=\"login.form.rememberme\">Remember me</span>\n                        </label>\n                    </div>\n                    <div class=\"col-xs-4\">\n                        <button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button>\n                    </div>\n                </div>\n            </form>\n            <a class=\"\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a>\n        </div>\n    </div>\n--><!--\n    <div class=\"et_pb_section et_pb_section_0 et_pb_with_background et_pb_section_video et_pb_fullwidth_section et_section_regular\">\n				<span class=\"et_pb_section_video_bg et_pb_video_play_outside_viewport\" data-ratio=\"1.7777777777777777\">\n\n			<span class=\"mejs-offscreen\">Video Player</span><div id=\"mep_0\" class=\"mejs-container mejs-container-keyboard-inactive mejs-video\" tabindex=\"0\" role=\"application\" aria-label=\"Video Player\" style=\"width: 1905px; height: 1071.56px; min-width: 0px; margin: 0px 0px 0px -952.5px;\"><div class=\"mejs-inner\"><div class=\"mejs-mediaelement\"><mediaelementwrapper id=\"mejs_3419787519435957\"><video loop=\"loop\" autoplay=\"\" playsinline=\"\" muted=\"\" id=\"mejs_3419787519435957_html5\" preload=\"none\" src=\"https://www.cargochief.com/wp-content/uploads/2018/03/combined-forklift-scene.mp4\" style=\"width: 1905px; height: 1071.56px; margin: 0px;\">\n				<source type=\"video/mp4\" src=\"https://www.cargochief.com/wp-content/uploads/2018/03/combined-forklift-scene.mp4\">\n				<source type=\"video/webm\" src=\"https://www.cargochief.com/wp-content/uploads/2018/03/combined-forklift-scene.webm\">\n			</video></mediaelementwrapper></div><div class=\"mejs-layers\"><div class=\"mejs-poster mejs-layer\" style=\"display: none; width: 640px; height: 360px;\"></div><div class=\"mejs-overlay mejs-layer\" style=\"width: 640px; height: 360px; display: none;\"><div class=\"mejs-overlay-loading\"><span class=\"mejs-overlay-loading-bg-img\"></span></div></div><div class=\"mejs-overlay mejs-layer\" style=\"display: none; width: 640px; height: 360px;\"><div class=\"mejs-overlay-error\"></div></div><div class=\"mejs-overlay mejs-layer mejs-overlay-play\" style=\"width: 640px; height: 360px; display: none;\"><div class=\"mejs-overlay-button\" role=\"button\" tabindex=\"0\" aria-label=\"Play\" aria-pressed=\"false\"></div></div></div><div class=\"mejs-controls mejs-offscreen\" style=\"opacity: 0;\"><div class=\"mejs-button mejs-playpause-button mejs-pause\"><button type=\"button\" aria-controls=\"mep_0\" title=\"Pause\" aria-label=\"Pause\" tabindex=\"0\"></button></div><div class=\"mejs-time mejs-currenttime-container\" role=\"timer\" aria-live=\"off\"><span class=\"mejs-currenttime\">00:00</span></div><div class=\"mejs-time-rail\"><span class=\"mejs-time-total mejs-time-slider\" role=\"slider\" tabindex=\"0\"><span class=\"mejs-time-buffering\" style=\"display: none;\"></span><span class=\"mejs-time-loaded\" style=\"transform: scaleX(1);\"></span><span class=\"mejs-time-current\" style=\"transform: scaleX(0.87);\"></span><span class=\"mejs-time-hovered no-hover\"></span><span class=\"mejs-time-handle\" style=\"transform: translateX(87px);\"><span class=\"mejs-time-handle-content\"></span></span><span class=\"mejs-time-float\"><span class=\"mejs-time-float-current\">00:00</span><span class=\"mejs-time-float-corner\"></span></span></span></div><div class=\"mejs-time mejs-duration-container\"><span class=\"mejs-duration\">00:51</span></div><div class=\"mejs-button mejs-volume-button mejs-unmute\"><button type=\"button\" aria-controls=\"mep_0\" title=\"Unmute\" aria-label=\"Unmute\" tabindex=\"0\"></button><a href=\"javascript:void(0);\" class=\"mejs-volume-slider\" aria-label=\"Volume Slider\" aria-valuemin=\"0\" aria-valuemax=\"100\" role=\"slider\" aria-orientation=\"vertical\" aria-valuenow=\"0\" aria-valuetext=\"0%\"><span class=\"mejs-offscreen\">Use Up/Down Arrow keys to increase or decrease volume.</span><div class=\"mejs-volume-total\"><div class=\"mejs-volume-current\" style=\"bottom: 0px; height: 0%;\"></div><div class=\"mejs-volume-handle\" style=\"bottom: 0%; margin-bottom: -3px;\"></div></div></a></div><div class=\"mejs-button mejs-fullscreen-button\"><button type=\"button\" aria-controls=\"mep_0\" title=\"Fullscreen\" aria-label=\"Fullscreen\" tabindex=\"0\"></button></div></div></div></div>\n				</span>\n    </div>\n--></div>");
$templateCache.put("app/home/vehicle-event-history-filter.html","<div class=\"box\" id=\"my-box-widget\"><div class=\"box-header with-border\"><h3 class=\"box-title\" translate=\"fleetApp.vehicle.positionHistory\">Histórico</h3><div class=\"box-tools pull-right\"><!-- Collapse Button --> <button type=\"button\" class=\"btn btn-box-tool\" ng-click=\"$ctrl.close()\"><i class=\"fa fa-times\"></i></button></div><!-- /.box-tools  --></div><!-- /.box-header --><div class=\"box-body\"><div class=\"row\"><div class=\"col-md-2\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"$ctrl.vehicle.vehicleId\" model-label=\"$ctrl.vehicle.vehiclePlate\" disabled=\"disabled\" label=\"\'fleetApp.expense.vehicle\'\"></vehicle-typeahead></div><!-- start date time --><div class=\"col-md-3\"><label class=\"control-label required\" translate=\"global.field.initialDate\">Initial Date</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" datetime-picker=\"dd MMM yyyy HH:mm\" ng-model=\"$ctrl.initialDateTime\" is-open=\"$ctrl.datePickerOpenStatus.initialDateTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openCalendar(\'initialDateTime\')\"><i class=\"fa fa-calendar\"></i></button></span></p></div><!-- end date time --><div class=\"col-md-3\"><label class=\"control-label required\" translate=\"global.field.endDate\">End Date</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" datetime-picker=\"dd MMM yyyy HH:mm\" ng-model=\"$ctrl.endDateTime\" is-open=\"$ctrl.datePickerOpenStatus.endDateTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.openCalendar(\'endDateTime\')\"><i class=\"fa fa-calendar\"></i></button></span></p></div><div class=\"col-md-3\"><div>&nbsp;</div><button class=\"btn btn-primary\" ng-click=\"$ctrl.search()\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.search\">Search</span></button> <button class=\"btn btn-primary\" ng-click=\"$ctrl.export()\"><span class=\"glyphicon glyphicon-export\"></span> <span translate=\"entity.action.export\">Search</span></button></div></div></div><!-- /.box-body\n    <div class=\"box-footer\">\n        The footer of the box\n    </div>\n    --><!-- box-footer --></div><!-- /.box -->");
$templateCache.put("app/account/activate/activate.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"activate.title\">Activation</h1><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"activate.messages.success\" translate-compile><strong>Your user has been activated.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"activate.messages.error\"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>");
$templateCache.put("app/account/password/password.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"password.title\" translate-values=\"{username: \'{{vm.account.login}}\'}\">Password for [<b>{{vm.account.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"password.messages.success\"><strong>Password changed!</strong></div><div class=\"alert alert-danger\" ng-show=\"vm.error\" translate=\"password.messages.error\"><strong>An error has occurred!</strong> The password could not be changed.</div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.changePassword()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your confirmation password is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your confirmation password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"password.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/admin/audits/audits.html","<div><h2 translate=\"audits.title\">Audits</h2><div class=\"row\"><div class=\"col-md-5\"><h4 translate=\"audits.filter.title\">Filter by date</h4><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"audits.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onChangeDate()\" required> <span class=\"input-group-addon\" translate=\"audits.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onChangeDate()\" required></p></div></div><table class=\"table table-condensed table-striped table-bordered table-responsive\"><thead><tr><th ng-click=\"predicate = \'timestamp\'; reverse=!reverse\"><span translate=\"audits.table.header.date\">Date</span></th><th ng-click=\"predicate = \'principal\'; reverse=!reverse\"><span translate=\"audits.table.header.principal\">User</span></th><th ng-click=\"predicate = \'type\'; reverse=!reverse\"><span translate=\"audits.table.header.status\">State</span></th><th ng-click=\"predicate = \'data.message\'; reverse=!reverse\"><span translate=\"audits.table.header.data\">Extra data</span></th></tr></thead><tr ng-repeat=\"audit in vm.audits | filter:filter | orderBy:predicate:reverse\" ng-hide=\"audit.filtered\"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show=\"audit.data.message\">{{audit.data.message}}</span> <span ng-show=\"audit.data.remoteAddress\"><span translate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadPage(vm.page)\"></uib-pagination></div></div>");
$templateCache.put("app/admin/configuration/configuration.html","<div><h2 translate=\"configuration.title\">Configuration</h2><span translate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><label ng-hide=\"filteredConfig.length == 0\">Spring configuration</label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filteredConfig.length == 0\"><thead><tr><th ng-click=\"predicate = \'prefix\'; reverse=!reverse\" class=\"col-sm-4\"><span translate=\"configuration.table.prefix\">Prefix</span></th><th translate=\"configuration.table.properties\" class=\"col-sm-8\">Properties</th></tr></thead><tr ng-repeat=\"entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)\"><td><span>{{entry.prefix}}</span></td><td><div class=\"row\" ng-repeat=\"(key, value) in entry.properties\"><div class=\"col-md-4\">{{key}}</div><div class=\"col-md-8\"><span class=\"pull-right label label-default break\">{{value}}</span></div></div></td></tr></table><div ng-repeat=\"(key, value) in vm.allConfiguration\"><label ng-hide=\"filtered.length == 0\"><span>{{key}}</span></label><table class=\"table table-condensed table-striped table-bordered table-responsive\" style=\"table-layout:fixed\" ng-hide=\"filtered.length == 0\"><thead><tr><th class=\"col-sm-4\">Property</th><th class=\"col-sm-8\">Value</th></tr></thead><tbody><tr ng-repeat=\"item in filtered = (value | filter:filter)\"><td class=\"break\">{{item.key}}</td><td class=\"break\"><span class=\"pull-right label label-default break\">{{item.val}}</span></td></tr></tbody></table></div></div>");
$templateCache.put("app/account/settings/settings.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h2 translate=\"settings.title\" translate-values=\"{username: \'{{vm.settingsAccount.login}}\'}\">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class=\"alert alert-success\" ng-show=\"vm.success\" translate=\"settings.messages.success\"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name=\"form\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"firstName\" translate=\"settings.form.firstname\">First Name</label><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"{{\'settings.form.firstname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.firstName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.firstName.$dirty && form.firstName.$invalid\"><p class=\"help-block\" ng-show=\"form.firstName.$error.required\" translate=\"settings.messages.validate.firstname.required\">Your first name is required.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.minlength\" translate=\"settings.messages.validate.firstname.minlength\">Your first name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.firstName.$error.maxlength\" translate=\"settings.messages.validate.firstname.maxlength\">Your first name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"lastName\" translate=\"settings.form.lastname\">Last Name</label><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"{{\'settings.form.lastname.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.lastName\" ng-minlength=\"1\" ng-maxlength=\"50\" required maxlength=\"50\"><div ng-show=\"form.lastName.$dirty && form.lastName.$invalid\"><p class=\"help-block\" ng-show=\"form.lastName.$error.required\" translate=\"settings.messages.validate.lastname.required\">Your last name is required.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.minlength\" translate=\"settings.messages.validate.lastname.minlength\">Your last name is required to be at least 1 character.</p><p class=\"help-block\" ng-show=\"form.lastName.$error.maxlength\" translate=\"settings.messages.validate.lastname.maxlength\">Your last name cannot be longer than 50 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.settingsAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required maxlength=\"100\"><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label for=\"langKey\" translate=\"settings.form.language\">Language</label><select id=\"langKey\" name=\"langKey\" class=\"form-control\" ng-model=\"vm.settingsAccount.langKey\" ng-controller=\"JhiLanguageController as languageVm\" ng-options=\"code as (code | findLanguageFromKey) for code in languageVm.languages\"></select></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"settings.form.button\">Save</button></form></div></div></div>");
$templateCache.put("app/admin/docs/docs.html","<iframe src=\"swagger-ui/index.html\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\" width=\"100%\" height=\"900\" scrolling=\"auto\" target=\"_top\"></iframe>");
$templateCache.put("app/admin/health/health.html","<div><h2 translate=\"health.title\">Health Checks</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"health.refresh.button\">Refresh</span></button></p><table id=\"healthCheck\" class=\"table table-striped\"><thead><tr><th class=\"col-md-7\" translate=\"health.table.service\">Service Name</th><th class=\"col-md-2 text-center\" translate=\"health.table.status\">Status</th><th class=\"col-md-2 text-center\" translate=\"health.details.details\">Details</th></tr></thead><tbody><tr ng-repeat=\"health in vm.healthData\"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class=\"text-center\"><span class=\"label\" ng-class=\"vm.getLabelClass(health.status)\">{{\'health.status.\' + health.status | translate}}</span></td><td class=\"text-center\"><a class=\"hand\" ng-click=\"vm.showHealth(health)\" ng-show=\"health.details || health.error\"><i class=\"glyphicon glyphicon-eye-open\"></i></a></td></tr></tbody></table></div>");
$templateCache.put("app/admin/health/health.modal.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\" id=\"showHealthLabel\">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class=\"modal-body pad\"><div ng-show=\"vm.currentHealth.details\"><h4 translate=\"health.details.properties\">Properties</h4><table class=\"table table-striped\"><thead><tr><th class=\"col-md-6 text-left\" translate=\"health.details.name\">Name</th><th class=\"col-md-6 text-left\" translate=\"health.details.value\">Value</th></tr></thead><tbody><tr ng-repeat=\"(k,v) in vm.currentHealth.details\"><td class=\"col-md-6 text-left\">{{k}}</td><td class=\"col-md-6 text-left\">{{v}}</td></tr></tbody></table></div><div ng-show=\"vm.currentHealth.error\"><h4 translate=\"health.details.error\">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default pull-left\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/entity-audit/entity-audit.detail.html","<div class=\"modal-header\"><button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"modal-title\">Audit Details</h4></div><div class=\"modal-body pad\"><div><strong>{{vm.audit.action}} action was performed on below data</strong><br><br><del class=\"diff diff-key\">Old/Removed value</del> &nbsp; <ins class=\"diff diff-key\">New/Added value</ins></div><br><label>Changed Fields</label><pre id=\"resultChanges\" ng-bind-html=\"vm.diffValueChanges\"></pre><label>All Fields</label><pre id=\"result\" ng-bind-html=\"vm.diffValue\"></pre></div><div class=\"modal-footer\"><button data-dismiss=\"modal\" class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/entity-audit/entity-audits.html","<div ng-cloak class=\"pad\"><div class=\"row\"><h3 class=\"col-sm-12\">Entity Audits</h3></div><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-12 pad\"><h4>Filter</h4><form name=\"auditForm\" role=\"form\" novalidate show-validation><div class=\"row\"><div class=\"col-md-8 form-group\"><label>Entity/Table</label><select class=\"input-sm form-control\" name=\"qualifiedName\" id=\"qualifiedName\" required ng-options=\"vm.getEntityName(entity) for entity in vm.entities\" ng-model=\"vm.qualifiedName\"></select><div ng-show=\"auditForm.qualifiedName.$invalid\"><p class=\"help-block\" ng-show=\"auditForm.qualifiedName.$error.required\">This field is required</p></div></div><div class=\"col-md-4 form-group\"><label>Limit to</label><select class=\"input-sm form-control\" name=\"limit\" id=\"limit\" required ng-options=\"option for option in vm.limits\" ng-model=\"vm.limit\"></select></div></div><div class=\"row pad\"><button ng-disabled=\"auditForm.$invalid\" class=\"btn btn-primary pull-right\" ng-click=\"vm.loadChanges()\"><i class=\"glyphicon glyphicon-import\"></i>&nbsp;Load Change List</button></div></form></div></div><div ng-show=\"!vm.loading\"><div class=\"table-responsive\" ng-if=\"vm.audits.length > 0\"><p ng-if=\"vm.qualifiedName\">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class=\"form-inline\"><div class=\"form-group\"><label for=\"searchField\">Filter:</label><input type=\"text\" class=\"form-control\" id=\"searchField\" ng-model=\"filter.$\" placeholder=\"global filter\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" id=\"searchFieldEntityId\" ng-model=\"filter.entityId\" placeholder=\"entity id filter\"></div></form><table class=\"table table-bordered table-hover table-striped\"><thead><tr><th>Entity Id</th><th>Action</th><th>Version</th><th>Value</th><th>Modified Date</th><th>Modified By</th><th><i class=\"glyphicon glyphicon-eye-open\"></i></th></tr></thead><tbody><tr ng-repeat=\"audit in vm.audits | filter:filter\"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class=\"audit-obj\" ng-bind-html=\"vm.format(audit.entityValue)\"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class=\"no-pad\">\n                        <div class=\"audit-obj\">\n                            <table class=\"table table-bordered table-hover no-margin\">\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Value</th>\n                                </tr>\n                                <tr ng-repeat=\"(k,v) in audit.entityValue\" ng-if=\"!vm.isObject(v)\">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if=\"vm.isDate(k)\">{{v | date:\'medium\'}}</span>\n                                        <span ng-if=\"!vm.isDate(k)\">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type=\"button\" ng-click=\"vm.openChange(audit)\" uib-tooltip=\"View Audit Change Details\" uib-tooltip-placement=\"auto\" class=\"btn btn-info btn-xs\"><i class=\"glyphicon glyphicon-eye-open\"></i></button></td></tr></tbody></table></div><p ng-if=\"vm.displayedChanges.length == 0\">No Data found for the filters</p></div></div>");
$templateCache.put("app/admin/logs/logs.html","<div class=\"table-responsive\"><h2 translate=\"logs.title\">Logs</h2><p translate=\"logs.nbloggers\" translate-values=\"{total: \'{{ vm.loggers.length }}\'}\">There are {{ vm.loggers.length }} loggers.</p><span translate=\"logs.filter\">Filter</span> <input type=\"text\" ng-model=\"filter\" class=\"form-control\"><table class=\"table table-condensed table-striped table-bordered\"><thead><tr title=\"click to order\"><th ng-click=\"predicate = \'name\'; reverse=!reverse\"><span translate=\"logs.table.name\">Name</span></th><th ng-click=\"predicate = \'level\'; reverse=!reverse\"><span translate=\"logs.table.level\">Level</span></th></tr></thead><tr ng-repeat=\"logger in vm.loggers | filter:filter | orderBy:predicate:reverse\"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click=\"vm.changeLevel(logger.name, \'TRACE\')\" ng-class=\"(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">TRACE</button> <button ng-click=\"vm.changeLevel(logger.name, \'DEBUG\')\" ng-class=\"(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">DEBUG</button> <button ng-click=\"vm.changeLevel(logger.name, \'INFO\')\" ng-class=\"(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">INFO</button> <button ng-click=\"vm.changeLevel(logger.name, \'WARN\')\" ng-class=\"(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">WARN</button> <button ng-click=\"vm.changeLevel(logger.name, \'ERROR\')\" ng-class=\"(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'\" class=\"btn btn-default btn-xs\">ERROR</button></td></tr></table></div>");
$templateCache.put("app/admin/metrics/metrics.html","<div><h2 translate=\"metrics.title\">Application Metrics</h2><p><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.refresh()\"><span class=\"glyphicon glyphicon-refresh\"></span>&nbsp;<span translate=\"metrics.refresh.button\">Refresh</span></button></p><h3 translate=\"metrics.jvm.title\">JVM Metrics</h3><div class=\"row\" ng-hide=\"vm.updatingMetrics\"><div class=\"col-md-4\"><b translate=\"metrics.jvm.memory.title\">Memory</b><p><span translate=\"metrics.jvm.memory.total\">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.total.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.total.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.heap.max\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value\" value=\"vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class=\"hand\" ng-click=\"vm.refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"glyphicon glyphicon-eye-open\"></i></a><p><span translate=\"metrics.jvm.threads.runnable\">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.runnable.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.waiting.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"warning\"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min=\"0\" value=\"vm.metrics.gauges[\'jvm.threads.blocked.count\'].value\" max=\"vm.metrics.gauges[\'jvm.threads.count\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class=\"col-md-4\"><b translate=\"metrics.jvm.gc.title\">Garbage collections</b><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class=\"row\"><div class=\"col-md-9\" translate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div><div class=\"col-md-3 text-right\">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class=\"well well-lg\" ng-show=\"vm.updatingMetrics\" translate=\"metrics.updating\">Updating...</div><h3 translate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3><p><span translate=\"metrics.jvm.http.active\">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate=\"metrics.jvm.http.total\">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.jvm.http.table.code\">Code</th><th translate=\"metrics.jvm.http.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.jvm.http.table.mean\">Mean</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th><th class=\"text-right\"><span translate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate=\"metrics.jvm.http.code.ok\">OK</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.notfound\">Not Found</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate=\"metrics.jvm.http.code.servererror\">Server error</td><td><uib-progressbar min=\"0\" max=\"vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count\" value=\"vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class=\"text-right\">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"metrics.servicesstats.table.name\">Service name</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.count\">Count</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.min\">Min</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p50\">p50</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p75\">p75</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p95\">p95</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.p99\">p99</th><th class=\"text-right\" translate=\"metrics.servicesstats.table.max\">Max</th></tr></thead><tbody><tr ng-repeat=\"(k, v) in vm.servicesStats\"><td>{{k}}</td><td class=\"text-right\">{{v.count}}</td><td class=\"text-right\">{{v.mean * 1000 | number:0}}</td><td class=\"text-right\">{{v.min * 1000 | number:0}}</td><td class=\"text-right\">{{v.p50 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p75 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p95 * 1000 | number:0}}</td><td class=\"text-right\">{{v.p99 * 1000 | number:0}}</td><td class=\"text-right\">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate=\"metrics.datasource.title\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\">DataSource statistics (time in millisecond)</h3><div class=\"table-responsive\" ng-show=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value > 0\"><table class=\"table table-striped\"><thead><tr><th><span translate=\"metrics.datasource.usage\">Usage</span> ({{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value}})</th><th class=\"text-right\" translate=\"metrics.datasource.count\">Count</th><th class=\"text-right\" translate=\"metrics.datasource.mean\">Mean</th><th class=\"text-right\" translate=\"metrics.datasource.min\">Min</th><th class=\"text-right\" translate=\"metrics.datasource.p50\">p50</th><th class=\"text-right\" translate=\"metrics.datasource.p75\">p75</th><th class=\"text-right\" translate=\"metrics.datasource.p95\">p95</th><th class=\"text-right\" translate=\"metrics.datasource.p99\">p99</th><th class=\"text-right\" translate=\"metrics.datasource.max\">Max</th></tr></thead><tbody><tr><td><div class=\"progress progress-striped\"><uib-progressbar min=\"0\" max=\"vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value\" value=\"vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value\" class=\"progress-striped active\" type=\"success\"><span>{{vm.metrics.gauges[\'HikariPool-0.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-0.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].count}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].mean | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].min | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p50 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p75 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p95 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].p99 | number:2}}</td><td class=\"text-right\">{{vm.metrics.histograms[\'HikariPool-0.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/admin/metrics/metrics.modal.html","<!-- Modal used to display the threads dump --><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"metrics.jvm.threads.dump.title\">Threads dump</h4></div><div class=\"modal-body pad\"><span class=\"label label-primary\" ng-click=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge\">{{vm.threadDumpAll}}</span></span>&nbsp; <span class=\"label label-success\" ng-click=\"threadDumpFilter = {threadState: \'RUNNABLE\'}\">Runnable&nbsp;<span class=\"badge\">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class=\"label label-info\" ng-click=\"threadDumpFilter = {threadState: \'WAITING\'}\">Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class=\"label label-warning\" ng-click=\"threadDumpFilter = {threadState: \'TIMED_WAITING\'}\">Timed Waiting&nbsp;<span class=\"badge\">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class=\"label label-danger\" ng-click=\"threadDumpFilter = {threadState: \'BLOCKED\'}\">Blocked&nbsp;<span class=\"badge\">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class=\"voffset2\">&nbsp;</div>Filter <input type=\"text\" ng-model=\"threadDumpFilter\" class=\"form-control\"><div class=\"row pad\" ng-repeat=\"(k, v) in vm.threadDump | filter:threadDumpFilter\"><h5><span class=\"label\" ng-class=\"vm.getLabelClass(v.threadState)\">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click=\"show = !show\"><span ng-show=\"!show\" translate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span> <span ng-show=\"show\" translate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span></a></h5><div class=\"well\" ng-show=\"show\"><div ng-repeat=\"(stK, stV) in v.stackTrace\">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class=\"voffset1\"></span></div></div><table class=\"table table-condensed\"><thead><tr><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th><th class=\"text-right\" translate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th><th translate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default pull-left\" data-dismiss=\"modal\" ng-click=\"vm.cancel()\">Done</button></div>");
$templateCache.put("app/admin/user-management/user-management-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.user.login)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"userManagement.delete.question\" translate-values=\"{login: \'{{vm.user.login}}\'}\">Are you sure you want to delete this User?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management-detail.html","<div><h2><span translate=\"userManagement.detail.title\">User</span> \"{{vm.user.login}}\"</h2><dl class=\"dl-horizontal\"><dt><span translate=\"userManagement.login\">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate=\"userManagement.firstName\">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate=\"userManagement.lastName\">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate=\"userManagement.email\">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate=\"userManagement.activated\">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate=\"userManagement.langKey\">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate=\"userManagement.createdBy\">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate=\"userManagement.createdDate\">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate=\"userManagement.profiles\">Profiles</span></dt><dd><ul class=\"list-unstyled\"><li ng-repeat=\"authority in vm.user.authorities\"><span>{{authority}}</span></li></ul></dd></dl><button type=\"submit\" ui-sref=\"user-management\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/admin/user-management/user-management-dialog.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myUserLabel\" translate=\"userManagement.home.createOrEditLabel\" ng-if=\"vm.user.id\">Create or edit a User</h4><h4 class=\"modal-title\" translate=\"userManagement.home.createLabel\" ng-if=\"!vm.user.id\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"userManagement.firstName\">First Name</label><input type=\"text\" class=\"form-control\" name=\"firstName\" ng-model=\"vm.user.firstName\" ng-maxlength=\"50\"><div ng-show=\"editForm.firstName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.firstName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-6\"><label translate=\"userManagement.lastName\">Last Name</label><input type=\"text\" class=\"form-control\" name=\"lastName\" ng-model=\"vm.user.lastName\" ng-maxlength=\"50\"><div ng-show=\"editForm.lastName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.lastName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div></div><div class=\"row\"><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"userManagement.email\">Email</label><input type=\"email\" class=\"form-control\" name=\"email\" ng-model=\"vm.user.email\" required ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p><p class=\"help-block\" ng-show=\"editForm.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p></div></div><div class=\"form-group col-md-2\"><label translate=\"userManagement.langKey\">Lang Key</label><select class=\"form-control\" name=\"langKey\" ng-model=\"vm.user.langKey\" ng-options=\"language as language for language in vm.languages track by language\"></select></div><div class=\"form-group col-md-2\"><label for=\"password\" translate=\"userManagement.activated\">Activated</label><label class=\"form-control\" for=\"activated\"><span>&nbsp;</span> <input ng-disabled=\"vm.user.id === null\" type=\"checkbox\" id=\"activated\" ng-model=\"vm.user.activated\"></label></div></div><div class=\"row\"><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"userManagement.login\">Login</label><input type=\"text\" class=\"form-control\" name=\"login\" ng-model=\"vm.user.login\" ng-required=\"vm.user.id == null\" ng-minlength=\"1\" ng-maxlength=\"50\" ng-pattern=\"/^[_\'.@A-Za-z0-9-]*$/\"><div ng-show=\"editForm.login.$invalid\"><p class=\"help-block\" ng-show=\"editForm.login.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.login.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"50\">This field cannot be longer than 50 characters.</p></div></div><div class=\"form-group col-md-2\"><label for=\"password\" translate=\"userManagement.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'userManagement.password\' | translate}}\" ng-model=\"vm.user.password\"></div><div class=\"form-group col-md-6\"><label translate=\"userManagement.profiles\">Profiles</label><select class=\"form-control\" multiple=\"multiple\" name=\"authority\" ng-model=\"vm.user.authorities\" ng-options=\"authority | translate for authority in vm.authorities\"></select></div><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\" data-translate=\"userManagement.photoUrl\" for=\"field_photoUrl\">Photo Url</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"photoUrl\" id=\"field_photoUrl\" ng-model=\"vm.user.photoUrl\" ng-maxlength=\"255\"><div class=\"input-group-btn\"><button id=\"upload_widget\" class=\"btn btn-info\">Upload</button></div></div><div ng-show=\"editForm.photoUrl.$invalid\"><p class=\"help-block\" ng-show=\"editForm.photoUrl.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button ng-disabled=\"editForm.$invalid || isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/admin/user-management/user-management.html","<div><h2 translate=\"userManagement.home.title\">Users</h2><jhi-alert></jhi-alert><div class=\"row\"><div class=\"col-md-4\"><button class=\"btn btn-primary\" ui-sref=\"user-management.new\"><span class=\"glyphicon glyphicon-flash\"></span> <span translate=\"userManagement.home.createLabel\">Create a new User</span></button></div></div><div class=\"table-responsive\"><table class=\"table table-striped\"><thead><tr><th translate=\"global.field.id\">ID</th><th translate=\"userManagement.login\">Login</th><th translate=\"userManagement.email\">Email</th><th></th><th translate=\"userManagement.langKey\">Lang Key</th><th translate=\"userManagement.profiles\">Profiles</th><th translate=\"userManagement.createdDate\">Created Date</th><th translate=\"userManagement.lastModifiedBy\">Last Modified By</th><th translate=\"userManagement.lastModifiedDate\">Last Modified Date</th><th></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users track by user.id\"><td><a ui-sref=\"user-management-detail({login:user.login})\">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class=\"label label-danger\" ng-click=\"vm.setActive(user, true)\" ng-show=\"!user.activated\" translate=\"userManagement.deactivated\" style=\"cursor: pointer\">Deactivated</span> <span class=\"label label-success\" ng-click=\"vm.setActive(user, false)\" ng-show=\"user.activated\" translate=\"userManagement.activated\" style=\"cursor: pointer\">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat=\"authority in user.authorities\"><span class=\"label label-info\">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><!--\n                        <button ng-click=\"vm.changePass(user.id)\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-key\"></span>\n                            <span class=\"hidden-xs hidden-sm\" >Password</span>\n                        </button>\n                        --> <button type=\"submit\" ui-sref=\"user-management.edit({login:user.login})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"user-management.delete({login:user.login})\" class=\"btn btn-danger btn-sm\" ng-disabled=\"vm.currentAccount.login==user.login\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.loadAll()\"></uib-pagination></div></div>");
$templateCache.put("app/components/login/login.html","<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.cancel()\">&times;</button><h4 class=\"modal-title\" translate=\"global.title\">Sign in</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"login.title\">Sign in</h1></div><div class=\"col-md-8 col-md-offset-2\"><div class=\"alert alert-danger\" ng-show=\"vm.authenticationError\" translate=\"login.messages.error.authentication\"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class=\"col-md-8 col-md-offset-2\"><form class=\"form\" role=\"form\" ng-submit=\"vm.login($event)\"><div class=\"form-group\"><label for=\"username\" translate=\"global.form.username\">Login</label><input type=\"text\" class=\"form-control\" id=\"username\" placeholder=\"{{\'global.form.username.placeholder\' | translate}}\" ng-model=\"vm.username\"></div><div class=\"form-group\"><label for=\"password\" translate=\"login.form.password\">Password</label><input type=\"password\" class=\"form-control\" id=\"password\" placeholder=\"{{\'login.form.password.placeholder\' | translate}}\" ng-model=\"vm.password\"></div><div class=\"form-group\"><label for=\"rememberMe\"><input type=\"checkbox\" id=\"rememberMe\" ng-model=\"vm.rememberMe\" checked=\"checked\"> <span translate=\"login.form.rememberme\">Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\" translate=\"login.form.button\">Sign in</button></form><p></p><div class=\"\"><a class=\"\" href=\"\" ng-click=\"vm.requestResetPassword()\" translate=\"login.password.forgot\">Did you forget your password?</a></div></div></div></div>");
$templateCache.put("app/entities/address/address-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.address.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.address.delete.question\" translate-values=\"{id: \'{{vm.address.id}}\'}\">Are you sure you want to delete this Address?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/address/address-detail.html","<div><h2><span translate=\"fleetApp.address.detail.title\">Address</span> {{vm.address.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.address.postcode\">Postcode</span></dt><dd><span>{{vm.address.postcode}}</span></dd><dt><span translate=\"fleetApp.address.street\">Street</span></dt><dd><span>{{vm.address.street}}</span></dd><dt><span translate=\"fleetApp.address.number\">Number</span></dt><dd><span>{{vm.address.number}}</span></dd><dt><span translate=\"fleetApp.address.district\">District</span></dt><dd><span>{{vm.address.district}}</span></dd><dt><span translate=\"fleetApp.address.latitude\">Latitude</span></dt><dd><span>{{vm.address.latitude}}</span></dd><dt><span translate=\"fleetApp.address.longitude\">Longitude</span></dt><dd><span>{{vm.address.longitude}}</span></dd><dt><span translate=\"fleetApp.address.city\">City</span></dt><dd><span>{{vm.address.city}}</span></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"address-detail.edit({id:vm.address.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/address/address-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myAddressLabel\" translate=\"fleetApp.address.home.createOrEditLabel\">Create or edit a Address</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.address.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.address.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.postcode\" for=\"field_postcode\">Postcode</label><input type=\"text\" class=\"form-control\" name=\"postcode\" id=\"field_postcode\" ng-model=\"vm.address.postcode\" ng-maxlength=\"8\"><div ng-show=\"editForm.postcode.$invalid\"><p class=\"help-block\" ng-show=\"editForm.postcode.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"8\">This field cannot be longer than 8 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.street\" for=\"field_street\">Street</label><input type=\"text\" class=\"form-control\" name=\"street\" id=\"field_street\" ng-model=\"vm.address.street\" ng-maxlength=\"255\"><div ng-show=\"editForm.street.$invalid\"><p class=\"help-block\" ng-show=\"editForm.street.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.number\" for=\"field_number\">Number</label><input type=\"text\" class=\"form-control\" name=\"number\" id=\"field_number\" ng-model=\"vm.address.number\" ng-maxlength=\"10\"><div ng-show=\"editForm.number.$invalid\"><p class=\"help-block\" ng-show=\"editForm.number.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.district\" for=\"field_district\">District</label><input type=\"text\" class=\"form-control\" name=\"district\" id=\"field_district\" ng-model=\"vm.address.district\" ng-maxlength=\"100\"><div ng-show=\"editForm.district.$invalid\"><p class=\"help-block\" ng-show=\"editForm.district.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.latitude\" for=\"field_latitude\">Latitude</label><input type=\"number\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.address.latitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.longitude\" for=\"field_longitude\">Longitude</label><input type=\"number\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.address.longitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.address.city\" for=\"field_city\">City</label><input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" ng-model=\"vm.address.city\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/address/addresses.html","<div><h2 translate=\"fleetApp.address.home.title\">Addresses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"address.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.address.home.createLabel\">Create new Address</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"postcode\"><span translate=\"fleetApp.address.postcode\">Postcode</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"street\"><span translate=\"fleetApp.address.street\">Street</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"number\"><span translate=\"fleetApp.address.number\">Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"district\"><span translate=\"fleetApp.address.district\">District</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitude\"><span translate=\"fleetApp.address.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitude\"><span translate=\"fleetApp.address.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"city\"><span translate=\"fleetApp.address.city\">City</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"address in vm.addresses track by address.id\"><td><a ui-sref=\"address-detail({id:address.id})\">{{address.id}}</a></td><td>{{address.postcode}}</td><td>{{address.street}}</td><td>{{address.number}}</td><td>{{address.district}}</td><td>{{address.latitude}}</td><td>{{address.longitude}}</td><td>{{address.city}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"address-detail({id:address.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"address.edit({id:address.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"address.delete({id:address.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/bank-account/bank-account-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.bankAccount.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.bankAccount.delete.question\" translate-values=\"{id: \'{{vm.bankAccount.id}}\'}\">Are you sure you want to delete this Bank Account?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/bank-account/bank-account-detail.html","<div><h2><span translate=\"fleetApp.bankAccount.detail.title\">Bank Account</span> {{vm.bankAccount.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.bankAccount.accountNumber\">Account Number</span></dt><dd><span>{{vm.bankAccount.accountNumber}}</span></dd><dt><span translate=\"fleetApp.bankAccount.accountCheckNumber\">Account Check Number</span></dt><dd><span>{{vm.bankAccount.accountCheckNumber}}</span></dd><dt><span translate=\"fleetApp.bankAccount.name\">Name</span></dt><dd><span>{{vm.bankAccount.name}}</span></dd><dt><span translate=\"fleetApp.bankAccount.branchNumber\">Branch Number</span></dt><dd><span>{{vm.bankAccount.branchNumber}}</span></dd><dt><span translate=\"fleetApp.bankAccount.accountType\">Account Type</span></dt><dd><span>{{vm.bankAccount.accountType}}</span></dd><dt><span translate=\"fleetApp.bankAccount.bankNumber\">Bank Number</span></dt><dd><span>{{vm.bankAccount.bankNumber}}</span></dd><dt><span translate=\"fleetApp.bankAccount.federalId\">Federal Id</span></dt><dd><span>{{vm.bankAccount.federalId}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/bank-account/bank-account-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBankAccountLabel\" translate=\"fleetApp.bankAccount.home.createOrEditLabel\">Create or edit a Bank Account</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-3\" ng-show=\"vm.bankAccount.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.bankAccount.id\" readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.accountNumber\" for=\"field_accountNumber\">Account Number</label><input type=\"text\" class=\"form-control\" name=\"accountNumber\" id=\"field_accountNumber\" ng-model=\"vm.bankAccount.accountNumber\" required ng-maxlength=\"15\"><div ng-show=\"editForm.accountNumber.$invalid\"><p class=\"help-block\" ng-show=\"editForm.accountNumber.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.accountNumber.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"15\">This field cannot be longer than 15 characters.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.accountCheckNumber\" for=\"field_accountCheckNumber\">Account Check Number</label><input type=\"number\" class=\"form-control\" name=\"accountCheckNumber\" id=\"field_accountCheckNumber\" ng-model=\"vm.bankAccount.accountCheckNumber\" required><div ng-show=\"editForm.accountCheckNumber.$invalid\"><p class=\"help-block\" ng-show=\"editForm.accountCheckNumber.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.accountCheckNumber.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.bank.home.title\">Bank</label><bank-typeahead id=\"field_driver\" model-id=\"vm.bankAccount.bankId\" model-label=\"vm.bankAccount.bankName\" hide-title=\"true\"></bank-typeahead></div><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.branchNumber\" for=\"field_branchNumber\">Branch Number</label><input type=\"text\" class=\"form-control\" name=\"branchNumber\" id=\"field_branchNumber\" ng-model=\"vm.bankAccount.branchNumber\" required ng-maxlength=\"8\"><div ng-show=\"editForm.branchNumber.$invalid\"><p class=\"help-block\" ng-show=\"editForm.branchNumber.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.branchNumber.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"8\">This field cannot be longer than 8 characters.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.accountType\" for=\"field_accountType\">Account Type</label><select class=\"form-control\" name=\"deviceType\" ng-model=\"vm.bankAccount.accountType\" id=\"field_accountType\" ng-options=\"state.id as state.name for state in vm.stateOptions\" required></select><div ng-show=\"editForm.accountType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.accountType.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.accountType.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group col-md-12\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.bankAccount.name\" required ng-maxlength=\"200\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"200\">This field cannot be longer than 200 characters.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.federalId\" for=\"field_federalId\">Federal Id</label><input type=\"text\" class=\"form-control\" name=\"federalId\" id=\"field_federalId\" ng-model=\"vm.bankAccount.federalId\" ui-br-cpfcnpj-mask required><div ng-show=\"editForm.federalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.federalId.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div></div><div class=\"modal-footer\"><!--\n        <ul>\n            <li ng-repeat=\"(key, errors) in editForm.$error track by $index\"> <strong>{{ key }}</strong> errors\n                <ul>\n                    <li ng-repeat=\"e in errors\">{{ e.$name }} has an error: <strong>{{ key }}</strong>.</li>\n                </ul>\n            </li>\n        </ul>\n        --> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/bank-account/bank-accounts.html","<div><h2 translate=\"fleetApp.bankAccount.home.title\">Bank Accounts</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"bank-account.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.bankAccount.home.createLabel\">Create new Bank Account</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"fleetApp.bankAccount.name\">Name</span></th><th><span translate=\"fleetApp.bankAccount.federalId\">Federal Id</span></th><th><span translate=\"fleetApp.bankAccount.accountNumber\">Account Number</span></th><th><span translate=\"fleetApp.bankAccount.accountCheckNumber\">Account Check Number</span></th><th><span translate=\"fleetApp.bank.home.title\">Bank Number</span></th><th><span translate=\"fleetApp.bankAccount.branchNumber\">Branch Number</span></th><th><span translate=\"fleetApp.bankAccount.accountType\">Account Type</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"bankAccount in vm.bankAccounts track by bankAccount.id\"><td><a ui-sref=\"bank-account-detail({id:bankAccount.id})\">{{bankAccount.id}}</a></td><td>{{bankAccount.name}}</td><td>{{bankAccount.federalId}}</td><td>{{bankAccount.accountNumber}}</td><td>{{bankAccount.accountCheckNumber}}</td><td>{{bankAccount.bankName}}</td><td>{{bankAccount.branchNumber}}</td><td>{{bankAccount.accountType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"bank-account-detail({id:bankAccount.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"bank-account.edit({id:bankAccount.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"bank-account.delete({id:bankAccount.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/bank/bank-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.bank.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.bank.delete.question\" translate-values=\"{id: \'{{vm.bank.id}}\'}\">Are you sure you want to delete this Bank?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/bank/bank-detail.html","<div><h2><span translate=\"fleetApp.bank.detail.title\">Bank</span> {{vm.bank.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.bank.name\">Name</span></dt><dd><span>{{vm.bank.name}}</span></dd><dt><span translate=\"fleetApp.bank.code\">Code</span></dt><dd><span>{{vm.bank.code}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/bank/bank-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myBankLabel\" translate=\"fleetApp.bank.home.createOrEditLabel\">Create or edit a Bank</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.bank.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.bank.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.bank.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.bank.name\" required ng-maxlength=\"200\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"200\">This field cannot be longer than 200 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.bank.code\" for=\"field_code\">Code</label><input type=\"text\" class=\"form-control\" name=\"code\" id=\"field_code\" ng-model=\"vm.bank.code\" required ng-maxlength=\"8\"><div ng-show=\"editForm.code.$invalid\"><p class=\"help-block\" ng-show=\"editForm.code.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.code.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"8\">This field cannot be longer than 8 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/bank/banks.html","<div><h2 translate=\"fleetApp.bank.home.title\">Banks</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"bank.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.bank.home.createLabel\">Create new Bank</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"fleetApp.bank.name\">Name</span></th><th><span translate=\"fleetApp.bank.code\">Code</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"bank in vm.banks track by bank.id\"><td><a ui-sref=\"bank-detail({id:bank.id})\">{{bank.id}}</a></td><td>{{bank.name}}</td><td>{{bank.code}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"bank-detail({id:bank.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"bank.edit({id:bank.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"bank.delete({id:bank.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/collect/collect-dialog-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaskLabel\"><span translate=\"fleetApp.task.detail.title\">Task</span> nº{{vm.task.id}} &nbsp;&nbsp;&nbsp;{{vm.task.pickupPersonId}}-{{vm.task.pickupPersonName}}</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row invoice-info\"><div class=\"col-sm-4 invoice-col\">Origem<address><strong>{{vm.task.pickupPersonExternalId}} - {{vm.task.pickupPersonName}}</strong><br><!--\n                    795 Folsom Ave, Suite 600<br>\n                    San Francisco, CA 94107<br>\n                    Phone: (804) 123-5432<br>\n                    Email: info@almasaeedstudio.com\n                    --></address></div><!-- /.col --><div class=\"col-sm-4 invoice-col\">Destino<address><strong>{{vm.task.personExternalId}} - {{vm.task.personName}}</strong><br><!--\n                    795 Folsom Ave, Suite 600<br>\n                    San Francisco, CA 94107<br>\n                    Phone: (555) 539-1037<br>\n                    Email: john.doe@example.com\n                    --></address></div><!-- /.col --><div class=\"col-sm-4 invoice-col\"><b>Observação: </b>{{vm.task.notes}}<br><!--\n                <br>\n                <b>Order ID:</b> 4F3S8J<br>\n                <b>Payment Due:</b> 2/22/2014<br>\n                <b>Account:</b> 968-34567\n                --></div><!-- /.col --></div><div class=\"row\"><div class=\"col-sm-12\"><label translate=\"fleetApp.task.taskStatus\">Status da Entrega:</label>:</div><div class=\"col-sm-12\" ng-switch=\"vm.task.taskStatus\"><div class=\"alert alert-success\" ng-switch-when=\"COMPLETED\"><h4><i class=\"icon fa fa-check\"></i><label translate=\"fleetApp.TaskStatus.COMPLETED\">COMPLETED</label></h4></div><div class=\"alert alert-danger\" ng-switch-when=\"REJECTED\"><h4><i class=\"icon fa fa-ban\"></i><label translate=\"fleetApp.TaskStatus.REJECTED\">REJECTED</label></h4><label>{{vm.dashboard.rejectionReason}}</label></div><div class=\"alert alert-warning\" ng-switch-when=\"PARTIALLY_DONE\"><h4><i class=\"icon fa fa-ban\"></i><label translate=\"fleetApp.TaskStatus.PARTIALLY_DONE\">PARTIALLY_DONE</label></h4><label>{{vm.dashboard.rejectionReason}}</label></div><div class=\"alert alert-info\" ng-switch-default><h4><i class=\"icon fa fa-info\"></i><label translate=\"fleetApp.TaskStatus.{{vm.task.taskStatus}}\">STATUS</label></h4></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></div>");
$templateCache.put("app/entities/collect/collect-item.component.html","<div class=\"box-body\"><div class=\"row\"><div class=\"col-xs-12\"><person-typeahead model-id=\"$ctrl.task.pickupPersonId\" model-label=\"$ctrl.task.pickupPersonName\" label=\"\'global.field.origin\'\"></person-typeahead></div><div class=\"col-xs-12\"><person-typeahead model-id=\"$ctrl.task.personId\" model-label=\"$ctrl.task.personName\" label=\"\'global.field.destiny\'\"></person-typeahead></div><div class=\"col-md-6\"><label class=\"control-label\">Valor</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-dollar\"></i></span> <input type=\"number\" ng-model=\"$ctrl.task.total\" class=\"form-control\"></div></div><div class=\"form-group col-md-12\"><label class=\"control-label\" translate=\"fleetApp.task.taskStatus\" for=\"field_taskStatus\">Task Status</label><select class=\"form-control\" name=\"taskStatus\" ng-model=\"$ctrl.task.taskStatus\" id=\"field_taskStatus\" required><option value=\"IN_PROGRESS\" translate=\"fleetApp.TaskStatus.IN_PROGRESS\">IN_PROGRESS</option><option value=\"COMPLETED\" translate=\"fleetApp.TaskStatus.COMPLETED\">COMPLETED</option><option value=\"NOT_STARTED\" translate=\"fleetApp.TaskStatus.NOT_STARTED\">NOT_STARTED</option><option value=\"PARTIALLY_DONE\" translate=\"fleetApp.TaskStatus.PARTIALLY_DONE\">PARTIALLY_DONE</option><option value=\"REJECTED\" translate=\"fleetApp.TaskStatus.REJECTED\">REJECTED</option></select><div ng-show=\"editForm.taskStatus.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taskStatus.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-md-6\"><label class=\"control-label\">Descrição</label><textarea maxlength=\"100\" rows=\"1\" ng-model=\"$ctrl.task.notes\" class=\"form-control\"></textarea></div><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"fleetApp.visit.arrivalTime\" for=\"field_arrivalTime\">Arrival Time</label><div class=\"input-group\"><input id=\"field_arrivalTime\" type=\"text\" class=\"form-control\" name=\"arrivalTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"$ctrl.task.firstTimeIn\" is-open=\"isOpenTask\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"isOpenTask = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.arrivalTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.arrivalTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"fleetApp.visit.departure\" for=\"field_departure\">Departure</label><div class=\"input-group\"><input id=\"field_departure\" type=\"text\" class=\"form-control\" name=\"departure\" datetime-picker=\"{{dateformat}}\" ng-model=\"$ctrl.task.lastTimeOut\" is-open=\"isOpenTaskDeparture\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"isOpenTaskDeparture = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.departure.$invalid\"><p class=\"help-block\" ng-show=\"editForm.departure.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.odometer\">Start Odometer</label><input type=\"number\" class=\"form-control\" name=\"startOdometer\" ng-model=\"$ctrl.task.odometer\"></div></div></div>");
$templateCache.put("app/entities/company/companies.html","<div><h2 translate=\"fleetApp.company.home.title\">Companies</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"company.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.company.home.createLabel\">Create new Company</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"fleetApp.company.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"domain\"><span translate=\"fleetApp.company.domain\">Domain</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activated\"><span translate=\"fleetApp.company.activated\">Activated</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"company in vm.companies track by company.id\"><td><a ui-sref=\"company-detail({id:company.id})\">{{company.id}}</a></td><td>{{company.name}}</td><td>{{company.domain}}</td><td>{{company.activated}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"company-detail({id:company.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"company.edit({id:company.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"company.delete({id:company.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/company/company-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.company.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.company.delete.question\" translate-values=\"{id: \'{{vm.company.id}}\'}\">Are you sure you want to delete this Company?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/company/company-detail.html","<div><h2><span translate=\"fleetApp.company.detail.title\">Company</span> {{vm.company.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.company.name\">Name</span></dt><dd><span>{{vm.company.name}}</span></dd><dt><span translate=\"fleetApp.company.domain\">Domain</span></dt><dd><span>{{vm.company.domain}}</span></dd><dt><span translate=\"fleetApp.company.activated\">Activated</span></dt><dd><span>{{vm.company.activated}}</span></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/company/company-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myCompanyLabel\" translate=\"fleetApp.company.home.createOrEditLabel\">Create or edit a Company</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.company.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.company.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.company.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.company.name\" required ng-maxlength=\"150\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.company.domain\" for=\"field_domain\">Domain</label><input type=\"text\" class=\"form-control\" name=\"domain\" id=\"field_domain\" ng-model=\"vm.company.domain\" required ng-maxlength=\"15\"><div ng-show=\"editForm.domain.$invalid\"><p class=\"help-block\" ng-show=\"editForm.domain.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.domain.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"15\">This field cannot be longer than 15 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.company.activated\" for=\"field_activated\">Activated</label><input type=\"checkbox\" name=\"activated\" id=\"field_activated\" ng-model=\"vm.company.activated\"><div ng-show=\"editForm.activated.$invalid\"><p class=\"help-block\" ng-show=\"editForm.activated.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/dashboard/dashboard-box-include.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div class=\"row\"><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"info-box\"><span class=\"info-box-icon bg-aqua\"><i class=\"ion ion-ios-gear-outline\"></i></span> <a ng-click=\"vm.toItineraries()\"><div class=\"info-box-content\"><span class=\"info-box-text\">Itinerários</span> <span class=\"info-box-number\">{{vm.dashboard.itineraryCount}}</span></div></a></div></div><!--\n    <div class=\"col-md-2 col-sm-4 col-xs-6\">\n        <div class=\"info-box\">\n            <span class=\"info-box-icon bg-aqua\"><i class=\"glyphicon glyphicon-shopping-cart\"></i></span>\n            <a ng-click=\"vm.toTasks(\'\')\">\n                <div class=\"info-box-content\">\n                    <span class=\"info-box-text\">Entregas</span>\n                    <span class=\"info-box-number\">{{vm.dashboard.tasksCount}}</span>\n                </div>\n            </a>\n        </div>\n    </div>\n    --><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"info-box\"><span class=\"info-box-icon bg-blue\"><i class=\"glyphicon glyphicon-shopping-cart\"></i></span> <a ng-click=\"vm.toTasks(\'COMPLETED\')\"><div class=\"info-box-content\"><span class=\"info-box-text\">Entregando</span> <span class=\"info-box-number\">{{vm.dashboard.taskInProgressCount}}</span></div></a></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"info-box\"><span class=\"info-box-icon bg-red\"><i class=\"glyphicon glyphicon-exclamation-sign\"></i></span> <a ng-click=\"vm.toTasks(\'REJECTED\')\"><div class=\"info-box-content\"><span class=\"info-box-text\">Devolvidas</span> <span class=\"info-box-number\">{{vm.dashboard.taskRejectedCount}}</span></div></a></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"info-box\"><span class=\"info-box-icon bg-yellow\"><i class=\"glyphicon glyphicon-warning-sign\"></i></span> <a ng-click=\"vm.toTasks(\'PARTIALLY_DONE\')\"><div class=\"info-box-content\"><span class=\"info-box-text\">Parcial</span> <span class=\"info-box-number\">{{vm.dashboard.taskPartiallyDoneCount}}</span></div></a></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"info-box\"><span class=\"info-box-icon bg-green\"><i class=\"glyphicon glyphicon-ok\"></i></span> <a ng-click=\"vm.toTasks(\'COMPLETED\')\"><div class=\"info-box-content\"><span class=\"info-box-text\">Entregues</span> <span class=\"info-box-number\">{{vm.dashboard.taskCompletedCount}}</span></div></a></div></div><div class=\"col-md-2 col-sm-4 col-xs-6\"><div class=\"info-box\"><span class=\"info-box-icon bg-black\"><i class=\"glyphicon glyphicon-minus\"></i></span> <a ng-click=\"vm.toTasks(\'NOT_STARTED\')\"><div class=\"info-box-content\"><span class=\"info-box-text\">Não</span> <span class=\"info-box-text\">Iniciadas</span> <span class=\"info-box-number\">{{vm.dashboard.taskNotStartedCount}}</span></div></a></div></div><!-- /.col --></div>");
$templateCache.put("app/entities/dashboard/dashboard-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.dashboard.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.dashboard.delete.question\" translate-values=\"{id: \'{{vm.dashboard.id}}\'}\">Are you sure you want to delete this Dashboard?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/dashboard/dashboard-detail.html","<div><h2><span translate=\"fleetApp.dashboard.detail.title\">Dashboard</span> {{vm.dashboard.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"dashboard-detail.edit({id:vm.dashboard.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/dashboard/dashboard-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDashboardLabel\"><span translate=\"fleetApp.dashboard.detail.task\">Task Detail</span> {{vm.dashboard.id}}</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-4\"><div class=\"thumbnail\"><img ng-src=\"{{vm.dashboard.photoUrl}}\" alt=\"{{vm.dashboard.personDTO.tradeName}}\"></div></div><div class=\"col-md-8\"><div class=\"row\"><div class=\"col-md-6\"><address><strong>{{vm.dashboard.personDTO.tradeName}}</strong><br>{{vm.dashboard.addressDTO.street}} {{addressDTO.number}}<br>{{vm.dashboard.addressDTO.city}} {{vm.dashboard.addressDTO.district}}<br>Telefone: (62) 123-5432<br>Email: {{vm.dashboard.personDTO.email}}<br><a href=\"http://maps.google.com/maps?z=12&t=m&q=loc:{{vm.dashboard.addressDTO.latitude}}+{{vm.dashboard.addressDTO.longitude}}\" target=\"_blank\">{{vm.dashboard.addressDTO.latitude}},{{vm.dashboard.addressDTO.longitude}}</a><br></address></div><div class=\"col-sm-6 invoice-col\"><b>Entrega {{vm.dashboard.id}}</b><br><br><b>Pedido nº:</b> 4F3S8J<br><b>Conta:</b> 968-34567</div></div></div></div><div class=\"alert alert-danger\" ng-show=\"vm.dashboard.rejectionReason\"><h4><i class=\"icon fa fa-ban\"></i> Motivo da devolução</h4>{{vm.dashboard.rejectionReason}}</div><div class=\"row\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Qtd</th><th>Produto</th><th>Lote</th><th>Subtotal</th></tr></thead><tbody><tr><td>1</td><td>ACECLOFENACO</td><td>455-981-221</td><td>R$ 64.50</td></tr><tr><td>1</td><td>ACETATO DE NORETISTERONA + ETINILESTRADIOL</td><td>247-925-726</td><td>R$ 50.00</td></tr><tr><td>1</td><td>ACICLOVIR</td><td>735-845-642</td><td>R$ 10.70</td></tr><tr><td>1</td><td>CEFPROZILA</td><td>422-568-642</td><td>R$ 25.99</td></tr></tbody></table></div><!-- /.col --></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/dashboard/dashboard-graph-template.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><jhi-alert></jhi-alert><section class=\"content\"><div><div class=\"box-body no-padding\"><div class=\"row\"><div class=\"col-md-12 col-sm-12\"><div class=\"col-md-12 col-sm-12\"><div class=\"col-md-2\"><input type=\"text\" name=\"table_search\" class=\"form-control input-sm\" placeholder=\"{{\'entity.action.search\' | translate}}\" ng-model=\"searchText\"></div><div class=\"col-xs-1\"><button class=\"btn btn-default\" ng-click=\"$ctrl.refresh()\"><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-xs-2 no-padding-left\" has-any-authority=\"ROLE_ADMIN, EDIT_ITINERARY\"><button class=\"btn btn-default\" ui-sref=\"dashboard.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.itinerary.home.createLabel\">Create new Itinerary</span></button></div></div><div class=\"col-md-12 col-sm-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><tbody><tr ng-repeat=\"group in $ctrl.groups | filter:searchText track by group.vehiclePlate\"><td class=\"col-sm-2 invoice-col\"><img ng-if=\"group.vehiclePhotoUrl\" alt=\"{{group.vehiclePlate}}\" class=\"img-circle\" width=\"50px\" height=\"50px\" ng-src=\"{{group.vehiclePhotoUrl}}\"><ul class=\"list-unstyled\"><li><strong>{{group.vehiclePlate}}</strong><!--\n                                                    <button type=\"button\" class=\"btn btn-box-tool\" title=\"\" uib-tooltip=\"Mensagens\"\n                                                            ui-sref=\"dashboard.messages-modal({id: group.itineraries[0].id})\">\n                                                        <i class=\"fa fa-comments\"></i></button>\n                                                   --> <button type=\"button\" class=\"btn btn-box-tool\" title=\"\" uib-tooltip=\"Jornada de trabalho\" ui-sref=\"dashboard.officehours-modal({\n                                                                itineraryId: group.itineraries[0].id,\n                                                                vehicleId: group.vehicleId,\n                                                                vehiclePlate: group.vehiclePlate})\"><!--ng-click=\"$ctrl.onOfficeHourClicked(group.itineraries[0], $ctrl.date)\">--> <i class=\"fa fa-clock-o\"></i></button></li><li ng-show=\"group.driverFirstName\">Responsável: {{group.driverFirstName}}</li><li>{{group.vehicleTypeName}}</li></ul></td><td class=\"col-md-10\"><table class=\"jh-table\"><tr ng-repeat=\"itinerary in group.itineraries track by itinerary.id\"><td class=\"register-box-left\"><span class=\"text-sm\"><ul class=\"list-unstyled text-sm\"><li><div class=\"btn-group\" uib-dropdown><button id=\"split-button\" type=\"button\" class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.onItineraryMapClicked(itinerary.id, itinerary.vehicleId)\">Rota {{$index + 1}}</button> <button type=\"button\" class=\"btn btn-sm btn-default\" uib-dropdown-toggle><span class=\"caret\"></span> <span class=\"sr-only\">Opções</span></button><ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a ng-click=\"$ctrl.onItineraryMapClicked(itinerary.id, itinerary.vehicleId)\"><i class=\"fa fa-map\"></i>Mapa</a></li><li role=\"menuitem\"><a has-any-authority=\"ROLE_ADMIN, EDIT_ITINERARY\" ng-click=\"$ctrl.onEditItineraryClicked(itinerary.id)\"><i class=\"fa fa-edit\"></i>Editar</a></li><li class=\"divider\"></li><li role=\"menuitem\"><a has-any-authority=\"ROLE_ADMIN, EDIT_ITINERARY\" ng-click=\"$ctrl.onDeleteItineraryClicked(itinerary.id)\"><i class=\"fa fa-remove\"></i>Excluir</a></li></ul></div></li><li ng-if=\"itinerary.ordersNumber\"><i class=\"fa fa-barcode\"></i> <a uib-popover=\"{{$ctrl.arrayToString(itinerary.ordersNumber)}}\" popover-title=\"Pedidos\">{{ \'fleetApp.itinerary.ordersN\' | translate }}</a></li><li ng-if=\"itinerary.serviceNumber\"><i class=\"fa fa-barcode\"></i> <a uib-popover=\"{{$ctrl.arrayToString(itinerary.serviceNumber)}}\" popover-title=\"Remessas\">{{ \'fleetApp.itinerary.servicesN\' | translate }}</a></li><li ng-if=\"itinerary.endTime\" uib-tooltip=\"Duração\"><i class=\"fa fa-hourglass-end\"></i> Duração: {{itinerary.spentTime}}</li><li ng-if=\"itinerary.driverAssistant > 0\"><i class=\"fa fa-user-plus\"></i> Ajudantes: {{itinerary.driverAssistant}}</li></ul></span></td><td><ul class=\"list-inline\"><li ng-repeat=\"task in itinerary.tasks\" class=\"description-block\"><span ng-style=\"$ctrl.taskStyle(task.taskStatus)\" class=\"register-box-msg\" ng-click=\"$ctrl.onTaskClicked(task)\"><!--icon --> <i ng-class=\"$ctrl.taskClass(task)\" uib-tooltip=\"{{task.personExternalId}} {{task.personName}}\"></i></span><div class=\"text-sm\" ng-switch on=\"task.taskType\"><label ng-if=\"task.taskType != \'COLLECT\'\" uib-tooltip=\"{{task.personExternalId}}\n                                                                   {{task.personName}}\">{{task.personName | truncate: 20: \'...\'}}</label><label ng-if=\"task.taskType == \'COLLECT\'\" uib-tooltip=\"{{task.pickupPersonId}}\n                                                                   {{task.pickupPersonName}}\">{{task.pickupPersonName | truncate: 20: \'...\'}}</label><span ng-switch-when=\"WAREHOUSE_DEPARTURE\"><div uib-tooltip=\"Saída do centro de distribuição {{task.departure | date:\'short\'}}\"><i class=\"fa fa-chevron-circle-up\" ng-if=\"task.departure\"></i> {{task.departure | date:\'shortTime\'}}</div><div>&nbsp;</div></span><span ng-switch-when=\"WAREHOUSE_ARRIVAL\"><div uib-tooltip=\"Chegada no centro de distribuição {{task.arrivalTime | date:\'short\'}}\"><i class=\"fa fa-chevron-circle-down\" ng-if=\"task.arrivalTime\"></i> {{task.arrivalTime | date:\'shortTime\'}}</div><div>&nbsp;</div></span><span ng-if=\"task.taskType == \'COLLECT\' || task.taskType == \'DELIVER\'\"><div><span uib-tooltip=\"Hora de chegada {{task.arrivalTime | date:\'short\'}}\"><i class=\"fa fa-chevron-circle-up {{$ctrl.taskHourStyle(itinerary.startTime, task.arrivalTime)}}\" ng-if=\"task.arrivalTime\"></i> {{task.arrivalTime | date:\'shortTime\'}} </span><span uib-tooltip=\"Saída do cliente {{task.departure | date:\'short\'}}\"><span ng-if=\"task.departure\"><i class=\"fa fa-chevron-circle-down {{$ctrl.taskHourStyle(itinerary.startTime, task.departure)}}\"></i> {{task.departure | date:\'shortTime\'}}</span>&nbsp;</span></div><div uib-tooltip=\"Tempo gasto\"><span ng-show=\"task.departure\"><i class=\"fa fa-hourglass-end\"></i> {{task.spentTime}}</span>&nbsp;</div></span></div></li></ul></td></tr></table></td></tr></tbody></table></div></div></div></div></div></div></section>");
$templateCache.put("app/entities/dashboard/dashboards.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><section class=\"content-header\"><h1><span translate=\"fleetApp.dashboard.home.title\">Dashboard</span> <small><a ng-click=\"vm.openCalendar(\'dashboardDate\')\" datetime-picker enable-time=\"false\" when-closed=\"vm.transitionTo(true)\" ng-model=\"vm.pickerDate\" is-open=\"vm.datePickerOpenStatus.dashboardDate\">{{ vm.dashboardDate | date:\'dd/MM/yyyy\'}} <i class=\"fa fa-calendar\"></i></a></small></h1></section><dashboard-graph date=\"vm.dashboardDate\"></dashboard-graph>");
$templateCache.put("app/entities/dashboard/itinerary-map-dialog.html","<form name=\"form\" ng-submit=\"vm.close()\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"fleetApp.itinerary.detail.title\">Detalhes da rota</h4></div><div class=\"modal-body\"><div class=\"content-map-modal\"><geomap></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/deliver/deliver-item.component.html","<div class=\"box-body\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\">Pedido</label><div class=\"input-group\"><input type=\"number\" ng-model=\"orderNumber\" class=\"form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.searchByOrderNumber($ctrl.task, orderNumber); orderNumber = undefined;\"><i class=\"fa fa-plus\"></i></button></span></div></div><div class=\"col-md-2\" ng-repeat=\"number in $ctrl.task.ordersNumber\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><span class=\"center-text\">{{number}}</span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.removeOrder($ctrl.task, number, $index)\" uib-tooltip=\"Remover\"><i class=\"fa fa-remove\"></i></button></span></div></div></div><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\">Nota de Entrega (Ordem de remessa)</label><div class=\"input-group\"><input type=\"text\" ng-model=\"serviceNumber\" class=\"form-control\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.searchService($ctrl.task, serviceNumber); serviceNumber = undefined;\"><i class=\"fa fa-plus\"></i></button></span></div></div><div class=\"col-md-2\" ng-repeat=\"number in $ctrl.task.servicesNumber\"><label class=\"control-label\">&nbsp;</label><div class=\"input-group\"><span class=\"center-text\">{{number}}</span> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.removeService($ctrl.task, number, $index)\" uib-tooltip=\"Remover\"><i class=\"fa fa-remove\"></i></button></span></div></div></div><div class=\"col-xs-8\"><person-typeahead model-id=\"$ctrl.task.personId\" model-label=\"$ctrl.task.personName\" label=\"\'global.field.customer\'\"></person-typeahead></div><div class=\"form-group col-md-8\"><label class=\"control-label\" translate=\"fleetApp.task.taskStatus\" for=\"field_taskStatus\">Task Status</label><select class=\"form-control\" name=\"taskStatus\" ng-model=\"$ctrl.task.taskStatus\" id=\"field_taskStatus\" required><option value=\"IN_PROGRESS\" translate=\"fleetApp.TaskStatus.IN_PROGRESS\">IN_PROGRESS</option><option value=\"COMPLETED\" translate=\"fleetApp.TaskStatus.COMPLETED\">COMPLETED</option><option value=\"NOT_STARTED\" translate=\"fleetApp.TaskStatus.NOT_STARTED\">NOT_STARTED</option><option value=\"PARTIALLY_DONE\" translate=\"fleetApp.TaskStatus.PARTIALLY_DONE\">PARTIALLY_DONE</option><option value=\"REJECTED\" translate=\"fleetApp.TaskStatus.REJECTED\">REJECTED</option></select><div ng-show=\"$ctrl.formName.taskStatus.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taskStatus.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-12\" ng-if=\" $ctrl.task.servicesNumber.length > 0 ||  $ctrl.task.ordersNumber.length > 0\"><uib-accordion><div uib-accordion-group class=\"panel-default\" is-open=\"status.open\"><uib-accordion-heading><span ng-click=\"$ctrl.showInvoices($ctrl.task)\">Motivos de devolução <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></span></uib-accordion-heading><div class=\"row\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Id</th><th>Id Externo</th><th>Produto</th><th>Lote</th><th>Validade</th><th>Valor Unitário</th><th>Qtd</th><th>Motivo devolução</th></tr></thead><tbody><tr ng-repeat=\"invoiceItem in $ctrl.task.itens\"><td>{{invoiceItem.externalId}}</td><td>{{invoiceItem.secondExternalId}}</td><td>{{invoiceItem.name}}</td><td>{{invoiceItem.lot}}</td><td>{{invoiceItem.expirationDate | date:\'shortDate\'}}</td><td>{{invoiceItem.pricePerUnit | currency:fractionSize:6}}</td><td>{{invoiceItem.quantity}}</td><td><select class=\"form-control\" ng-model=\"invoiceItem.refusedReasonId\" ng-options=\"i.id as (i.name) for i in $ctrl.refusedReasons\"><option></option></select></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td><strong>{{vm.task.total | currency:fractionSize:6}}</strong></td></tr></tbody></table></div></div></div></uib-accordion></div><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"fleetApp.visit.arrivalTime\" for=\"field_arrivalTime\">Arrival Time</label><div class=\"input-group\"><input id=\"field_arrivalTime\" type=\"text\" class=\"form-control\" name=\"arrivalTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"$ctrl.task.firstTimeIn\" is-open=\"isOpenTask\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"isOpenTask = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.arrivalTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.arrivalTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group col-md-4\"><label class=\"control-label\" translate=\"fleetApp.visit.departure\" for=\"field_departure\">Departure</label><div class=\"input-group\"><input id=\"field_departure\" type=\"text\" class=\"form-control\" name=\"departure\" datetime-picker=\"{{dateformat}}\" ng-model=\"$ctrl.task.lastTimeOut\" is-open=\"isOpenTaskDeparture\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"isOpenTaskDeparture = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.departure.$invalid\"><p class=\"help-block\" ng-show=\"editForm.departure.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.odometer\">Start Odometer</label><input type=\"number\" class=\"form-control\" name=\"startOdometer\" ng-model=\"$ctrl.task.odometer\"></div></div>");
$templateCache.put("app/entities/device/device-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.device.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.device.delete.question\" translate-values=\"{id: \'{{vm.device.id}}\'}\">Are you sure you want to delete this Device?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/device/device-detail.html","<div><h2><span translate=\"fleetApp.device.detail.title\">Device</span> {{vm.device.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.device.name\">Name</span></dt><dd><span>{{vm.device.name}}</span></dd><dt><span translate=\"fleetApp.device.uniqueId\">Unique Id</span></dt><dd><span>{{vm.device.uniqueId}}</span></dd><dt><span translate=\"fleetApp.device.status\">Status</span></dt><dd><span>{{vm.device.status}}</span></dd><dt><span translate=\"fleetApp.device.lastUpdate\">Last Update</span></dt><dd><span>{{vm.device.lastUpdate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.device.deviceType\">deviceType</span></dt><dd><span>{{vm.device.deviceType}}</span></dd><dt><span translate=\"fleetApp.device.traccarId\">Traccar Id</span></dt><dd><span>{{vm.device.traccarId}}</span></dd><dt><span translate=\"fleetApp.device.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.device.companyId})\">{{vm.device.companyName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/device/device-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myDeviceLabel\" translate=\"fleetApp.device.home.createOrEditLabel\">Create or edit a Device</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.device.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.device.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.device.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.device.name\" required ng-maxlength=\"128\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.device.uniqueId\" for=\"field_uniqueId\">Unique Id</label><input type=\"text\" class=\"form-control\" name=\"uniqueId\" id=\"field_uniqueId\" ng-model=\"vm.device.uniqueId\" required ng-maxlength=\"128\"><div ng-show=\"editForm.uniqueId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.uniqueId.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.uniqueId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.device.status\" for=\"field_status\">Status</label><input type=\"text\" class=\"form-control\" name=\"status\" id=\"field_status\" ng-model=\"vm.device.status\" ng-maxlength=\"128\"><div ng-show=\"editForm.status.$invalid\"><p class=\"help-block\" ng-show=\"editForm.status.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"128\">This field cannot be longer than 128 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.device.lastUpdate\" for=\"field_lastUpdate\">Last Update</label><div class=\"input-group\"><input id=\"field_lastUpdate\" type=\"text\" class=\"form-control\" name=\"lastUpdate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.device.lastUpdate\" is-open=\"vm.datePickerOpenStatus.lastUpdate\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'lastUpdate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.device.traccarId\" for=\"field_traccarId\">Traccar Id</label><input type=\"number\" class=\"form-control\" name=\"traccarId\" id=\"field_traccarId\" ng-model=\"vm.device.traccarId\"></div><div class=\"form-group\"><label translate=\"fleetApp.device.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.device.companyId\" ng-options=\"company.id as company.name for company in vm.companies\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.company.$invalid\"><p class=\"help-block\" ng-show=\"editForm.company.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.device.deviceType\" for=\"field_deviceType\">Device Type</label><select class=\"form-control\" name=\"deviceType\" ng-model=\"vm.device.deviceType\" id=\"field_deviceType\" required><option value=\"CELLPHONE\">CELLPHONE</option><option value=\"AUTOTRAC\">AUTOTRAC</option><option value=\"OMNILINK\">OMNILINK</option></select><div ng-show=\"editForm.deviceType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.deviceType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/device/devices.html","<div><h2 translate=\"fleetApp.device.home.title\">Devices</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-2 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"device.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.device.home.createLabel\">Create new Device</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"fleetApp.device.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"uniqueId\"><span translate=\"fleetApp.device.uniqueId\">Unique Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"status\"><span translate=\"fleetApp.device.status\">Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"lastUpdate\"><span translate=\"fleetApp.device.lastUpdate\">Last Update</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"traccarId\"><span translate=\"fleetApp.device.traccarId\">Traccar Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyName\"><span translate=\"fleetApp.device.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deviceType\"><span translate=\"fleetApp.device.deviceType\">Type</span><span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"device in vm.devices track by device.id\"><td><a ui-sref=\"device-detail({id:device.id})\">{{device.id}}</a></td><td>{{device.name}}</td><td>{{device.uniqueId}}</td><td>{{device.status}}</td><td>{{device.lastUpdate | date:\'medium\'}}</td><td>{{device.traccarId}}</td><td><a ui-sref=\"company-detail({id:device.companyId})\">{{device.companyName}}</a></td><td>{{device.deviceType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"device-detail({id:device.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"device.edit({id:device.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"device.delete({id:device.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/expense/expense-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.expense.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.expense.delete.question\" translate-values=\"{id: \'{{vm.expense.id}}\'}\">Are you sure you want to delete this Expense?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/expense/expense-detail.html","<div><h2><span translate=\"fleetApp.expense.detail.title\">Expense</span> {{vm.expense.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.expense.expenseType\">Expense Type</span></dt><dd><span translate=\"{{\'fleetApp.ExpenseType.\' + vm.expense.expenseType}}\">{{vm.expense.expenseType}}</span></dd><dt><span translate=\"fleetApp.expense.total\">Total</span></dt><dd><span>{{vm.expense.total}}</span></dd><dt><span translate=\"fleetApp.expense.expenseDate\">Expense Date</span></dt><dd><span>{{vm.expense.expenseDate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.expense.driver\">Driver</span></dt><dd>{{vm.expense.driverFirstName}}</dd><dt><span translate=\"fleetApp.expense.vehicle\">Vehicle</span></dt><dd>{{vm.expense.vehiclePlate}}</dd><dt><span translate=\"fleetApp.expense.company\">Company</span></dt><dd>{{vm.expense.companyName}}</dd><dt><span translate=\"fleetApp.expense.creator\">Creator</span></dt><dd>{{vm.expense.creatorFirstName}}</dd><dt><span translate=\"fleetApp.expense.creation\">Creation</span></dt><dd><span>{{vm.expense.creation | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.expense.fleetMedia\">Fleet Media</span><br><a ui-sref=\"fleet-media-detail({id:vm.expense.fleetMediaId})\">{{vm.expense.fleetMediaId}}</a></dt><dd ng-if=\"vm.expense.fleetMediaUrl\"><div class=\"\"><a target=\"_blank\" ng-href=\"{{ vm.expense.fleetMediaUrl }}\">{{ \'fleetApp.expense.seeFleetMedia\' | translate }} <i class=\"fa fa-file-image-o\" aria-hidden=\"true\"></i></a></div></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/expense/expense-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myExpenseLabel\" translate=\"fleetApp.expense.home.createOrEditLabel\">Create or edit a Expense</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.expense.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.expense.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.expense.expenseType\" for=\"field_expenseType\">Expense Type</label><select class=\"form-control\" name=\"expenseType\" ng-model=\"vm.expense.expenseType\" id=\"field_expenseType\" required><option value=\"toll\" translate=\"fleetApp.ExpenseType.toll\">toll</option><option value=\"fuel\" translate=\"fleetApp.ExpenseType.fuel\">fuel</option></select><div ng-show=\"editForm.expenseType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.expenseType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.expense.total\" for=\"field_total\">Total</label><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-dollar\"></i></span> <input type=\"text\" ng-model=\"vm.expense.total\" ui-money-mask=\"2\" class=\"form-control\" id=\"field_total\"></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.expense.expenseDate\" for=\"field_expenseDate\">Expense Date</label><div class=\"input-group\"><input id=\"field_expenseDate\" type=\"text\" class=\"form-control\" name=\"expenseDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.expense.expenseDate\" is-open=\"vm.datePickerOpenStatus.expenseDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'expenseDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.expenseDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.expenseDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.expenseDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><user-typeahead id=\"field_driver\" model-id=\"vm.expense.driverId\" model-label=\"vm.expense.driverFirstName\" label=\"\'fleetApp.expense.driver\'\"></user-typeahead></div><div ng-show=\"editForm.driver.$invalid\"><p class=\"help-block\" ng-show=\"editForm.driver.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.expense.vehicleId\" model-label=\"vm.expense.vehiclePlate\" label=\"\'fleetApp.expense.vehicle\'\"></vehicle-typeahead></div><div ng-show=\"editForm.vehicle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.vehicle.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\" ngf-drop ngf-change=\"vm.setFilemedia($file, vm.expense)\"><label class=\"control-label\" translate=\"fleetApp.expense.fleetMedia\" for=\"field_filemedia\">Filemedia</label><div><div ng-if=\"vm.expense.filemedia\" class=\"help-block clearfix\"><a class=\"pull-left\" ng-click=\"vm.openFile(vm.expense.filemediaContentType, vm.expense.filemedia)\" translate=\"entity.action.open\">open</a><br><span class=\"pull-left\">{{vm.expense.filemediaContentType}}, {{vm.byteSize(vm.expense.filemedia)}}</span> <button ng-click=\"vm.expense.filemedia=null;vm.expense.filemediaContentType=null;\" class=\"btn btn-default btn-xs pull-right\"><span class=\"glyphicon glyphicon-remove\"></span></button></div><button type=\"file\" ngf-select class=\"btn btn-default btn-block\" ngf-change=\"vm.setFilemedia($file, vm.expense)\" translate=\"entity.action.addblob\">Add blob</button></div><input type=\"hidden\" class=\"form-control\" name=\"filemedia\" id=\"field_filemedia\" ng-model=\"vm.expense.filemedia\" maxbytes=\"1000000\"> <input type=\"hidden\" class=\"form-control\" name=\"filemediaContentType\" id=\"field_filemediaContentType\" ng-model=\"vm.expense.filemediaContentType\"><div ng-show=\"editForm.filemedia.$invalid\"><p class=\"help-block\" ng-show=\"editForm.filemedia.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.filemedia.$error.maxbytes\" translate=\"entity.validation.maxbytes\" translate-value-max=\"1000000\">This field cannot be more than 1000000.</p></div></div><!--\n        <div class=\"form-group\">\n            <label translate=\"fleetApp.expense.fleetMedia\" for=\"field_fleetMedia\">Fleet Media</label>\n            <select class=\"form-control\" id=\"field_fleetMedia\" name=\"fleetMedia\" ng-model=\"vm.expense.fleetMediaId\" ng-options=\"fleetMedia.id as fleetMedia.id for fleetMedia in vm.fleetmedias\"             required>\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div ng-show=\"editForm.fleetMedia.$invalid\">\n            <p class=\"help-block\"\n                ng-show=\"editForm.fleetMedia.$error.required\" translate=\"entity.validation.required\">\n                This field is required.\n            </p>\n        </div>\n        --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/expense/expenses.html","<div><h2 translate=\"fleetApp.expense.home.title\">Expenses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"fleetApp.expense.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onDateChange()\" required> <span class=\"input-group-addon\" translate=\"fleetApp.expense.filter.to\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.toDate\" ng-change=\"vm.onDateChange()\" required></p></div><div class=\"col-md-2\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.vehicleId\" model-label=\"vm.vehiclePlate\" hide-title=\"true\" label=\"\'fleetApp.expense.vehicle\'\"></vehicle-typeahead></div><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ng-click=\"vm.loadAll()\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.search\">Search</span></button> <button class=\"btn btn-primary\" ui-sref=\"expense.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.expense.home.createLabel\">Create new Expense</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expenseType\"><span translate=\"fleetApp.expense.expenseType\">Expense Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"total\"><span translate=\"fleetApp.expense.total\">Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expenseDate\"><span translate=\"fleetApp.expense.expenseDate\">Expense Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.expense.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><span translate=\"fleetApp.expense.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyName\"><span translate=\"fleetApp.expense.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"expense in vm.expenses track by expense.id\"><td><a ui-sref=\"expense-detail({id:expense.id})\">{{expense.id}}</a></td><td translate=\"{{\'fleetApp.ExpenseType.\' + expense.expenseType}}\">{{expense.expenseType}}</td><td>{{expense.total}}</td><td>{{expense.expenseDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{expense.driverFirstName}}</td><td>{{expense.vehiclePlate}}</td><td>{{expense.companyName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"expense-detail({id:expense.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"expense.edit({id:expense.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"expense.delete({id:expense.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/fleet-media/fleet-media-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.fleetMedia.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.fleetMedia.delete.question\" translate-values=\"{id: \'{{vm.fleetMedia.id}}\'}\">Are you sure you want to delete this Fleet Media?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/fleet-media/fleet-media-detail.html","<div><h2><span translate=\"fleetApp.fleetMedia.detail.title\">Fleet Media</span> {{vm.fleetMedia.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.fleetMedia.externalId\">External Id</span></dt><dd><span>{{vm.fleetMedia.externalId}}</span></dd><dt><span translate=\"fleetApp.fleetMedia.url\">Url</span></dt><dd><span>{{vm.fleetMedia.url}}</span></dd><dt><span translate=\"fleetApp.fleetMedia.mediaType\">Media Type</span></dt><dd><span translate=\"{{\'fleetApp.MediaType.\' + vm.fleetMedia.mediaType}}\">{{vm.fleetMedia.mediaType}}</span></dd><dt><span translate=\"fleetApp.fleetMedia.creationDate\">Creation Date</span></dt><dd><span>{{vm.fleetMedia.creationDate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.fleetMedia.creator\">Creator</span></dt><dd>{{vm.fleetMedia.creatorId}}</dd><dt><span translate=\"fleetApp.fleetMedia.task\">Task</span></dt><dd><a ui-sref=\"task-detail({id:vm.fleetMedia.taskId})\">{{vm.fleetMedia.taskId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/fleet-media/fleet-media-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFleetMediaLabel\" translate=\"fleetApp.fleetMedia.home.createOrEditLabel\">Create or edit a Fleet Media</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.fleetMedia.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.fleetMedia.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.fleetMedia.externalId\" for=\"field_externalId\">External Id</label><input type=\"text\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.fleetMedia.externalId\" ng-maxlength=\"200\"><div ng-show=\"editForm.externalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.externalId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"200\">This field cannot be longer than 200 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.fleetMedia.url\" for=\"field_url\">Url</label><input type=\"text\" class=\"form-control\" name=\"url\" id=\"field_url\" ng-model=\"vm.fleetMedia.url\" ng-maxlength=\"20\"><div ng-show=\"editForm.url.$invalid\"><p class=\"help-block\" ng-show=\"editForm.url.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">This field cannot be longer than 20 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.fleetMedia.mediaType\" for=\"field_mediaType\">Media Type</label><select class=\"form-control\" name=\"mediaType\" ng-model=\"vm.fleetMedia.mediaType\" id=\"field_mediaType\" required><option value=\"JPEG\" translate=\"fleetApp.MediaType.JPEG\">JPEG</option><option value=\"PDF\" translate=\"fleetApp.MediaType.PDF\">PDF</option></select><div ng-show=\"editForm.mediaType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.mediaType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.fleetMedia.creationDate\" for=\"field_creationDate\">Creation Date</label><div class=\"input-group\"><input id=\"field_creationDate\" type=\"text\" class=\"form-control\" name=\"creationDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.fleetMedia.creationDate\" is-open=\"vm.datePickerOpenStatus.creationDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'creationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.creationDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.creationDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.creationDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.fleetMedia.creator\" for=\"field_creator\">Creator</label><select class=\"form-control\" id=\"field_creator\" name=\"creator\" ng-model=\"vm.fleetMedia.creatorId\" ng-options=\"user.id as user.id for user in vm.users\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.creator.$invalid\"><p class=\"help-block\" ng-show=\"editForm.creator.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"fleetApp.fleetMedia.task\" for=\"field_task\">Task</label><select class=\"form-control\" id=\"field_task\" name=\"task\" ng-model=\"vm.fleetMedia.taskId\" ng-options=\"task.id as task.id for task in vm.tasks\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/fleet-media/fleet-medias.html","<div><h2 translate=\"fleetApp.fleetMedia.home.title\">Fleet Medias</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"fleet-media.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.fleetMedia.home.createLabel\">Create new Fleet Media</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"url\"><span translate=\"fleetApp.fleetMedia.url\">Url</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"mediaType\"><span translate=\"fleetApp.fleetMedia.mediaType\">Media Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creationDate\"><span translate=\"fleetApp.fleetMedia.creationDate\">Creation Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creatorId\"><span translate=\"fleetApp.fleetMedia.creator\">Creator</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taskId\"><span translate=\"fleetApp.fleetMedia.task\">Task</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deleted\"><span translate=\"fleetApp.fleetMedia.delete\">deleted</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"fleetMedia in vm.fleetMedias track by fleetMedia.id\"><td><a ui-sref=\"fleet-media-detail({id:fleetMedia.id})\">{{fleetMedia.id}}</a></td><td><a target=\"_blank\" ng-click=\"vm.openImage(fleetMedia.url)\">{{ fleetMedia.url | truncate: 10: \'...\': true }}</a></td><td translate=\"{{\'fleetApp.MediaType.\' + fleetMedia.mediaType}}\">{{fleetMedia.mediaType}}</td><td>{{fleetMedia.creationDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{fleetMedia.creatorId}}</td><td><a ui-sref=\"task-detail({id:fleetMedia.taskId})\">{{fleetMedia.taskId}}</a></td><td>{{fleetMedia.deleted}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"fleet-media-detail({id:fleetMedia.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"fleet-media.edit({id:fleetMedia.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"fleet-media.delete({id:fleetMedia.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/fleet-preference/fleet-preference-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.fleetPreference.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.fleetPreference.delete.question\" translate-values=\"{id: \'{{vm.fleetPreference.id}}\'}\">Are you sure you want to delete this Fleet Preference?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/fleet-preference/fleet-preference-detail.html","<div><h2><span translate=\"fleetApp.fleetPreference.detail.title\">Fleet Preference</span> {{vm.fleetPreference.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.fleetPreference.fleetPreferenceType\">Fleet Preference Type</span></dt><dd><span translate=\"{{\'fleetApp.FleetPreferenceType.\' + vm.fleetPreference.fleetPreferenceType}}\">{{vm.fleetPreference.fleetPreferenceType}}</span></dd><dt><span translate=\"fleetApp.fleetPreference.fieldValue\">Field Value</span></dt><dd><span>{{vm.fleetPreference.fieldValue}}</span></dd><dt><span translate=\"fleetApp.fleetPreference.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.fleetPreference.companyId})\">{{vm.fleetPreference.companyId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/fleet-preference/fleet-preference-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myFleetPreferenceLabel\" translate=\"fleetApp.fleetPreference.home.createOrEditLabel\">Create or edit a Fleet Preference</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.fleetPreference.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.fleetPreference.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.fleetPreference.fleetPreferenceType\" for=\"field_fleetPreferenceType\">Fleet Preference Type</label><select class=\"form-control\" name=\"fleetPreferenceType\" ng-model=\"vm.fleetPreference.fleetPreferenceType\" id=\"field_fleetPreferenceType\" required><option value=\"SMS_DELIVERY_IN_TRANSIT_LAYOUT\" translate=\"fleetApp.FleetPreferenceType.SMS_DELIVERY_IN_TRANSIT_LAYOUT\">SMS_DELIVERY_IN_TRANSIT_LAYOUT</option><option value=\"SEND_SMS_DELIVERY_IN_TRANSIT\" translate=\"fleetApp.FleetPreferenceType.SEND_SMS_DELIVERY_IN_TRANSIT\">SEND_SMS_DELIVERY_IN_TRANSIT</option><option value=\"SEND_SMS_DELIVERY_IN_TRANSIT\" translate=\"fleetApp.FleetPreferenceType.SMS_DELIVERED_LAYOUT\">SMS_DELIVERED_LAYOUT</option><option value=\"SEND_SMS_DELIVERY_IN_TRANSIT\" translate=\"fleetApp.FleetPreferenceType.SEND_SMS_DELIVERED\">SEND_SMS_DELIVERED</option><option value=\"INITIAL_MAP_POSITION\" translate=\"fleetApp.FleetPreferenceType.INITIAL_MAP_POSITION\">INITIAL_MAP_POSITION</option><option value=\"DEFAULT_DEPARTURE_LOCATION\" translate=\"fleetApp.FleetPreferenceType.DEFAULT_DEPARTURE_LOCATION\">DEFAULT_DEPARTURE_LOCATION</option><option value=\"DEFAULT_ARRIVAL_LOCATION\" translate=\"fleetApp.FleetPreferenceType.DEFAULT_ARRIVAL_LOCATION\">DEFAULT_ARRIVAL_LOCATION</option></select><div ng-show=\"editForm.fleetPreferenceType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.fleetPreferenceType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.fleetPreference.fieldValue\" for=\"field_fieldValue\">Field Value</label><input type=\"text\" class=\"form-control\" name=\"fieldValue\" id=\"field_fieldValue\" ng-model=\"vm.fleetPreference.fieldValue\" required><div ng-show=\"editForm.fieldValue.$invalid\"><p class=\"help-block\" ng-show=\"editForm.fieldValue.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/fleet-preference/fleet-preferences.html","<div><h2 translate=\"fleetApp.fleetPreference.home.title\">Fleet Preferences</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"fleet-preference.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.fleetPreference.home.createLabel\">Create new Fleet Preference</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fleetPreferenceType\"><span translate=\"fleetApp.fleetPreference.fleetPreferenceType\">Fleet Preference Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fieldValue\"><span translate=\"fleetApp.fleetPreference.fieldValue\">Field Value</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"fleetPreference in vm.fleetPreferences track by fleetPreference.id\"><td><a ui-sref=\"fleet-preference-detail({id:fleetPreference.id})\">{{fleetPreference.id}}</a></td><td translate=\"{{\'fleetApp.FleetPreferenceType.\' + fleetPreference.fleetPreferenceType}}\">{{fleetPreference.fleetPreferenceType}}</td><td>{{fleetPreference.fieldValue}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"fleet-preference-detail({id:fleetPreference.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"fleet-preference.edit({id:fleetPreference.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"fleet-preference.delete({id:fleetPreference.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/geomap/geomap.menu.html","<uib-tabset active=\"active\"><uib-tab heading=\"Veículos\"><!--<div class=\"input-group\">\n            <input type=\"text\" class=\"form-control\" placeholder=\"Pesquisar...\" ng-model=\"searchText\">\n            <span class=\"input-group-btn\">\n                <button class=\"btn btn-flat\" ng-click=\"searchText = \'\'\"><i class=\"fa fa-remove\" ng-if=\"searchText\"></i>\n                </button>\n              </span>\n        </div>--><div class=\"direct-chat-messages\"><div ng-repeat=\"vehicle in vm.vehicles | filter:searchText track by vehicle.vehicleId\"><div class=\"info-box\" ng-click=\"vm.selectVehicle(vehicle)\"><span class=\"info-box-icon bg-aqua\" style=\"width: 50px\"><i class=\"fa fa-truck\"></i></span><div class=\"info-box-content\" style=\"margin-left: 50px\"><span class=\"vehicle-plate\">{{vehicle.vehiclePlate}}</span><div class=\"pull-right\"><span class=\"text-muted small\">{{vehicle.vehicleTypeName}}</span></div><br><span>{{vehicle.driverFirstName}}</span><div class=\"pull-right\"><span class=\"text-muted small\">{{vehicle.deviceTime | date:\'short\'}}</span> <i class=\"fa fa-signal disabled\" style=\"color: green\"></i><!--<i class=\"fa fa-signal\" style=\"color: gray\"></i>--></div></div></div></div></div></uib-tab><uib-tab><uib-tab-heading><!--<i class=\"glyphicon glyphicon-bell\"></i> --> Itinerários</uib-tab-heading><a ng-click=\"vm.openCalendar(\'dashboardDate\')\" datetime-picker enable-time=\"false\" when-closed=\"vm.transitionTo(true)\" ng-model=\"vm.pickerDate\" is-open=\"vm.datePickerOpenStatus.dashboardDate\">{{ vm.dashboardDate | date:\'dd/MM/yyyy\'}} <i class=\"fa fa-calendar\"></i></a> {{ clock | date:\'HH:mm:ss\' }}<div class=\"direct-chat-messages\"><div ng-repeat=\"itinerary in vm.itineraries | filter:searchText track by itinerary.id\"><div class=\"info-box\" ng-click=\"vm.selectItinerarie(itinerary)\"><span class=\"info-box-icon bg-aqua\" style=\"width: 50px\"><i class=\"fa fa-cubes\"></i></span><div class=\"info-box-content\" style=\"margin-left: 50px\"><span class=\"vehicle-plate\">{{itinerary.vehiclePlate}}</span><div class=\"pull-right\"><span class=\"text-muted small\">{{itinerary.driverFirstName}}</span></div><br><span>{{itinerary.total | currency:fractionSize:6}}</span><div class=\"pull-right\"></div></div></div></div></div></uib-tab></uib-tabset><!--\n<div class=\"horizontalMenu\" ng-cloak>\n    <div class=\" col-lg-offset-3 horizontalMenuItem\" style=\"width:280px;\" >\n        <div class=\"small-box bg-aqua\" ng-click=\"vm.navigateTo(\'home.itineraries\');\">\n            <div class=\"inner\">\n                <h3>{{vm.dashboard.itineraryCount}}</h3>\n                <p>Itinerários</p>\n            </div>\n            <div class=\"icon\">\n                <i class=\"ion ion-ios-gear-outline\"></i>\n            </div>\n            <a class=\"small-box-footer\">Detalhes <i class=\"fa fa-arrow-circle-right\"></i></a>\n        </div>\n    </div>\n    <div class=\" horizontalMenuItem\" style=\"width:280px;\">\n        <div class=\"small-box bg-olive\" ng-click=\"vm.navigateTo(\'home.vehicles\');\">\n            <div class=\"inner\">\n                <h3>{{vm.dashboard.vehicleCount}}</h3>\n                <p>Veículos</p>\n            </div>\n            <div class=\"icon\">\n                <i class=\"fa fa-truck\"></i>\n            </div>\n            <a class=\"small-box-footer\">Detalhes <i class=\"fa fa-arrow-circle-right\"></i></a>\n        </div>\n    </div>\n    <div class=\" horizontalMenuItem\" style=\"width:280px;\" ng-if=\"false\">\n        <div class=\"small-box bg-aqua\">\n            <div class=\"inner\">\n                <h3>150</h3>\n                <p>Clientes</p>\n            </div>\n            <div class=\"icon\">\n                <i class=\"ion ion-person-add\"></i>\n            </div>\n            <a href=\"#\" class=\"small-box-footer\">Detalhes <i class=\"fa fa-arrow-circle-right\"></i></a>\n        </div>\n    </div>\n</div>\n-->");
$templateCache.put("app/entities/geomap/geomap.template.html","<!--Map--><div id=\"mapid\"></div>");
$templateCache.put("app/entities/invoice/invoice-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.invoice.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.invoice.delete.question\" translate-values=\"{id: \'{{vm.invoice.id}}\'}\">Are you sure you want to delete this Invoice?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/invoice/invoice-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2><span translate=\"fleetApp.invoice.detail.title\">Invoice</span> {{vm.invoice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.invoice.number\">Number</span></dt><dd><span>{{vm.invoice.number}}</span></dd><dt><span translate=\"fleetApp.invoice.date\">Date</span></dt><dd><span>{{vm.invoice.date | date:\'mediumDate\'}}</span></dd><dt><span translate=\"fleetApp.invoice.invoiceStatus\">Invoice Status</span></dt><dd><span translate=\"{{\'fleetApp.InvoiceStatus.\' + vm.invoice.invoiceStatus}}\">{{vm.invoice.invoiceStatus}}</span></dd><dt><span translate=\"fleetApp.invoice.personAddress\">Person Address</span></dt><dd><a ui-sref=\"person-address-detail({id:vm.invoice.personAddressId})\">{{vm.invoice.personAddressId}}</a></dd><dt><span translate=\"fleetApp.invoice.task\">Task</span></dt><dd><a ui-sref=\"task-detail({id:vm.invoice.taskId})\">{{vm.invoice.taskId}}</a></dd><dt><span translate=\"fleetApp.invoice.refusedReason\">Refused Reason</span></dt><dd><a ui-sref=\"refused-reason-detail({id:vm.invoice.refusedReasonId})\">{{vm.invoice.refusedReasonName}}</a></dd><dt><span translate=\"fleetApp.invoice.order\">Order</span></dt><dd><a ui-sref=\"order-detail({id:vm.invoice.orderId})\">{{vm.invoice.orderExternalId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/invoice/invoice-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInvoiceLabel\" translate=\"fleetApp.invoice.home.createOrEditLabel\">Create or edit a Invoice</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><uib-tabset active=\"active\"><uib-tab index=\"0\" heading=\"Detalhes\"><div class=\"row\"><div class=\"form-group col-md-3\" ng-show=\"vm.invoice.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.invoice.id\" readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.invoice.number\" for=\"field_number\">Number</label><input type=\"text\" class=\"form-control\" name=\"number\" id=\"field_number\" ng-model=\"vm.invoice.number\" required ng-maxlength=\"30\"><div class=\"custom-control custom-checkbox\"><input class=\"custom-control-input\" type=\"checkbox\" id=\"customCheckbox1\" value=\"option1\" ng-model=\"vm.invoice.createOrderIfNotExists\"><label for=\"customCheckbox1\" class=\"custom-control-label\">Criar Ordem se não existir</label></div><div ng-show=\"editForm.number.$invalid\"><p class=\"help-block\" ng-show=\"editForm.number.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.number.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"30\">This field cannot be longer than 30 characters.</p></div></div><div class=\"form-group col-md-3\"><label translate=\"global.menu.entities.order\" for=\"field_order\">Order</label><input id=\"field_order\" type=\"text\" class=\"form-control\" name=\"order\" ng-model=\"vm.invoice.orderId\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.invoice.date\" for=\"field_date\">Date</label><div class=\"input-group\"><input id=\"field_date\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.invoice.date\" is-open=\"vm.datePickerOpenStatus.date\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'date\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.date.$invalid\"><p class=\"help-block\" ng-show=\"editForm.date.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><!--\n                    <div class=\"form-group col-md-3\">\n                        <label class=\"control-label\" translate=\"fleetApp.invoice.invoiceStatus\" for=\"field_invoiceStatus\">Invoice Status</label>\n                        <select class=\"form-control\" name=\"invoiceStatus\" ng-model=\"vm.invoice.invoiceStatus\" id=\"field_invoiceStatus\">\n                            <option value=\"REFUSED\" translate=\"fleetApp.InvoiceStatus.REFUSED\">REFUSED</option>\n                        </select>\n                    </div>\n                    --><!--\n                    <div class=\"form-group col-md-6\">\n                        <label translate=\"fleetApp.invoice.refusedReason\" for=\"field_refusedReason\">Refused Reason</label>\n                        <select class=\"form-control\" id=\"field_refusedReason\" name=\"refusedReason\" ng-model=\"vm.invoice.refusedReasonId\"\n                                ng-options=\"refusedReason.id as refusedReason.name for refusedReason in vm.refusedreasons\">\n                            <option value=\"\"></option>\n                        </select>\n                    </div>\n                    --><div class=\"form-group col-md-6\"><person-typeahead id=\"field_personAddress\" model-id=\"vm.invoice.personId\" model-label=\"vm.personName\" label=\"\'global.field.customer\'\"></person-typeahead></div></div></uib-tab><uib-tab index=\"1\" heading=\"Produtos\"><div class=\"col-md-12\"><div class=\"row\" ng-repeat=\"item in vm.invoice.items\"><invoice-item-create item=\"item\"></invoice-item-create></div></div></uib-tab></uib-tabset><!--\n        <div class=\"form-group\">\n            <label translate=\"fleetApp.invoice.personAddress\" for=\"field_personAddress\">Person Address</label>\n            <select class=\"form-control\" id=\"field_personAddress\" name=\"personAddress\" ng-model=\"vm.invoice.personAddressId\"\n                    ng-options=\"personAddress.id as personAddress.id for personAddress in vm.personaddresses\"             required>\n                <option value=\"\"></option>\n            </select>\n        </div>\n        --><!--\n        <div class=\"form-group\">\n            <label translate=\"fleetApp.invoice.task\" for=\"field_task\">Task</label>\n            <select class=\"form-control\" id=\"field_task\" name=\"task\" ng-model=\"vm.invoice.taskId\" ng-options=\"task.id as task.id for task in vm.tasks\"            >\n                <option value=\"\"></option>\n            </select>\n        </div>\n        --></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/invoice/invoices.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.invoice.home.title\">Invoices</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"invoice.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.invoice.home.createLabel\">Create new Invoice</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"number\"><span translate=\"fleetApp.invoice.number\">Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"date\"><span translate=\"fleetApp.invoice.date\">Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"invoiceStatus\"><span translate=\"fleetApp.invoice.invoiceStatus\">Invoice Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personAddressId\"><span translate=\"fleetApp.invoice.personAddress\">Person Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taskId\"><span translate=\"fleetApp.invoice.task\">Task</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"refusedReasonName\"><span translate=\"fleetApp.invoice.refusedReason\">Refused Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"orderExternalId\"><span translate=\"fleetApp.invoice.order\">Order</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"invoice in vm.invoices track by invoice.id\"><td><a ui-sref=\"invoice-detail({id:invoice.id})\">{{invoice.id}}</a></td><td>{{invoice.number}}</td><td>{{invoice.date | date:\'mediumDate\'}}</td><td translate=\"{{\'fleetApp.InvoiceStatus.\' + invoice.invoiceStatus}}\">{{invoice.invoiceStatus}}</td><td><a ui-sref=\"person-address-detail({id:invoice.personAddressId})\">{{invoice.personAddressId}}</a></td><td><a ui-sref=\"task-detail({id:invoice.taskId})\">{{invoice.taskId}}</a></td><td><a ui-sref=\"refused-reason-detail({id:invoice.refusedReasonId})\">{{invoice.refusedReasonName}}</a></td><td><a ui-sref=\"order-detail({id:invoice.orderId})\">{{invoice.orderExternalId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"invoice-detail({id:invoice.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"invoice.edit({id:invoice.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"invoice.delete({id:invoice.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/invoice-item/invoice-item-create.component.html","<div class=\"box\"><div class=\"row\"><div class=\"form-group col-md-12\"><product-typeahead product=\"$ctrl.item.product\"></product-typeahead></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"$ctrl.item.quantity\" required><div ng-show=\"editForm.quantity.$invalid\"><p class=\"help-block\" ng-show=\"editForm.quantity.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.quantity.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.pricePerUnit\" for=\"field_pricePerUnit\">Price Per Unit</label><input type=\"number\" class=\"form-control\" name=\"pricePerUnit\" id=\"field_pricePerUnit\" ng-model=\"$ctrl.item.pricePerUnit\" required><div ng-show=\"editForm.pricePerUnit.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pricePerUnit.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.pricePerUnit.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.total\" for=\"field_total\">Total</label><input type=\"number\" class=\"form-control\" name=\"total\" id=\"field_total\" ng-model=\"vm.invoiceItem.total\" required><div ng-show=\"editForm.total.$invalid\"><p class=\"help-block\" ng-show=\"editForm.total.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.total.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"col-md-4 form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.discountPercent\" for=\"field_discountPercent\">Discount Percent</label><input type=\"number\" class=\"form-control\" name=\"discountPercent\" id=\"field_discountPercent\" ng-model=\"vm.invoiceItem.discountPercent\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.discount\" for=\"field_discount\">Discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.invoiceItem.discount\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.size\" for=\"field_size\">Size</label><input type=\"number\" class=\"form-control\" name=\"size\" id=\"field_size\" ng-model=\"vm.invoiceItem.size\"></div><div class=\"col-md-4 form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.unityType\" for=\"field_unityType\">Unity Type</label><input type=\"text\" class=\"form-control\" name=\"unityType\" id=\"field_unityType\" ng-model=\"vm.invoiceItem.unityType\" ng-maxlength=\"30\"><div ng-show=\"editForm.unityType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.unityType.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"30\">This field cannot be longer than 30 characters.</p></div></div></div></div>");
$templateCache.put("app/entities/invoice-item/invoice-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.invoiceItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.invoiceItem.delete.question\" translate-values=\"{id: \'{{vm.invoiceItem.id}}\'}\">Are you sure you want to delete this Invoice Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/invoice-item/invoice-item-detail.html","<div><h2><span translate=\"fleetApp.invoiceItem.detail.title\">Invoice Item</span> {{vm.invoiceItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.invoiceItem.quantity\">Quantity</span></dt><dd><span>{{vm.invoiceItem.quantity}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.pricePerUnit\">Price Per Unit</span></dt><dd><span>{{vm.invoiceItem.pricePerUnit}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.total\">Total</span></dt><dd><span>{{vm.invoiceItem.total}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.discountPercent\">Discount Percent</span></dt><dd><span>{{vm.invoiceItem.discountPercent}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.discount\">Discount</span></dt><dd><span>{{vm.invoiceItem.discount}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.size\">Size</span></dt><dd><span>{{vm.invoiceItem.size}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.unityType\">Unity Type</span></dt><dd><span>{{vm.invoiceItem.unityType}}</span></dd><dt><span translate=\"fleetApp.invoiceItem.product\">Product</span></dt><dd><a ui-sref=\"product-detail({id:vm.invoiceItem.productId})\">{{vm.invoiceItem.productName}}</a></dd><dt><span translate=\"fleetApp.invoiceItem.invoice\">Invoice</span></dt><dd><a ui-sref=\"invoice-detail({id:vm.invoiceItem.invoiceId})\">{{vm.invoiceItem.invoiceId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/invoice-item/invoice-item-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInvoiceItemLabel\" translate=\"fleetApp.invoiceItem.home.createOrEditLabel\">Create or edit a Invoice Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.invoiceItem.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.invoiceItem.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.quantity\" for=\"field_quantity\">Quantity</label><input type=\"number\" class=\"form-control\" name=\"quantity\" id=\"field_quantity\" ng-model=\"vm.invoiceItem.quantity\" required><div ng-show=\"editForm.quantity.$invalid\"><p class=\"help-block\" ng-show=\"editForm.quantity.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.quantity.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.pricePerUnit\" for=\"field_pricePerUnit\">Price Per Unit</label><input type=\"number\" class=\"form-control\" name=\"pricePerUnit\" id=\"field_pricePerUnit\" ng-model=\"vm.invoiceItem.pricePerUnit\" required><div ng-show=\"editForm.pricePerUnit.$invalid\"><p class=\"help-block\" ng-show=\"editForm.pricePerUnit.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.pricePerUnit.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.total\" for=\"field_total\">Total</label><input type=\"number\" class=\"form-control\" name=\"total\" id=\"field_total\" ng-model=\"vm.invoiceItem.total\" required><div ng-show=\"editForm.total.$invalid\"><p class=\"help-block\" ng-show=\"editForm.total.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.total.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.discountPercent\" for=\"field_discountPercent\">Discount Percent</label><input type=\"number\" class=\"form-control\" name=\"discountPercent\" id=\"field_discountPercent\" ng-model=\"vm.invoiceItem.discountPercent\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.discount\" for=\"field_discount\">Discount</label><input type=\"number\" class=\"form-control\" name=\"discount\" id=\"field_discount\" ng-model=\"vm.invoiceItem.discount\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.size\" for=\"field_size\">Size</label><input type=\"number\" class=\"form-control\" name=\"size\" id=\"field_size\" ng-model=\"vm.invoiceItem.size\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.invoiceItem.unityType\" for=\"field_unityType\">Unity Type</label><input type=\"text\" class=\"form-control\" name=\"unityType\" id=\"field_unityType\" ng-model=\"vm.invoiceItem.unityType\" ng-maxlength=\"30\"><div ng-show=\"editForm.unityType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.unityType.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"30\">This field cannot be longer than 30 characters.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.invoiceItem.product\" for=\"field_product\">Product</label><select class=\"form-control\" id=\"field_product\" name=\"product\" ng-model=\"vm.invoiceItem.productId\" ng-options=\"product.id as product.name for product in vm.products\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.product.$invalid\"><p class=\"help-block\" ng-show=\"editForm.product.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"fleetApp.invoiceItem.invoice\" for=\"field_invoice\">Invoice</label><select class=\"form-control\" id=\"field_invoice\" name=\"invoice\" ng-model=\"vm.invoiceItem.invoiceId\" ng-options=\"invoice.id as invoice.id for invoice in vm.invoices\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.invoice.$invalid\"><p class=\"help-block\" ng-show=\"editForm.invoice.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/invoice-item/invoice-item.component.html","<div class=\"row\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-striped\"><thead><tr><th>Id</th><th>Id Externo</th><th>Produto</th><th>Lote</th><th>Validade</th><th>Valor Unitário</th><th>Qtd</th><th>Valor Total</th></tr></thead><tbody><tr ng-repeat=\"invoiceItem in $ctrl.itens\" ng-class=\"$ctrl.getLineClass(invoiceItem)\" uib-tooltip=\"{{invoiceItem.refusedReasonName}}\" tooltip-placement=\"bottom\"><td>{{invoiceItem.externalId}}</td><td>{{invoiceItem.secondExternalId}}</td><td>{{invoiceItem.name}}</td><td>{{invoiceItem.lot}}</td><td>{{invoiceItem.expirationDate | date:\'shortDate\'}}</td><td>{{invoiceItem.pricePerUnit | currency:fractionSize:6}}</td><td>{{invoiceItem.quantity}}</td><td>{{invoiceItem.total | currency:fractionSize:6}} <a><i uib-popover=\"{{invoiceItem.refusedReasonName}}\" popover-placement=\"bottom\" ng-if=\"invoiceItem.refusedReasonId > 0\" popover-title=\"Motivo da devolução\" type=\"button\" class=\"fa fa-info-circle\"></i></a></td></tr><tr><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td><strong>{{$ctrl.total | sum | currency:fractionSize:6}}</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/invoice-item/invoice-items-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myInvoiceItemLabel\" translate=\"fleetApp.invoiceItem.home.title\">Invoice Item</h4></div><div class=\"modal-body\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th>ID Externo</th><th><span translate=\"fleetApp.invoiceItem.product\">Product</span></th><th><span translate=\"fleetApp.invoiceItem.quantity\">Quantity</span></th><th><span translate=\"fleetApp.invoiceItem.pricePerUnit\">Price Per Unit</span></th><th><span translate=\"fleetApp.invoiceItem.total\">Total</span></th><th><span translate=\"fleetApp.invoiceItem.size\">Size</span></th><th><span translate=\"fleetApp.invoiceItem.unityType\">Unity Type</span></th></tr></thead><tbody><tr ng-repeat=\"invoiceItem in vm.invoiceItems track by invoiceItem.id\"><td>{{invoiceItem.productExternalId}}</td><td>{{invoiceItem.productSecondExternalId}}</td><td>{{invoiceItem.productName}}</td><td>{{invoiceItem.quantity}}</td><td>{{invoiceItem.pricePerUnit | currency:fractionSize:6}}</td><td>{{invoiceItem.total | currency:fractionSize:6}}</td><td>{{invoiceItem.size}}</td><td>{{invoiceItem.unityType}}</td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div>");
$templateCache.put("app/entities/invoice-item/invoice-items.html","<div><h2 translate=\"fleetApp.invoiceItem.home.title\">Invoice Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"invoice-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.invoiceItem.home.createLabel\">Create new Invoice Item</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"quantity\"><span translate=\"fleetApp.invoiceItem.quantity\">Quantity</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"pricePerUnit\"><span translate=\"fleetApp.invoiceItem.pricePerUnit\">Price Per Unit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"total\"><span translate=\"fleetApp.invoiceItem.total\">Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discountPercent\"><span translate=\"fleetApp.invoiceItem.discountPercent\">Discount Percent</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"discount\"><span translate=\"fleetApp.invoiceItem.discount\">Discount</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"size\"><span translate=\"fleetApp.invoiceItem.size\">Size</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"unityType\"><span translate=\"fleetApp.invoiceItem.unityType\">Unity Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"productName\"><span translate=\"fleetApp.invoiceItem.product\">Product</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"invoiceId\"><span translate=\"fleetApp.invoiceItem.invoice\">Invoice</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"invoiceItem in vm.invoiceItems track by invoiceItem.id\"><td><a ui-sref=\"invoice-item-detail({id:invoiceItem.id})\">{{invoiceItem.id}}</a></td><td>{{invoiceItem.quantity}}</td><td>{{invoiceItem.pricePerUnit}}</td><td>{{invoiceItem.total}}</td><td>{{invoiceItem.discountPercent}}</td><td>{{invoiceItem.discount}}</td><td>{{invoiceItem.size}}</td><td>{{invoiceItem.unityType}}</td><td><a ui-sref=\"product-detail({id:invoiceItem.productId})\">{{invoiceItem.productName}}</a></td><td><a ui-sref=\"invoice-detail({id:invoiceItem.invoiceId})\">{{invoiceItem.invoiceId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"invoice-item-detail({id:invoiceItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"invoice-item.edit({id:invoiceItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"invoice-item.delete({id:invoiceItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/itinerary/itineraries.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.itinerary.home.title\">Itineraries</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><!--\n            <div class=\"col-xs-2 no-padding-left\" has-authority=\"ROLE_ADMIN\">\n                <button class=\"btn btn-primary\" ui-sref=\"itinerary.new\" >\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span  translate=\"fleetApp.itinerary.home.createLabel\">\n                        Create new Itinerary\n                    </span>\n                </button>\n            </div>\n            --><div class=\"col-xs-2\"><p class=\"input-group\"><span class=\"input-group-addon\">Data</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onDateChange()\" required></p></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><span translate=\"fleetApp.itinerary.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.itinerary.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"plannedDate\"><span translate=\"fleetApp.itinerary.plannedDate\">Planned</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"number\"><span translate=\"fleetApp.itinerary.number\">Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"startTime\"><span translate=\"fleetApp.itinerary.startEndTime\">Start Time</span><span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startOdometer\"><span translate=\"fleetApp.itinerary.odometer\">Odometer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"fleetApp.itinerary.km\">Km</span></th><!--<th jh-sort-by=\"creatorLogin\" has-authority=\"ROLE_ADMIN\"><span translate=\"fleetApp.itinerary.creator\">Creator</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th><span translate=\"fleetApp.itinerary.tasks\">Tarefas</span></th><th jh-sort-by=\"companyName\" has-authority=\"ROLE_ADMIN\"><span translate=\"fleetApp.itinerary.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"itinerary in vm.itineraries track by itinerary.id\"><td><a ui-sref=\"itinerary-detail({id:itinerary.id})\">{{itinerary.id}}</a></td><td><a ui-sref=\"vehicle-detail({id:itinerary.vehicleId})\">{{itinerary.vehiclePlate}}</a></td><td class=\"users-list clearfix\"><span class=\"users-list-name\">{{itinerary.driverFirstName}}</span></td><td>{{itinerary.plannedDate | date:\'short\'}}</td><!--<td>{{itinerary.number}}</td>--><td>Início: {{itinerary.startTime | date:\'short\' }}<br>Fim: {{itinerary.endTime | date:\'short\'}}</td><td>Inicial: {{itinerary.startOdometer}}<br>Final:&nbsp;&nbsp;&nbsp;&nbsp;{{itinerary.endOdometer}}</td><td>{{itinerary.odometerDelta}}</td><!--<td has-authority=\"ROLE_ADMIN\">{{itinerary.creatorLogin}}</td>--><td><a ui-sref=\"tasks({id:itinerary.id})\">{{itinerary.taskQtd}}</a></td><td has-authority=\"ROLE_ADMIN\"><a ui-sref=\"company-detail({id:itinerary.companyId})\">{{itinerary.companyName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"tasks({id:itinerary.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\">Tarefas</span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"itinerary-messages({id:itinerary.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\">Messages</span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"itinerary-detail({id:itinerary.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"itinerary.edit({id:itinerary.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"itinerary.delete({id:itinerary.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/itinerary/itinerary-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.itinerary.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.itinerary.delete.question\" translate-values=\"{id: \'{{vm.itinerary.id}}\'}\">Are you sure you want to delete this Itinerary?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/itinerary/itinerary-detail.html","<div><h2><span translate=\"fleetApp.itinerary.detail.title\">Itinerary</span> {{vm.itinerary.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.itinerary.creationDate\">Creation Date</span></dt><dd><span>{{vm.itinerary.creationDate | date:\'medium\' }}</span></dd><dt><span translate=\"fleetApp.itinerary.plannedDate\">Planned Date</span></dt><dd><span>{{vm.itinerary.plannedDate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.itinerary.number\">Number</span></dt><dd><span>{{vm.itinerary.number}}</span></dd><dt><span translate=\"fleetApp.itinerary.startTime\">Start Time</span></dt><dd><span>{{vm.itinerary.startTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.itinerary.endTime\">End Time</span></dt><dd><span>{{vm.itinerary.endTime | date:\'mediumDate\'}}</span></dd><dt><span translate=\"fleetApp.itinerary.startOdometer\">Start Odometer</span></dt><dd><span>{{vm.itinerary.startOdometer}}</span></dd><dt><span translate=\"fleetApp.itinerary.endOdometer\">End Odometer</span></dt><dd><span>{{vm.itinerary.endOdometer}}</span></dd><dt><span translate=\"fleetApp.itinerary.vehicle\">Vehicle</span></dt><dd><a ui-sref=\"vehicle-detail({id:vm.itinerary.vehicleId})\">{{vm.itinerary.vehiclePlate}}</a></dd><dt><span translate=\"fleetApp.itinerary.creator\">Creator</span></dt><dd>{{vm.itinerary.creatorLogin}}</dd><dt><span translate=\"fleetApp.itinerary.driver\">Driver</span></dt><dd>{{vm.itinerary.driverFirstName}}</dd><dt><span translate=\"fleetApp.itinerary.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.itinerary.companyId})\">{{vm.itinerary.companyName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/itinerary/itinerary-dialog-tab1.html","<div class=\"row\"><div class=\"form-group col-md-3\"><vehicle-typeahead name=\"vehicle\" model-id=\"vm.itinerary.vehicleId\" model-label=\"vm.itinerary.vehiclePlate\"></vehicle-typeahead></div><div class=\"col-md-4\"><user-typeahead model-id=\"vm.itinerary.driverId\" model-label=\"vm.itinerary.driverFirstName\" label=\"\'fleetApp.itinerary.driver\'\" translate-label-key=\"\'fleetApp.itinerary.driver\'\"></user-typeahead></div><div class=\"col-md-4\"><user-typeahead model-id=\"vm.itinerary.driverHelperId\" model-label=\"vm.itinerary.driverHelperFirstName\" label=\"\'fleetApp.itinerary.driverHelper\'\" translate-label-key=\"\'fleetApp.itinerary.driverHelper\'\"></user-typeahead></div></div><div class=\"row\"><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.plannedDate\" for=\"field_plannedDate\">Planned Date</label><div class=\"input-group\"><input id=\"field_plannedDate\" type=\"text\" class=\"form-control\" name=\"plannedDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.itinerary.plannedDate\" is-open=\"vm.datePickerOpenStatus.plannedDate\" timepicker-options=\"vm.timepickerOptions\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'plannedDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.plannedDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.plannedDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.plannedDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.startTime\" for=\"field_startTime\">Start Time</label><div class=\"input-group\"><input id=\"field_startTime\" type=\"text\" class=\"form-control\" name=\"startTime\" datetime-picker=\"{{dateformat}}\" timepicker-options=\"vm.timepickerOptions\" ng-model=\"vm.itinerary.startTime\" is-open=\"vm.datePickerOpenStatus.startTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.endTime\" for=\"field_endTime\">End Time</label><div class=\"input-group\"><input id=\"field_endTime\" type=\"text\" class=\"form-control\" name=\"endTime\" datetime-picker=\"{{dateformat}}\" timepicker-options=\"vm.timepickerOptions\" ng-model=\"vm.itinerary.endTime\" is-open=\"vm.datePickerOpenStatus.endTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"row\"><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.startOdometer\" for=\"field_startOdometer\">Start Odometer</label><input type=\"number\" class=\"form-control\" name=\"startOdometer\" id=\"field_startOdometer\" ng-model=\"vm.itinerary.startOdometer\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.itinerary.endOdometer\" for=\"field_endOdometer\">End Odometer</label><input type=\"number\" class=\"form-control\" name=\"endOdometer\" id=\"field_endOdometer\" ng-model=\"vm.itinerary.endOdometer\"></div></div><div class=\"row\"><user-itinerary-selector itinerary=\"vm.itinerary\"></div>");
$templateCache.put("app/entities/itinerary/itinerary-dialog-tab2.html","<!-- TASKS --><div class=\"\"><ul class=\"list-inline\"><li><a class=\"btn btn-app\" ng-click=\"vm.addTask(\'DELIVER\')\"><i class=\"glyphicon glyphicon-import\"></i> Adicionar entrega </a><a class=\"btn btn-app\" ng-click=\"vm.addTask(\'COLLECT\')\"><i class=\"fa fa-exchange\"></i> Adicionar coleta</a></li><li ng-repeat=\"task in vm.itinerary.tasks\"><div class=\"box\" ng-if=\"task.taskType == \'DELIVER\'\"><div class=\"box-header with-border\"><h3 class=\"box-title\">Entrega - {{task.personName}}</h3><div class=\"box-tools pull-right\"><button type=\"button\" class=\"btn\" uib-tooltip=\"Remover\" ng-click=\"vm.removeTask($index);\"><i class=\"fa fa-remove\"></i></button></div></div><deliver-item task=\"task\" form-name=\"editForm\"></deliver-item></div><div class=\"box\" ng-if=\"task.taskType == \'COLLECT\'\"><div class=\"box-header with-border\"><h3 class=\"box-title\">Coleta - {{task.pickupPersonName}}</h3><div class=\"box-tools pull-right\"><button type=\"button\" class=\"btn\" uib-tooltip=\"Remover\" ng-click=\"vm.removeTask($index);\"><i class=\"fa fa-remove\"></i></button></div></div><collect-item task=\"task\"></collect-item></div></li><li ng-if=\"vm.itinerary.tasks.length > 2\"><a class=\"btn btn-app\" ng-click=\"vm.addTask(\'DELIVER\')\"><i class=\"glyphicon glyphicon-import\"></i> Adicionar entrega </a><a class=\"btn btn-app\" ng-click=\"vm.addTask(\'COLLECT\')\"><i class=\"fa fa-exchange\"></i> Adicionar coleta</a></li></ul></div>");
$templateCache.put("app/entities/itinerary/itinerary-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation ng-cloak><div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 ng-if=\"!vm.itinerary.id\" class=\"modal-title\" id=\"lblCreate\" translate=\"fleetApp.itinerary.home.createLabel\">Create a Itinerary</h4><h4 ng-if=\"vm.itinerary.id\" class=\"modal-title\" id=\"lblEdit\"><span translate=\"fleetApp.itinerary.home.editLabel\">Edit a Itinerary</span> {{vm.itinerary.id}}</h4></div><div class=\"modal-body\"><jhi-alert></jhi-alert><uib-tabset active=\"active\" class=\"nav-tabs-custom\"><uib-tab heading=\"Dados básicos\"><div ng-include=\"\'app/entities/itinerary/itinerary-dialog-tab1.html\'\"></div></uib-tab><uib-tab heading=\"Tarefas\"><div ng-include=\"\'app/entities/itinerary/itinerary-dialog-tab2.html\'\"></div></uib-tab><uib-tab heading=\"Json\" has-authority=\"ROLE_ADMIN\">{{vm.itinerary | json}}</uib-tab></uib-tabset></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-md-12 pull-right\"><ul><li ng-repeat=\"(key, errors) in editForm.$error track by $index\"><strong>{{ key }}</strong> errors<ul><li ng-repeat=\"e in errors\">{{ e.$name }} possui um erro: <strong>{{ key }}</strong>.</li></ul></li></ul></div><div class=\"col-md-12\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div></div></div></form>");
$templateCache.put("app/entities/job-error/job-error-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.jobError.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.jobError.delete.question\" translate-values=\"{id: \'{{vm.jobError.id}}\'}\">Are you sure you want to delete this Job Error?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/job-error/job-error-detail.html","<div><h2><span translate=\"fleetApp.jobError.detail.title\">Job Error</span> {{vm.jobError.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.jobError.description\">Description</span></dt><dd><span>{{vm.jobError.description}}</span></dd><dt><span translate=\"fleetApp.jobError.creationDate\">Creation Date</span></dt><dd><span>{{vm.jobError.creationDate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.jobError.message\">Message</span></dt><dd><a ui-sref=\"message-detail({id:vm.jobError.messageId})\">{{vm.jobError.messageId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/job-error/job-error-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myJobErrorLabel\" translate=\"fleetApp.jobError.home.createOrEditLabel\">Create or edit a Job Error</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.jobError.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.jobError.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.jobError.description\" for=\"field_description\">Description</label><input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\" ng-model=\"vm.jobError.description\" ng-maxlength=\"300\"><div ng-show=\"editForm.description.$invalid\"><p class=\"help-block\" ng-show=\"editForm.description.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"300\">This field cannot be longer than 300 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.jobError.creationDate\" for=\"field_creationDate\">Creation Date</label><div class=\"input-group\"><input id=\"field_creationDate\" type=\"text\" class=\"form-control\" name=\"creationDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.jobError.creationDate\" is-open=\"vm.datePickerOpenStatus.creationDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'creationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.creationDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.creationDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.creationDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.jobError.message\" for=\"field_message\">Message</label><select class=\"form-control\" id=\"field_message\" name=\"message\" ng-model=\"vm.jobError.messageId\" ng-options=\"message.id as message.id for message in vm.messages\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/job-error/job-errors.html","<div><h2 translate=\"fleetApp.jobError.home.title\">Job Errors</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><!--\n            <div class=\"col-xs-4 no-padding-left\">\n                <button class=\"btn btn-primary\" ui-sref=\"job-error.new\" >\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span  translate=\"fleetApp.jobError.home.createLabel\">\n                        Create new Job Error\n                    </span>\n                </button>\n            </div>\n            --><div class=\"col-xs-2\"><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"fleetApp.jobError.creationDate\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.transition()\" required></p></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"description\"><span translate=\"fleetApp.jobError.description\">Description</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creationDate\"><span translate=\"fleetApp.jobError.creationDate\">Creation Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"messageId\"><span translate=\"fleetApp.jobError.message\">Message</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"jobError in vm.jobErrors track by jobError.id\"><td><a ui-sref=\"job-error-detail({id:jobError.id})\">{{jobError.id}}</a></td><td>{{jobError.description}}</td><td>{{jobError.creationDate | date:\'medium\'}}</td><td><a ui-sref=\"message-detail({id:jobError.messageId})\">{{jobError.messageId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"job-error-detail({id:jobError.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"job-error.edit({id:jobError.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"job-error.delete({id:jobError.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/message/message-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.message.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.message.delete.question\" translate-values=\"{id: \'{{vm.message.id}}\'}\">Are you sure you want to delete this Message?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/message/message-detail.html","<div><h2><span translate=\"fleetApp.message.detail.title\">Message</span> {{vm.message.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.message.messageTime\">Message Time</span></dt><dd><span>{{vm.message.messageTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.message.macroNumber\">Macro Number</span></dt><dd><span>{{vm.message.macroNumber}}</span></dd><dt><span translate=\"fleetApp.message.text\">Text</span></dt><dd><span>{{vm.message.text}}</span></dd><dt><span translate=\"fleetApp.message.macroJob\">Macro Job</span></dt><dd><span>{{vm.message.macroJob}}</span></dd><dt><span translate=\"fleetApp.message.latitude\">Latitude</span></dt><dd><span>{{vm.message.latitude}}</span></dd><dt><span translate=\"fleetApp.message.longitude\">Longitude</span></dt><dd><span>{{vm.message.longitude}}</span></dd><dt><span translate=\"fleetApp.message.landmark\">Landmark</span></dt><dd><span>{{vm.message.landmark}}</span></dd><dt><span translate=\"fleetApp.message.vehicleIgnition\">Vehicle Ignition</span></dt><dd><span>{{vm.message.vehicleIgnition}}</span></dd><dt><span translate=\"fleetApp.message.positionTime\">Position Time</span></dt><dd><span>{{vm.message.positionTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.message.device\">Device</span></dt><dd><a ui-sref=\"device-detail({id:vm.message.deviceId})\">{{vm.message.deviceName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/message/message-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMessageLabel\" translate=\"fleetApp.message.home.createOrEditLabel\">Create or edit a Message</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.message.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.message.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.messageTime\" for=\"field_messageTime\">Message Time</label><div class=\"input-group\"><input id=\"field_messageTime\" type=\"text\" class=\"form-control\" name=\"messageTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.message.messageTime\" is-open=\"vm.datePickerOpenStatus.messageTime\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'messageTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.messageTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.messageTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.messageTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.macroNumber\" for=\"field_macroNumber\">Macro Number</label><input type=\"number\" class=\"form-control\" name=\"macroNumber\" id=\"field_macroNumber\" ng-model=\"vm.message.macroNumber\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.text\" for=\"field_text\">Text</label><input type=\"text\" class=\"form-control\" name=\"text\" id=\"field_text\" ng-model=\"vm.message.text\" ng-maxlength=\"4000\"><div ng-show=\"editForm.text.$invalid\"><p class=\"help-block\" ng-show=\"editForm.text.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"4000\">This field cannot be longer than 4000 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.macroJob\" for=\"field_macroJob\">Macro Job</label><input type=\"checkbox\" name=\"macroJob\" id=\"field_macroJob\" ng-model=\"vm.message.macroJob\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.latitude\" for=\"field_latitude\">Latitude</label><input type=\"number\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.message.latitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.longitude\" for=\"field_longitude\">Longitude</label><input type=\"number\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.message.longitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.landmark\" for=\"field_landmark\">Landmark</label><input type=\"text\" class=\"form-control\" name=\"landmark\" id=\"field_landmark\" ng-model=\"vm.message.landmark\" ng-maxlength=\"255\"><div ng-show=\"editForm.landmark.$invalid\"><p class=\"help-block\" ng-show=\"editForm.landmark.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.vehicleIgnition\" for=\"field_vehicleIgnition\">Vehicle Ignition</label><input type=\"number\" class=\"form-control\" name=\"vehicleIgnition\" id=\"field_vehicleIgnition\" ng-model=\"vm.message.vehicleIgnition\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.message.positionTime\" for=\"field_positionTime\">Position Time</label><div class=\"input-group\"><input id=\"field_positionTime\" type=\"text\" class=\"form-control\" name=\"positionTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.message.positionTime\" is-open=\"vm.datePickerOpenStatus.positionTime\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'positionTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label translate=\"fleetApp.message.device\" for=\"field_device\">Device</label><select class=\"form-control\" id=\"field_device\" name=\"device\" ng-model=\"vm.message.deviceId\" ng-options=\"device.id as device.name for device in vm.devices\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.device.$invalid\"><p class=\"help-block\" ng-show=\"editForm.device.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/message/messages-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myMessageLabel\" translate=\"fleetApp.message.home.title\">Message</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"fleetApp.message.messageTime\">Message Time</span></th><th><span translate=\"fleetApp.message.macroNumber\">Macro Number</span></th><th><span translate=\"fleetApp.message.text\">Text</span></th><th><span translate=\"fleetApp.message.macroJob\">Macro Job</span></th><th><span translate=\"fleetApp.message.device\">Device</span></th></tr></thead><tbody><tr ng-repeat=\"message in vm.messages track by message.id\"><td>{{message.id}}</td><td>{{message.messageTime | date:\'short\'}}</td><td>{{message.macroNumber}}</td><td>{{message.text}}</td><td>{{message.macroJob}}</td><td>{{message.deviceName}}</td></tr></tbody></table></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></div>");
$templateCache.put("app/entities/message/messages.html","<div><h2 translate=\"fleetApp.message.home.title\">Messages</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><h4 translate=\"fleetApp.message.filter.title\">Filter by date</h4><div class=\"row\"><div class=\"col-xs-3\"><p class=\"input-group\"><span class=\"input-group-addon\" translate=\"fleetApp.message.filter.from\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.fromDate\" ng-change=\"vm.onDateChange()\" required></p></div><div class=\"col-xs-2\"><button class=\"btn btn-primary\" ng-click=\"vm.loadAll()\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.search\">Search</span></button></div><div class=\"col-xs-2\" has-authority=\"ROLE_ADMIN\"><button class=\"btn btn-primary\" ui-sref=\"message.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.message.home.createLabel\">Create new Message</span></button></div><div class=\"col-xs-2\" has-authority=\"ROLE_ADMIN\"><button class=\"btn btn-primary\" ng-click=\"vm.jobAllMessages()\"><span class=\"glyphicon glyphicon-refresh\"></span> <span translate=\"fleetApp.message.processAll\">Process all messages</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"messageTime\"><span translate=\"fleetApp.message.messageTime\">Message Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"macroNumber\"><span translate=\"fleetApp.message.macroNumber\">Macro Number</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"text\"><span translate=\"fleetApp.message.text\">Text</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"macroJob\"><span translate=\"fleetApp.message.macroJob\">Macro Job</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"latitude\"><span translate=\"fleetApp.message.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"longitude\"><span translate=\"fleetApp.message.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"landmark\"><span translate=\"fleetApp.message.landmark\">Landmark</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"vehicleIgnition\"><span translate=\"fleetApp.message.vehicleIgnition\">Vehicle Ignition</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    <th jh-sort-by=\"positionTime\"><span translate=\"fleetApp.message.positionTime\">Position Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th>\n                    --><th jh-sort-by=\"deviceName\"><span translate=\"fleetApp.message.device\">Device</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"device.deviceType\"><span translate=\"fleetApp.device.deviceType\">deviceType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"message in vm.messages track by message.id\"><td><a ui-sref=\"message-detail({id:message.id})\">{{message.id}}</a></td><td>{{message.messageTime | date:\'short\' }}</td><td>{{message.macroNumber}}</td><td>{{message.text}}</td><td>{{message.macroJob}}</td><!--<td>{{message.latitude}}</td>\n                    <td>{{message.longitude}}</td>\n                    <td>{{message.landmark}}</td>\n                    <td>{{message.vehicleIgnition}}</td>\n                    <td>{{message.positionTime | date:\'medium\'}}</td>\n                    --><td><a ui-sref=\"device-detail({id:message.deviceId})\">{{message.deviceName}}</a></td><td>{{message.deviceType}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"message-detail({id:message.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"message.edit({id:message.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"message.delete({id:message.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button> <button ng-click=\"vm.job(message.id)\" has-authority=\"ROLE_ADMIN\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-refresh\"></span> <span class=\"hidden-xs hidden-sm\">Job</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/officehours/officehour-dashboard-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOfficehoursLabel\" translate=\"fleetApp.officehours.home.title\">Officehours</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startTime\"><span translate=\"fleetApp.officehours.startTime\">Start Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endTime\"><span translate=\"fleetApp.officehours.endTime\">End Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><span translate=\"fleetApp.officehours.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.officehours.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"officehours in vm.officehours track by officehours.id\"><td>{{officehours.id}}</td><td>{{officehours.startTime | date:\'short\'}}</td><td>{{officehours.endTime | date:\'short\'}}</td><td>{{officehours.vehiclePlate}}</td><td>{{officehours.driverFirstName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\" ng-click=\"vm.edit(officehours.id)\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\" ng-click=\"vm.del(officehours.id)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\" class=\"btn btn-default\" ng-click=\"vm.add()\"><span class=\"glyphicon glyphicon-plus\"></span>&nbsp;<span translate=\"entity.action.add\">Add</span></button></div></form>");
$templateCache.put("app/entities/officehours/officehours-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.officehours.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.officehours.delete.question\" translate-values=\"{id: \'{{vm.officehours.id}}\'}\">Are you sure you want to delete this Officehours?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/officehours/officehours-detail.html","<div><h2><span translate=\"fleetApp.officehours.detail.title\">Officehours</span> {{vm.officehours.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.officehours.startTime\">Start Time</span></dt><dd><span>{{vm.officehours.startTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.officehours.endTime\">End Time</span></dt><dd><span>{{vm.officehours.endTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.officehours.creation\">Creation</span></dt><dd><span>{{vm.officehours.creation | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.officehours.creator\">Creator</span></dt><dd>{{vm.officehours.creatorFirstName}}</dd><dt><span translate=\"fleetApp.officehours.vehicle\">Vehicle</span></dt><dd><a ui-sref=\"vehicle-detail({id:vm.officehours.vehicleId})\">{{vm.officehours.vehiclePlate}}</a></dd><dt><span translate=\"fleetApp.officehours.driver\">Driver</span></dt><dd>{{vm.officehours.driverFirstName}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/officehours/officehours-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOfficehoursLabel\" translate=\"fleetApp.officehours.home.createOrEditLabel\">Create or edit a Officehours</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.officehours.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.officehours.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.officehours.startTime\" for=\"field_startTime\">Start Time</label><div class=\"input-group\"><input id=\"field_startTime\" type=\"text\" class=\"form-control\" name=\"startTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.officehours.startTime\" is-open=\"vm.datePickerOpenStatus.startTime\" timepicker-options=\"vm.timepickerOptions\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.officehours.endTime\" for=\"field_endTime\">End Time</label><div class=\"input-group\"><input id=\"field_endTime\" type=\"text\" class=\"form-control\" name=\"endTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.officehours.endTime\" is-open=\"vm.datePickerOpenStatus.endTime\" timepicker-options=\"vm.timepickerOptions\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"form-group\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.officehours.vehicleId\" model-label=\"vm.officehours.vehiclePlate\" disabled=\"disabled\" label=\"\'fleetApp.expense.vehicle\'\"><!--\n            <label translate=\"fleetApp.officehours.vehicle\" for=\"field_vehicle\">Vehicle</label>\n            <select class=\"form-control\" id=\"field_vehicle\" name=\"vehicle\"\n                    readonly ng-disabled=\"true\"\n                    ng-model=\"vm.officehours.vehicleId\" ng-options=\"vehicle.id as vehicle.plate for vehicle in vm.vehicles\"             required>\n                <option value=\"\"></option>\n            </select>\n            --></div><div ng-show=\"editForm.vehicle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.vehicle.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"fleetApp.officehours.driver\" for=\"field_driver\">Driver</label><user-typeahead id=\"field_driver\" model-id=\"vm.officehours.driverId\" model-label=\"vm.officehours.driverFirstName\" hide-title=\"true\"><!--\n            <label translate=\"fleetApp.officehours.driver\" for=\"field_driver\">Driver</label>\n            <select class=\"form-control\" id=\"field_driver\" name=\"driver\"\n                    readonly ng-disabled=\"true\"\n                    ng-model=\"vm.officehours.driverId\" ng-options=\"user.id as user.firstName for user in vm.users\"             required>\n                <option value=\"\"></option>\n            </select>\n            --></div><div ng-show=\"editForm.driver.$invalid\"><p class=\"help-block\" ng-show=\"editForm.driver.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/officehours/officehours.html","<div><h2 translate=\"fleetApp.officehours.home.title\">Officehours</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"officehours.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.officehours.home.createLabel\">Create new Officehours</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startTime\"><span translate=\"fleetApp.officehours.startTime\">Start Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endTime\"><span translate=\"fleetApp.officehours.endTime\">End Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creation\"><span translate=\"fleetApp.officehours.creation\">Creation</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creatorFirstName\"><span translate=\"fleetApp.officehours.creator\">Creator</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><span translate=\"fleetApp.officehours.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.officehours.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"officehours in vm.officehours track by officehours.id\"><td><a ui-sref=\"officehours-detail({id:officehours.id})\">{{officehours.id}}</a></td><td>{{officehours.startTime | date:\'medium\'}}</td><td>{{officehours.endTime | date:\'medium\'}}</td><td>{{officehours.creation | date:\'medium\'}}</td><td>{{officehours.creatorFirstName}}</td><td><a ui-sref=\"vehicle-detail({id:officehours.vehicleId})\">{{officehours.vehiclePlate}}</a></td><td>{{officehours.driverFirstName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"officehours-detail({id:officehours.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"officehours.edit({id:officehours.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"officehours.delete({id:officehours.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/order/order-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.order.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.order.delete.question\" translate-values=\"{id: \'{{vm.order.id}}\'}\">Are you sure you want to delete this Order?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/order/order-detail.html","<div><h2><span translate=\"fleetApp.order.detail.title\">Order</span> {{vm.order.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.order.externalId\">External Id</span></dt><dd><span>{{vm.order.externalId}}</span></dd><dt><span translate=\"fleetApp.order.personAddress\">Person Address</span></dt><dd><a ui-sref=\"person-address-detail({id:vm.order.personAddressId})\">{{vm.order.personAddressId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/order/order-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myOrderLabel\" translate=\"fleetApp.order.home.createOrEditLabel\">Create or edit a Order</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.order.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.order.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.order.externalId\" for=\"field_externalId\">External Id</label><input type=\"number\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.order.externalId\" required><div ng-show=\"editForm.externalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.externalId.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.externalId.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><!--\n            <label translate=\"fleetApp.order.personAddress\" for=\"field_personAddress\">Person Address</label>\n            <select class=\"form-control\" id=\"field_personAddress\" name=\"personAddress\" ng-model=\"vm.order.personAddressId\"\n                    ng-options=\"personAddress.id as personAddress.id for personAddress in vm.personaddresses\"            >\n                <option value=\"\"></option>\n            </select>\n            --></div><div class=\"form-group\"><person-typeahead id=\"field_personAddress\" model-id=\"vm.order.personId\" model-label=\"vm.personName\" label=\"\'global.field.customer\'\"></person-typeahead></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/order/orders.html","<div><h2 translate=\"fleetApp.order.home.title\">Orders</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><div>&nbsp;</div><button class=\"btn btn-primary\" ui-sref=\"order.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.order.home.createLabel\">Create new Order</span></button></div><div class=\"col-xs-4\"><person-typeahead model-id=\"vm.personId\" model-label=\"vm.personName\" label=\"\'global.field.customer\'\"></person-typeahead></div><div class=\"col-xs-2\"><div>&nbsp;</div><button class=\"btn btn-primary\" ng-click=\"vm.search()\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.search\">Search</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span translate=\"fleetApp.order.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personAddressId\"><span translate=\"fleetApp.order.personAddress\">Person Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"order in vm.orders track by order.id\"><td><a ui-sref=\"order-detail({id:order.id})\">{{order.id}}</a></td><td>{{order.externalId}}</td><td><a ui-sref=\"person-address-detail({id:order.personAddressId})\">{{order.personAddressId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"order-detail({id:order.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"order.edit({id:order.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"order.delete({id:order.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/person/people.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.person.home.title\">People</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><form ng-submit=\"vm.search()\"><div class=\"col-md-4 col-md-offset-2\"><input class=\"form-control\" placeholder=\"{{\'fleetApp.person.name\' | translate}}\" ng-model=\"vm.personName\" ng-disabled=\"vm.isLoading\"></div><div class=\"col-md-4\"><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"vm.isLoading\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.search\">Search</span></button> <button class=\"btn btn-default\" ui-sref=\"person.new\" ng-disabled=\"vm.isLoading\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.person.home.createLabel\">Create new Person</span></button></div></form></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personType\"><span translate=\"fleetApp.person.personType\">Person Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--                    <th jh-sort-by=\"federalId\"><span translate=\"fleetApp.person.federalId\">Federal Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"name\"><span translate=\"fleetApp.person.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"tradeName\"><span translate=\"fleetApp.person.tradeName\">Trade Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--                    <th jh-sort-by=\"phone\"><span translate=\"fleetApp.person.phone\">Phone</span> <span class=\"glyphicon glyphicon-sort\"></span></th>--><th></th></tr></thead><tbody><tr ng-repeat=\"person in vm.people track by person.id\"><td><a ui-sref=\"person-detail({id:person.id})\">{{person.id}}</a></td><td translate=\"{{\'fleetApp.PersonType.\' + person.personType}}\">{{person.personType}}</td><!--                    <td>{{person.federalId}}</td>--><td>{{person.name}}</td><td>{{person.tradeName}}</td><!--                    <td>{{person.phone}}</td>--><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"person-detail({id:person.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"person.edit({id:person.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"person.delete({id:person.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/person/person-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.person.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.person.delete.question\" translate-values=\"{id: \'{{vm.person.id}}\'}\">Are you sure you want to delete this Person?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/person/person-detail-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPersonLabel\"><span>Cliente</span></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-4\"><div class=\"thumbnail\" ng-if=\"vm.person.photoUrl\"><img ng-src=\"{{vm.person.photoUrl}}\" alt=\"{{vm.person.name}}\"></div></div><div class=\"col-md-8\"><div class=\"row\"><div class=\"col-md-6\"><address><strong>{{vm.person.tradeName}}</strong><br>{{vm.person.street}} {{vm.person.number}}<br>{{vm.person.city}} {{vm.person.district}}<br><div ng-if=\"vm.person.latitude\"><a href=\"http://maps.google.com/maps?z=12&t=m&q=loc:{{vm.person.latitude}}+{{vm.person.longitude}}\" target=\"_blank\">{{vm.person.latitude}},{{vm.person.longitude}}</a><br></div></address></div></div></div></div><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.person.personType\">Person Type</span></dt><dd><span translate=\"{{\'fleetApp.PersonType.\' + vm.person.personType}}\">{{vm.person.personType}}</span></dd><dt><span translate=\"fleetApp.person.federalId\">Federal Id</span></dt><dd><span>{{vm.person.federalId}}</span></dd><dt><span translate=\"fleetApp.person.name\">Name</span></dt><dd><span>{{vm.person.name}}</span></dd><dt><span translate=\"fleetApp.person.tradeName\">Trade Name</span></dt><dd><span>{{vm.person.tradeName}}</span></dd><dt><span translate=\"fleetApp.person.email\">Email</span></dt><dd><span>{{vm.person.email}}</span></dd><dt><span translate=\"fleetApp.person.alfaId\">Alfa Id</span></dt><dd><span>{{vm.person.alfaId}}</span></dd><dt><span translate=\"fleetApp.person.externalId\">External Id</span></dt><dd><span>{{vm.person.externalId}}</span></dd><dt><span translate=\"fleetApp.person.company\">Company</span></dt><dd>{{vm.person.companyName}}</dd></dl></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div></form>");
$templateCache.put("app/entities/person/person-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2><span translate=\"fleetApp.person.detail.title\">Person</span> {{vm.person.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.person.personType\">Person Type</span></dt><dd><span translate=\"{{\'fleetApp.PersonType.\' + vm.person.personType}}\">{{vm.person.personType}}</span></dd><dt><span translate=\"fleetApp.person.federalId\">Federal Id</span></dt><dd><span>{{vm.person.federalId}}</span></dd><dt><span translate=\"fleetApp.person.name\">Name</span></dt><dd><span>{{vm.person.name}}</span></dd><dt><span translate=\"fleetApp.person.tradeName\">Trade Name</span></dt><dd><span>{{vm.person.tradeName}}</span></dd><dt><span translate=\"fleetApp.person.email\">Email</span></dt><dd><span>{{vm.person.email}}</span></dd><dt><span translate=\"fleetApp.person.alfaId\">Alfa Id</span></dt><dd><span>{{vm.person.alfaId}}</span></dd><dt><span translate=\"fleetApp.person.externalId\">External Id</span></dt><dd><span>{{vm.person.externalId}}</span></dd><dt><span translate=\"fleetApp.person.photoUrl\">Photo Url</span></dt><dd><span>{{vm.person.photoUrl}}</span></dd><dt><span translate=\"fleetApp.person.phone\">Phone</span></dt><dd><span>{{vm.person.phone}}</span></dd><dt><span>Contato</span></dt><dd><span>{{vm.person.contact}}</span></dd><dt><span translate=\"fleetApp.person.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.person.companyId})\">{{vm.person.companyName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/person/person-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPersonLabel\" ng-show=\"vm.person.id\">{{ \'fleetApp.person.home.createOrEditLabel\' | translate}} {{vm.person.id}}</h4><h4 class=\"modal-title\" ng-show=\"!vm.person.id\" id=\"myPersonLabel2\" translate=\"fleetApp.person.home.createLabel\"></h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-sm-3\"><label class=\"control-label required\" translate=\"fleetApp.person.personType\" for=\"field_personType\">Person Type</label><select class=\"form-control\" name=\"personType\" ng-model=\"vm.person.personType\" id=\"field_personType\" required><option value=\"COMPANY\" translate=\"fleetApp.PersonType.COMPANY\">COMPANY</option><option value=\"INDIVIDUAL\" translate=\"fleetApp.PersonType.INDIVIDUAL\">INDIVIDUAL</option></select><div ng-show=\"editForm.personType.$invalid\" class=\"help-block\"><p class=\"help-block\" ng-show=\"editForm.personType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.person.federalId\" for=\"field_federalId\">Federal Id</label><input type=\"text\" class=\"form-control\" name=\"federalId\" id=\"field_federalId\" ng-model=\"vm.person.federalId\" ui-br-cpfcnpj-mask><div ng-show=\"editForm.federalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.federalId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"14\">This field cannot be longer than 14 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.person.alfaId\" for=\"field_alfaId\">Alfa Id</label><input type=\"text\" class=\"form-control\" name=\"alfaId\" id=\"field_alfaId\" ng-model=\"vm.person.alfaId\" ng-maxlength=\"20\"><div ng-show=\"editForm.alfaId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.alfaId.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">This field cannot be longer than 20 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.person.externalId\" for=\"field_externalId\">External Id</label><input type=\"number\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.person.externalId\"></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"fleetApp.person.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.person.name\" ng-maxlength=\"200\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"200\">This field cannot be longer than 200 characters.</p></div></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"fleetApp.person.tradeName\" for=\"field_tradeName\">Trade Name</label><input type=\"text\" class=\"form-control\" name=\"tradeName\" id=\"field_tradeName\" ng-model=\"vm.person.tradeName\" ng-maxlength=\"100\"><div ng-show=\"editForm.tradeName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.tradeName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"fleetApp.person.email\" for=\"field_email\">Email</label><input type=\"text\" class=\"form-control\" name=\"email\" id=\"field_email\" ng-model=\"vm.person.email\" ng-maxlength=\"100\"><div ng-show=\"editForm.email.$invalid\"><p class=\"help-block\" ng-show=\"editForm.email.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.person.phone\" for=\"field_phone\">Phone</label><input type=\"text\" class=\"form-control\" name=\"phone\" id=\"field_phone\" ng-model=\"vm.person.phone\" ng-maxlength=\"14\" maxlength=\"14\"><div ng-show=\"editForm.phone.$invalid\"><p class=\"help-block\" ng-show=\"editForm.phone.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"14\">This field cannot be longer than 14 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" for=\"field_contact\">Contato</label><input type=\"text\" class=\"form-control\" name=\"contact\" id=\"field_contact\" ng-model=\"vm.person.contact\" ng-maxlength=\"100\" maxlength=\"100\"><div ng-show=\"editForm.contact.$invalid\"><p class=\"help-block\" ng-show=\"editForm.contact.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.address.postcode\" for=\"field_postcode\">Postcode</label><input type=\"text\" class=\"form-control\" name=\"postcode\" id=\"field_postcode\" ng-model=\"vm.person.address.postcode\" ng-maxlength=\"8\" maxlength=\"8\"></div><div class=\"form-group col-sm-4\"><label class=\"control-label\" translate=\"fleetApp.address.street\" for=\"field_street\">Street</label><input type=\"text\" class=\"form-control\" name=\"street\" id=\"field_street\" ng-model=\"vm.person.address.street\" ng-maxlength=\"255\"><div ng-show=\"editForm.street.$invalid\"><p class=\"help-block\" ng-show=\"editForm.street.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div><div class=\"form-group col-sm-2\"><label class=\"control-label\" translate=\"fleetApp.address.number\" for=\"field_number\">Number</label><input type=\"text\" class=\"form-control\" name=\"number\" id=\"field_number\" ng-model=\"vm.person.address.number\" ng-maxlength=\"10\"><div ng-show=\"editForm.number.$invalid\"><p class=\"help-block\" ng-show=\"editForm.number.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"10\">This field cannot be longer than 10 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.address.district\" for=\"field_district\">District</label><input type=\"text\" class=\"form-control\" name=\"district\" id=\"field_district\" ng-model=\"vm.person.address.district\" ng-maxlength=\"100\"><div ng-show=\"editForm.district.$invalid\"><p class=\"help-block\" ng-show=\"editForm.district.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.address.city\" for=\"field_city\">City</label><input type=\"text\" class=\"form-control\" name=\"city\" id=\"field_city\" ng-model=\"vm.person.address.city\"></div><div class=\"form-group col-sm-2\"><label class=\"control-label\" translate=\"fleetApp.address.state\" for=\"field_uf\">UF</label><input type=\"text\" class=\"form-control\" name=\"state\" id=\"field_uf\" ng-maxlength=\"120\" ng-model=\"vm.person.address.state\"></div><div class=\"form-group col-sm-6\"><label class=\"control-label\" translate=\"fleetApp.address.details\" for=\"field_details\">Detalhes</label><input type=\"text\" class=\"form-control\" name=\"details\" id=\"field_details\" ng-maxlength=\"255\" ng-model=\"vm.person.address.details\"></div></div><div class=\"row\"><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.address.latitude\" for=\"field_latitude\">Latitude</label><input type=\"number\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.person.address.latitude\"></div><div class=\"form-group col-sm-3\"><label class=\"control-label\" translate=\"fleetApp.address.longitude\" for=\"field_longitude\">Longitude</label><input type=\"number\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.person.address.longitude\"></div><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.person.photoUrl\" for=\"field_photoUrl\">Photo Url</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"photoUrl\" id=\"field_photoUrl\" ng-model=\"vm.person.photoUrl\" ng-maxlength=\"255\"><div class=\"input-group-btn\"><button id=\"upload_widget\" class=\"btn btn-info\">Upload</button></div></div><div ng-show=\"editForm.photoUrl.$invalid\"><p class=\"help-block\" ng-show=\"editForm.photoUrl.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div></div><div class=\"row\"><!--\n            <div class=\"form-group col-sm-6\" ngf-drop ngf-change=\"vm.setPhoto($file, vm.person)\" ngf-pattern=\"\'image/*\'\">\n                <label class=\"control-label\" data-translate=\"fleetApp.person.photo\" for=\"field_photo\">Photo</label>\n                <div>\n                    <img data-ng-src=\"{{\'data:\' + vm.person.photoContentType + \';base64,\' + vm.person.photo}}\" style=\"max-height: 100px;\" ng-if=\"vm.person.photo\"/>\n                    <div ng-if=\"vm.person.photo\" class=\"help-block clearfix\">\n                        <span class=\"pull-left\">{{vm.person.photoContentType}}, {{vm.byteSize(vm.person.photo)}}</span>\n                        <button type=\"button\" ng-click=\"vm.person.photo=null;vm.person.photoContentType=null;\"\n                                class=\"btn btn-default btn-xs pull-right\">\n                            <span class=\"glyphicon glyphicon-remove\"></span>\n                        </button>\n                    </div>\n                    <button type=\"button\" ngf-select class=\"btn btn-default btn-block\"\n                            ngf-change=\"vm.setPhoto($file, vm.person)\" accept=\"image/*\" data-translate=\"entity.action.addimage\">\n                        Add image\n                    </button>\n                </div>\n                <input type=\"hidden\" class=\"form-control\" name=\"photo\" id=\"field_photo\"\n                       ng-model=\"vm.teste.photo\"\n                />\n                <input type=\"hidden\" class=\"form-control\" name=\"photoContentType\" id=\"field_photoContentType\"\n                       ng-model=\"vm.teste.photoContentType\" />\n            </div>\n            --></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 pull-right\"><ul><li ng-repeat=\"(key, errors) in editForm.$error track by $index\"><strong>{{ key }}</strong> errors<ul><li ng-repeat=\"e in errors\">{{ e.$name }} possui um erro: <strong>{{ key }}</strong>.</li></ul></li></ul></div><!--        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.saveAndUpdateTasks()\"--><!--            ng-disabled=\"!vm.person.id || editForm.$invalid\">--><!--            &nbsp;<span translate=\"fleetApp.person.updateTaskAddress\">Update Task Address</span>--><!--        </button>--> <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"button\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/person-address/person-address-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.personAddress.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.personAddress.delete.question\" translate-values=\"{id: \'{{vm.personAddress.id}}\'}\">Are you sure you want to delete this Person Address?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/person-address/person-address-detail.html","<div><h2><span translate=\"fleetApp.personAddress.detail.title\">Person Address</span> {{vm.personAddress.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.personAddress.created\">Created</span></dt><dd><span>{{vm.personAddress.created | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.personAddress.person\">Person</span></dt><dd><a ui-sref=\"person-detail({id:vm.personAddress.personId})\">{{vm.personAddress.personName}}</a></dd><dt><span translate=\"fleetApp.personAddress.address\">Address</span></dt><dd><a ui-sref=\"address-detail({id:vm.personAddress.addressId})\">{{vm.personAddress.addressId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/person-address/person-address-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPersonAddressLabel\" translate=\"fleetApp.personAddress.home.createOrEditLabel\">Create or edit a Person Address</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.personAddress.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.personAddress.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.personAddress.created\" for=\"field_created\">Created</label><div class=\"input-group\"><input id=\"field_created\" type=\"text\" class=\"form-control\" name=\"created\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.personAddress.created\" is-open=\"vm.datePickerOpenStatus.created\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'created\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.created.$invalid\"><p class=\"help-block\" ng-show=\"editForm.created.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.created.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.personAddress.person\" for=\"field_person\">Person</label><select class=\"form-control\" id=\"field_person\" name=\"person\" ng-model=\"vm.personAddress.personId\" ng-options=\"person.id as person.name for person in vm.people\"><option value=\"\"></option></select></div><div class=\"form-group\"><label translate=\"fleetApp.personAddress.address\" for=\"field_address\">Address</label><select class=\"form-control\" id=\"field_address\" name=\"address\" ng-model=\"vm.personAddress.addressId\" ng-options=\"address.id as address.id for address in vm.addresses\"><option value=\"\"></option></select></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/person-address/person-addresses.html","<div><h2 translate=\"fleetApp.personAddress.home.title\">Person Addresses</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"person-address.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.personAddress.home.createLabel\">Create new Person Address</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"created\"><span translate=\"fleetApp.personAddress.created\">Created</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personName\"><span translate=\"fleetApp.personAddress.person\">Person</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"addressId\"><span translate=\"fleetApp.personAddress.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"personAddress in vm.personAddresses track by personAddress.id\"><td><a ui-sref=\"person-address-detail({id:personAddress.id})\">{{personAddress.id}}</a></td><td>{{personAddress.created | date:\'medium\'}}</td><td><a ui-sref=\"person-detail({id:personAddress.personId})\">{{personAddress.personName}}</a></td><td><a ui-sref=\"address-detail({id:personAddress.addressId})\">{{personAddress.addressId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"person-address-detail({id:personAddress.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"person-address.edit({id:personAddress.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"person-address.delete({id:personAddress.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/person-distance/person-distance-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.personDistance.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.personDistance.delete.question\" translate-values=\"{id: \'{{vm.personDistance.id}}\'}\">Are you sure you want to delete this Person Distance?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/person-distance/person-distance-detail.html","<div><h2><span translate=\"fleetApp.personDistance.detail.title\">Person Distance</span> {{vm.personDistance.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.personDistance.distance\">Distance</span></dt><dd><span>{{vm.personDistance.distance}}</span></dd><dt><span translate=\"fleetApp.personDistance.from\">From</span></dt><dd><a ui-sref=\"person-detail({id:vm.personDistance.fromId})\">{{vm.personDistance.fromName}}</a></dd><dt><span translate=\"fleetApp.personDistance.to\">To</span></dt><dd><a ui-sref=\"person-detail({id:vm.personDistance.toId})\">{{vm.personDistance.toName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/person-distance/person-distance-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPersonDistanceLabel\" translate=\"fleetApp.personDistance.home.createOrEditLabel\">Create or edit a Person Distance</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.personDistance.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.personDistance.id\" readonly=\"readonly\"></div><div class=\"form-group\"><person-typeahead model-id=\"vm.personDistance.fromId\" model-label=\"vm.personDistance.fromName\" label=\"\'fleetApp.personDistance.from\'\"></person-typeahead></div><div ng-show=\"editForm.from.$invalid\"><p class=\"help-block\" ng-show=\"editForm.from.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><person-typeahead model-id=\"vm.personDistance.toId\" model-label=\"vm.personDistance.toName\" label=\"\'fleetApp.personDistance.to\'\"></person-typeahead></div><div ng-show=\"editForm.to.$invalid\"><p class=\"help-block\" ng-show=\"editForm.to.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.personDistance.distance\" for=\"field_distance\">Distance</label><input type=\"text\" class=\"form-control\" name=\"distance\" id=\"field_distance\" ui-number-mask=\"0\" ng-model=\"vm.personDistance.distance\" required><div ng-show=\"editForm.distance.$invalid\"><p class=\"help-block\" ng-show=\"editForm.distance.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.distance.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/person-distance/person-distances.html","<div><h2 translate=\"fleetApp.personDistance.home.title\">Person Distances</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"person-distance.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.personDistance.home.createLabel\">Create new Person Distance</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"fromName\"><span translate=\"fleetApp.personDistance.from\">From</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"toName\"><span translate=\"fleetApp.personDistance.to\">To</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"distance\"><span translate=\"fleetApp.personDistance.distance\">Distance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"personDistance in vm.personDistances track by personDistance.id\"><td><a ui-sref=\"person-distance-detail({id:personDistance.id})\">{{personDistance.id}}</a></td><td><a ui-sref=\"person-detail({id:personDistance.fromId})\">{{personDistance.fromName}}</a></td><td><a ui-sref=\"person-detail({id:personDistance.toId})\">{{personDistance.toName}}</a></td><td>{{personDistance.distance}} km</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"person-distance-detail({id:personDistance.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"person-distance.edit({id:personDistance.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"person-distance.delete({id:personDistance.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/position/position-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.position.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.position.delete.question\" translate-values=\"{id: \'{{vm.position.id}}\'}\">Are you sure you want to delete this Position?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/position/position-detail.html","<div><h2><span translate=\"fleetApp.position.detail.title\">Position</span> {{vm.position.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.position.serverTime\">Server Time</span></dt><dd><span>{{vm.position.serverTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.position.deviceTime\">Device Time</span></dt><dd><span>{{vm.position.deviceTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.position.latitude\">Latitude</span></dt><dd><span>{{vm.position.latitude}}</span></dd><dt><span translate=\"fleetApp.position.longitude\">Longitude</span></dt><dd><span>{{vm.position.longitude}}</span></dd><dt><span translate=\"fleetApp.position.altitude\">Altitude</span></dt><dd><span>{{vm.position.altitude}}</span></dd><dt><span translate=\"fleetApp.position.speed\">Speed</span></dt><dd><span>{{vm.position.speed}}</span></dd><dt><span translate=\"fleetApp.position.course\">Course</span></dt><dd><span>{{vm.position.course}}</span></dd><dt><span translate=\"fleetApp.position.address\">Address</span></dt><dd><span>{{vm.position.address}}</span></dd><dt><span translate=\"fleetApp.position.vehicleIgnition\">Vehicle Ignition</span></dt><dd><span>{{vm.position.vehicleIgnition}}</span></dd><dt><span translate=\"fleetApp.position.vehicle\">Vehicle</span></dt><dd><a ui-sref=\"vehicle-detail({id:vm.position.vehicleId})\">{{vm.position.vehiclePlate}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/position/position-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myPositionLabel\" translate=\"fleetApp.position.home.createOrEditLabel\">Create or edit a Position</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.position.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.position.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.serverTime\" for=\"field_serverTime\">Server Time</label><div class=\"input-group\"><input id=\"field_serverTime\" type=\"text\" class=\"form-control\" name=\"serverTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.position.serverTime\" is-open=\"vm.datePickerOpenStatus.serverTime\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'serverTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.serverTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.serverTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.serverTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.deviceTime\" for=\"field_deviceTime\">Device Time</label><div class=\"input-group\"><input id=\"field_deviceTime\" type=\"text\" class=\"form-control\" name=\"deviceTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.position.deviceTime\" is-open=\"vm.datePickerOpenStatus.deviceTime\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'deviceTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.deviceTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.deviceTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.deviceTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.latitude\" for=\"field_latitude\">Latitude</label><input type=\"number\" class=\"form-control\" name=\"latitude\" id=\"field_latitude\" ng-model=\"vm.position.latitude\" required><div ng-show=\"editForm.latitude.$invalid\"><p class=\"help-block\" ng-show=\"editForm.latitude.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.latitude.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.longitude\" for=\"field_longitude\">Longitude</label><input type=\"number\" class=\"form-control\" name=\"longitude\" id=\"field_longitude\" ng-model=\"vm.position.longitude\" required><div ng-show=\"editForm.longitude.$invalid\"><p class=\"help-block\" ng-show=\"editForm.longitude.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.longitude.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.altitude\" for=\"field_altitude\">Altitude</label><input type=\"number\" class=\"form-control\" name=\"altitude\" id=\"field_altitude\" ng-model=\"vm.position.altitude\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.speed\" for=\"field_speed\">Speed</label><input type=\"number\" class=\"form-control\" name=\"speed\" id=\"field_speed\" ng-model=\"vm.position.speed\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.course\" for=\"field_course\">Course</label><input type=\"number\" class=\"form-control\" name=\"course\" id=\"field_course\" ng-model=\"vm.position.course\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.address\" for=\"field_address\">Address</label><input type=\"text\" class=\"form-control\" name=\"address\" id=\"field_address\" ng-model=\"vm.position.address\" ng-maxlength=\"512\"><div ng-show=\"editForm.address.$invalid\"><p class=\"help-block\" ng-show=\"editForm.address.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"512\">This field cannot be longer than 512 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.position.vehicleIgnition\" for=\"field_vehicleIgnition\">Vehicle Ignition</label><input type=\"number\" class=\"form-control\" name=\"vehicleIgnition\" id=\"field_vehicleIgnition\" ng-model=\"vm.position.vehicleIgnition\" required><div ng-show=\"editForm.vehicleIgnition.$invalid\"><p class=\"help-block\" ng-show=\"editForm.vehicleIgnition.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.vehicleIgnition.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.position.vehicle\" for=\"field_vehicle\">Vehicle</label><select class=\"form-control\" id=\"field_vehicle\" name=\"vehicle\" ng-model=\"vm.position.vehicleId\" ng-options=\"vehicle.id as vehicle.plate for vehicle in vm.vehicles\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.vehicle.$invalid\"><p class=\"help-block\" ng-show=\"editForm.vehicle.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/position/positions.html","<div><h2 translate=\"fleetApp.position.home.title\">Positions</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"position.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.position.home.createLabel\">Create new Position</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"serverTime\"><span translate=\"fleetApp.position.serverTime\">Server Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deviceTime\"><span translate=\"fleetApp.position.deviceTime\">Device Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"latitude\"><span translate=\"fleetApp.position.latitude\">Latitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"longitude\"><span translate=\"fleetApp.position.longitude\">Longitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"altitude\"><span translate=\"fleetApp.position.altitude\">Altitude</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"speed\"><span translate=\"fleetApp.position.speed\">Speed</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"course\"><span translate=\"fleetApp.position.course\">Course</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"address\"><span translate=\"fleetApp.position.address\">Address</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehicleIgnition\"><span translate=\"fleetApp.position.vehicleIgnition\">Vehicle Ignition</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><span translate=\"fleetApp.position.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"position in vm.positions track by position.id\"><td><a ui-sref=\"position-detail({id:position.id})\">{{position.id}}</a></td><td>{{position.serverTime | date:\'medium\'}}</td><td>{{position.deviceTime | date:\'medium\'}}</td><td>{{position.latitude}}</td><td>{{position.longitude}}</td><td>{{position.altitude}}</td><td>{{position.speed}}</td><td>{{position.course}}</td><td>{{position.address}}</td><td>{{position.vehicleIgnition}}</td><td><a ui-sref=\"vehicle-detail({id:position.vehicleId})\">{{position.vehiclePlate}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"position-detail({id:position.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"position.edit({id:position.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"position.delete({id:position.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/product/product-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.product.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.product.delete.question\" translate-values=\"{id: \'{{vm.product.id}}\'}\">Are you sure you want to delete this Product?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/product/product-detail.html","<div><h2><span translate=\"fleetApp.product.detail.title\">Product</span> {{vm.product.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.product.name\">Name</span></dt><dd><span>{{vm.product.name}}</span></dd><dt><span translate=\"fleetApp.product.shortName\">Short Name</span></dt><dd><span>{{vm.product.shortName}}</span></dd><dt><span translate=\"fleetApp.product.unit\">Unit</span></dt><dd><span>{{vm.product.unit}}</span></dd><dt><span translate=\"fleetApp.product.externalId\">External Id</span></dt><dd><span>{{vm.product.externalId}}</span></dd><dt><span translate=\"fleetApp.product.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.product.companyId})\">{{vm.product.companyName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/product/product-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myProductLabel\" translate=\"fleetApp.product.home.createOrEditLabel\">Create or edit a Product</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.product.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.product.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.product.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.product.name\" required ng-maxlength=\"500\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"500\">This field cannot be longer than 500 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.product.shortName\" for=\"field_shortName\">Short Name</label><input type=\"text\" class=\"form-control\" name=\"shortName\" id=\"field_shortName\" ng-model=\"vm.product.shortName\" ng-maxlength=\"100\"><div ng-show=\"editForm.shortName.$invalid\"><p class=\"help-block\" ng-show=\"editForm.shortName.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.product.unit\" for=\"field_unit\">Unit</label><input type=\"text\" class=\"form-control\" name=\"unit\" id=\"field_unit\" ng-model=\"vm.product.unit\" ng-maxlength=\"20\"><div ng-show=\"editForm.unit.$invalid\"><p class=\"help-block\" ng-show=\"editForm.unit.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"20\">This field cannot be longer than 20 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.product.externalId\" for=\"field_externalId\">External Id</label><input type=\"number\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.product.externalId\" required><div ng-show=\"editForm.externalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.externalId.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.externalId.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/product/products.html","<div><h2 translate=\"fleetApp.product.home.title\">Products</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"product.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.product.home.createLabel\">Create new Product</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"fleetApp.product.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"shortName\"><span translate=\"fleetApp.product.shortName\">Short Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"unit\"><span translate=\"fleetApp.product.unit\">Unit</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span translate=\"fleetApp.product.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"product in vm.products track by product.id\"><td><a ui-sref=\"product-detail({id:product.id})\">{{product.id}}</a></td><td>{{product.name}}</td><td>{{product.shortName}}</td><td>{{product.unit}}</td><td>{{product.externalId}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"product-detail({id:product.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"product.edit({id:product.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"product.delete({id:product.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count><uib-pagination class=\"pagination-sm\" total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pagination></div></div>");
$templateCache.put("app/entities/refused-reason/refused-reason-delete-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.refusedReason.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.refusedReason.delete.question\" translate-values=\"{id: \'{{vm.refusedReason.id}}\'}\">Are you sure you want to delete this Refused Reason?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/refused-reason/refused-reason-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2><span translate=\"fleetApp.refusedReason.detail.title\">Refused Reason</span> {{vm.refusedReason.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.refusedReason.name\">Name</span></dt><dd><span>{{vm.refusedReason.name}}</span></dd><dt><span translate=\"fleetApp.refusedReason.externalId\">External Id</span></dt><dd><span>{{vm.refusedReason.externalId}}</span></dd><dt><span translate=\"fleetApp.refusedReason.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.refusedReason.companyId})\">{{vm.refusedReason.companyName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/refused-reason/refused-reason-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRefusedReasonLabel\" translate=\"fleetApp.refusedReason.home.createOrEditLabel\">Create or edit a Refused Reason</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.refusedReason.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.refusedReason.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.refusedReason.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.refusedReason.name\" required ng-maxlength=\"100\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"100\">This field cannot be longer than 100 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.refusedReason.externalId\" for=\"field_externalId\">External Id</label><input type=\"number\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.refusedReason.externalId\" required><div ng-show=\"editForm.externalId.$invalid\"><p class=\"help-block\" ng-show=\"editForm.externalId.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.externalId.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/refused-reason/refused-reasons.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.refusedReason.home.title\">Refused Reasons</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"refused-reason.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.refusedReason.home.createLabel\">Create new Refused Reason</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span translate=\"fleetApp.refusedReason.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span translate=\"fleetApp.refusedReason.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"companyName\"><span translate=\"fleetApp.refusedReason.company\">Company</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"refusedReason in vm.refusedReasons track by refusedReason.id\"><td><a ui-sref=\"refused-reason-detail({id:refusedReason.id})\">{{refusedReason.id}}</a></td><td>{{refusedReason.name}}</td><td>{{refusedReason.externalId}}</td><td><a ui-sref=\"company-detail({id:refusedReason.companyId})\">{{refusedReason.companyName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"refused-reason-detail({id:refusedReason.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"refused-reason.edit({id:refusedReason.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"refused-reason.delete({id:refusedReason.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/report/delivered-product.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.report.home.title.deliveredProduct\">Reports</h2><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-3 no-padding-left\"><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.initialDate\" for=\"field_date\">Date</label><div class=\"input-group\"><input id=\"field_date\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.report.startDate\" is-open=\"vm.datePickerOpenStatus.date\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'date\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.date.$invalid\"><p class=\"help-block\" ng-show=\"editForm.date.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-xs-3 no-padding-left\"><div class=\"form-group\"><label class=\"control-label\" translate=\"global.field.endDate\" for=\"field_enddate\">Date</label><div class=\"input-group\"><input id=\"field_enddate\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.report.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.date.$invalid\"><p class=\"help-block\" ng-show=\"editForm.endDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-xs-4 no-padding-left\"><div class=\"form-group\"><label class=\"control-label\">&nbsp</label><div class=\"input-group\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\"><span class=\"glyphicon glyphicon-refresh\"></span> <span>Atualizar</span></button></div></div></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th>Motorista</th><th>Placa</th><th>OS</th><th>Pedido</th><th>Cliente</th><th>Entrada</th><th>Saída</th><th>Duração</th><th>Qtd Notas</th><th>R$ Notas</th><th>Devoluções</th><th></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports\"><td>{{report.driverName}}</td><td>{{report.plate}}</td><td>{{report.itineraryNumber}}</td><td>{{report.oderNumber}}</td><td>{{report.personName}}</td><td>{{report.firstTimeIn}}</td><td>{{report.lastTimeOut}}</td><td>{{report.durationTime}}</td><td>{{report.invoiceQuantity}}</td><td>{{report.invoiceValue | currency:fractionSize:6}}</td><td>{{report.rejectedInvoices}}</td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/report/payment-report.html","<div><h2 translate=\"fleetApp.vehiclePayment.home.title\">Vehicle Payments</h2><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon\" translate=\"global.field.initialDate\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.startDate\" ng-change=\"vm.onDateChange()\" required> <span class=\"input-group-addon\" translate=\"global.field.endDate\">to</span> <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.endDate\" ng-change=\"vm.onDateChange()\" required></div><div class=\"btn-group\"><button class=\"btn btn-default\" ng-click=\"vm.fortnight(\'first\')\">1ª Quinzena</button> <button class=\"btn btn-default\" ng-click=\"vm.fortnight(\'second\')\">2ª Quinzena</button></div></div><div class=\"col-md-1\">&nbsp;</div><div class=\"col-md-2\"><div class=\"input-group\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.vehicleId\" model-label=\"vm.vehiclePlate\" hide-title=\"true\" label=\"\'fleetApp.expense.vehicle\'\"></vehicle-typeahead></div></div><div class=\"col-md-5\"><button class=\"btn btn-primary\" ng-click=\"vm.analyticReport()\"><span class=\"fa fa-file-excel-o\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.export\"></span></button></div></div></div></div>");
$templateCache.put("app/entities/report/reports.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.report.home.title.analytic\">Reports</h2><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><person-typeahead model-label=\"vm.person.name\" model-id=\"vm.person.id\" label=\"\'global.field.customer\'\"></person-typeahead></div><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"global.field.initialDate\" for=\"field_date\">Date</label><div class=\"input-group\"><input id=\"field_date\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.report.startDate\" is-open=\"vm.datePickerOpenStatus.date\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'date\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.date.$invalid\"><p class=\"help-block\" ng-show=\"editForm.date.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"global.field.endDate\" for=\"field_enddate\">Date</label><div class=\"input-group\"><input id=\"field_enddate\" type=\"text\" class=\"form-control\" name=\"date\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.report.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.date.$invalid\"><p class=\"help-block\" ng-show=\"editForm.endDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-4\"><product-typeahead product=\"vm.product\"></product-typeahead></div><div class=\"col-md-3\"><label>Cód SES</label><input class=\"form-control\" name=\"secondExternalId\" id=\"field_secondExternalId\" ng-model=\"vm.secondExternalId\"></div><div class=\"col-md-1\"><div class=\"form-group\"><label class=\"control-label\">&nbsp</label><div class=\"input-group\"><button class=\"btn btn-primary\" ng-click=\"vm.transition()\"><span class=\"glyphicon glyphicon-refresh\"></span> <span>Atualizar</span></button></div></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label class=\"control-label\">&nbsp</label><div class=\"input-group\"><button class=\"btn btn-default\" ng-click=\"vm.analyticReport()\"><span class=\"fa fa-file-excel-o\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.export\"></span></button></div></div></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th>Id</th><th>Planejado</th><th>Motorista</th><th>Placa</th><th>Pedido</th><th>Cliente</th><th>Entrada</th><th>Saída</th><th>Duração</th><th>Qtd Notas</th><th ng-if=\"vm.product\">R$ Produto</th><th>R$ Notas</th><th>Devoluções</th><th></th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports\"><td>{{report.taskId}}</td><td>{{report.plannedDate | date:\'shortDate\'}}</td><td>{{report.driverName}}</td><td>{{report.plate}}</td><td>{{report.oderNumber}}</td><td>{{report.personName}}</td><td>{{report.firstTimeIn | date:\'short\'}}</td><td>{{report.lastTimeOut | date:\'short\'}}</td><td>{{report.durationTime}}</td><td>{{report.invoiceQuantity}}</td><td ng-if=\"vm.product\">{{report.productValue | currency:fractionSize:6}}</td><td>{{report.invoiceValue | currency:fractionSize:6}}</td><td>{{report.rejectedInvoices}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"report.products-by-task({id: report.taskId})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\">Produtos</span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/report/time-report.html","<div><h2 translate=\"global.menu.entities.time\">Time</h2><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"input-group\"><span class=\"input-group-addon\" translate=\"global.field.initialDate\">from</span> <input type=\"date\" class=\"input-sm form-control\" name=\"start\" ng-model=\"vm.startDate\" ng-change=\"vm.onDateChange()\" required><!--\n                    <span class=\"input-group-addon\" translate=\"global.field.endDate\">to</span>\n                    <input type=\"date\" class=\"input-sm form-control\" name=\"end\" ng-model=\"vm.endDate\"\n                           ng-change=\"vm.onDateChange()\" required/>\n                     --></div><div class=\"btn-group\"><button class=\"btn btn-default\" ng-click=\"vm.fortnight(\'first\')\">1ª Quinzena</button> <button class=\"btn btn-default\" ng-click=\"vm.fortnight(\'second\')\">2ª Quinzena</button></div></div><div class=\"col-md-1\">&nbsp;</div><!--\n            <div class=\"col-md-2\">\n                <div class=\"input-group\">\n                    <vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.vehicleId\" model-label=\"vm.vehiclePlate\"\n                                       hide-title=\"true\" label=\"\'fleetApp.expense.vehicle\'\"></vehicle-typeahead>\n                </div>\n            </div>\n            --><div class=\"col-md-5\"><button class=\"btn btn-default\" ng-click=\"vm.analyticReport()\"><span class=\"fa fa-file-excel-o\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.export\"></span></button></div></div></div></div>");
$templateCache.put("app/entities/route-review/route-review-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.routeReview.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.routeReview.delete.question\" translate-values=\"{id: \'{{vm.routeReview.id}}\'}\">Are you sure you want to delete this Route Review?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/route-review/route-review-detail.html","<div><h2><span translate=\"fleetApp.routeReview.detail.title\">Route Review</span> {{vm.routeReview.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.routeReview.reason\">Reason</span></dt><dd><span>{{vm.routeReview.reason}}</span></dd><dt><span translate=\"fleetApp.routeReview.creationDate\">Creation Date</span></dt><dd><span>{{vm.routeReview.creationDate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.routeReview.visit\">Visit</span></dt><dd><a ui-sref=\"visit-detail({id:vm.routeReview.visitId})\">{{vm.routeReview.visitId}}</a></dd><dt><span translate=\"fleetApp.routeReview.creator\">Creator</span></dt><dd>{{vm.routeReview.creatorLogin}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/route-review/route-review-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myRouteReviewLabel\" translate=\"fleetApp.routeReview.home.createOrEditLabel\">Create or edit a Route Review</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.routeReview.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.routeReview.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.routeReview.reason\" for=\"field_reason\">Reason</label><input type=\"text\" class=\"form-control\" name=\"reason\" id=\"field_reason\" ng-model=\"vm.routeReview.reason\" required ng-maxlength=\"500\"><div ng-show=\"editForm.reason.$invalid\"><p class=\"help-block\" ng-show=\"editForm.reason.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.reason.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"500\">This field cannot be longer than 500 characters.</p></div></div><!--\n        <div class=\"form-group\">\n            <label class=\"control-label\" translate=\"fleetApp.routeReview.creationDate\" for=\"field_creationDate\">Creation Date</label>\n                <div class=\"input-group\">\n                    <input id=\"field_creationDate\" type=\"text\" class=\"form-control\" name=\"creationDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.routeReview.creationDate\" is-open=\"vm.datePickerOpenStatus.creationDate\"\n                    required  />\n                    <span class=\"input-group-btn\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'creationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button>\n                    </span>\n                </div>\n            <div ng-show=\"editForm.creationDate.$invalid\">\n                <p class=\"help-block\"\n                    ng-show=\"editForm.creationDate.$error.required\" translate=\"entity.validation.required\">\n                    This field is required.\n                </p>\n                <p class=\"help-block\"\n                    ng-show=\"editForm.creationDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">\n                    This field should be a date and time.\n                </p>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"fleetApp.routeReview.visit\" for=\"field_visit\">Visit</label>\n            <select class=\"form-control\" id=\"field_visit\" name=\"visit\" ng-model=\"vm.routeReview.visitId\" ng-options=\"visit.id as visit.id for visit in vm.visits\"            >\n                <option value=\"\"></option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label translate=\"fleetApp.routeReview.creator\" for=\"field_creator\">Creator</label>\n            <select class=\"form-control\" id=\"field_creator\" name=\"creator\" ng-model=\"vm.routeReview.creatorId\" ng-options=\"user.id as user.login for user in vm.users\"             required>\n                <option value=\"\"></option>\n            </select>\n        </div>\n        --><div ng-show=\"editForm.creator.$invalid\"><p class=\"help-block\" ng-show=\"editForm.creator.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/route-review/route-reviews.html","<div><h2 translate=\"fleetApp.routeReview.home.title\">Route Reviews</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 padding-left\"><a ng-click=\"vm.openCalendar(\'routeReviewDate\')\" datetime-picker enable-time=\"false\" when-closed=\"vm.transition()\" ng-model=\"vm.pickerDate\" is-open=\"vm.datePickerOpenStatus.routeReviewDate\">{{ vm.routeReviewDate | date:\'dd/MM/yyyy\'}} <i class=\"fa fa-calendar\"></i> </a><!--\n                <button class=\"btn btn-primary\" ui-sref=\"route-review.new\" >\n                    <span class=\"glyphicon glyphicon-plus\"></span>\n                    <span  translate=\"fleetApp.routeReview.home.createLabel\">\n                        Create new Route Review\n                    </span>\n                </button>\n                --> <button class=\"btn btn-primary btn-sm\" ng-click=\"vm.reindex()\" has-authority=\"ROLE_ADMIN\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.routeReview.reindex\">Process old stuff</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span translate=\"fleetApp.vehicle.plate\">Plate</span> <span></span></th><th jh-sort-by=\"visitId\"><span translate=\"fleetApp.routeReview.origin\">Origin</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"visitId\"><span translate=\"fleetApp.routeReview.destiny\">Destiny</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reason\"><span translate=\"fleetApp.routeReview.expectedDistance\">expectedDistance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reason\"><span translate=\"fleetApp.routeReview.travelledDistance\">travelledDistance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reason\"><span translate=\"fleetApp.routeReview.difference\">difference</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"reason\"><span translate=\"fleetApp.routeReview.reason\">Reason</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"routeReview in vm.routeReviews track by routeReview.visitId\"><!--<td><a ui-sref=\"route-review-detail({id:routeReview.id})\">{{routeReview.id}}</a></td>--><!--<td>{{routeReview.creationDate | date:\'medium\'}}</td>--><!--<td>{{routeReview.creatorLogin}}</td>--><td>{{routeReview.plate}}</td><td>{{routeReview.fromPersonName}}</td><td>{{routeReview.destinyName}}</td><td>{{routeReview.expectedDistance}}</td><td>{{routeReview.travelledDistance}}</td><td>{{routeReview.difference}}</td><td>{{routeReview.reason}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" class=\"btn btn-primary btn-sm\" ng-if=\"!routeReview.id\" ui-sref=\"route-review.new({visitId:routeReview.visitId})\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.routeReview.home.createLabel\">Create new Route Review</span></button> <button type=\"submit\" ng-if=\"routeReview.id\" ui-sref=\"route-review-detail({id:routeReview.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ng-if=\"routeReview.id\" ui-sref=\"route-review.edit({id:routeReview.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ng-if=\"routeReview.id\" ui-sref=\"route-review.delete({id:routeReview.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/task/itinerary-task-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaskLabel\" translate=\"fleetApp.task.home.title\">Tasks</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"fleetApp.invoice.number\">Number</span></th><th><span>Nr Pedido</span></th><th><span translate=\"fleetApp.task.taskType\">Task Type</span></th><th><span translate=\"fleetApp.task.taskStatus\">Task Status</span></th><th><span>Destinatário</span></th><th></th></tr></thead><tbody ng-repeat=\"task in vm.tasks\"><tr><td>{{task.id}}</td><td>{{vm.arrayToString(task.servicesNumber)}}</td><td>{{vm.arrayToString(task.ordersNumber)}}</td><td translate=\"{{\'fleetApp.TaskType.\' + task.taskType}}\">{{task.taskType}}</td><td translate=\"{{\'fleetApp.TaskStatus.\' + task.taskStatus}}\">{{task.taskStatus}}</td><td><strong>{{task.personName}}</strong></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.openDialog(task)\" ng-if=\"task.isCollapsed\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\">Exibir Detalhes</span></button></div><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.openDialog(task)\" ng-if=\"!task.isCollapsed\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-close\"></span> <span class=\"hidden-xs hidden-sm\">Ocultar Detalhes</span></button></div></td></tr><tr uib-collapse=\"task.isCollapsed\" ng-if=\"!task.isCollapsed\"><td class=\"box box-default\" colspan=\"7\"><h2 class=\"page-header\"><i class=\"fa fa-globe\"></i> {{task.personName}} <small class=\"pull-right\"><a target=\"_blank\" href=\"http://maps.google.com/?q={{task.addressDTO.latitude}},{{task.addressDTO.longitude}}\"><span translate=\"fleetApp.address.street\">Rua</span> {{task.addressDTO.street}}, {{task.addressDTO.number}} {{task.addressDTO.district}}, {{task.addressDTO.city}} {{task.addressDTO.phone}} {{task.addressDTO.contact}} {{task.addressDTO.email}}</a></small></h2><uib-tabset active=\"active\"><uib-tab index=\"0\" heading=\"Produtos\"><div class=\"slide-animate\" ng-include=\"\'app/entities/task/template-invoice.html\'\"></div></uib-tab><uib-tab index=\"1\" heading=\"Visitas\" ng-click=\"vm.showVisits(task)\"><div class=\"slide-animate\" ng-include=\"\'app/entities/task/template-visit.html\'\"></div></uib-tab></uib-tabset><div class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button ng-click=\"vm.openDialog(task.id)\" ng-if=\"!vm.isCollapsed\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-close\"></span> <span class=\"hidden-xs hidden-sm\">Ocultar</span></button></div></div></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></form>");
$templateCache.put("app/entities/task/task-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.task.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.task.delete.question\" translate-values=\"{id: \'{{vm.task.id}}\'}\">Are you sure you want to delete this Task?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/task/task-detail.html","<div><h2><span translate=\"fleetApp.task.detail.title\">Task</span> {{vm.task.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.task.taskType\">Task Type</span></dt><dd><span translate=\"{{\'fleetApp.TaskType.\' + vm.task.taskType}}\">{{vm.task.taskType}}</span></dd><dt><span translate=\"fleetApp.task.taskStatus\">Task Status</span></dt><dd><span translate=\"{{\'fleetApp.TaskStatus.\' + vm.task.taskStatus}}\">{{vm.task.taskStatus}}</span></dd><dt><span translate=\"fleetApp.task.itinerary\">Itinerary</span></dt><dd><a ui-sref=\"itinerary-detail({id:vm.task.itineraryId})\">{{vm.task.itineraryId}}</a></dd><dt><span translate=\"fleetApp.task.personAddress\">Person Address</span></dt><dd><a ui-sref=\"person-address-detail({id:vm.task.personAddressId})\">{{vm.task.personAddressId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/task/task-dialog-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><div class=\"modal-header\"><div class=\"pull-right\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button></div><!--\n        <div class=\"pull-right\">\n            <button type=\"button\" class=\"btn btn-box-tool\" ng-click=\"toogleMedia = !toogleMedia\">\n                <i class=\"fa fa-fw fa-camera fa-2x\"></i>\n            </button>\n        </div>\n        class=\"modal-title\"\n        --><label id=\"myTaskLabel\">Shipment > {{vm.task.personExternalId}}-{{vm.task.personName}} <small>(ID: {{vm.task.id}})</small></label></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><uib-tabset active=\"active\"><uib-tab index=\"0\"><uib-tab-heading>{{\'fleetApp.task.detail\' | translate}}</uib-tab-heading><div class=\"row\"><div class=\"col-md-12\"><div class=\"col-md-4\"><div class=\"thumbnail\" ng-if=\"vm.task.photoUrl\"><img ng-src=\"{{vm.task.photoUrl}}\" alt=\"{{vm.task.personName}}\"></div></div><div class=\"col-md-8\"><div class=\"row\"><div class=\"col-md-8\"><address><strong>{{vm.task.personExternalId}} - {{vm.task.personName}}</strong><br>{{vm.task.addressDTO.street}}, {{vm.task.addressDTO.number}}<br>{{vm.task.addressDTO.district}} {{vm.task.addressDTO.city}} {{vm.task.addressDTO.state}}<br><span ng-if=\"vm.task.addressDTO.details\">{{vm.task.addressDTO.details}}<br></span>Telefone: {{vm.task.phone}}<br>Contato: {{vm.task.contact}}<br><a ng-if=\"vm.task.addressDTO.latitude\" href=\"http://maps.google.com/maps?z=12&t=m&q=loc:{{vm.task.addressDTO.latitude}}+{{vm.task.addressDTO.longitude}}\" target=\"_blank\"><i class=\"fa fa-fw fa-map\"></i> </a><br></address></div><div class=\"col-sm-4 invoice-col\"><b>Pedido:</b> {{vm.arrayToString(vm.task.ordersNumber)}}<br><b>Remessa:</b> {{vm.arrayToString(vm.task.servicesNumber)}}<br><b>Tarefa:</b> {{vm.task.id}}<br><b>Veículo:</b>&nbsp;{{vm.task.vehiclePlate}}<br><b>Responsável:</b>&nbsp;{{vm.task.driverFirstName}}</div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><label translate=\"fleetApp.task.taskStatus\">Status da Entrega:</label>:</div></div><div class=\"row\"><div class=\"col-sm-12\" ng-switch=\"vm.task.taskStatus\"><div class=\"alert alert-success\" ng-switch-when=\"COMPLETED\"><h4><i class=\"icon fa fa-check\"></i><label translate=\"fleetApp.TaskStatus.COMPLETED\">COMPLETED</label></h4></div><div class=\"alert alert-danger\" ng-switch-when=\"REJECTED\"><h4><i class=\"icon fa fa-ban\"></i><label translate=\"fleetApp.TaskStatus.REJECTED\">REJECTED</label></h4></div><div class=\"alert alert-warning\" ng-switch-when=\"PARTIALLY_DONE\"><h4><i class=\"icon fa fa-ban\"></i><label translate=\"fleetApp.TaskStatus.PARTIALLY_DONE\">PARTIALLY_DONE</label></h4></div><div class=\"alert alert-info\" ng-switch-default><h4><i class=\"icon fa fa-info\"></i><label translate=\"fleetApp.TaskStatus.{{vm.task.taskStatus}}\">STATUS</label></h4></div></div></div></div></uib-tab><uib-tab index=\"3\"><uib-tab-heading>{{\'fleetApp.task.orderDetail\' | translate}}</uib-tab-heading><div class=\"col-sm-12\">&nbsp;</div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"btn-group\"><label class=\"btn btn-default\" ng-model=\"vm.radioModel\" uib-btn-radio=\"\'product\'\" uncheckable>Listar produtos</label><label class=\"btn btn-default\" ng-model=\"vm.radioModel\" uib-btn-radio=\"\'ordernumber\'\" uncheckable>Agrupar por pedido</label><label class=\"btn btn-default\" ng-model=\"vm.radioModel\" uib-btn-radio=\"\'invoice\'\" uncheckable>Agrupar por remessa</label></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><span ng-if=\"vm.radioModel == \'product\'\"><invoice-item itens=\"vm.task.itens\"></invoice-item></span><span ng-if=\"vm.radioModel == \'ordernumber\'\"><uib-tabset active=\"active\" class=\"nav-tabs-custom\"><uib-tab heading=\"{{key}}\" ng-repeat=\"(key, value) in vm.task.itens | groupBy: \'orderNumber\'\"><invoice-item itens=\"value\"></invoice-item></uib-tab></uib-tabset></span><span ng-if=\"vm.radioModel == \'invoice\'\"><uib-tabset active=\"active\" class=\"nav-tabs-custom\"><uib-tab heading=\"{{key}}\" ng-repeat=\"(key, value) in vm.task.itens | groupBy: \'invoiceNumber\'\"><invoice-item itens=\"value\"></invoice-item></uib-tab></uib-tabset></span></div></div></uib-tab><uib-tab index=\"1\" disable=\"{{vm.task.fleetMedias.length == 0}}\" uib-tooltip=\"{{vm.task.fleetMedias.length == 0 ? \'No documents\' : \'\'}}\"><uib-tab-heading><i class=\"fa fa-fw fa-camera\"></i> {{\'fleetApp.task.document\' | translate}}</uib-tab-heading><div class=\"col-md-12\" ng-if=\"vm.task.fleetMedias.length == 0\"><label>No documents :(</label></div><div style=\"height: 320px\"><div uib-carousel active=\"active\" no-wrap=\"noWrapSlides\"><div uib-slide ng-repeat=\"item in vm.task.fleetMedias track by item.id\" index=\"$index\"><img ng-src=\"{{item.urlFixed}}\" style=\"margin:auto\"><div class=\"carousel-caption\"><p>{{item.id}}</p></div><a ng-href=\"{{item.urlOriginal}}\" target=\"_blank\"><span>View in real size</span></a></div></div></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading>{{\'fleetApp.task.progress\' | translate}}</uib-tab-heading><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span data-translate=\"global.field.id\">ID</span></th><th><span data-translate=\"fleetApp.taskEvent.eventDateTime\">Event Date Time</span></th><th><span data-translate=\"fleetApp.taskEvent.eventType\">Event Type</span></th><th><span data-translate=\"fleetApp.taskEvent.user\">User</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"taskEvent in vm.task.taskEvents track by taskEvent.id\"><td>{{taskEvent.id}}</td><td>{{taskEvent.eventDateTime | date:\'medium\'}}</td><td data-translate=\"{{\'fleetApp.TaskEventType.\' + taskEvent.eventType}}\">{{taskEvent.eventType}}</td><td>{{taskEvent.userName}}</td></tr></tbody></table></div></uib-tab></uib-tabset><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button></div></div></div>");
$templateCache.put("app/entities/task/task-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaskLabel\" translate=\"fleetApp.task.home.createOrEditLabel\">Create or edit a Task</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.task.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.task.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.task.taskType\" for=\"field_taskType\">Task Type</label><select class=\"form-control\" name=\"taskType\" ng-model=\"vm.task.taskType\" id=\"field_taskType\" required><option value=\"GENERIC\" translate=\"fleetApp.TaskType.GENERIC\">GENERIC</option><option value=\"DELIVER\" translate=\"fleetApp.TaskType.DELIVER\">DELIVER</option><option value=\"PICKUP\" translate=\"fleetApp.TaskType.PICKUP\">PICKUP</option></select><div ng-show=\"editForm.taskType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taskType.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.task.taskStatus\" for=\"field_taskStatus\">Task Status</label><select class=\"form-control\" name=\"taskStatus\" ng-model=\"vm.task.taskStatus\" id=\"field_taskStatus\" required><option value=\"IN_PROGRESS\" translate=\"fleetApp.TaskStatus.IN_PROGRESS\">IN_PROGRESS</option><option value=\"COMPLETED\" translate=\"fleetApp.TaskStatus.COMPLETED\">COMPLETED</option><option value=\"NOT_STARTED\" translate=\"fleetApp.TaskStatus.NOT_STARTED\">NOT_STARTED</option><option value=\"PARTIALLY_DONE\" translate=\"fleetApp.TaskStatus.PARTIALLY_DONE\">PARTIALLY_DONE</option><option value=\"REJECTED\" translate=\"fleetApp.TaskStatus.REJECTED\">REJECTED</option></select><div ng-show=\"editForm.taskStatus.$invalid\"><p class=\"help-block\" ng-show=\"editForm.taskStatus.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.task.itinerary\" for=\"field_itinerary\">Itinerary</label><select class=\"form-control\" id=\"field_itinerary\" name=\"itinerary\" ng-model=\"vm.task.itineraryId\" ng-options=\"itinerary.id as itinerary.id for itinerary in vm.itineraries\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.itinerary.$invalid\"><p class=\"help-block\" ng-show=\"editForm.itinerary.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"fleetApp.task.personAddress\" for=\"field_personAddress\">Person Address</label><select class=\"form-control\" id=\"field_personAddress\" name=\"personAddress\" ng-model=\"vm.task.personAddressId\" ng-options=\"personAddress.id as personAddress.id for personAddress in vm.personaddresses\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.personAddress.$invalid\"><p class=\"help-block\" ng-show=\"editForm.personAddress.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/task/tasks.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 translate=\"fleetApp.task.home.title\">Tasks</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\" has-authority=\"ROLE_ADMIN\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"task.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.task.home.createLabel\">Create new Task</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><b><span translate=\"fleetApp.itinerary.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></b></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.itinerary.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"order\"><span translate=\"fleetApp.task.order\">Order Nr</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"service\"><span translate=\"fleetApp.task.service\">Service</span><span class=\"glyphicon glyphicon-sort\"></span></th><th>Entrada</th><th>Saída</th><th jh-sort-by=\"taskType\"><span translate=\"fleetApp.task.taskType\">Task Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taskStatus\"><span translate=\"fleetApp.task.taskStatus\">Task Status</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"itineraryId\"><span translate=\"fleetApp.task.itinerary\">Itinerary</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"personAddressId\"><span translate=\"fleetApp.task.client\">Cliente</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"task in vm.tasks track by task.id\"><td><a ui-sref=\"task-detail({id:task.id})\">{{task.id}}</a></td><td>{{task.vehiclePlate}}</td><td>{{task.driverFirstName}}</td><td>{{task.ordersNumber}}</td><td>{{task.servicesNumber}}</td><td>{{task.firstTimeIn | date:\'short\'}}</td><td>{{task.lastTimeOut | date:\'short\'}}</td><td translate=\"{{\'fleetApp.TaskType.\' + task.taskType}}\">{{task.taskType}}</td><td translate=\"{{\'fleetApp.TaskStatus.\' + task.taskStatus}}\">{{task.taskStatus}}</td><td><a ui-sref=\"itinerary-detail({id:task.itineraryId})\">{{task.itineraryId}}</a></td><td>{{task.personName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"task-detail({id:task.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"task.edit({id:task.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" has-authority=\"ROLE_ADMIN\" ui-sref=\"task.delete({id:task.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/task/template-invoice.html","<!DOCTYPE html><!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><div class=\"row\"><div class=\"col-xs-12 table-responsive\"><table class=\"table table-striped\"><thead><tr><th>ID</th><th>ID Externo</th><th>Produto</th><th>Unidade</th><th>Quantidade</th><th>Total</th></tr></thead><tbody ng-repeat=\"item in task.itens\"><tr><td>{{item.productExternalId}}</td><td>{{item.productSecondExternalId}}</td><td>{{item.productName}}</td><td>{{item.unityType}}</td><td>{{item.quantity}}</td><td>{{item.total | currency:fractionSize:6}}</td></tr></tbody></table></div><!-- /.col --></div></div>");
$templateCache.put("app/entities/task/template-visit.html","<!DOCTYPE html><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"fleetApp.visit.arrivalTime\">Arrival Time</span></th><th><span translate=\"fleetApp.visit.departure\">Departure</span></th><th><span translate=\"fleetApp.visit.spentTime\">Spent Time</span></th><th><span translate=\"fleetApp.visit.targetDistance\">Target Distance</span></th><th has-authority=\"ROLE_ADMIN\"><span translate=\"fleetApp.visit.creationDate\">Creation Date</span></th><th><span translate=\"fleetApp.visit.odometer\">Odometer</span></th><th><span translate=\"fleetApp.visit.bypass\">Bypass</span></th><th has-authority=\"ROLE_ADMIN\"><span translate=\"fleetApp.visit.position\">Position</span></th></tr></thead><tbody><tr ng-repeat=\"visit in task.visits track by visit.id\"><td>{{visit.id}}</td><td>{{visit.arrivalTime | date:\'short\'}}</td><td>{{visit.departure | date:\'short\'}}</td><td>{{visit.spentTime}}</td><td>{{visit.targetDistance}}</td><td has-authority=\"ROLE_ADMIN\">{{visit.creationDate | date:\'short\'}}</td><td>{{visit.odometer}}</td><td>{{visit.bypass}}</td><td has-authority=\"ROLE_ADMIN\"><a ui-sref=\"position-detail({id:visit.positionId})\">{{visit.positionId}}</a></td></tr></tbody></table></div>");
$templateCache.put("app/entities/task-event/task-event-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.taskEvent.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"fleetApp.taskEvent.delete.question\" translate-values=\"{id: \'{{vm.taskEvent.id}}\'}\">Are you sure you want to delete this Task Event?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/task-event/task-event-detail.html","<div><h2><span data-translate=\"fleetApp.taskEvent.detail.title\">Task Event</span> {{vm.taskEvent.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"fleetApp.taskEvent.eventDateTime\">Event Date Time</span></dt><dd><span>{{vm.taskEvent.eventDateTime | date:\'medium\'}}</span></dd><dt><span data-translate=\"fleetApp.taskEvent.eventType\">Event Type</span></dt><dd><span data-translate=\"{{\'fleetApp.TaskEventType.\' + vm.taskEvent.eventType}}\">{{vm.taskEvent.eventType}}</span></dd><dt><span data-translate=\"fleetApp.taskEvent.user\">User</span></dt><dd>{{vm.taskEvent.userLogin}}</dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"task-event-detail.edit({id:vm.taskEvent.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/task-event/task-event-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myTaskEventLabel\" data-translate=\"fleetApp.taskEvent.home.createOrEditLabel\">Create or edit a Task Event</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.taskEvent.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.taskEvent.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.taskEvent.eventDateTime\" for=\"field_eventDateTime\">Event Date Time</label><div class=\"input-group\"><input id=\"field_eventDateTime\" type=\"text\" class=\"form-control\" name=\"eventDateTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.taskEvent.eventDateTime\" is-open=\"vm.datePickerOpenStatus.eventDateTime\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'eventDateTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.eventDateTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.eventDateTime.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.eventDateTime.$error.ZonedDateTimelocal\" data-translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.taskEvent.eventType\" for=\"field_eventType\">Event Type</label><select class=\"form-control\" name=\"eventType\" ng-model=\"vm.taskEvent.eventType\" id=\"field_eventType\" required><option value=\"Arrival\" data-translate=\"fleetApp.TaskEventType.Arrival\">Arrival</option></select><div ng-show=\"editForm.eventType.$invalid\"><p class=\"help-block\" ng-show=\"editForm.eventType.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label data-translate=\"fleetApp.taskEvent.user\" for=\"field_user\">User</label><select class=\"form-control\" id=\"field_user\" name=\"user\" ng-model=\"vm.taskEvent.userId\" ng-options=\"user.id as user.login for user in vm.users\" required></select></div><div ng-show=\"editForm.user.$invalid\"><p class=\"help-block\" ng-show=\"editForm.user.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/task-event/task-events.html","<div><h2 data-translate=\"fleetApp.taskEvent.home.title\">Task Events</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"task-event.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"fleetApp.taskEvent.home.createLabel\">Create new Task Event</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventDateTime\"><span data-translate=\"fleetApp.taskEvent.eventDateTime\">Event Date Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"eventType\"><span data-translate=\"fleetApp.taskEvent.eventType\">Event Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"userLogin\"><span data-translate=\"fleetApp.taskEvent.user\">User</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"taskEvent in vm.taskEvents track by taskEvent.id\"><td><a ui-sref=\"task-event-detail({id:taskEvent.id})\">{{taskEvent.id}}</a></td><td>{{taskEvent.eventDateTime | date:\'medium\'}}</td><td data-translate=\"{{\'fleetApp.TaskEventType.\' + taskEvent.eventType}}\">{{taskEvent.eventType}}</td><td>{{taskEvent.userLogin}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"task-event-detail({id:taskEvent.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"task-event.edit({id:taskEvent.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"task-event.delete({id:taskEvent.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-sm-down\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/user-itinerary/user-itinerary-selector.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"box box-default\"><div class=\"box-header with-border\"><h3 class=\"box-title\"><span translate=\"fleetApp.itinerary.driverHelpers\">Ajudantes</span></h3></div><div class=\"box-body\"><div class=\"col-md-4\"><user-typeahead model-id=\"$ctrl.userId\" model-label=\"$ctrl.userFirstName\" hide-title=\"\'true\'\" label=\"\'fleetApp.itinerary.driverHelper\'\" translate-label-key=\"\'fleetApp.itinerary.driverHelper\'\"></div><div class=\"col-md-2\"><button class=\"btn btn-default\" ng-click=\"$ctrl.addUser()\" type=\"button\">Adicionar</button></div></div><div class=\"col-md-12\"><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"fleetApp.itinerary.driverHelpers\">Ajudantes</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"user in $ctrl.itinerary.users\"><td>{{user.userFirstName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button class=\"btn btn-danger btn-sm\" type=\"button\" ng-click=\"$ctrl.removeUser(user.userId)\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/entities/v3/v3.html","<div style=\"height=100%\" fullscreen><button ng-click=\"vm.postMessage()\">POST</button><iframe id=\"da-iframe\" width=\"100%\" height=\"100%\" frameborder=\"0\" src=\"https://v3.siglog.com.br/\" title=\"W3Schools Free Online Web Tutorials\"></iframe></div>");
$templateCache.put("app/entities/vehicle/vehicle-delete-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vehicle.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"fleetApp.vehicle.delete.question\" translate-values=\"{id: \'{{vm.vehicle.id}}\'}\">Are you sure you want to delete this Vehicle?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vehicle/vehicle-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2><span data-translate=\"fleetApp.vehicle.detail.title\">Vehicle</span> {{vm.vehicle.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"fleetApp.vehicle.plate\">Plate</span></dt><dd><span>{{vm.vehicle.plate}}</span></dd><dt><span data-translate=\"fleetApp.vehicle.activated\">Activated</span></dt><dd><span>{{vm.vehicle.activated}}</span></dd><dt><span data-translate=\"fleetApp.vehicle.externalId\">External Id</span></dt><dd><span>{{vm.vehicle.externalId}}</span></dd><dt><span data-translate=\"fleetApp.vehicle.photoUrl\">Photo Url</span></dt><dd><span>{{vm.vehicle.photoUrl}}</span></dd><dt><span translate=\"fleetApp.vehicle.kmCost\">Km Cost</span></dt><dd><input type=\"text\" class=\"form-control\" name=\"kmCost\" id=\"field_kmCost\" ng-model=\"vm.vehicle.kmCost\" ui-number-mask=\"2\" ng-disabled=\"true\"></dd><dt><span translate=\"fleetApp.vehicle.dailyCost\">Daily Cost</span></dt><dd><input type=\"text\" class=\"form-control\" name=\"dailyCost\" id=\"field_dailyCost\" ng-model=\"vm.vehicle.dailyCost\" ui-number-mask=\"2\" ng-disabled=\"true\"></dd><dt><span translate=\"fleetApp.vehicle.extraTimeCost\">Extra Time Cost</span></dt><dd><input type=\"text\" class=\"form-control\" name=\"extraTimeCost\" id=\"field_extraTimeCost\" ng-model=\"vm.vehicle.extraTimeCost\" ui-number-mask=\"2\" ng-disabled=\"true\"></dd><dt><span translate=\"fleetApp.vehicle.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.vehicle.companyId})\">{{vm.vehicle.companyName}}</a></dd><dt><span data-translate=\"fleetApp.vehicle.device\">Device</span></dt><dd><a ui-sref=\"device-detail({id:vm.vehicle.deviceId})\">{{vm.vehicle.deviceUniqueId}}</a></dd><dt><span data-translate=\"fleetApp.vehicle.vehicleType\">Vehicle Type</span></dt><dd><a ui-sref=\"vehicle-type-detail({id:vm.vehicle.vehicleTypeId})\">{{vm.vehicle.vehicleTypeName}}</a></dd><dt><span data-translate=\"fleetApp.vehicle.driver\">Driver</span></dt><dd><span>{{vm.vehicle.driverFirstName}}</span></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"vehicle-detail.edit({id:vm.vehicle.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/vehicle/vehicle-dialog.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVehicleLabel\" data-translate=\"fleetApp.vehicle.home.createOrEditLabel\">Create or edit a Vehicle</h4></div><div class=\"modal-body\"><div class=\"row\"><jhi-alert-error></jhi-alert-error><div class=\"col-md-4 col-sm-4 col-xs-6\" ng-show=\"vm.vehicle.id\"><div class=\"form-group\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vehicle.id\" readonly=\"readonly\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.vehicle.plate\" for=\"field_plate\">Plate</label><input type=\"text\" class=\"form-control\" name=\"plate\" id=\"field_plate\" ng-model=\"vm.vehicle.plate\" required ng-maxlength=\"20\"><div ng-show=\"editForm.plate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.plate.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.plate.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"20\">This field cannot be longer than 20 characters.</p></div></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.vehicle.activated\" for=\"field_activated\">Activated</label><input type=\"checkbox\" class=\"\" name=\"activated\" id=\"field_activated\" ng-model=\"vm.vehicle.activated\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.vehicle.externalId\" for=\"field_externalId\">External Id</label><input type=\"number\" class=\"form-control\" name=\"externalId\" id=\"field_externalId\" ng-model=\"vm.vehicle.externalId\"></div></div><div class=\"col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.vehicle.photoUrl\" for=\"field_photoUrl\">Photo Url</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"photoUrl\" id=\"field_photoUrl\" ng-model=\"vm.vehicle.photoUrl\" ng-maxlength=\"255\"><div class=\"input-group-btn\"><button id=\"upload_widget\" class=\"btn btn-info\">Upload</button></div></div><div ng-show=\"editForm.photoUrl.$invalid\"><p class=\"help-block\" ng-show=\"editForm.photoUrl.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"255\">This field cannot be longer than 255 characters.</p></div></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.kmCost\" for=\"field_kmCost\">Km Cost</label><input type=\"text\" class=\"form-control\" name=\"kmCost\" id=\"field_kmCost\" ng-model=\"vm.vehicle.kmCost\" ui-number-mask=\"2\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.kmCostTrip\" for=\"field_kmCostTrip\">Km Cost Trip</label><input type=\"text\" class=\"form-control\" name=\"kmCost\" id=\"field_kmCostTrip\" ng-model=\"vm.vehicle.kmCostTrip\" ui-number-mask=\"2\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.kmAllowed\" for=\"field_kmAllowed\">KM Allower</label><input type=\"number\" class=\"form-control\" name=\"kmCost\" id=\"field_kmAllowed\" ng-model=\"vm.vehicle.kmAllowed\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.timeAllowed\" for=\"field_timeAllowed\">Time Allowed</label><input type=\"number\" class=\"form-control\" name=\"kmCost\" id=\"field_timeAllowed\" ng-model=\"vm.vehicle.timeAllowed\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.dailyCost\" for=\"field_dailyCost\">Daily Cost</label><input type=\"text\" class=\"form-control\" name=\"dailyCost\" id=\"field_dailyCost\" ng-model=\"vm.vehicle.dailyCost\" ui-number-mask=\"2\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.extraTimeCost\" for=\"field_extraTimeCost\">Extra Time Cost</label><input type=\"text\" class=\"form-control\" name=\"extraTimeCost\" id=\"field_extraTimeCost\" ng-model=\"vm.vehicle.extraTimeCost\" ui-number-mask=\"2\"></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicle.company\" for=\"field_company\">Company</label><select class=\"form-control\" id=\"field_company\" name=\"company\" ng-model=\"vm.vehicle.companyId\" ng-options=\"company.id as company.name for company in vm.companies\" required><option value=\"\"></option></select><div ng-show=\"editForm.company.$invalid\"><p class=\"help-block\" ng-show=\"editForm.company.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-4 col-sm-4 col-xs-6\"><div class=\"form-group\"><device-typeahead model-id=\"vm.vehicle.deviceId\" model-label=\"vm.vehicle.deviceUniqueId\" label=\"\'fleetApp.vehicle.device\'\"></device-typeahead></div></div><!--\n            <div class=\"form-group\">\n                <label data-translate=\"fleetApp.vehicle.device\" for=\"field_device\">Device</label>\n                <select class=\"form-control\" id=\"field_device\" name=\"device\" ng-model=\"vm.vehicle.deviceId\"\n                        ng-options=\"device.id as device.uniqueId for device in vm.devices\">\n                    <option value=\"\"></option>\n                </select>\n            </div>\n            --><div class=\"form-group col-md-4 col-sm-4 col-xs-6\"><label data-translate=\"fleetApp.vehicle.vehicleType\" for=\"field_vehicleType\">Vehicle Type</label><select class=\"form-control\" id=\"field_vehicleType\" name=\"vehicleType\" ng-model=\"vm.vehicle.vehicleTypeId\" ng-options=\"vehicleType.id as vehicleType.name for vehicleType in vm.vehicletypes\"><option value=\"\"></option></select></div><div class=\"form-group col-md-4 col-sm-4 col-xs-6\"><label class=\"control-label\" translate=\"fleetApp.vehicle.driver\">Driver</label><user-typeahead id=\"field_driver\" model-id=\"vm.vehicle.driverId\" model-label=\"vm.vehicle.driverFirstName\" hide-title=\"true\"></user-typeahead></div><div class=\"form-group col-md-4 col-sm-4 col-xs-6\"><label class=\"control-label\" translate=\"fleetApp.bankAccount.home.title\">Bank Account</label><bank-account-typeahead id=\"field_driver\" model-id=\"vm.vehicle.bankAccountId\" model-label=\"vm.vehicle.bankAccountName\" hide-title=\"true\"></bank-account-typeahead></div><div class=\"form-group col-md-4 col-sm-4 col-xs-6\"><label class=\"control-label\" translate=\"fleetApp.vehicleGroup.home.title\">Vehicle Group</label><vehicle-group-typeahead id=\"field_vehicle_group\" model-id=\"vm.vehicle.vehicleGroupId\" model-label=\"vm.vehicle.vehicleGroupName\" hide-title=\"true\"></vehicle-group-typeahead></div></div></div><div class=\"modal-footer\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></div></form>");
$templateCache.put("app/entities/vehicle/vehicles.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 data-translate=\"fleetApp.vehicle.home.title\">Vehicles</h2><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"vehicle.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"fleetApp.vehicle.home.createLabel\">Create new Vehicle</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"plate\"><span data-translate=\"fleetApp.vehicle.plate\">Plate</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"activated\"><span data-translate=\"fleetApp.vehicle.activated\">Activated</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"externalId\"><span data-translate=\"fleetApp.vehicle.externalId\">External Id</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmCost\"><span translate=\"fleetApp.vehicle.kmCost\">Km Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dailyCost\"><span translate=\"fleetApp.vehicle.dailyCost\">Daily Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"extraTimeCost\"><span translate=\"fleetApp.vehicle.extraTimeCost\">Extra Time Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deviceUniqueId\"><span data-translate=\"fleetApp.vehicle.device\">Device</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"deviceDeviceType\"><span data-translate=\"fleetApp.device.deviceType\">deviceType</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehicleTypeName\"><span data-translate=\"fleetApp.vehicle.vehicleType\">Vehicle Type</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vehicle in vm.vehicles track by vehicle.id\"><td><a ui-sref=\"vehicle-detail({id:vehicle.id})\">{{vehicle.id}}</a></td><td>{{vehicle.plate}}</td><td>{{vehicle.activated}}</td><td>{{vehicle.externalId}}</td><td>{{vehicle.kmCost}}</td><td>{{vehicle.dailyCost}}</td><td>{{vehicle.extraTimeCost}}</td><td><a ui-sref=\"device-detail({id:vehicle.deviceId})\">{{vehicle.deviceUniqueId}}</a></td><td>{{vehicle.deviceType}}</td><td><a ui-sref=\"vehicle-type-detail({id:vehicle.vehicleTypeId})\">{{vehicle.vehicleTypeName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vehicle-detail({id:vehicle.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vehicle.edit({id:vehicle.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vehicle.delete({id:vehicle.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/vehicle-group/vehicle-group-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vehicleGroup.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.vehicleGroup.delete.question\" translate-values=\"{id: \'{{vm.vehicleGroup.id}}\'}\">Are you sure you want to delete this Vehicle Group?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vehicle-group/vehicle-group-detail.html","<div><h2><span translate=\"fleetApp.vehicleGroup.detail.title\">Vehicle Group</span> {{vm.vehicleGroup.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.vehicleGroup.name\">Name</span></dt><dd><span>{{vm.vehicleGroup.name}}</span></dd><dt><span translate=\"fleetApp.vehicleGroup.company\">Company</span></dt><dd><a ui-sref=\"company-detail({id:vm.vehicleGroup.companyId})\">{{vm.vehicleGroup.companyName}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/vehicle-group/vehicle-group-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVehicleGroupLabel\" translate=\"fleetApp.vehicleGroup.home.createOrEditLabel\">Create or edit a Vehicle Group</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.vehicleGroup.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vehicleGroup.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehicleGroup.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.vehicleGroup.name\" required ng-maxlength=\"150\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" translate=\"entity.validation.maxlength\" translate-value-max=\"150\">This field cannot be longer than 150 characters.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.vehicleGroup.company\" for=\"field_company\">Company</label><input id=\"field_company\" class=\"form-control\" disabled=\"disabled\" type=\"text\" ng-model=\"vm.vehicleGroup.companyName\"></div><div ng-show=\"editForm.company.$invalid\"><p class=\"help-block\" ng-show=\"editForm.company.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/vehicle-group/vehicle-groups.html","<div><h2 translate=\"fleetApp.vehicleGroup.home.title\">Vehicle Groups</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"vehicle-group.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.vehicleGroup.home.createLabel\">Create new Vehicle Group</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><span translate=\"fleetApp.vehicleGroup.name\">Name</span></th><th><span translate=\"fleetApp.vehicleGroup.company\">Company</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vehicleGroup in vm.vehicleGroups track by vehicleGroup.id\"><td><a ui-sref=\"vehicle-group-detail({id:vehicleGroup.id})\">{{vehicleGroup.id}}</a></td><td>{{vehicleGroup.name}}</td><td><a ui-sref=\"company-detail({id:vehicleGroup.companyId})\">{{vehicleGroup.companyName}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vehicle-group-detail({id:vehicleGroup.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-group.edit({id:vehicleGroup.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-group.delete({id:vehicleGroup.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/entities/vehicle-payment/vehicle-payment-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vehiclePayment.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.vehiclePayment.delete.question\" translate-values=\"{id: \'{{vm.vehiclePayment.id}}\'}\">Are you sure you want to delete this Vehicle Payment?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vehicle-payment/vehicle-payment-detail.html","<div><h2><span translate=\"fleetApp.vehiclePayment.detail.title\">Vehicle Payment</span> {{vm.vehiclePayment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.vehiclePayment.creation\">Creation</span></dt><dd><span>{{vm.vehiclePayment.creation | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.extraTimeCost\">Extra Time Cost</span></dt><dd><span>{{vm.vehiclePayment.extraTimeCost}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.startDate\">Start Date</span></dt><dd><span>{{vm.vehiclePayment.startDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.endDate\">End Date</span></dt><dd><span>{{vm.vehiclePayment.endDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.expenseCost\">Expense Cost</span></dt><dd><span>{{vm.vehiclePayment.expenseCost}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.total\">Total</span></dt><dd><span>{{vm.vehiclePayment.total}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.timeAllowed\">Time Allowed</span></dt><dd><span>{{vm.vehiclePayment.timeAllowed}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.kmAllowed\">Km Allowed</span></dt><dd><span>{{vm.vehiclePayment.kmAllowed}}</span></dd><dt><span translate=\"fleetApp.vehiclePayment.creator\">Creator</span></dt><dd>{{vm.vehiclePayment.creatorFirstName}}</dd><dt><span translate=\"fleetApp.vehiclePayment.vehicle\">Vehicle</span></dt><dd><a ui-sref=\"vehicle-detail({id:vm.vehiclePayment.vehicleId})\">{{vm.vehiclePayment.vehiclePlate}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/vehicle-payment/vehicle-payment-edit.html","<form name=\"editForm\" role=\"form\" novalidate show-validation><div><h4 class=\"modal-title\" id=\"myVehiclePaymentLabel\" translate=\"fleetApp.vehiclePayment.home.editLabel\">Edit</h4><hr><div class=\"row\"><jhi-alert></jhi-alert><div class=\"form-group col-md-1\" ng-show=\"vm.vehiclePayment.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vehiclePayment.id\" readonly=\"readonly\"></div><div class=\"col-md-2\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.vehicle\" for=\"field_vehicle\">Vehicle</label><input id=\"field_vehicle\" type=\"text\" class=\"form-control\" name=\"field_vehicle\" ng-model=\"vm.vehiclePayment.vehiclePlate\" required disabled=\"disabled\"><div ng-show=\"vm.vehiclePayment.vehicleId == null\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.startDate\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.vehiclePayment.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.startDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.startDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.endDate\" for=\"field_endDate\">End Date</label><div class=\"input-group\"><input id=\"field_endDate\" type=\"text\" class=\"form-control\" name=\"endDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.vehiclePayment.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.endDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.endDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-2\"><label class=\"input-group\">&nbsp</label><button class=\"btn btn-primary\" ng-click=\"vm.addItem()\" ng-disabled=\"deleteForm.$invalid || !vm.vehiclePayment.vehicleId\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.vehiclePaymentItem.home.createLabel\">Create new Vehicle Payment Item</span></button></div><div class=\"form-group col-md-2\"><label class=\"input-group\">&nbsp</label><button class=\"btn btn-default\" ng-click=\"vm.importItineraryData()\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.vehiclePayment.importData\">Import itinerary data</span></button></div></div><!-- Informações Avançadas --><div class=\"\"><uib-accordion close-others=\"oneAtATime\"><div uib-accordion-group class=\"panel-default\" is-open=\"status.open\"><uib-accordion-heading>Informações financeiras do veículo {{ vm.vehiclePayment.vehiclePlate }} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></uib-accordion-heading><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.dailyCost\">dailyCost</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_dailyCost\" ng-model=\"vm.vehiclePayment.dailyCost\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.kmCost\">kmCost</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_kmCost\" ng-model=\"vm.vehiclePayment.kmCost\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.kmCostTrip\">kmCostTrip</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_kmCostTrip\" ng-model=\"vm.vehiclePayment.kmCostTrip\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.extraTimeCost\">extraTimeCost</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_extraTimeCost\" ng-model=\"vm.vehiclePayment.extraTimeCost\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.timeAllowed\">timeAllowed</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_timeAllowedt\" ng-value=\"vm.vehicleTimeAllowed\" readonly=\"readonly\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.kmAllowed\">kmAllowed</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_kmAllowed\" ng-value=\"vm.vehiclePayment.kmAllowed\" readonly=\"readonly\"></div></div></uib-accordion></div><div class=\"row\"><div class=\"pull-right\"></div></div><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\" ng-show=\"vm.vehiclePayment.id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paymentDate\"><span translate=\"fleetApp.vehiclePaymentItem.paymentDate\">Payment Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.vehiclePaymentItem.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--\n                <th jh-sort-by=\"startOdometer\"><span translate=\"fleetApp.vehiclePaymentItem.startOdometer\">Start Odometer</span> <span\n                    class=\"glyphicon glyphicon-sort\"></span></th>\n                <th jh-sort-by=\"endOdometer\"><span translate=\"fleetApp.vehiclePaymentItem.endOdometer\">End Odometer</span> <span\n                    class=\"glyphicon glyphicon-sort\"></span></th>\n                    --><th jh-sort-by=\"kmTotal\"><span translate=\"fleetApp.vehiclePaymentItem.kmTotal\">Km Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--<th jh-sort-by=\"kmExtra\"><span translate=\"fleetApp.vehiclePaymentItem.kmExtra\">Km Extra</span> <span\n                    class=\"glyphicon glyphicon-sort\"></span></th>--><th jh-sort-by=\"kmExtraRegular\"><span translate=\"fleetApp.vehiclePaymentItem.kmExtraRegularSmall\">Km Extra Regular</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmExtraTrip\"><span translate=\"fleetApp.vehiclePaymentItem.kmExtraTripSmall\">Km Extra Trip</span> <span class=\"glyphicon glyphicon-sort\"></span></th><!--\n                <th jh-sort-by=\"kmCostTotalRegular\"><span translate=\"fleetApp.vehiclePaymentItem.kmCostTotalRegular\">Km Cost Total Regular</span>\n                    <span class=\"glyphicon glyphicon-sort\"></span></th>\n                <th jh-sort-by=\"kmCostTotalTrip\"><span translate=\"fleetApp.vehiclePaymentItem.kmCostTotalTrip\">Km Cost Total Trip</span> <span\n                    class=\"glyphicon glyphicon-sort\"></span></th>\n                --><th jh-sort-by=\"startTime\"><span translate=\"fleetApp.vehiclePaymentItem.startTime\">Start Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endTime\"><span translate=\"fleetApp.vehiclePaymentItem.endTime\">End Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalTime\"><span translate=\"fleetApp.vehiclePaymentItem.totalTime\">Total Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"extraTime\"><span translate=\"fleetApp.vehiclePaymentItem.extraTime\">Extra Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"extraTimeCostTotal\"><span translate=\"fleetApp.vehiclePaymentItem.extraTimeCostTotal\">Extra Time Cost Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expenseTotal\"><span translate=\"fleetApp.vehiclePaymentItem.expenseTotal\">Expense Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"refundCost\"><span translate=\"fleetApp.vehiclePayment.refund\">Refund Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"total\"><span translate=\"fleetApp.vehiclePaymentItem.total\">Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vehiclePaymentItem in vm.vehiclePayment.itens | orderBy: \'paymentDate\' \"><td ng-show=\"vm.vehiclePayment.id\">{{vehiclePaymentItem.id}}</td><td>{{vehiclePaymentItem.paymentDate | date:\'dd/MM/yyyy\'}}</td><td>{{vehiclePaymentItem.driverFirstName}}</td><!--<td>{{vehiclePaymentItem.startOdometer}}</td>\n                <td>{{vehiclePaymentItem.endOdometer}}</td>--><td>{{vehiclePaymentItem.kmTotal}} km</td><!--<td>{{vehiclePaymentItem.kmExtra}}</td> --><td>{{vehiclePaymentItem.kmExtraRegular}} km, {{vehiclePaymentItem.kmCostTotalRegular | currency}}</td><!-- KM EXTR. SOMENTE\n                NORMAL --><td>{{vehiclePaymentItem.kmExtraTrip}} km, {{vehiclePaymentItem.kmCostTotalTrip | currency}}</td><!-- KM EXT. SOMENTE VIAGEM --><!--<td>{{vehiclePaymentItem.kmCostTotalRegular}}</td>\n                <td>{{vehiclePaymentItem.kmCostTotalTrip}}</td> --><td>{{vehiclePaymentItem.startTime | date:\'hh:mm\'}}</td><td>{{vehiclePaymentItem.endTime | date:\'hh:mm\'}}</td><td>{{vm.convertMinutesToDisplay(vehiclePaymentItem.totalTime)}}</td><!-- HORA TOTAL --><td>{{vm.convertMinutesToDisplay(vehiclePaymentItem.extraTime)}}</td><!-- HORA EXTRA --><td>{{vehiclePaymentItem.extraTimeCostTotal | currency}}</td><!-- CUSTO H. EXTRA --><td>{{vehiclePaymentItem.expenseTotal | currency}}</td><!-- VALOR PEDÁGIO E ABASTECIMENTO --><td>{{vehiclePaymentItem.refundTotal | currency}}</td><td>{{vehiclePaymentItem.total | currency}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" uib-tooltip=\"{{\'entity.action.view\' | translate}}\" ui-sref=\"vehicle-payment-item-detail({id:vehiclePaymentItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm hidden-lg\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ng-click=\"vm.editItem(vehiclePaymentItem.id)\" class=\"btn btn-primary btn-sm\" uib-tooltip=\"{{\'entity.action.edit\' | translate}}\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm hidden-lg\" translate=\"entity.action.edit\"></span></button> <button ng-click=\"vm.deleteItem(vehiclePaymentItem)\" class=\"btn btn-danger btn-sm\" uib-tooltip=\"{{\'entity.action.delete\' | translate}}\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm hidden-lg\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><!-- TOTAL --><div class=\"row\"><div class=\"form-group col-md-2 pull-right\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.totalMinusExpense\">Total - Expense + Reembolso</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_totalMinusExpense\" ng-value=\"vm.vehiclePayment.total - vm.vehiclePayment.expenseCost + vm.vehiclePayment.refundCost | currency\" readonly=\"readonly\"></div><div class=\"form-group col-md-2 pull-right\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.total\">total</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_total\" ng-model=\"vm.vehiclePayment.total\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-2 pull-right\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.refund\">exrefundCostpenseCost</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_refundCost\" ng-model=\"vm.vehiclePayment.refundCost\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-2 pull-right\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.expenseCost\">expenseCost</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_expenseCost\" ng-model=\"vm.vehiclePayment.expenseCost\" ui-money-mask readonly=\"readonly\"></div><div class=\"form-group col-md-2 pull-right\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.kmTotalExtra\">kmTotalExtra</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_kmTotalExtra\" ng-model=\"vm.vehiclePayment.kmTotalExtra\" ui-number-mask=\"0\" readonly=\"readonly\"></div><div class=\"form-group col-md-2 pull-right\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.kmTotalRegular\">kmTotalRegular</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_kmTotalRegular\" ng-model=\"vm.vehiclePayment.kmTotalRegular\" ui-number-mask=\"0\" readonly=\"readonly\"></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"pull-right\"><button ng-click=\"vm.cancel()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Voltar</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\" ng-click=\"vm.save()\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div></div></div></form>");
$templateCache.put("app/entities/vehicle-payment/vehicle-payment-new-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVehiclePaymentLabel\" translate=\"fleetApp.vehiclePayment.home.createLabel\">Create</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.startDate\" for=\"field_startDate\">Start Date</label><div class=\"input-group\"><input id=\"field_startDate\" type=\"text\" class=\"form-control\" name=\"startDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.vehiclePayment.startDate\" is-open=\"vm.datePickerOpenStatus.startDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.startDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.startDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group col-md-6\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.endDate\" for=\"field_endDate\">End Date</label><div class=\"input-group\"><input id=\"field_endDate\" type=\"text\" class=\"form-control\" name=\"endDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.vehiclePayment.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" datepicker-options=\"{minDate: vm.vehiclePayment.startDate}\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.endDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.endDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-md-12\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.vehiclePayment.vehicleId\" model-label=\"vm.vehiclePayment.vehiclePlate\" label=\"\'fleetApp.vehiclePayment.vehicle\'\"></vehicle-typeahead><div ng-show=\"vm.vehiclePayment.vehicleId == null\"><p class=\"help-block\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehiclePayment.importData\" for=\"field_importData\">Import Data</label><input type=\"checkbox\" name=\"activated\" id=\"field_importData\" ng-model=\"vm.vehiclePayment.importItineraryData\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving || vm.vehiclePayment.vehicleId == null\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/vehicle-payment/vehicle-payments.html","<div><h2 translate=\"fleetApp.vehiclePayment.home.title\">Vehicle Payments</h2><jhi-alert-error></jhi-alert-error><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"input-group\"><span class=\"input-group-addon\" translate=\"global.field.initialDate\" required>from</span><div class=\"input-group\"><input id=\"field_date\" type=\"text\" class=\"form-control\" name=\"dateIni\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.startDate\" is-open=\"vm.datePickerOpenStatus.dateIni\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'dateIni\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"dateIni.$invalid\"><p class=\"help-block\" ng-show=\"dateIni.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><span class=\"input-group-addon\" translate=\"global.field.endDate\" required>to</span><div class=\"input-group\"><input id=\"field_date_end\" type=\"text\" class=\"form-control\" name=\"endDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.endDate\" is-open=\"vm.datePickerOpenStatus.endDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"endDate.$invalid\"><p class=\"help-block\" ng-show=\"endDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"btn-group\"><button class=\"btn btn-default\" ng-click=\"vm.fortnight(\'first\')\">1ª Quinzena</button> <button class=\"btn btn-default\" ng-click=\"vm.fortnight(\'second\')\">2ª Quinzena</button></div></div><div class=\"col-md-1\">&nbsp;</div><div class=\"col-md-2\"><div class=\"input-group\"><vehicle-typeahead id=\"field_vehicle\" name=\"vehicle\" model-id=\"vm.vehicleId\" model-label=\"vm.vehiclePlate\" hide-title=\"true\" label=\"\'fleetApp.expense.vehicle\'\"></vehicle-typeahead></div></div><div class=\"col-md-5\"><button class=\"btn btn-primary\" ng-click=\"vm.search()\"><span class=\"glyphicon glyphicon-search\"></span> <span translate=\"entity.action.search\">Search</span></button> <button class=\"btn btn-primary\" ui-sref=\"vehicle-payment.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.vehiclePayment.home.createLabel\">Create new Vehicle Payment</span></button> <button class=\"btn btn-default\" ng-click=\"vm.reportTotal()\"><span class=\"fa fa-file-excel-o\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.export\"></span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePlate\"><span translate=\"fleetApp.vehiclePayment.vehicle\">Vehicle</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startDate\"><span translate=\"fleetApp.vehiclePayment.startDate\">Start Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endDate\"><span translate=\"fleetApp.vehiclePayment.endDate\">End Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"refundCost\"><span translate=\"fleetApp.vehiclePayment.refund\">Refund</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expenseCost\"><span translate=\"fleetApp.vehiclePayment.expenseCost\">Expense Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"total\"><span translate=\"fleetApp.vehiclePayment.total\">Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th><span translate=\"fleetApp.vehiclePayment.totalMinusExpense\">TOTALMINUSEXPENSE</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vehiclePayment in vm.vehiclePayments track by vehiclePayment.id\"><td><a ui-sref=\"vehicle-payment-detail({id:vehiclePayment.id})\">{{vehiclePayment.id}}</a></td><td><a ui-sref=\"vehicle-detail({id:vehiclePayment.vehicleId})\">{{vehiclePayment.vehiclePlate}}</a></td><td>{{vehiclePayment.startDate | date:\'dd/MM/yyyy\'}}</td><td>{{vehiclePayment.endDate | date:\'dd/MM/yyyy\'}}</td><td>{{vehiclePayment.refundCost | currency}}</td><td>{{vehiclePayment.expenseCost | currency}}</td><td>{{vehiclePayment.total | currency}}</td><td>{{vehiclePayment.total - vehiclePayment.expenseCost + vehiclePayment.refundCost | currency}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button class=\"btn btn-default\" ng-click=\"vm.report(vehiclePayment.id)\"><span class=\"fa fa-file-excel-o\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.export\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-payment-detail({id:vehiclePayment.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-payment.edit({id:vehiclePayment.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-payment.delete({id:vehiclePayment.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/vehicle-payment-item/vehicle-payment-item-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vehiclePaymentItem.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.vehiclePaymentItem.delete.question\" translate-values=\"{id: \'{{vm.vehiclePaymentItem.id}}\'}\">Are you sure you want to delete this Vehicle Payment Item?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vehicle-payment-item/vehicle-payment-item-detail.html","<div><h2><span translate=\"fleetApp.vehiclePaymentItem.detail.title\">Vehicle Payment Item</span> {{vm.vehiclePaymentItem.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.vehiclePaymentItem.paymentDate\">Payment Date</span></dt><dd><span>{{vm.vehiclePaymentItem.paymentDate | date:\'mediumDate\'}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.startOdometer\">Start Odometer</span></dt><dd><span>{{vm.vehiclePaymentItem.startOdometer}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.endOdometer\">End Odometer</span></dt><dd><span>{{vm.vehiclePaymentItem.endOdometer}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.kmTotal\">Km Total</span></dt><dd><span>{{vm.vehiclePaymentItem.kmTotal}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.kmExtra\">Km Extra</span></dt><dd><span>{{vm.vehiclePaymentItem.kmExtra}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.kmExtraRegular\">Km Extra Regular</span></dt><dd><span>{{vm.vehiclePaymentItem.kmExtraRegular}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.kmExtraTrip\">Km Extra Trip</span></dt><dd><span>{{vm.vehiclePaymentItem.kmExtraTrip}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.kmCostTotalRegular\">Km Cost Total Regular</span></dt><dd><span>{{vm.vehiclePaymentItem.kmCostTotalRegular}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.kmCostTotalTrip\">Km Cost Total Trip</span></dt><dd><span>{{vm.vehiclePaymentItem.kmCostTotalTrip}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.startTime\">Start Time</span></dt><dd><span>{{vm.vehiclePaymentItem.startTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.endTime\">End Time</span></dt><dd><span>{{vm.vehiclePaymentItem.endTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.totalTime\">Total Time</span></dt><dd><span>{{vm.vehiclePaymentItem.totalTime}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.extraTime\">Extra Time</span></dt><dd><span>{{vm.vehiclePaymentItem.extraTime}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.extraTimeCostTotal\">Extra Time Cost Total</span></dt><dd><span>{{vm.vehiclePaymentItem.extraTimeCostTotal}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.expenseTotal\">Expense Total</span></dt><dd><span>{{vm.vehiclePaymentItem.expenseTotal}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.total\">Total</span></dt><dd><span>{{vm.vehiclePaymentItem.total}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.dailyCost\">Daily Cost</span></dt><dd><span>{{vm.vehiclePaymentItem.dailyCost}}</span></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.vehiclePayment\">Vehicle Payment</span></dt><dd><a ui-sref=\"vehicle-payment-detail({id:vm.vehiclePaymentItem.vehiclePaymentId})\">{{vm.vehiclePaymentItem.vehiclePaymentId}}</a></dd><dt><span translate=\"fleetApp.vehiclePaymentItem.driver\">Driver</span></dt><dd>{{vm.vehiclePaymentItem.driverFirstName}}</dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/vehicle-payment-item/vehicle-payment-item-dialog.html","<form name=\"editForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVehiclePaymentItemLabel\" translate=\"fleetApp.vehiclePaymentItem.home.createOrEditLabel\">Create or edit a Vehicle Payment Item</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"row\"><div class=\"col-md-2\" ng-show=\"vm.vehiclePaymentItem.id\"><div class=\"form-group\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vehiclePaymentItem.id\" readonly=\"readonly\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.paymentDate\" for=\"field_paymentDate\">Payment Date</label><div class=\"input-group\"><input id=\"field_paymentDate\" type=\"text\" class=\"form-control\" name=\"paymentDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"vm.vehiclePaymentItem.paymentDate\" is-open=\"vm.datePickerOpenStatus.paymentDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'paymentDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.paymentDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.paymentDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.type\" for=\"field_type\">Type</label><select class=\"form-control\" name=\"type\" ng-model=\"vm.vehiclePaymentItem.type\" id=\"field_type\" convert-to-number><option value=\"0\">FINAL DE SEMANA / FERIADO</option><option value=\"\"></option></select></div></div><div class=\"col-md-3\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.driver\">Driver</label><user-typeahead id=\"field_driver\" model-id=\"vm.vehiclePaymentItem.driverId\" model-label=\"vm.vehiclePaymentItem.driverFirstName\" hide-title=\"true\"></user-typeahead></div><!-- km ----------------------><div class=\"col-sm-12\"><div class=\"box box-primary\"><div class=\"box-header with-border\"><h3 class=\"box-title\">km</h3></div><!-- /.box-header --><div class=\"box-body\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.startOdometer\" for=\"field_startOdometer\">Start Odometer</label><input type=\"text\" ui-number-mask=\"0\" class=\"form-control\" name=\"startOdometer\" id=\"field_startOdometer\" ng-model=\"vm.vehiclePaymentItem.startOdometer\" ng-change=\"vm.updateOdometer()\" required><div ng-show=\"editForm.startOdometer.$invalid\"><p class=\"help-block\" ng-show=\"editForm.startOdometer.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block\" ng-show=\"editForm.endOdometer.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.endOdometer\" for=\"field_endOdometer\">End Odometer</label><input type=\"number\" class=\"form-control\" name=\"endOdometer\" id=\"field_endOdometer\" ng-min=\"{{vm.vehiclePaymentItem.startOdometer}}\" ng-model=\"vm.vehiclePaymentItem.endOdometer\" ng-change=\"vm.updateOdometer()\" required><div ng-show=\"editForm.endOdometer.$invalid\"><p class=\"help-block\" ng-show=\"editForm.endOdometer.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p><p class=\"help-block\" ng-show=\"editForm.endOdometer.$error.required\" translate=\"entity.validation.required\">This field is required. This field should be more than</p><p class=\"help-block\" ng-show=\"editForm.endOdometer.$error.min\" translate=\"entity.validation.min\" translate-value-min=\"{{vm.vehiclePaymentItem.startOdometer}}\">This field is required.</p></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.kmTotal\" for=\"field_kmTotal\">Km Total</label><input type=\"number\" class=\"form-control alert alert-info\" name=\"kmTotal\" id=\"field_kmTotal\" ng-model=\"vm.vehiclePaymentItem.kmTotal\" ng-change=\"vm.changeTotal()\" readonly=\"readonly\"></div></div><div class=\"col-md-4\" ng-if=\"vm.vehiclePaymentItem.kmExtra\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.kmExtraRegular\" for=\"field_kmExtraRegular\">Km Extra Regular</label><input type=\"number\" class=\"form-control\" name=\"kmExtraRegular\" id=\"field_kmExtraRegular\" ng-model=\"vm.vehiclePaymentItem.kmExtraRegular\" ng-change=\"vm.updateKmExtraRegular()\" required><div ng-show=\"editForm.kmExtraRegular.$invalid\"><p class=\"help-block\" ng-show=\"editForm.kmExtraRegular.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"col-md-4\" ng-if=\"vm.vehiclePaymentItem.kmExtra\"><div class=\"form-group\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.kmExtraTrip\" for=\"field_kmExtraTrip\">Km Extra Trip</label><input type=\"number\" class=\"form-control\" name=\"kmExtraTrip\" id=\"field_kmExtraTrip\" ng-model=\"vm.vehiclePaymentItem.kmExtraTrip\" ng-change=\"vm.updateKmExtraTrip()\" required><div ng-show=\"editForm.kmExtraTrip.$invalid\"><p class=\"help-block\" ng-show=\"editForm.kmExtraTrip.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div></div><div class=\"col-md-4\" ng-if=\"vm.vehiclePaymentItem.kmExtra\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.kmExtra\" for=\"field_kmExtra\">Km Extra</label><input type=\"number\" class=\"form-control alert alert-danger\" name=\"kmExtra\" id=\"field_kmExtra\" ng-model=\"vm.vehiclePaymentItem.kmExtra\" readonly=\"readonly\"></div></div></div><!-- /.box-body --><div class=\"box-footer\" ng-if=\"vm.vehiclePaymentItem.kmExtra\"><div class=\"col-md-4\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.kmCostTotalRegular\" for=\"field_kmCostTotalRegular\">Km Cost Total Regular</label><input type=\"text\" ui-number-mask=\"2\" class=\"form-control\" name=\"kmCostTotalRegular\" id=\"field_kmCostTotalRegular\" ng-model=\"vm.vehiclePaymentItem.kmCostTotalRegular\" readonly=\"readonly\" ng-change=\"vm.changeTotal()\"></div><div class=\"col-md-4\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.kmCostTotalTrip\" for=\"field_kmCostTotalTrip\">Km Cost Total Trip</label><input type=\"text\" ui-number-mask=\"2\" class=\"form-control\" name=\"kmCostTotalTrip\" id=\"field_kmCostTotalTrip\" ng-model=\"vm.vehiclePaymentItem.kmCostTotalTrip\" readonly=\"readonly\" ng-change=\"vm.changeTotal()\"></div></div></div><!-- /.box --></div><div class=\"col-md-12\"><div class=\"box box-primary\"><div class=\"box-header with-border\"><h3 class=\"box-title\" translate=\"fleetApp.vehiclePayment.hour\">Hora</h3></div><div class=\"box-body\"><div class=\"row\"><div class=\"form-group col-md-4\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.startTime\" for=\"field_startTime\">Start Time</label><div id=\"field_startTime\" uib-timepicker ng-model=\"vm.vehiclePaymentItem.startTime\" required min=\"vm.minStartTime\" max=\"vm.maxStartTime\" show-meridian=\"true\" ng-change=\"vm.changeTime()\"></div><div uib-datepicker ng-model=\"vm.vehiclePaymentItem.startTime\" class=\"box box-solid\" style=\"background-color:#f7f7f7\" ng-change=\"vm.changeTime()\" datepicker-options=\"{showWeeks: false}\"></div><div ng-show=\"editForm.startTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.startTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.startTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group col-md-4\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.endTime\" for=\"field_endTime\">End Time</label><div id=\"field_endTime\" uib-timepicker ng-model=\"vm.vehiclePaymentItem.endTime\" required min=\"vm.vehiclePaymentItem.startTime\" show-meridian=\"true\" ng-change=\"vm.changeTime()\"></div><div uib-datepicker ng-model=\"vm.vehiclePaymentItem.endTime\" class=\"box box-solid\" style=\"background-color:#f7f7f7\" ng-change=\"vm.changeTime()\" datepicker-options=\"{minDate: vm.vehiclePaymentItem.startTime, showWeeks: false}\"></div><div ng-show=\"editForm.endTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.endTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.endTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div><div ng-show=\"vm.isInitialTimeIsAfterEndTime()\"><p class=\"help-block\" translate=\"error.initialHour.grater.than.endHour\">This field is required.</p></div></div><div class=\"form-group col-md-4\"><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.totalTime\" for=\"field_totalTime\">Total Time</label><pre id=\"field_totalTime\" class=\"alert alert-info\" ng-if=\"vm.totalTimeFormatted\"><b>{{ vm.totalTimeFormatted }}</b></pre></div><div class=\"form-group\"><span ng-if=\"vm.extraTimeFormatted\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.extraTime\" for=\"field_extraTime\">Extra Time</label><pre id=\"field_extraTime\" class=\"alert alert-danger\" ng-if=\"vm.extraTimeFormatted\"><b>{{ vm.extraTimeFormatted }}</b></pre></span><div ng-show=\"editForm.extraTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.extraTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.extraTime.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\" ng-if=\"vm.vehiclePaymentItem.extraTimeCostTotal\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.extraTimeCostTotal\" for=\"field_extraTimeCostTotal\">Extra Time Cost Total</label><input type=\"text\" ui-number-mask=\"2\" class=\"form-control\" readonly=\"readonly\" ng-model=\"vm.vehiclePaymentItem.extraTimeCostTotal\" name=\"extraTimeCostTotal\" id=\"field_extraTimeCostTotal\"></div></div></div></div></div></div><div class=\"col-md-12\"><div class=\"box box-primary\"><div class=\"box-header with-border\"><h3 class=\"box-title\" translate=\"fleetApp.vehiclePayment.expenseCost\"></h3><div class=\"pull-right\"><button type=\"button\" ng-click=\"vm.addExpense()\" class=\"btn btn-sm\" translate=\"entity.action.add\"></button></div></div><div class=\"box-body\" ng-if=\"vm.vehiclePaymentItem.expenses.length > 0\"><div class=\"row\"><div><table class=\"jh-table table table-striped\"><thead><tr><th><span translate=\"global.field.id\">ID</span></th><th><label class=\"control-label required\" translate=\"fleetApp.expense.expenseDate\">Data</label></th><th><label class=\"control-label required\" translate=\"fleetApp.expense.expenseType\">expenseType</label></th><th><label class=\"control-label required\" translate=\"fleetApp.expense.total\">Total</label></th></tr></thead><tbody><tr ng-repeat=\"expense in vm.vehiclePaymentItem.expenses track by $index\"><td>{{expense.id}}</td><td><div class=\"input-group\"><input id=\"field_expenseDate\" type=\"text\" class=\"form-control\" name=\"expenseDate\" uib-datepicker-popup=\"{{dateformat}}\" ng-model=\"expense.expenseDate\" is-open=\"vm.datePickerOpenStatus[\'expense\' + $index]\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'expense\' + $index)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.expenseDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.expenseDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.expenseDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></td><td><select class=\"form-control\" name=\"expenseType\" ng-model=\"expense.expenseType\" id=\"field_expenseType\" required><option value=\"toll\" translate=\"fleetApp.ExpenseType.toll\">toll</option><option value=\"fuel\" translate=\"fleetApp.ExpenseType.fuel\">fuel</option></select></td><td><div class=\"input-group\"><span class=\"input-group-addon\"><i class=\"fa fa-dollar\"></i></span> <input type=\"text\" ng-model=\"expense.total\" ui-money-mask=\"2\" class=\"form-control\" id=\"field_expense_total\" ng-change=\"vm.changeTotal()\"></div><div ng-show=\"editForm.total.$invalid\"><p class=\"help-block\" ng-show=\"editForm.total.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.total.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></td><td><button uib-tooltip=\"{{\'entity.action.delete\' | translate}}\" ng-click=\"vm.deleteItem(vm.vehiclePaymentItem.expenses, expense)\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span></button></td></tr></tbody></table></div></div></div></div></div><div class=\"col-md-12\"><div class=\"box box-primary\"><div class=\"box-header with-border\"><h3 class=\"box-title\">Total</h3></div><div class=\"box-body\"><div class=\"form-group col-md-3\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePaymentItem.expenseTotal\" for=\"field_expenseTotal\">Expense Total</label><input type=\"text\" ui-number-mask=\"2\" class=\"form-control\" name=\"expenseTotal\" id=\"field_expenseTotal\" ng-model=\"vm.vehiclePaymentItem.expenseTotal\" readonly=\"readonly\"><div ng-show=\"editForm.expenseTotal.$invalid\"><p class=\"help-block\" ng-show=\"editForm.expenseTotal.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.expenseTotal.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group col-md-3\"><label class=\"control-label required\" translate=\"fleetApp.vehiclePayment.refund\" for=\"field_refundTotal\">Expense Total</label><input type=\"text\" ui-number-mask=\"2\" class=\"form-control\" name=\"refundTotal\" id=\"field_refundTotal\" ng-model=\"vm.vehiclePaymentItem.refundTotal\" ng-change=\"vm.changeTotal()\" readonly=\"readonly\"><div ng-show=\"editForm.refundTotal.$invalid\"><p class=\"help-block\" ng-show=\"editForm.refundTotal.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.refundTotal.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group col-md-3\"><label class=\"control-label\" translate=\"fleetApp.vehiclePaymentItem.total\" for=\"field_total\">Total</label><input type=\"text\" class=\"form-control\" name=\"total\" id=\"field_total\" ng-model=\"vm.vehiclePaymentItem.total\" ui-number-mask=\"2\" required readonly=\"readonly\"></div></div></div></div></div><div class=\"modal-footer\"><jhi-alert-error></jhi-alert-error><ul><li ng-repeat=\"(key, errors) in editForm.$error track by $index\"><strong>{{ key }}</strong> errors<ul><li ng-repeat=\"e in errors\">{{ e.$name }} has an error: <strong>{{ key }}</strong>.</li></ul></li></ul><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button><!-- ng-disabled=\"editForm.$invalid || vm.isSaving\" --> <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ng-disabled=\"(editForm.$invalid || vm.isSaving) || !vm.vehiclePaymentItem.driverId\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></div></form>");
$templateCache.put("app/entities/vehicle-payment-item/vehicle-payment-items.html","<div><h2 translate=\"fleetApp.vehiclePaymentItem.home.title\">Vehicle Payment Items</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"vehicle-payment-item.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.vehiclePaymentItem.home.createLabel\">Create new Vehicle Payment Item</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"paymentDate\"><span translate=\"fleetApp.vehiclePaymentItem.paymentDate\">Payment Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startOdometer\"><span translate=\"fleetApp.vehiclePaymentItem.startOdometer\">Start Odometer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endOdometer\"><span translate=\"fleetApp.vehiclePaymentItem.endOdometer\">End Odometer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmTotal\"><span translate=\"fleetApp.vehiclePaymentItem.kmTotal\">Km Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmExtra\"><span translate=\"fleetApp.vehiclePaymentItem.kmExtra\">Km Extra</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmExtraRegular\"><span translate=\"fleetApp.vehiclePaymentItem.kmExtraRegular\">Km Extra Regular</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmExtraTrip\"><span translate=\"fleetApp.vehiclePaymentItem.kmExtraTrip\">Km Extra Trip</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmCostTotalRegular\"><span translate=\"fleetApp.vehiclePaymentItem.kmCostTotalRegular\">Km Cost Total Regular</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"kmCostTotalTrip\"><span translate=\"fleetApp.vehiclePaymentItem.kmCostTotalTrip\">Km Cost Total Trip</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"startTime\"><span translate=\"fleetApp.vehiclePaymentItem.startTime\">Start Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"endTime\"><span translate=\"fleetApp.vehiclePaymentItem.endTime\">End Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"totalTime\"><span translate=\"fleetApp.vehiclePaymentItem.totalTime\">Total Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"extraTime\"><span translate=\"fleetApp.vehiclePaymentItem.extraTime\">Extra Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"extraTimeCostTotal\"><span translate=\"fleetApp.vehiclePaymentItem.extraTimeCostTotal\">Extra Time Cost Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"expenseTotal\"><span translate=\"fleetApp.vehiclePaymentItem.expenseTotal\">Expense Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"total\"><span translate=\"fleetApp.vehiclePaymentItem.total\">Total</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"dailyCost\"><span translate=\"fleetApp.vehiclePaymentItem.dailyCost\">Daily Cost</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"vehiclePaymentId\"><span translate=\"fleetApp.vehiclePaymentItem.vehiclePayment\">Vehicle Payment</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"driverFirstName\"><span translate=\"fleetApp.vehiclePaymentItem.driver\">Driver</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vehiclePaymentItem in vm.vehiclePaymentItems track by vehiclePaymentItem.id\"><td><a ui-sref=\"vehicle-payment-item-detail({id:vehiclePaymentItem.id})\">{{vehiclePaymentItem.id}}</a></td><td>{{vehiclePaymentItem.paymentDate | date:\'mediumDate\'}}</td><td>{{vehiclePaymentItem.startOdometer}}</td><td>{{vehiclePaymentItem.endOdometer}}</td><td>{{vehiclePaymentItem.kmTotal}}</td><td>{{vehiclePaymentItem.kmExtra}}</td><td>{{vehiclePaymentItem.kmExtraRegular}}</td><td>{{vehiclePaymentItem.kmExtraTrip}}</td><td>{{vehiclePaymentItem.kmCostTotalRegular}}</td><td>{{vehiclePaymentItem.kmCostTotalTrip}}</td><td>{{vehiclePaymentItem.startTime | date:\'medium\'}}</td><td>{{vehiclePaymentItem.endTime | date:\'medium\'}}</td><td>{{vehiclePaymentItem.totalTime}}</td><td>{{vehiclePaymentItem.extraTime}}</td><td>{{vehiclePaymentItem.extraTimeCostTotal}}</td><td>{{vehiclePaymentItem.expenseTotal}}</td><td>{{vehiclePaymentItem.total}}</td><td>{{vehiclePaymentItem.dailyCost}}</td><td><a ui-sref=\"vehicle-payment-detail({id:vehiclePaymentItem.vehiclePaymentId})\">{{vehiclePaymentItem.vehiclePaymentId}}</a></td><td>{{vehiclePaymentItem.driverFirstName}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vehicle-payment-item-detail({id:vehiclePaymentItem.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-payment-item.edit({id:vehiclePaymentItem.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-payment-item.delete({id:vehiclePaymentItem.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/vehicle-type/vehicle-type-delete-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.vehicleType.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" data-translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p data-translate=\"fleetApp.vehicleType.delete.question\" translate-values=\"{id: \'{{vm.vehicleType.id}}\'}\">Are you sure you want to delete this Vehicle Type?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span data-translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/vehicle-type/vehicle-type-detail.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2><span data-translate=\"fleetApp.vehicleType.detail.title\">Vehicle Type</span> {{vm.vehicleType.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span data-translate=\"fleetApp.vehicleType.name\">Name</span></dt><dd><span>{{vm.vehicleType.name}}</span></dd><dt><span data-translate=\"fleetApp.vehicleType.icon\">Icon</span></dt><dd><span>{{vm.vehicleType.icon}}</span></dd></dl><button type=\"submit\" ui-sref=\"{{ vm.previousState }}\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span data-translate=\"entity.action.back\"> Back</span></button> <button type=\"button\" ui-sref=\"vehicle-type-detail.edit({id:vm.vehicleType.id})\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.edit\">Edit</span></button></div>");
$templateCache.put("app/entities/vehicle-type/vehicle-type-dialog.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVehicleTypeLabel\" data-translate=\"fleetApp.vehicleType.home.createOrEditLabel\">Create or edit a Vehicle Type</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.vehicleType.id\"><label for=\"id\" data-translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.vehicleType.id\" readonly=\"readonly\"></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.vehicleType.name\" for=\"field_name\">Name</label><input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\" ng-model=\"vm.vehicleType.name\" required ng-maxlength=\"60\"><div ng-show=\"editForm.name.$invalid\"><p class=\"help-block\" ng-show=\"editForm.name.$error.required\" data-translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.name.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"60\">This field cannot be longer than 60 characters.</p></div></div><div class=\"form-group\"><label class=\"control-label\" data-translate=\"fleetApp.vehicleType.icon\" for=\"field_icon\">Icon</label><input type=\"text\" class=\"form-control\" name=\"icon\" id=\"field_icon\" ng-model=\"vm.vehicleType.icon\" ng-maxlength=\"40\"><div ng-show=\"editForm.icon.$invalid\"><p class=\"help-block\" ng-show=\"editForm.icon.$error.maxlength\" data-translate=\"entity.validation.maxlength\" translate-value-max=\"40\">This field cannot be longer than 40 characters.</p></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span data-translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span data-translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/vehicle-type/vehicle-types.html","<!--\n  ~ Copyright (c) 2016. Iuri Pereira(iuricmp@gmail.com)\n  ~\n  --><div><h2 data-translate=\"fleetApp.vehicleType.home.title\">Vehicle Types</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"vehicle-type.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span data-translate=\"fleetApp.vehicleType.home.createLabel\">Create new Vehicle Type</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span data-translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"name\"><span data-translate=\"fleetApp.vehicleType.name\">Name</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"icon\"><span data-translate=\"fleetApp.vehicleType.icon\">Icon</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"vehicleType in vm.vehicleTypes track by vehicleType.id\"><td><a ui-sref=\"vehicle-type-detail({id:vehicleType.id})\">{{vehicleType.id}}</a></td><td>{{vehicleType.name}}</td><td>{{vehicleType.icon}}</td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"vehicle-type-detail({id:vehicleType.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-type.edit({id:vehicleType.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"vehicle-type.delete({id:vehicleType.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" data-translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\" items-per-page=\"vm.itemsPerPage\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/entities/visit/visit-delete-dialog.html","<form name=\"deleteForm\" ng-submit=\"vm.confirmDelete(vm.visit.id)\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" translate=\"entity.delete.title\">Confirm delete operation</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><p translate=\"fleetApp.visit.delete.question\" translate-values=\"{id: \'{{vm.visit.id}}\'}\">Are you sure you want to delete this Visit?</p></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"deleteForm.$invalid\" class=\"btn btn-danger\"><span class=\"glyphicon glyphicon-remove-circle\"></span>&nbsp;<span translate=\"entity.action.delete\">Delete</span></button></div></form>");
$templateCache.put("app/entities/visit/visit-detail.html","<div><h2><span translate=\"fleetApp.visit.detail.title\">Visit</span> {{vm.visit.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class=\"dl-horizontal jh-entity-details\"><dt><span translate=\"fleetApp.visit.arrivalTime\">Arrival Time</span></dt><dd><span>{{vm.visit.arrivalTime | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.visit.departure\">Departure</span></dt><dd><span>{{vm.visit.departure | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.visit.targetDistance\">Target Distance</span></dt><dd><span>{{vm.visit.targetDistance}}</span></dd><dt><span translate=\"fleetApp.visit.creationDate\">Creation Date</span></dt><dd><span>{{vm.visit.creationDate | date:\'medium\'}}</span></dd><dt><span translate=\"fleetApp.visit.odometer\">Odometer</span></dt><dd><span>{{vm.visit.odometer}}</span></dd><dt><span translate=\"fleetApp.visit.bypass\">Bypass</span></dt><dd><span>{{vm.visit.bypass}}</span></dd><dt><span translate=\"fleetApp.visit.spentTime\">Spent Time</span></dt><dd><span>{{vm.visit.spentTime}}</span></dd><dt><span translate=\"fleetApp.visit.task\">Task</span></dt><dd><a ui-sref=\"task-detail({id:vm.visit.taskId})\">{{vm.visit.taskId}}</a></dd><dt><span translate=\"fleetApp.visit.position\">Position</span></dt><dd><a ui-sref=\"position-detail({id:vm.visit.positionId})\">{{vm.visit.positionId}}</a></dd></dl><button type=\"submit\" onclick=\"window.history.back()\" class=\"btn btn-info\"><span class=\"glyphicon glyphicon-arrow-left\"></span>&nbsp;<span translate=\"entity.action.back\"> Back</span></button></div>");
$templateCache.put("app/entities/visit/visit-dialog.html","<form name=\"editForm\" role=\"form\" novalidate ng-submit=\"vm.save()\" show-validation><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"vm.clear()\">&times;</button><h4 class=\"modal-title\" id=\"myVisitLabel\" translate=\"fleetApp.visit.home.createOrEditLabel\">Create or edit a Visit</h4></div><div class=\"modal-body\"><jhi-alert-error></jhi-alert-error><div class=\"form-group\" ng-show=\"vm.visit.id\"><label for=\"id\" translate=\"global.field.id\">ID</label><input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\" ng-model=\"vm.visit.id\" readonly=\"readonly\"></div><div class=\"form-group\">{{vm.visit.arrivalTime}}<label class=\"control-label\" translate=\"fleetApp.visit.arrivalTime\" for=\"field_arrivalTime\">Arrival Time</label><div class=\"input-group\"><input id=\"field_arrivalTime\" type=\"text\" class=\"form-control\" name=\"arrivalTime\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.visit.arrivalTime\" is-open=\"vm.datePickerOpenStatus.arrivalTime\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'arrivalTime\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.arrivalTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.arrivalTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.arrivalTime.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.visit.departure\" for=\"field_departure\">Departure</label><div class=\"input-group\"><input id=\"field_departure\" type=\"text\" class=\"form-control\" name=\"departure\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.visit.departure\" is-open=\"vm.datePickerOpenStatus.departure\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'departure\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.departure.$invalid\"><p class=\"help-block\" ng-show=\"editForm.departure.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.departure.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.visit.targetDistance\" for=\"field_targetDistance\">Target Distance</label><input type=\"number\" class=\"form-control\" name=\"targetDistance\" id=\"field_targetDistance\" ng-model=\"vm.visit.targetDistance\" required><div ng-show=\"editForm.targetDistance.$invalid\"><p class=\"help-block\" ng-show=\"editForm.targetDistance.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.targetDistance.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.visit.creationDate\" for=\"field_creationDate\">Creation Date</label><div class=\"input-group\"><input id=\"field_creationDate\" type=\"text\" class=\"form-control\" name=\"creationDate\" datetime-picker=\"{{dateformat}}\" ng-model=\"vm.visit.creationDate\" is-open=\"vm.datePickerOpenStatus.creationDate\" required> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openCalendar(\'creationDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-show=\"editForm.creationDate.$invalid\"><p class=\"help-block\" ng-show=\"editForm.creationDate.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.creationDate.$error.ZonedDateTimelocal\" translate=\"entity.validation.ZonedDateTimelocal\">This field should be a date and time.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.visit.odometer\" for=\"field_odometer\">Odometer</label><input type=\"number\" class=\"form-control\" name=\"odometer\" id=\"field_odometer\" ng-model=\"vm.visit.odometer\" required><div ng-show=\"editForm.odometer.$invalid\"><p class=\"help-block\" ng-show=\"editForm.odometer.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.odometer.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.visit.bypass\" for=\"field_bypass\">Bypass</label><input type=\"checkbox\" class=\"form-control\" name=\"bypass\" id=\"field_bypass\" ng-model=\"vm.visit.bypass\"><div ng-show=\"editForm.bypass.$invalid\"><p class=\"help-block\" ng-show=\"editForm.bypass.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"form-group\"><label class=\"control-label\" translate=\"fleetApp.visit.spentTime\" for=\"field_spentTime\">Spent Time</label><input type=\"number\" class=\"form-control\" name=\"spentTime\" id=\"field_spentTime\" ng-model=\"vm.visit.spentTime\" required><div ng-show=\"editForm.spentTime.$invalid\"><p class=\"help-block\" ng-show=\"editForm.spentTime.$error.required\" translate=\"entity.validation.required\">This field is required.</p><p class=\"help-block\" ng-show=\"editForm.spentTime.$error.number\" translate=\"entity.validation.number\">This field should be a number.</p></div></div><div class=\"form-group\"><label translate=\"fleetApp.visit.task\" for=\"field_task\">Task</label><select class=\"form-control\" id=\"field_task\" name=\"task\" ng-model=\"vm.visit.taskId\" ng-options=\"task.id as task.id for task in vm.tasks\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.task.$invalid\"><p class=\"help-block\" ng-show=\"editForm.task.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div><div class=\"form-group\"><label translate=\"fleetApp.visit.position\" for=\"field_position\">Position</label><select class=\"form-control\" id=\"field_position\" name=\"position\" ng-model=\"vm.visit.positionId\" ng-options=\"position.id as position.id for position in vm.positions\" required><option value=\"\"></option></select></div><div ng-show=\"editForm.position.$invalid\"><p class=\"help-block\" ng-show=\"editForm.position.$error.required\" translate=\"entity.validation.required\">This field is required.</p></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" ng-click=\"vm.clear()\"><span class=\"glyphicon glyphicon-ban-circle\"></span>&nbsp;<span translate=\"entity.action.cancel\">Cancel</span></button> <button type=\"submit\" ng-disabled=\"editForm.$invalid || vm.isSaving\" class=\"btn btn-primary\"><span class=\"glyphicon glyphicon-save\"></span>&nbsp;<span translate=\"entity.action.save\">Save</span></button></div></form>");
$templateCache.put("app/entities/visit/visits.html","<div><h2 translate=\"fleetApp.visit.home.title\">Visits</h2><jhi-alert></jhi-alert><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-4 no-padding-left\"><button class=\"btn btn-primary\" ui-sref=\"visit.new\"><span class=\"glyphicon glyphicon-plus\"></span> <span translate=\"fleetApp.visit.home.createLabel\">Create new Visit</span></button></div></div></div><br><div class=\"table-responsive\"><table class=\"jh-table table table-striped\"><thead><tr jh-sort=\"vm.predicate\" ascending=\"vm.reverse\" callback=\"vm.transition()\"><th jh-sort-by=\"id\"><span translate=\"global.field.id\">ID</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"arrivalTime\"><span translate=\"fleetApp.visit.arrivalTime\">Arrival Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"departure\"><span translate=\"fleetApp.visit.departure\">Departure</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"targetDistance\"><span translate=\"fleetApp.visit.targetDistance\">Target Distance</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"creationDate\"><span translate=\"fleetApp.visit.creationDate\">Creation Date</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"odometer\"><span translate=\"fleetApp.visit.odometer\">Odometer</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"bypass\"><span translate=\"fleetApp.visit.bypass\">Bypass</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"spentTime\"><span translate=\"fleetApp.visit.spentTime\">Spent Time</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"taskId\"><span translate=\"fleetApp.visit.task\">Task</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th jh-sort-by=\"positionId\"><span translate=\"fleetApp.visit.position\">Position</span> <span class=\"glyphicon glyphicon-sort\"></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"visit in vm.visits track by visit.id\"><td><a ui-sref=\"visit-detail({id:visit.id})\">{{visit.id}}</a></td><td>{{visit.arrivalTime | date:\'medium\'}}</td><td>{{visit.departure | date:\'medium\'}}</td><td>{{visit.targetDistance}}</td><td>{{visit.creationDate | date:\'medium\'}}</td><td>{{visit.odometer}}</td><td>{{visit.bypass}}</td><td>{{visit.spentTime}}</td><td><a ui-sref=\"task-detail({id:visit.taskId})\">{{visit.taskId}}</a></td><td><a ui-sref=\"position-detail({id:visit.positionId})\">{{visit.positionId}}</a></td><td class=\"text-right\"><div class=\"btn-group flex-btn-group-container\"><button type=\"submit\" ui-sref=\"visit-detail({id:visit.id})\" class=\"btn btn-info btn-sm\"><span class=\"glyphicon glyphicon-eye-open\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.view\"></span></button> <button type=\"submit\" ui-sref=\"visit.edit({id:visit.id})\" class=\"btn btn-primary btn-sm\"><span class=\"glyphicon glyphicon-pencil\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.edit\"></span></button> <button type=\"submit\" ui-sref=\"visit.delete({id:visit.id})\" class=\"btn btn-danger btn-sm\"><span class=\"glyphicon glyphicon-remove-circle\"></span> <span class=\"hidden-xs hidden-sm\" translate=\"entity.action.delete\"></span></button></div></td></tr></tbody></table></div><div class=\"text-center\"><jhi-item-count page=\"vm.page\" total=\"vm.queryCount\"></jhi-item-count></div><uib-pager total-items=\"vm.totalItems\" ng-model=\"vm.page\" ng-change=\"vm.transition()\"></uib-pager></div>");
$templateCache.put("app/layouts/error/accessdenied.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div class=\"alert alert-danger\" translate=\"error.403\">You are not authorized to access the page.</div></div></div></div>");
$templateCache.put("app/layouts/error/error.html","<div ng-cloak><div class=\"row\"><div class=\"col-md-4\"><span class=\"hipster img-responsive img-rounded\"></span></div><div class=\"col-md-8\"><h1 translate=\"error.title\">Error Page!</h1><div ng-show=\"errorMessage\"><div class=\"alert alert-danger\">{{errorMessage}}</div></div></div></div></div>");
$templateCache.put("app/layouts/navbar/navbar.html","<!-- Header Navbar: style can be found in header.less --><nav class=\"navbar navbar-static-top\"><!--\n    <a ng-href=\"#\" class=\"logo\">\n        <span class=\"logo-mini\"><b>SIGLOG</b></span>\n        <span class=\"logo-lg\">\n            <img class=\"logo-img2\" src=\"content/images/fleet-light-desktop-logo.png\"/>\n        </span>\n    </a>\n    --><div class=\"navbar-header\"><a ng-href=\"#\" class=\"navbar-brand\"><div class=\"brand-img\"><!--image come from css--></div></a><button type=\"button\" class=\"navbar-toggle collapsed\" ng-click=\"vm.toggleNavbar()\"><i class=\"fa fa-bars\"></i></button></div><div class=\"container\"><div class=\"collapse navbar-collapse pull-left\" id=\"navbar-collapse\" ng-switch=\"vm.isAuthenticated()\" uib-collapse=\"vm.isNavbarCollapsed\"><ul class=\"nav navbar-nav\"><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"home\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-home\"></span> <span class=\"hidden-sm\" translate=\"global.menu.home\">Home</span></a></li><li ui-sref-active=\"active\" ng-switch-when=\"true\"><a ui-sref=\"dashboard\" ng-click=\"vm.collapseNavbar();\"><span class=\"glyphicon glyphicon-map-marker\"></span> <span class=\"hidden-sm\" translate=\"global.menu.dashboard\">Dashboard</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class=\"{active: vm.$state.includes(\'entity\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"entity-menu\"><span><span class=\"fa fa-navicon\"></span> <span class=\"hidden-sm\" translate=\"global.menu.entities.main\">Entities </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu scrollable-menu\" uib-dropdown-menu><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"person\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.person\">Person</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN\"><a ui-sref=\"bank\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.bank\">Bank</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\"><a ui-sref=\"bank-account\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.bankAccount\">Bank Account</span></a></li><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\"><a ui-sref=\"expense\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.expense\">Expense</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"person-distance\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.personDistance\">Person Distance</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"company\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.company\">Company</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"address\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.address\">Address</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"vehicle-group\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.vehicleGroup\">Group</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"itinerary\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.itinerary\">Itinerary</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"message\" ng-click=\"vm.collapseNavbar()\" has-authority=\"ROLE_ADMIN\"><span translate=\"global.menu.entities.message\">Message</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"invoice\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.invoice\">Invoice</span></a></li><!--<li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\">\n                            <a ui-sref=\"invoice-item\" ng-click=\"vm.collapseNavbar()\">\n\n                                <span translate=\"global.menu.entities.invoiceItem\">Invoice Item</span>\n                            </a>\n                        </li>--><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, EDIT_FINANCIAL\"><a ui-sref=\"vehicle-payment\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.vehiclePayment\">Vehicle Payment</span></a></li><!--<li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\">\n                            <a ui-sref=\"vehicle-payment-item\" ng-click=\"vm.collapseNavbar()\">\n\n                                <span translate=\"global.menu.entities.vehiclePaymentItem\">Vehicle Payment Item</span>\n                            </a>\n                        </li>--><li ui-sref-active=\"active\" has-any-authority=\"ROLE_ADMIN, EDIT_OFFICEHOURS\"><a ui-sref=\"officehours\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.officehours\">Officehours</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"device\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.device\">Device</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"task\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.task\">Task</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"job-error\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.jobError\">Job Error</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"order\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.order\">Order</span></a></li><!--<li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\">\n                            <a ui-sref=\"position\" ng-click=\"vm.collapseNavbar()\">\n\n                                <span translate=\"global.menu.entities.position\">Position</span>\n                            </a>\n                        </li>--><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"person-address\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.personAddress\">Person Address</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"product\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.product\">Product</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"refused-reason\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.refusedReason\">Refused Reason</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"user-management\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.user\">User</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"vehicle\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.vehicle\">Vehicle</span></a></li><!--<li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\">\n                            <a ui-sref=\"visit\" ng-click=\"vm.collapseNavbar()\">\n\n                                <span translate=\"global.menu.entities.visit\">Visit</span>\n                            </a>\n                        </li>--><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"vehicle-type\" ng-click=\"vm.collapseNavbar()\"><span data-translate=\"global.menu.entities.vehicleType\">Vehicle Type</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"fleet-media\" ng-click=\"vm.collapseNavbar()\"><!--<span class=\"fa fa-photo\"></span>&nbsp;--> <span translate=\"global.menu.entities.fleetMedia\">Fleet Media</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"fleet-preference\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.fleetPreference\">Fleet Preference</span></a></li><li ui-sref-active=\"active\" has-authority=\"ROLE_ADMIN\"><a ui-sref=\"v3\" ng-click=\"vm.collapseNavbar()\"><span>v3</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class=\"{active: vm.$state.includes(\'report\')}\" ng-switch-when=\"true\" uib-dropdown class=\"dropdown pointer\" has-authority=\"ACCESS_REPORTS\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"report-menu\"><span><span class=\"hidden-sm\" translate=\"global.menu.report.main\">Report </span><b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"report\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.report.analytics\">Analytics</span></a></li><li ui-sref-active=\"active\" has-authority=\"EDIT_ROUTE_REVIEW\"><a ui-sref=\"route-review\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.routeReview\">Route Review</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"report.payment\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.vehiclePayment\">Vehicle Payment</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"report.time\" ng-click=\"vm.collapseNavbar()\"><span translate=\"global.menu.entities.time\">Time</span></a></li></ul></li><li ng-class=\"{active: vm.$state.includes(\'admin\')}\" ng-switch-when=\"true\" has-authority=\"ROLE_ADMIN\" uib-dropdown class=\"dropdown pointer\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" id=\"admin-menu\"><span><span class=\"glyphicon glyphicon-tower\"></span> <span class=\"hidden-sm\" translate=\"global.menu.admin.main\">Administration</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><li ui-sref-active=\"active\"><a ui-sref=\"jhi-metrics\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-dashboard\"></span>&nbsp; <span translate=\"global.menu.admin.metrics\">Metrics</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-health\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-heart\"></span>&nbsp; <span translate=\"global.menu.admin.health\">Health</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"jhi-configuration\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.configuration\">Configuration</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"audits\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-bell\"></span>&nbsp; <span translate=\"global.menu.admin.audits\">Audits</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"logs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-tasks\"></span>&nbsp; <span translate=\"global.menu.admin.logs\">Logs</span></a></li><li ng-hide=\"vm.inProduction || vm.swaggerDisabled\" ui-sref-active=\"active\"><a ui-sref=\"docs\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-book\"></span>&nbsp; <span translate=\"global.menu.admin.apidocs\">API</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"entity-audit\" ng-click=\"vm.collapseNavbar()\"><span class=\"glyphicon glyphicon-list-alt\"></span>&nbsp; <span translate=\"global.menu.admin.entity-audit\">Entity Audit</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active=\"active\" uib-dropdown class=\"dropdown pointer\" ng-controller=\"JhiLanguageController as languageVm\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\" ng-if=\"languageVm.languages.length > 1\"><span><span class=\"glyphicon glyphicon-flag\"></span><!--<span class=\"hidden-sm\" translate=\"global.menu.language\">Language</span>--> <span class=\"hidden-sm\">{{languageVm.currentLanguage}}</span> <b class=\"caret\"></b></span></a><ul class=\"dropdown-menu\" uib-dropdown-menu ng-if=\"languageVm.languages.length > 1\"><li active-menu=\"{{language}}\" ng-repeat=\"language in languageVm.languages\"><a href=\"\" ng-click=\"languageVm.changeLanguage(language);vm.collapseNavbar();\">{{language | findLanguageFromKey}}</a></li></ul></li><li ui-sref-active=\"active\" ng-switch-when=\"false\"><a href=\"\" ng-click=\"vm.login()\" id=\"login\" ng-if=\"vm.hasSubdomain\"><span class=\"glyphicon glyphicon-log-in\"></span>&nbsp; <span translate=\"global.menu.account.login\">Sign in</span></a></li><!-- User Account: style can be found in dropdown.less --><li class=\"dropdown user user-menu\" uib-dropdown class=\"dropdown pointer\" ng-class=\"{active: vm.$state.includes(\'account\')}\" ng-switch-when=\"true\"><a class=\"dropdown-toggle\" uib-dropdown-toggle href=\"\"><span class=\"glyphicon glyphicon-user\"></span> <span class=\"hidden-xs\">{{vm.settingsAccount.firstName}}</span></a><ul class=\"dropdown-menu\" uib-dropdown-menu><!-- User image --><li class=\"user-header\"><span class=\"glyphicon glyphicon-user fa-3x\"></span><p>{{vm.settingsAccount.firstName}} {{vm.settingsAccount.lastName}}<br>{{vm.settingsAccount.login}} <small>{{vm.settingsAccount.email}}</small></p></li><!-- Menu Body --><li class=\"user-body\"><div class=\"row\"><!--\n                                <div class=\"col-xs-4 text-center\">\n                                    <a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\">\n                                    <span class=\"glyphicon glyphicon-lock\"></span><br>\n                                    <span translate=\"global.menu.account.password\">Password</span>\n                                    </a>\n                                </div>\n                                --><div class=\"col-xs-12 text-center\"><a ui-sref=\"settings\" ng-click=\"vm.collapseNavbar()\" class=\"btn btn-default btn-flat\"><span class=\"glyphicon glyphicon-user\"></span>&nbsp; <span translate=\"global.menu.account.settings\">Settings</span></a></div></div><!-- /.row --></li><!-- Menu Footer--><li class=\"user-footer\"><div class=\"pull-left\"><a ui-sref=\"password\" ng-click=\"vm.collapseNavbar()\" class=\"btn btn-default btn-flat\"><span class=\"glyphicon glyphicon-lock\"></span> <span translate=\"global.menu.account.password\">Password</span></a></div><div class=\"pull-right\"><a href=\"\" ng-click=\"vm.logout()\" id=\"logout\" class=\"btn btn-default btn-flat\"><span class=\"glyphicon glyphicon-log-out\"></span>&nbsp; <span translate=\"global.menu.account.logout\">Sign out</span></a></div></li></ul></li><li><a><span class=\"navbar-version\">v{{VERSION}}</span></a></li></ul></div></div></nav>");
$templateCache.put("app/account/reset/finish/reset.finish.html","<div><div class=\"row\"><div class=\"col-md-4 col-md-offset-4\"><h1 translate=\"reset.finish.title\">Reset password</h1><div class=\"alert alert-danger\" translate=\"reset.finish.messages.keymissing\" ng-show=\"vm.keyMissing\"><strong>The password reset key is missing.</strong></div><div class=\"alert alert-warning\" ng-hide=\"vm.success || vm.keyMissing\"><p translate=\"reset.finish.messages.info\">Choose a new password</p></div><div class=\"alert alert-danger\" ng-show=\"vm.error\"><p translate=\"reset.finish.messages.error\">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success\"><p translate=\"reset.finish.messages.success\" translate-compile><strong>Your password has been reset.</strong> Please <a class=\"alert-link\" href=\"\" ng-click=\"vm.login()\">sign in</a>.</p></div><div class=\"alert alert-danger\" ng-show=\"vm.doNotMatch\" translate=\"global.messages.error.dontmatch\">The password and its confirmation do not match!</div><div ng-hide=\"vm.keyMissing\"><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.finishReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"password\" translate=\"global.form.newpassword\">New password</label><input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" placeholder=\"{{\'global.form.newpassword.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.password\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.password.$dirty && form.password.$invalid\"><p class=\"help-block\" ng-show=\"form.password.$error.required\" translate=\"global.messages.validate.newpassword.required\">Your password is required.</p><p class=\"help-block\" ng-show=\"form.password.$error.minlength\" translate=\"global.messages.validate.newpassword.minlength\">Your password is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.password.$error.maxlength\" translate=\"global.messages.validate.newpassword.maxlength\">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check=\"vm.resetAccount.password\"></password-strength-bar></div><div class=\"form-group\"><label class=\"control-label\" for=\"confirmPassword\" translate=\"global.form.confirmpassword\">New password confirmation</label><input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\" placeholder=\"{{\'global.form.confirmpassword.placeholder\' | translate}}\" ng-model=\"vm.confirmPassword\" ng-minlength=\"4\" ng-maxlength=\"50\" required><div ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$invalid\"><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.required\" translate=\"global.messages.validate.confirmpassword.required\">Your password confirmation is required.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.minlength\" translate=\"global.messages.validate.confirmpassword.minlength\">Your password confirmation is required to be at least 4 characters.</p><p class=\"help-block\" ng-show=\"form.confirmPassword.$error.maxlength\" translate=\"global.messages.validate.confirmpassword.maxlength\">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.finish.form.button\">Reset Password</button></form></div></div></div></div>");
$templateCache.put("app/account/reset/request/reset.request.html","<div><div class=\"row\"><div class=\"col-md-8 col-md-offset-2\"><h1 translate=\"reset.request.title\">Reset your password</h1><div class=\"alert alert-danger\" translate=\"reset.request.messages.notfound\" ng-show=\"vm.errorEmailNotExists\"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class=\"alert alert-warning\" ng-hide=\"vm.success\"><p translate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p></div><div class=\"alert alert-success\" ng-show=\"vm.success == \'OK\'\"><p translate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your password.</p></div><form ng-show=\"!vm.success\" name=\"form\" role=\"form\" novalidate ng-submit=\"vm.requestReset()\" show-validation><div class=\"form-group\"><label class=\"control-label\" for=\"email\" translate=\"global.form.email\">E-mail</label><input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"{{\'global.form.email.placeholder\' | translate}}\" ng-model=\"vm.resetAccount.email\" ng-minlength=\"5\" ng-maxlength=\"100\" required><div ng-show=\"form.email.$dirty && form.email.$invalid\"><p class=\"help-block\" ng-show=\"form.email.$error.required\" translate=\"global.messages.validate.email.required\">Your e-mail is required.</p><p class=\"help-block\" ng-show=\"form.email.$error.email\" translate=\"global.messages.validate.email.invalid\">Your e-mail is invalid.</p><p class=\"help-block\" ng-show=\"form.email.$error.minlength\" translate=\"global.messages.validate.email.minlength\">Your e-mail is required to be at least 5 characters.</p><p class=\"help-block\" ng-show=\"form.email.$error.maxlength\" translate=\"global.messages.validate.email.maxlength\">Your e-mail cannot be longer than 100 characters.</p></div></div><button type=\"submit\" ng-disabled=\"form.$invalid\" class=\"btn btn-primary\" translate=\"reset.request.form.button\">Reset</button></form></div></div></div>");}]);})();